import { NgSelectModule } from '@ng-select/ng-select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { animate, style, transition, trigger } from '@angular/animations';
import { isString, isUndefined, isNumber, isNull } from 'util';
import { finalize } from 'rxjs/operators';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import 'moment';
import { NgbPopoverModule, NgbDate, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { SwiperComponent, SwiperDirective, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { DecimalPipe, PercentPipe, CommonModule, DatePipe } from '@angular/common';
import { __extends, __awaiter, __generator, __assign, __spread } from 'tslib';
import { Pipe, NgModule, Component, Input, ElementRef, EventEmitter, Output, Renderer2, ViewChild, ViewEncapsulation, HostListener, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule, FormGroup, ReactiveFormsModule, FormControl } from '@angular/forms';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TruncatePipe = /** @class */ (function () {
    function TruncatePipe() {
    }
    /**
     * @param {?} input
     * @param {?=} length
     * @param {?=} suffix
     * @param {?=} preserve
     * @return {?}
     */
    TruncatePipe.prototype.transform = /**
     * @param {?} input
     * @param {?=} length
     * @param {?=} suffix
     * @param {?=} preserve
     * @return {?}
     */
    function (input, length, suffix, preserve) {
        if (!input) {
            return '';
        }
        if (!isString(input)) {
            return input;
        }
        length = isUndefined(length) ? input.length : length;
        if (input.length <= length) {
            return input;
        }
        preserve = preserve || false;
        suffix = suffix || '';
        /** @type {?} */
        var index = length;
        if (preserve) {
            if (input.indexOf(' ', length) === -1) {
                index = input.length;
            }
            else {
                index = input.indexOf(' ', length);
            }
        }
        return input.substring(0, index) + suffix;
    };
    TruncatePipe.decorators = [
        { type: Pipe, args: [{ name: 'truncate' },] }
    ];
    return TruncatePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddSignPipe = /** @class */ (function (_super) {
    __extends(AddSignPipe, _super);
    function AddSignPipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} number
     * @return {?}
     */
    AddSignPipe.prototype.transform = /**
     * @param {?} number
     * @return {?}
     */
    function (number) {
        if (number || number.toString() === '0') {
            if (!isNumber(number)) {
                number = parseInt(number.replace(/\s/g, ''), 10);
            }
        }
        else {
            return '';
        }
        /** @type {?} */
        var result = _super.prototype.transform.call(this, number, '.0-1', 'fr');
        return number > 0 ? "+" + result : "" + result;
    };
    AddSignPipe.decorators = [
        { type: Pipe, args: [{ name: 'addSign' },] }
    ];
    return AddSignPipe;
}(DecimalPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ArrayJoinPipe = /** @class */ (function () {
    function ArrayJoinPipe() {
    }
    /**
     * @param {?} array
     * @param {?} separator
     * @return {?}
     */
    ArrayJoinPipe.prototype.transform = /**
     * @param {?} array
     * @param {?} separator
     * @return {?}
     */
    function (array, separator) {
        return array && array.length > 0 ? array.join(separator) : '';
    };
    ArrayJoinPipe.decorators = [
        { type: Pipe, args: [{ name: 'arrayJoin' },] }
    ];
    return ArrayJoinPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VersusPercentPipe = /** @class */ (function (_super) {
    __extends(VersusPercentPipe, _super);
    function VersusPercentPipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} input
     * @return {?}
     */
    VersusPercentPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        if (!isNumber(input)) {
            return;
        }
        return (input > 0 ? '+' : '') + _super.prototype.transform.call(this, input, '.0-1', 'fr');
    };
    VersusPercentPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'versuspercent',
                },] }
    ];
    return VersusPercentPipe;
}(PercentPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SanitizeHtmlPipe = /** @class */ (function () {
    function SanitizeHtmlPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} content
     * @return {?}
     */
    SanitizeHtmlPipe.prototype.transform = /**
     * @param {?} content
     * @return {?}
     */
    function (content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    };
    SanitizeHtmlPipe.decorators = [
        { type: Pipe, args: [{ name: 'sanitizeHtml', pure: false },] }
    ];
    /** @nocollapse */
    SanitizeHtmlPipe.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    return SanitizeHtmlPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FloorPercentPipe = /** @class */ (function (_super) {
    __extends(FloorPercentPipe, _super);
    function FloorPercentPipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} input
     * @return {?}
     */
    FloorPercentPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        if (!isNumber(input)) {
            input = parseInt(input, 10);
        }
        input = Math.floor(input * 100);
        return input + '%';
    };
    FloorPercentPipe.decorators = [
        { type: Pipe, args: [{ name: 'floorPercent' },] }
    ];
    return FloorPercentPipe;
}(PercentPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CeilPipe = /** @class */ (function () {
    function CeilPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    CeilPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        if (!isNumber(input)) {
            input = parseInt(input, 10);
        }
        input = Math.ceil(input);
        return input;
    };
    CeilPipe.decorators = [
        { type: Pipe, args: [{ name: 'ceil' },] }
    ];
    return CeilPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RemoveAfterHyphenPipe = /** @class */ (function () {
    function RemoveAfterHyphenPipe() {
    }
    /**
     * @param {?} input
     * @return {?}
     */
    RemoveAfterHyphenPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        if (input && typeof input === 'string') {
            return input.toString().split('-', 1)[0];
        }
        return '';
    };
    RemoveAfterHyphenPipe.decorators = [
        { type: Pipe, args: [{ name: 'RemoveAfterHyphenPipe' },] }
    ];
    return RemoveAfterHyphenPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomPercentPipe = /** @class */ (function (_super) {
    __extends(CustomPercentPipe, _super);
    function CustomPercentPipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} input
     * @return {?}
     */
    CustomPercentPipe.prototype.transform = /**
     * @param {?} input
     * @return {?}
     */
    function (input) {
        if (!isNumber(input)) {
            return;
        }
        return (input > 0 ? '+' : '') + _super.prototype.transform.call(this, input * 100, '.0-1', 'fr-FR') + '%';
    };
    CustomPercentPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'custompercent',
                },] }
    ];
    return CustomPercentPipe;
}(DecimalPipe));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BusinessOperationTypeConstant = {
    1: 'Opération promo.',
    2: 'Opération terrain',
    3: 'Titre info',
    4: 'Réglage',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BusinessOperationsTypePipe = /** @class */ (function () {
    function BusinessOperationsTypePipe() {
    }
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    BusinessOperationsTypePipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        if (value && typeof value === 'number') {
            return BusinessOperationTypeConstant[value];
        }
        else {
            return '';
        }
    };
    BusinessOperationsTypePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'businessOperationsType',
                },] }
    ];
    return BusinessOperationsTypePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PipesMetadata = {
    declarations: [
        AddSignPipe,
        ArrayJoinPipe,
        CeilPipe,
        CustomPercentPipe,
        FloorPercentPipe,
        RemoveAfterHyphenPipe,
        SanitizeHtmlPipe,
        TruncatePipe,
        VersusPercentPipe,
        BusinessOperationsTypePipe,
    ],
    imports: [],
    exports: [
        AddSignPipe,
        ArrayJoinPipe,
        CeilPipe,
        CustomPercentPipe,
        FloorPercentPipe,
        RemoveAfterHyphenPipe,
        SanitizeHtmlPipe,
        TruncatePipe,
        VersusPercentPipe,
        BusinessOperationsTypePipe,
    ],
};
var PipesModule = /** @class */ (function () {
    function PipesModule() {
    }
    /**
     * @return {?}
     */
    PipesModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: PipesModule,
            providers: [
                AddSignPipe,
                ArrayJoinPipe,
                CeilPipe,
                CustomPercentPipe,
                FloorPercentPipe,
                RemoveAfterHyphenPipe,
                SanitizeHtmlPipe,
                TruncatePipe,
                VersusPercentPipe,
                BusinessOperationsTypePipe,
            ],
        };
    };
    PipesModule.decorators = [
        { type: NgModule, args: [PipesMetadata,] }
    ];
    return PipesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ArrowIndicatorComponent = /** @class */ (function () {
    function ArrowIndicatorComponent() {
        this.size = 24;
        this.blur = false;
    }
    Object.defineProperty(ArrowIndicatorComponent.prototype, "fontSize", {
        get: /**
         * @return {?}
         */
        function () {
            return this.size / 10 + "rem";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArrowIndicatorComponent.prototype, "arrowOrientation", {
        get: /**
         * @return {?}
         */
        function () {
            return this.orientation;
        },
        enumerable: true,
        configurable: true
    });
    ArrowIndicatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-arrow-indicator',
                    template: "<div class=\"container {{ arrowOrientation }}\" [ngClass]=\"{'text-blur': blur}\" [ngStyle]=\"{ 'font-size': fontSize }\">\n  <div class=\"container-arrow\" *ngIf=\"!blur\"></div>\n  <div class=\"container-content\">{{ content * 100 | number: '.0-1' }}%</div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{display:flex;align-items:baseline;font-family:\"Roboto Slab\",serif;font-weight:300}.container .container-arrow{position:relative;vertical-align:middle;box-sizing:border-box;width:6px;height:6px;border-width:1.5px 1.5px 0 0;border-style:solid;margin:5px 10px 5px 20px}.container .container-arrow:after,.container .container-arrow:before{content:'';box-sizing:border-box}.container .container-arrow:before{right:.5px;top:0;position:absolute;height:1.5px;box-shadow:inset 0 0 0 32px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);width:20px;-webkit-transform-origin:right top;transform-origin:right top}.container.up{color:#2d54d2}.container.up .container-arrow{display:none}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container.up{color:#11c75c}.container.up .container-arrow{display:inline-block;top:-11px;color:#11c75c}}.container.down{color:#2d54d2}.container.down .container-arrow{display:none}@media (min-width:1140px){.container.down{color:#ff642e}.container.down .container-arrow{display:inline-block;top:-1px;color:#ff642e;-webkit-transform:rotate(90deg);transform:rotate(90deg)}}.container.text-blur{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}"]
                }] }
    ];
    ArrowIndicatorComponent.propDecorators = {
        content: [{ type: Input }],
        orientation: [{ type: Input }],
        size: [{ type: Input }],
        blur: [{ type: Input }]
    };
    return ArrowIndicatorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ArrowIndicatorMetadata = {
    declarations: [ArrowIndicatorComponent],
    imports: [CommonModule, PipesModule.forRoot()],
    exports: [ArrowIndicatorComponent],
};
var ArrowIndicatorModule = /** @class */ (function () {
    function ArrowIndicatorModule() {
    }
    ArrowIndicatorModule.decorators = [
        { type: NgModule, args: [ArrowIndicatorMetadata,] }
    ];
    return ArrowIndicatorModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BadgeComponent = /** @class */ (function () {
    function BadgeComponent() {
        this.size = 16;
        this.blur = false;
    }
    Object.defineProperty(BadgeComponent.prototype, "fontSize", {
        get: /**
         * @return {?}
         */
        function () {
            return this.size / 10 + "rem";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BadgeComponent.prototype, "backgdColor", {
        get: /**
         * @return {?}
         */
        function () {
            return this.background;
        },
        enumerable: true,
        configurable: true
    });
    BadgeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-badge',
                    template: "<div class=\"container\" [ngClass]=\"{backgdColor: true, 'text-blur': blur}\" [ngStyle]=\"{ 'font-size': fontSize }\">\n  <div class=\"container-content\">\n    {{ content }}<sup *ngIf=\"indice\">{{ indice }}</sup>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{border-radius:20px;text-align:center;padding:10px;width:20px;height:20px;font-family:\"Roboto Slab\",serif}.container.yellow{background:#ffec00}.container.white{background:0 0;border:1px solid rgba(15,17,18,.12);color:#657478}.container .container-content{position:relative;top:-2px}.container.text-blur,.container.text-blur.white{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}"]
                }] }
    ];
    BadgeComponent.propDecorators = {
        content: [{ type: Input }],
        background: [{ type: Input }],
        indice: [{ type: Input }],
        size: [{ type: Input }],
        blur: [{ type: Input }]
    };
    return BadgeComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BadgeMetadata = {
    declarations: [BadgeComponent],
    imports: [CommonModule],
    exports: [BadgeComponent],
};
var BadgeModule = /** @class */ (function () {
    function BadgeModule() {
    }
    BadgeModule.decorators = [
        { type: NgModule, args: [BadgeMetadata,] }
    ];
    return BadgeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var contentTypeEnum = {
    TEXT: 'text',
    LIST: 'list',
};
var BubbleComponent = /** @class */ (function () {
    function BubbleComponent(el) {
        this.el = el;
        this.contentType = contentTypeEnum.TEXT;
        this.listConfig = {
            maxRowsPerColumn: 10,
            numberOfColumnToDisplay: 3,
        };
        this.click = new EventEmitter();
        this.contentTypeEnum = contentTypeEnum;
    }
    /**
     * If the wish content is a list (using an array), return the content of the array as a list
     */
    /**
     * If the wish content is a list (using an array), return the content of the array as a list
     * @return {?}
     */
    BubbleComponent.prototype.getFormatedContentValues = /**
     * If the wish content is a list (using an array), return the content of the array as a list
     * @return {?}
     */
    function () {
        var _this = this;
        if (Array.isArray(this.content)) {
            if (this.content.length > 20) {
                this.listConfig.maxRowsPerColumn = Math.ceil(this.content.length / 2);
            }
            return this.content.reduce(function (acc, curr) {
                /** @type {?} */
                var currentIndex = acc.length - 1;
                if (acc[currentIndex].length < _this.listConfig.maxRowsPerColumn) {
                    acc[currentIndex].push(curr);
                }
                else {
                    acc.push([curr]);
                }
                return acc;
            }, [[]]);
        }
        return [];
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    BubbleComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.click.emit(evt);
    };
    BubbleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-bubble',
                    template: "<div class=\"bubble-container\" (click)=\"handleClicked($event)\">\n  <ng-container [ngSwitch]=\"contentType\">\n    <span class=\"simple-content\" *ngSwitchCase=\"contentTypeEnum.TEXT\">\n      {{ content }}\n    </span>\n    <div class=\"list-container\" *ngSwitchCase=\"contentTypeEnum.LIST\">\n      <ul\n        class=\"list-content\"\n        *ngFor=\"let itemGroup of getFormatedContentValues()\"\n      >\n        <li class=\"item\" *ngFor=\"let item of itemGroup\">\n          <span class=\"label\">{{ item.label }}</span>\n          <span class=\"separator\"></span>\n          <span class=\"value\">{{ item.value }}</span>\n        </li>\n      </ul>\n    </div>\n  </ng-container>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:inline-block;min-width:267px;font-family:Poppins,sans-serif;color:#fff}.bubble-container{position:relative;padding:16px;border-radius:4px;background-color:#657478}.simple-content{display:block;width:235px}.list-container{display:flex}.list-content{flex-shrink:0;min-width:267px;margin:0;padding:0}.list-content:not(:first-child){margin-left:24px}.item{display:flex;justify-content:space-between;margin:0;padding:0;list-style:none}.item .label{font-size:1.2rem;font-weight:600;line-height:1.33}.item .separator{flex-grow:1;align-self:flex-end;height:1px;margin:0 8px 5px;opacity:.15;border-radius:4px;background-color:#f5f5f5}.item .value{opacity:.8;font-family:Poppins,sans-serif;font-size:1.1rem;font-weight:500;line-height:1.45}"]
                }] }
    ];
    /** @nocollapse */
    BubbleComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    BubbleComponent.propDecorators = {
        contentType: [{ type: Input }],
        content: [{ type: Input }],
        listConfig: [{ type: Input }],
        click: [{ type: Output }]
    };
    return BubbleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BubbleMetadata = {
    declarations: [BubbleComponent],
    imports: [CommonModule],
    exports: [BubbleComponent],
};
var BubbleModule = /** @class */ (function () {
    function BubbleModule() {
    }
    BubbleModule.decorators = [
        { type: NgModule, args: [BubbleMetadata,] }
    ];
    return BubbleModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.click = new EventEmitter();
    }
    Object.defineProperty(ButtonComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._disabled;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            setTimeout(function () {
                _this._disabled = value;
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} evt
     * @return {?}
     */
    ButtonComponent.prototype.handleButtonClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        // stop propagation to prevent double call to event
        evt.stopPropagation();
        this.click.emit(evt);
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-button',
                    template: "<button\n  [type]=\"type\"\n  class=\"button\"\n  [attr.disabled]=\"disabled ? 'disabled' : null\"\n  (click)=\"handleButtonClicked($event)\"\n>\n  {{ text }}\n</button>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.button{width:100%;height:48px;border-radius:4px;border:none;background-color:#2d54d2;font-family:Poppins,sans-serif;color:#fff;font-size:1.4rem;font-weight:500;cursor:pointer}.button[disabled]{opacity:.6}"]
                }] }
    ];
    /** @nocollapse */
    ButtonComponent.ctorParameters = function () { return []; };
    ButtonComponent.propDecorators = {
        text: [{ type: Input }],
        type: [{ type: Input }],
        disabled: [{ type: Input }],
        click: [{ type: Output }]
    };
    return ButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ButtonMetadata = {
    declarations: [ButtonComponent],
    imports: [CommonModule],
    exports: [ButtonComponent],
};
var ButtonModule = /** @class */ (function () {
    function ButtonModule() {
    }
    ButtonModule.decorators = [
        { type: NgModule, args: [ButtonMetadata,] }
    ];
    return ButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Manually optimize the icon before adding it to the table of icons.
 * Change fill or stroke color by 'currentColor' if you want to custom icon color
 * optimizer example: https://jakearchibald.github.io/svgomg/
 */
/** @type {?} */
var icons = [];
icons['info'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 6c-3.3116 0-6 2.6884-6 6s2.6884 6 6 6 6-2.6884 6-6-2.6884-6-6-6zm0-2c4.416 0 8 3.584 8 8s-3.584 8-8 8-8-3.584-8-8 3.584-8 8-8zm1 12h-2v-5h2v5zm0-6h-2V8h2v2z\"/></svg>";
icons['call'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\"><defs><path id=\"call\" d=\"M17.01 12.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H1.19C.65 0 0 .24 0 .99 0 10.28 7.73 18 17.01 18c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z\"/></defs><use fill=\"currentColor\" transform=\"translate(3 3)\" xlink:href=\"#call\"/></svg>";
icons['check'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\"><defs><path id=\"check\" d=\"M6 11.17L1.83 7 .41 8.41 6 14 18 2 16.59.59z\"/></defs><use fill=\"currentColor\" transform=\"translate(3 5)\" xlink:href=\"#check\"/></svg>";
icons['dropdown-expand'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\"><defs><path id=\"dropdown-expand\" d=\"M0 0l5 5 5-5z\"/></defs><use fill=\"currentColor\" transform=\"translate(7 10)\" xlink:href=\"#dropdown-expand\"/></svg>";
icons['logout'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\"><defs><path id=\"logout\" d=\"M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0 1 19 12c0 3.87-3.13 7-7 7A6.995 6.995 0 0 1 7.58 6.58L6.17 5.17A8.932 8.932 0 0 0 3 12a9 9 0 0 0 18 0c0-2.74-1.23-5.18-3.17-6.83z\"/></defs><use fill=\"currentColor\" xlink:href=\"#logout\"/></svg>";
icons['menu'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\"><defs><path id=\"menu\" d=\"M0 12h18v-2H0v2zm0-5h18V5H0v2zm0-7v2h18V0H0z\"/></defs><use fill=\"currentColor\" transform=\"translate(3 6)\" xlink:href=\"#menu\"/></svg>";
icons['close'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\"><defs><path id=\"close\" d=\"M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z\"/></defs><use fill=\"#0F1112\" fill-rule=\"evenodd\" transform=\"translate(5 5)\" xlink:href=\"#close\"/></svg>";
icons['close2'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\"><defs><path id=\"close2\" d=\"M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z\"/></defs><use fill=\"currentColor\" fill-rule=\"evenodd\" transform=\"translate(5 5)\" xlink:href=\"#close2\"/></svg>";
icons['evol'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"11\"><path fill=\"#2D54D2\" d=\"M.71 11a.71.71 0 0 0 .502-.209l5.309-5.312a.475.475 0 0 1 .672 0l1.826 1.828c.717.717 1.968.717 2.685 0l4.872-4.875V4.72a.712.712 0 1 0 1.424 0V.713A.718.718 0 0 0 17.29 0h-4.006a.713.713 0 0 0 0 1.425h2.287L10.7 6.299a.475.475 0 0 1-.672 0L8.202 4.47a1.899 1.899 0 0 0-2.685 0L.208 9.783A.714.714 0 0 0 .71 11z\"/></svg>";
icons['shape'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"18\"><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M9.95.525a.453.453 0 0 0-.405.459v.896c-.848.585-1.732.911-2.728.911a9.242 9.242 0 0 1-3.354-.6.642.642 0 0 0-.348-.078.463.463 0 0 0-.355.269L.032 8.708c-.043.099-.031.18-.029.268a3.167 3.167 0 0 0 3.176 3.079c1.73 0 3.11-1.372 3.176-3.079a.668.668 0 0 0-.028-.268L4.003 3.321c.991.277 1.937.374 2.814.374.99 0 1.898-.277 2.728-.749v12.046H4.998v2.712h10.004v-2.712h-4.547V2.946c.83.472 1.738.749 2.728.749.877 0 1.823-.097 2.814-.374l-2.324 5.387a.668.668 0 0 0-.028.268c.067 1.707 1.447 3.079 3.176 3.079 1.73 0 3.134-1.37 3.176-3.079.002-.088.014-.17-.029-.268L17.24 2.382a.463.463 0 0 0-.355-.269.642.642 0 0 0-.348.078c-1.194.455-2.31.6-3.354.6-.996 0-1.88-.326-2.728-.91V.983a.45.45 0 0 0-.505-.46zM3.18 3.716L5.217 8.44H1.14l2.04-4.724zm13.64 0l2.04 4.724h-4.078l2.039-4.724z\"/></svg>";
icons['download'] = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\"><defs><path id=\"download\" d=\"M14 6h-4V0H4v6H0l7 7 7-7zM0 15v2h14v-2H0z\"/></defs><use fill=\"currentColor\" transform=\"translate(5 3)\" xlink:href=\"#download\"/></svg>";
icons['mail-outline'] = "\n<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path d=\"M18 0H2C.9 0 .01.9.01 2L0 14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 14H2V4l8 5 8-5v10zm-8-7L2 2h16l-8 5z\" id=\"mail-outline\"/></defs><use fill=\"currentColor\" fill-rule=\"nonzero\" xlink:href=\"#mail-outline\" transform=\"translate(2 4)\"/></svg>";
icons['chevron-right'] = "\n<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"chevron-right\" d=\"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z\"/></defs><use fill=\"currentColor\" transform=\"matrix(-1 0 0 1 23.41 0)\" xlink:href=\"#chevron-right\" fill-rule=\"evenodd\"/></svg>";
icons['error'] = "\n<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path d=\"M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0z\" id=\"error\"/></defs><g transform=\"translate(2 2)\" fill=\"none\" fill-rule=\"evenodd\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#error\"/></mask><use fill=\"#FF642E\" fill-rule=\"nonzero\" xlink:href=\"#a\"/><path fill=\"#FFF\" fill-rule=\"nonzero\" mask=\"url(#b)\" d=\"M11 15H9v-2h2zM11 11H9V5h2z\"/></g></svg>";
icons['success'] = "\n<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path d=\"M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0z\" id=\"success\"/></defs><g fill=\"none\" fill-rule=\"evenodd\"><use fill=\"#0EDB44\" fill-rule=\"nonzero\" xlink:href=\"#success\" transform=\"translate(2 2)\"/><path d=\"M16.83 8.027c-.031.033-.482.481-1.074 1.06l-2.12 2.068-2.12 2.068-.587.574-2.836-2.515-1.002 1.191 3.36 2.98.54.476.502-.514c.031-.033.482-.481 1.074-1.06.591-.577 1.356-1.318 2.12-2.063.764-.745 1.527-1.495 2.12-2.073.592-.58.98-.954 1.102-1.079L16.83 8.027z\" fill=\"#FFF\" fill-rule=\"nonzero\"/></g></svg>";
icons['alertes'] = "\n<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 18h-2v-2h2v2zm0-4h-2v-4h2v4zm-8.531 5H19.53L12 5.992 4.469 19zm0 2a2 2 0 0 1-1.731-3.002L10.269 4.99a2 2 0 0 1 3.462 0l7.531 13.008A2 2 0 0 1 19.532 21H4.468z\" fill=\"#FF642E\" fill-rule=\"nonzero\"/></svg>";

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconComponent = /** @class */ (function () {
    function IconComponent(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    /**
     * @return {?}
     */
    IconComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var svg = icons[this.icon];
        if (!svg && this.altText) {
            this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.altText);
            return;
        }
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', svg);
        if (this.iconWidth || this.iconSize) {
            this.renderer.setStyle(this.el.nativeElement, 'width', this.iconWidth || this.iconSize);
        }
        if (this.iconHeight || this.iconSize) {
            this.renderer.setStyle(this.el.nativeElement, 'height', this.iconHeight || this.iconSize);
        }
        /** @type {?} */
        var svgElement = this.el.nativeElement.children[0];
        this.renderer.setStyle(svgElement, 'width', '100%');
        this.renderer.setStyle(svgElement, 'height', '100%');
        this.renderer.setStyle(svgElement, 'position', 'relative');
    };
    IconComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-icon',
                    template: '',
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:inline-flex;align-self:center;color:inherit}"]
                }] }
    ];
    /** @nocollapse */
    IconComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    IconComponent.propDecorators = {
        icon: [{ type: Input }],
        altText: [{ type: Input }],
        iconWidth: [{ type: Input }],
        iconHeight: [{ type: Input }],
        iconSize: [{ type: Input }]
    };
    return IconComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var IconMetadata = {
    declarations: [IconComponent],
    imports: [CommonModule, FormsModule],
    exports: [IconComponent],
};
var IconModule = /** @class */ (function () {
    function IconModule() {
    }
    IconModule.decorators = [
        { type: NgModule, args: [IconMetadata,] }
    ];
    return IconModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputComponent = /** @class */ (function () {
    function InputComponent() {
        this.type = 'text';
        this.displayPassword = false;
    }
    Object.defineProperty(InputComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._disabled;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            setTimeout(function () {
                _this._disabled = value;
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    InputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.type === 'password') {
            this.displayPassword = true;
        }
    };
    /**
     * @param {?} changeRecord
     * @return {?}
     */
    InputComponent.prototype.ngOnChanges = /**
     * @param {?} changeRecord
     * @return {?}
     */
    function (changeRecord) {
        if (changeRecord.disabled) {
            this.inputElement.nativeElement.blur();
            if (changeRecord.disabled.currentValue) {
                this.focused = false;
            }
        }
    };
    /**
     * Determine the type of the password input on button click
     */
    /**
     * Determine the type of the password input on button click
     * @return {?}
     */
    InputComponent.prototype.showHidePassword = /**
     * Determine the type of the password input on button click
     * @return {?}
     */
    function () {
        if (this.type === 'password') {
            this.type = 'text';
        }
        else {
            this.type = 'password';
        }
    };
    InputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-input',
                    template: "<ng-container [formGroup]=\"group\">\n  <input\n    #input\n    class=\"input\"\n    [formControlName]=\"controlName\"\n    [type]=\"type\"\n    [name]=\"inputName\"\n    [placeholder]=\"placeholderName\"\n    (focus)=\"focused = true\"\n    (blur)=\"focused = false\"\n    [class.has-focus]=\"focused\"\n    [attr.disabled]=\"disabled ? 'disabled' : null\"\n  />\n\n  <img\n    *ngIf=\"displayPassword\"\n    src=\"/assets/login-page-icons/ic-chevron-right.svg\"\n    (click)=\"showHidePassword()\"\n    class=\"password-input-icon\"\n    role=\"button\"\n    alt=\"Afficher / masquer le mot de passe\"\n  />\n</ng-container>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{position:relative}::-ms-clear{display:none}::-ms-reveal{display:none}.input{padding-left:20px;padding-right:40px;width:100%;box-sizing:border-box;height:50px;border:1px solid rgba(15,17,18,.16);font-family:Poppins,sans-serif;font-size:1.4rem}.input:focus{border:1px solid #657478}.password-input-icon{width:30px;height:20px;position:absolute;top:0;right:10px}.password-input-icon:hover{cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    InputComponent.ctorParameters = function () { return []; };
    InputComponent.propDecorators = {
        inputElement: [{ type: ViewChild, args: ['input',] }],
        inputName: [{ type: Input }],
        type: [{ type: Input }],
        placeholderName: [{ type: Input }],
        controlName: [{ type: Input }],
        group: [{ type: Input }],
        focused: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return InputComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var InputMetadata = {
    declarations: [InputComponent],
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    exports: [InputComponent],
};
var InputModule = /** @class */ (function () {
    function InputModule() {
    }
    InputModule.decorators = [
        { type: NgModule, args: [InputMetadata,] }
    ];
    return InputModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapComponent = /** @class */ (function () {
    function MapComponent(httpClient, renderer) {
        this.httpClient = httpClient;
        this.renderer = renderer;
        this.mode = 'map';
        this.isInteractive = true;
        this.labelMap = false;
        this._market = 'family';
        this._isEvol = false;
        this.valueComparison = 'comparePublication'; // 2.0 routes use only comparePublication
        // 2.0 routes use only comparePublication
        this.warehouseChange = new EventEmitter();
        this.displayCode = 1;
    }
    Object.defineProperty(MapComponent.prototype, "market", {
        get: /**
         * @return {?}
         */
        function () {
            return this._market;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._market = value;
            if (this._valueType && (this._valueType === 'marketShare' || this._valueType === 'family')) {
                this._valueType = this.market === 'family' ? 'family' : 'marketShare';
                // Update Stat classes
                if (this.warehouseStats) {
                    this.setStatClasses(this.warehouseStats.warehouses);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "isEvol", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isEvol;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._isEvol = value;
            // Update Stat classes
            if (this.warehouseStats) {
                this.setStatClasses(this.warehouseStats.warehouses);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "warehousesInAlert", {
        get: /**
         * @return {?}
         */
        function () {
            return this._warehousesInAlert;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            // Deactivate previous warehouses in alert
            this.setAlertClasses(this._warehousesInAlert, false);
            // Activate the new warehouses in alert
            this._warehousesInAlert = value;
            this.setAlertClasses(this._warehousesInAlert, true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "warehouseStats", {
        get: /**
         * @return {?}
         */
        function () {
            return this._warehouseStats;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._warehouseStats = value;
            this.displayCode = value.displayCode.warehouses;
            this.setStatClasses(this._warehouseStats.warehouses);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "selectedWarehouse", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selectedWarehouse;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._selectedWarehouse = value;
            this.selectElement(document.getElementById(this.selectedWarehouse));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "valueType", {
        get: /**
         * @return {?}
         */
        function () {
            return this._valueType;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value === 'marketShare') {
                value = this.market === 'family' ? 'family' : 'marketShare';
            }
            this._valueType = value;
            // Update Stat classes
            if (this.warehouseStats) {
                this.setStatClasses(this.warehouseStats.warehouses);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MapComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var mapSvg, svgElt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.mapUrl) {
                            alert('MapComponent : paramètre "mapUrl" manquant.');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.httpClient.get(this.mapUrl, { responseType: 'text', withCredentials: true }).toPromise()];
                    case 1:
                        mapSvg = _a.sent();
                        this.renderer.setProperty(this.map.nativeElement, 'innerHTML', mapSvg);
                        svgElt = this.map.nativeElement.children[0];
                        this.renderer.setStyle(svgElt, 'width', '100%');
                        this.renderer.setStyle(svgElt, 'height', '100%');
                        if (this.selectedWarehouse) {
                            this.selectElement(document.getElementById(this.selectedWarehouse));
                        }
                        if (this.warehousesInAlert) {
                            this.setAlertClasses(this._warehousesInAlert, true);
                        }
                        if (this._warehouseStats) {
                            this.setStatClasses(this._warehouseStats.warehouses);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    MapComponent.prototype.onMapClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        if (!this.isInteractive) {
            return;
        }
        if (this.displayCode > 1) {
            return;
        }
        if (evt.target && (evt.target.tagName === 'polygon' || evt.target.tagName === 'path')) {
            this.selectElement(evt.target);
        }
    };
    /**
     * @param {?} elt
     * @return {?}
     */
    MapComponent.prototype.selectElement = /**
     * @param {?} elt
     * @return {?}
     */
    function (elt) {
        if (!elt) {
            this.deselectElement();
            return;
        }
        if (elt && elt !== this.clonedElt) {
            /** @type {?} */
            var warehouseId = elt.id;
            if (this.clonedElt && (this.clonedElt.parentElement || this.clonedElt.parentNode)) {
                this.renderer.removeChild(this.clonedElt.parentElement || this.clonedElt.parentNode, this.clonedElt);
            }
            this.clonedElt = elt.cloneNode(true);
            this.clonedElt.id = 'cloned_' + warehouseId;
            this.renderer.addClass(this.clonedElt, 'active');
            this.renderer.setAttribute(this.clonedElt, 'filter', 'url(#glow)');
            this.renderer.appendChild(elt.parentElement || elt.parentNode, this.clonedElt);
            this.warehouseChange.emit(warehouseId);
        }
    };
    /**
     * @return {?}
     */
    MapComponent.prototype.deselectElement = /**
     * @return {?}
     */
    function () {
        if (this.clonedElt && this.clonedElt.parentElement) {
            this.renderer.removeChild(this.clonedElt.parentElement, this.clonedElt);
            this.warehouseChange.emit(null);
        }
    };
    /**
     * @param {?} warehouses
     * @param {?} isInAlert
     * @return {?}
     */
    MapComponent.prototype.setAlertClasses = /**
     * @param {?} warehouses
     * @param {?} isInAlert
     * @return {?}
     */
    function (warehouses, isInAlert) {
        if (warehouses) {
            /** @type {?} */
            var elt = void 0;
            for (var i = 0, len = warehouses.length; i < len; i++) {
                elt = document.getElementById(warehouses[i]['warehouseId']);
                if (elt) {
                    if (isInAlert) {
                        this.renderer.addClass(elt, 'alert');
                    }
                    else {
                        this.renderer.removeClass(elt, 'alert');
                    }
                }
            }
        }
    };
    /**
     * @param {?} warehouses
     * @return {?}
     */
    MapComponent.prototype.setStatClasses = /**
     * @param {?} warehouses
     * @return {?}
     */
    function (warehouses) {
        if (warehouses && this.valueType && this.valueComparison) {
            /** @type {?} */
            var elt = void 0;
            /** @type {?} */
            var warehouse = void 0;
            /** @type {?} */
            var warehouseId = void 0;
            /** @type {?} */
            var cssClass = void 0;
            for (var i = 0, len = warehouses.length; i < len; i++) {
                warehouse = warehouses[i];
                warehouseId = warehouse.warehouse.id;
                elt = document.getElementById(warehouseId);
                if (!elt) {
                    console.warn('setStatClasses: Map ID not found:', warehouseId);
                }
                else {
                    // Remove previous stat classes
                    this.renderer.removeClass(elt, 'color1');
                    this.renderer.removeClass(elt, 'color2');
                    this.renderer.removeClass(elt, 'color3');
                    this.renderer.removeClass(elt, 'color4');
                    // Set the correct class according to the value
                    cssClass = this.getCssClass(warehouse, this.isEvol, this.valueType, this.valueComparison);
                    this.renderer.addClass(elt, cssClass);
                }
            }
        }
    };
    /**
     * @private
     * @param {?} warehouse
     * @param {?} isEvol
     * @param {?} valueType
     * @param {?} valueComp
     * @return {?}
     */
    MapComponent.prototype.getCssClass = /**
     * @private
     * @param {?} warehouse
     * @param {?} isEvol
     * @param {?} valueType
     * @param {?} valueComp
     * @return {?}
     */
    function (warehouse, isEvol, valueType, valueComp) {
        /** @type {?} */
        var cssClass;
        /** @type {?} */
        var comparedValue = warehouse[this.valueType][this.valueComparison].value;
        /** @type {?} */
        var currentValue = warehouse[this.valueType]['currentPublication'].value;
        if (this.displayCode > 1) {
            return 'gold';
        }
        if (!isEvol) {
            if (currentValue <= this.currentPublicationsQuartile.first) {
                cssClass = 'color1';
            }
            else if (currentValue <= this.currentPublicationsQuartile.mediane) {
                cssClass = 'color2';
            }
            else if (currentValue <= this.currentPublicationsQuartile.third) {
                cssClass = 'color3';
            }
            else {
                cssClass = 'color4';
            }
        }
        else {
            // Evolution
            /** @type {?} */
            var diff = currentValue - comparedValue;
            if (diff < 0) {
                // => Less performant
                cssClass = 'color1';
            }
            else if (diff > 0) {
                // => More performant
                cssClass = 'color3';
            }
            else {
                cssClass = 'color2';
            }
        }
        return cssClass;
    };
    MapComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-map',
                    template: "<div class=\"position-relative\">\n  <div class=\"lib-map-wrapper {{ mode }}\" [class.evol]=\"isEvol\" #map (click)=\"onMapClicked($event)\"></div>\n  <lib-button-gold\n    [subscription]=\"displayCode\"\n    [center]=\"true\"\n    type=\"button\"\n    [goldUrl]=\"goldUrl\"\n    [accountUrl]=\"accountUrl\"\n    text=\"Taux de vente\"\n    *ngIf=\"displayCode > 1\"\n  >\n\n  </lib-button-gold>\n  <ng-container *ngIf=\"labelMap\">* Donn\u00E9es tous segments</ng-container>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);.lib-map-wrapper.minimap{margin:-10px -10px -24px}.lib-map-wrapper.minimap /deep/ path,.lib-map-wrapper.minimap /deep/ polygon{fill:#b7b7b7;stroke:#fff;stroke-width:2px;stroke-linejoin:round}.lib-map-wrapper.minimap /deep/ path.alert,.lib-map-wrapper.minimap /deep/ polygon.alert{fill:#ff642e}@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){.lib-map-wrapper.minimap /deep/ svg{height:220px!important}.lib-map-wrapper.map /deep/ svg{height:300px!important}}@media screen and (-ms-high-contrast:active) and (min-width:1140px),(-ms-high-contrast:none) and (min-width:1140px){.lib-map-wrapper.map /deep/ svg{height:500px!important}}.lib-map-wrapper.map /deep/ path,.lib-map-wrapper.map /deep/ polygon{transition:fill .3s;stroke:#fff;stroke-width:2px;stroke-linejoin:round;cursor:pointer}.lib-map-wrapper.map /deep/ path.color1,.lib-map-wrapper.map /deep/ polygon.color1{fill:#eaeced}.lib-map-wrapper.map /deep/ path.color2,.lib-map-wrapper.map /deep/ polygon.color2{fill:#a3a9bf}.lib-map-wrapper.map /deep/ path.color3,.lib-map-wrapper.map /deep/ polygon.color3{fill:#596280}.lib-map-wrapper.map /deep/ path.color4,.lib-map-wrapper.map /deep/ polygon.color4{fill:#232a40}.lib-map-wrapper.map /deep/ path.active,.lib-map-wrapper.map /deep/ polygon.active{fill:#2d54d2;transition:fill;cursor:default}.lib-map-wrapper.map /deep/ path:not(.active):hover,.lib-map-wrapper.map /deep/ polygon:not(.active):hover{fill:#8198e4;transition:fill}.lib-map-wrapper.map /deep/ path.gold,.lib-map-wrapper.map /deep/ path.gold:hover,.lib-map-wrapper.map /deep/ polygon.gold,.lib-map-wrapper.map /deep/ polygon.gold:hover{fill:#dedede}.lib-map-wrapper.map.evol /deep/ path.color1,.lib-map-wrapper.map.evol /deep/ polygon.color1{fill:#e8e4d8}.lib-map-wrapper.map.evol /deep/ path.color2,.lib-map-wrapper.map.evol /deep/ polygon.color2{fill:#bfb9a3}.lib-map-wrapper.map.evol /deep/ path.color3,.lib-map-wrapper.map.evol /deep/ polygon.color3{fill:#807759}.lib-map-wrapper.map.evol /deep/ path.active,.lib-map-wrapper.map.evol /deep/ polygon.active{fill:#ffec00}.lib-map-wrapper.map.evol /deep/ path:not(.active):hover,.lib-map-wrapper.map.evol /deep/ polygon:not(.active):hover{fill:#ccbd00}.lib-map-wrapper.map.evol /deep/ path.gold,.lib-map-wrapper.map.evol /deep/ path.gold:hover,.lib-map-wrapper.map.evol /deep/ polygon.gold,.lib-map-wrapper.map.evol /deep/ polygon.gold:hover{fill:#dedede}.position-relative{position:relative}"]
                }] }
    ];
    /** @nocollapse */
    MapComponent.ctorParameters = function () { return [
        { type: HttpClient },
        { type: Renderer2 }
    ]; };
    MapComponent.propDecorators = {
        map: [{ type: ViewChild, args: ['map',] }],
        mapUrl: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        mode: [{ type: Input }],
        isInteractive: [{ type: Input }],
        labelMap: [{ type: Input }],
        currentPublicationsQuartile: [{ type: Input }],
        market: [{ type: Input }],
        _isEvol: [{ type: Input }],
        isEvol: [{ type: Input }],
        warehousesInAlert: [{ type: Input }],
        warehouseStats: [{ type: Input }],
        selectedWarehouse: [{ type: Input }],
        valueType: [{ type: Input }],
        warehouseChange: [{ type: Output }]
    };
    return MapComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonGoldComponent = /** @class */ (function () {
    function ButtonGoldComponent(http) {
        this.http = http;
        this.subscription = 1;
        this.blur = false;
        this.center = false;
        this.column = false;
        this.click = new EventEmitter();
        this.message = '';
        this.phone = '';
        this.isLoading = false;
        this.showPhone = false;
    }
    /**
     * @return {?}
     */
    ButtonGoldComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    ButtonGoldComponent.prototype.handleButtonClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        return __awaiter(this, void 0, void 0, function () {
            var subscriptions, subscriptionLabel, accountManager;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        // stop propagation to prevent double call to event
                        evt.stopPropagation();
                        if (!this.goldUrl) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.http.get(this.goldUrl).toPromise()];
                    case 1:
                        subscriptions = _a.sent();
                        subscriptionLabel = this.subscription === 2 ? 'silver' : 'gold';
                        if (subscriptions && subscriptions[subscriptionLabel]) {
                            this.message = subscriptions[subscriptionLabel].popin_message;
                        }
                        _a.label = 2;
                    case 2:
                        if (!this.accountUrl) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.http.get(this.accountUrl).toPromise()];
                    case 3:
                        accountManager = _a.sent();
                        if (accountManager && accountManager.phoneNumber) {
                            this.phone = accountManager.phoneNumber;
                        }
                        _a.label = 4;
                    case 4:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} e
     * @return {?}
     */
    ButtonGoldComponent.prototype.displayPhone = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.showPhone = !this.showPhone;
    };
    ButtonGoldComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-button-gold',
                    template: "<div [ngClass]=\"{'blur': blur, 'centered': center}\">\n  <button\n    id=\"test\"\n    [type]=\"type\"\n    class=\"button\"\n    [ngClass]=\"{'button-gold': subscription > 1, 'button-silver': subscription === 2, 'column': column}\"\n    (click)=\"handleButtonClicked($event)\"\n    [ngbPopover]=\"popContent\"\n    autoClose=\"outside\"\n    container=\"body\"\n    placement=\"top\"\n  >\n    <span>Abo</span>\n    {{ text }}\n  </button>\n  <ng-template #popContent>\n    <h3><span>Abonnement</span><span class=\"badge-gold\" [ngClass]=\"{'silver': subscription === 2}\">{{ subscription === 2 ? 'Silver' : 'Gold' }}</span></h3>\n    <ng-container *ngIf=\"isLoading\">\n      <lib-loader displayMode=\"icon\" loaderSize=\"small\"></lib-loader>\n    </ng-container>\n    <p *ngIf=\"!isLoading\">{{ message }}</p>\n    <button *ngIf=\"!isLoading\" (click)=\"displayPhone($event)\">{{ showPhone ? phone : 'Contacter mon charg\u00E9 de compte' }}</button>\n  </ng-template>\n</div>\n",
                    encapsulation: ViewEncapsulation.None,
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.centered{position:absolute;right:0;left:0;bottom:0;top:0;padding:10px;z-index:99}.centered .button{position:relative;-webkit-transform:translateY(-50%);transform:translateY(-50%);top:50%}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:300px;word-wrap:break-word;background-clip:padding-box}.popover .popover-body{background-color:#fff;padding:20px;border-radius:4px;box-shadow:0 2px 10px 0 rgba(0,0,0,.2);position:relative;bottom:10px}.popover .popover-body h3{font-size:2rem;color:#0f1112;padding:0;text-align:left;border-radius:0;display:flex;align-items:center;font-family:\"Roboto Slab\",serif;margin:0 0 10px}.popover .popover-body h3 .badge-gold{margin-left:8px;padding:5px 10px;background-color:#efc138;color:#fff;border-radius:4px}.popover .popover-body h3 .badge-gold.silver{background-color:#a3a9bf}.popover .popover-body p{font-family:Poppins,sans-serif;font-size:1.6rem;color:#0f1112;padding:0;text-align:left;border-radius:0;margin-bottom:30px}.popover .popover-body button{display:block;width:100%;font-family:Poppins,sans-serif;font-size:1.2rem;color:#fff;padding:15px;background-color:#0f1112;text-decoration:none;box-sizing:border-box;border:none;cursor:pointer}.button{padding:8px 10px;border-radius:4px;border:1px solid rgba(15,17,18,.16);background-color:#fff;font-family:Poppins,sans-serif;color:#0f1112;font-size:1.2rem;font-weight:700;cursor:pointer;display:flex;align-items:center;margin:0 auto}.button.column{flex-direction:column;margin-right:auto}.button span{font-size:1rem;font-weight:700;line-height:1.2;font-family:\"Roboto Slab\",serif;padding:2px 5px;display:inline-block;margin-right:5px;border-radius:2px;color:#fff}.button.button-gold span{background-color:#efc138}.button.button-silver span{background-color:#a3a9bf}.button:hover.button-gold{border-color:#efc138;color:#efc138}.button:hover.button-silver{border-color:#a3a9bf;color:#a3a9bf}"]
                }] }
    ];
    /** @nocollapse */
    ButtonGoldComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    ButtonGoldComponent.propDecorators = {
        text: [{ type: Input }],
        type: [{ type: Input }],
        subscription: [{ type: Input }],
        blur: [{ type: Input }],
        center: [{ type: Input }],
        column: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        click: [{ type: Output }]
    };
    return ButtonGoldComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoaderComponent = /** @class */ (function () {
    function LoaderComponent() {
        this.loaderSize = 'medium';
        this.loaderText = 'Chargement ...';
        this.loaderIcon = 'waves';
        this.loaderTheme = 'dark';
        this.displayMode = 'icon';
    }
    /**
     * @return {?}
     */
    LoaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    LoaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-loader',
                    template: "<div class=\"lib-loader-wrapper size-{{ loaderSize }}\">\r\n    <div class=\"lib-loader-icon-wrapper\" *ngIf=\"displayMode === 'both' || displayMode === 'icon'\">\r\n        <img src=\"/assets/loaders/loader_{{ loaderIcon }}.svg\" alt=\"loader\" class=\"lib-loader-icon theme-{{ loaderTheme }}\">\r\n    </div>\r\n    <div class=\"lib-loader-text theme-{{ loaderTheme }}\" *ngIf=\"displayMode === 'both' || displayMode === 'text'\">\r\n        {{ loaderText }}\r\n    </div>\r\n</div>\r\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);:host{display:block;width:100%}.lib-loader-wrapper{display:flex;flex-direction:column;justify-content:center;height:100%;width:100%;align-items:center}.theme-light{-webkit-filter:invert(100%);filter:invert(100%)}.size-small{font-size:1.4rem}.size-small .lib-loader-icon{width:40px;height:40px}.size-medium{font-size:1.8rem}.size-medium .lib-loader-icon{width:40px;height:40px}.size-big{font-size:2rem}.size-big .lib-loader-icon{width:60px;height:60px}"]
                }] }
    ];
    /** @nocollapse */
    LoaderComponent.ctorParameters = function () { return []; };
    LoaderComponent.propDecorators = {
        loaderSize: [{ type: Input }],
        loaderText: [{ type: Input }],
        loaderIcon: [{ type: Input }],
        loaderTheme: [{ type: Input }],
        displayMode: [{ type: Input }]
    };
    return LoaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var LoaderMetadata = {
    declarations: [LoaderComponent],
    imports: [CommonModule],
    exports: [LoaderComponent],
};
var LoaderModule = /** @class */ (function () {
    function LoaderModule() {
    }
    LoaderModule.decorators = [
        { type: NgModule, args: [LoaderMetadata,] }
    ];
    return LoaderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ButtonGoldMetadata = {
    declarations: [ButtonGoldComponent],
    imports: [CommonModule, NgbPopoverModule, LoaderModule],
    exports: [ButtonGoldComponent],
};
var ButtonGoldModule = /** @class */ (function () {
    function ButtonGoldModule() {
    }
    ButtonGoldModule.decorators = [
        { type: NgModule, args: [ButtonGoldMetadata,] }
    ];
    return ButtonGoldModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MapMetadata = {
    declarations: [MapComponent],
    imports: [CommonModule, HttpClientModule, ButtonGoldModule],
    exports: [MapComponent],
};
var MapModule = /** @class */ (function () {
    function MapModule() {
    }
    MapModule.decorators = [
        { type: NgModule, args: [MapMetadata,] }
    ];
    return MapModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuDesktopComponent = /** @class */ (function () {
    function MenuDesktopComponent() {
        this.changePage = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MenuDesktopComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    MenuDesktopComponent.prototype.handleChangePage = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.changePage.emit(evt);
    };
    /**
     * @param {?} url
     * @return {?}
     */
    MenuDesktopComponent.prototype.isCurrentPage = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        if (this.currentPage === 'temps-reel' && url === 'ventes-scannées') {
            return true;
        }
        return url === this.currentPage;
    };
    MenuDesktopComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-menu-desktop',
                    template: "<div class=\"menu-container\">\n  <div\n    *ngFor=\"let link of menu\"\n    class=\"link\"\n    [ngClass]=\"{ active: isCurrentPage(link.url) }\"\n    (click)=\"handleChangePage(link.url)\"\n  >\n    <div>\n      {{ link.label }}\n    </div>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.menu-container{background-color:#fff;width:100%;height:56px;z-index:10100;display:flex;align-items:center;margin-left:-26px}.menu-container:before{content:'';height:1px;background-color:rgba(15,17,18,.08);position:fixed;left:0;width:100%;top:64px;z-index:10101}.link{color:#657478;font-size:1.6rem;font-weight:500;text-decoration:none;height:100%;position:relative;display:flex;align-items:center;padding:0 26px}.link:after{content:'';height:4px;background-color:#0f1112;position:absolute;bottom:0;left:26px;right:26px;opacity:0}.link:hover{cursor:pointer}.link:hover:after{opacity:.1}.link.active{color:#0f1112;position:relative}.link.active:after{opacity:1}"]
                }] }
    ];
    /** @nocollapse */
    MenuDesktopComponent.ctorParameters = function () { return []; };
    MenuDesktopComponent.propDecorators = {
        currentPage: [{ type: Input }],
        menu: [{ type: Input }],
        changePage: [{ type: Output }]
    };
    return MenuDesktopComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MenuDesktopMetadata = {
    declarations: [MenuDesktopComponent],
    imports: [CommonModule],
    exports: [MenuDesktopComponent],
};
var MenuDesktopModule = /** @class */ (function () {
    function MenuDesktopModule() {
    }
    MenuDesktopModule.decorators = [
        { type: NgModule, args: [MenuDesktopMetadata,] }
    ];
    return MenuDesktopModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuMobileComponent = /** @class */ (function () {
    function MenuMobileComponent() {
        this.logout = new EventEmitter();
        this.changePage = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MenuMobileComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} evt
     * @return {?}
     */
    MenuMobileComponent.prototype.handleLogout = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.logout.emit(evt);
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    MenuMobileComponent.prototype.handleChangePage = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.changePage.emit(evt);
    };
    /**
     * @param {?} url
     * @return {?}
     */
    MenuMobileComponent.prototype.isCurrentPage = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return url === this.currentPage;
    };
    MenuMobileComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-menu-mobile',
                    template: "<div class=\"menu-container\">\n  <div\n    *ngFor=\"let link of menu\"\n    [ngClass]=\"{ 'menu-item': true, link: true, active: isCurrentPage(link.url) }\"\n    (click)=\"handleChangePage(link.url)\"\n  >\n    {{ link.label }}\n    <!-- <div class=\"divider\" [ngClass]=\"{ active: isCurrentPage(link.url) }\"></div> -->\n  </div>\n  <div class=\"menu-item deconnection-tab\" (click)=\"handleLogout($event)\">\n    <img src=\"/assets/icons/logout.svg\" />D\u00E9connexion\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.menu-container{position:fixed;background-color:#fff;width:100%;left:0;top:94px;z-index:10100;border:1px solid rgba(15,17,18,.08)}.deconnection-tab{color:#657478;font-size:1.6rem;font-weight:500;display:flex;align-items:center}.deconnection-tab:active{color:#0f1112}.menu-container img{padding-right:13px}.menu-item{line-height:56px;position:relative;color:#657478;font-size:1.6rem;font-weight:500;text-decoration:none;padding-left:24px}.menu-item:hover{cursor:pointer;background-color:rgba(15,17,18,.08)}.menu-item.active{color:#0f1112}.menu-item:after{content:'';position:absolute;bottom:0;left:24px;right:0;height:1px;background-color:rgba(15,17,18,.08)}.menu-item.active:after{height:2px;background-color:#0f1112}"]
                }] }
    ];
    /** @nocollapse */
    MenuMobileComponent.ctorParameters = function () { return []; };
    MenuMobileComponent.propDecorators = {
        currentPage: [{ type: Input }],
        menu: [{ type: Input }],
        logout: [{ type: Output }],
        changePage: [{ type: Output }]
    };
    return MenuMobileComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MenuMobileMetadata = {
    declarations: [MenuMobileComponent],
    imports: [CommonModule],
    exports: [MenuMobileComponent],
};
var MenuMobileModule = /** @class */ (function () {
    function MenuMobileModule() {
    }
    MenuMobileModule.decorators = [
        { type: NgModule, args: [MenuMobileMetadata,] }
    ];
    return MenuMobileModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavSwitchComponent = /** @class */ (function () {
    function NavSwitchComponent() {
        this.tabSelected = new EventEmitter();
    }
    /**
     * @return {?}
     */
    NavSwitchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} tabIndex
     * @return {?}
     */
    NavSwitchComponent.prototype.onSelectTab = /**
     * @param {?} tabIndex
     * @return {?}
     */
    function (tabIndex) {
        var _this = this;
        this.tabs.forEach(function (tab, index) {
            if (tabIndex === index) {
                _this.tabs[index].isActive = true;
                _this.tabSelected.emit(_this.tabs[index].value);
            }
            else {
                _this.tabs[index].isActive = false;
            }
        });
    };
    NavSwitchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-nav-switch',
                    template: "<div class=\"nav-tabs\">\n  <ng-container *ngFor=\"let tab of tabs; let i = index\">\n    <div class=\"nav-tabs-tab\" [ngClass]=\"[background, tab.isActive ? 'active' : '']\" (click)=\"onSelectTab(i)\">\n      {{ tab.label }}\n      <div [class]=\"tab.iconArrow\"></div>\n    </div>\n  </ng-container>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.nav-tabs{display:flex;color:#0f1112;height:40px;align-content:center}.nav-tabs .nav-tabs-tab{font-size:1.4rem;font-weight:600;color:#657478;flex-grow:1;text-align:center;padding:8px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:14px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.nav-tabs .nav-tabs-tab{font-size:1.6rem}}.nav-tabs .nav-tabs-tab.active{color:#0f1112;border-radius:24px}.nav-tabs .nav-tabs-tab.active.slategray{background:rgba(122,140,145,.16)}.nav-tabs .nav-tabs-tab.active.yellow{background:#ffec00}.nav-tabs .nav-tabs-tab.active.alabster{background:#f7f7f7}.nav-tabs .up{width:0;height:0;border-style:solid;border-width:0 7px 9px;border-color:transparent transparent #0f1112;margin-left:4px}.nav-tabs .down{width:0;height:0;border-style:solid;border-width:9px 7px 0;border-color:#0f1112 transparent transparent;margin-left:4px}"]
                }] }
    ];
    /** @nocollapse */
    NavSwitchComponent.ctorParameters = function () { return []; };
    NavSwitchComponent.propDecorators = {
        tabs: [{ type: Input }],
        background: [{ type: Input }],
        tabSelected: [{ type: Output }]
    };
    return NavSwitchComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var NavSwitchMetadata = {
    declarations: [NavSwitchComponent],
    imports: [CommonModule],
    exports: [NavSwitchComponent],
};
var NavSwitchModule = /** @class */ (function () {
    function NavSwitchModule() {
    }
    NavSwitchModule.decorators = [
        { type: NgModule, args: [NavSwitchMetadata,] }
    ];
    return NavSwitchModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PercentageCircleComponent = /** @class */ (function () {
    function PercentageCircleComponent() {
        this.percentage = 0;
        this.size = 32;
    }
    Object.defineProperty(PercentageCircleComponent.prototype, "percentageClass", {
        get: /**
         * @return {?}
         */
        function () {
            return "p" + Math.floor(this.percentage);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PercentageCircleComponent.prototype, "circleSize", {
        get: /**
         * @return {?}
         */
        function () {
            return this.size + "px";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PercentageCircleComponent.prototype, "circleColor", {
        get: /**
         * @return {?}
         */
        function () {
            return this.color ? this.color : 'blue';
        },
        enumerable: true,
        configurable: true
    });
    PercentageCircleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-percentage-circle',
                    template: "<div class=\"container\" [ngClass]=\"[percentageClass, circleColor]\" [ngStyle]=\"{ 'font-size': circleSize }\">\n  <div class=\"slice\">\n    <div class=\"bar\"></div>\n    <div class=\"fill\"></div>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.container.p100 .slice,.container.p51 .slice,.container.p52 .slice,.container.p53 .slice,.container.p54 .slice,.container.p55 .slice,.container.p56 .slice,.container.p57 .slice,.container.p58 .slice,.container.p59 .slice,.container.p60 .slice,.container.p61 .slice,.container.p62 .slice,.container.p63 .slice,.container.p64 .slice,.container.p65 .slice,.container.p66 .slice,.container.p67 .slice,.container.p68 .slice,.container.p69 .slice,.container.p70 .slice,.container.p71 .slice,.container.p72 .slice,.container.p73 .slice,.container.p74 .slice,.container.p75 .slice,.container.p76 .slice,.container.p77 .slice,.container.p78 .slice,.container.p79 .slice,.container.p80 .slice,.container.p81 .slice,.container.p82 .slice,.container.p83 .slice,.container.p84 .slice,.container.p85 .slice,.container.p86 .slice,.container.p87 .slice,.container.p88 .slice,.container.p89 .slice,.container.p90 .slice,.container.p91 .slice,.container.p92 .slice,.container.p93 .slice,.container.p94 .slice,.container.p95 .slice,.container.p96 .slice,.container.p97 .slice,.container.p98 .slice,.container.p99 .slice,.rect-auto{clip:rect(auto,auto,auto,auto)}.container .bar,.container.p100 .fill,.container.p51 .fill,.container.p52 .fill,.container.p53 .fill,.container.p54 .fill,.container.p55 .fill,.container.p56 .fill,.container.p57 .fill,.container.p58 .fill,.container.p59 .fill,.container.p60 .fill,.container.p61 .fill,.container.p62 .fill,.container.p63 .fill,.container.p64 .fill,.container.p65 .fill,.container.p66 .fill,.container.p67 .fill,.container.p68 .fill,.container.p69 .fill,.container.p70 .fill,.container.p71 .fill,.container.p72 .fill,.container.p73 .fill,.container.p74 .fill,.container.p75 .fill,.container.p76 .fill,.container.p77 .fill,.container.p78 .fill,.container.p79 .fill,.container.p80 .fill,.container.p81 .fill,.container.p82 .fill,.container.p83 .fill,.container.p84 .fill,.container.p85 .fill,.container.p86 .fill,.container.p87 .fill,.container.p88 .fill,.container.p89 .fill,.container.p90 .fill,.container.p91 .fill,.container.p92 .fill,.container.p93 .fill,.container.p94 .fill,.container.p95 .fill,.container.p96 .fill,.container.p97 .fill,.container.p98 .fill,.container.p99 .fill,.pie{position:absolute;border:.12em solid #2357ff;width:.76em;height:.76em;clip:rect(0,.5em,1em,0);border-radius:50%;-webkit-transform:rotate(0);transform:rotate(0)}.container.p100 .bar:after,.container.p100 .fill,.container.p51 .bar:after,.container.p51 .fill,.container.p52 .bar:after,.container.p52 .fill,.container.p53 .bar:after,.container.p53 .fill,.container.p54 .bar:after,.container.p54 .fill,.container.p55 .bar:after,.container.p55 .fill,.container.p56 .bar:after,.container.p56 .fill,.container.p57 .bar:after,.container.p57 .fill,.container.p58 .bar:after,.container.p58 .fill,.container.p59 .bar:after,.container.p59 .fill,.container.p60 .bar:after,.container.p60 .fill,.container.p61 .bar:after,.container.p61 .fill,.container.p62 .bar:after,.container.p62 .fill,.container.p63 .bar:after,.container.p63 .fill,.container.p64 .bar:after,.container.p64 .fill,.container.p65 .bar:after,.container.p65 .fill,.container.p66 .bar:after,.container.p66 .fill,.container.p67 .bar:after,.container.p67 .fill,.container.p68 .bar:after,.container.p68 .fill,.container.p69 .bar:after,.container.p69 .fill,.container.p70 .bar:after,.container.p70 .fill,.container.p71 .bar:after,.container.p71 .fill,.container.p72 .bar:after,.container.p72 .fill,.container.p73 .bar:after,.container.p73 .fill,.container.p74 .bar:after,.container.p74 .fill,.container.p75 .bar:after,.container.p75 .fill,.container.p76 .bar:after,.container.p76 .fill,.container.p77 .bar:after,.container.p77 .fill,.container.p78 .bar:after,.container.p78 .fill,.container.p79 .bar:after,.container.p79 .fill,.container.p80 .bar:after,.container.p80 .fill,.container.p81 .bar:after,.container.p81 .fill,.container.p82 .bar:after,.container.p82 .fill,.container.p83 .bar:after,.container.p83 .fill,.container.p84 .bar:after,.container.p84 .fill,.container.p85 .bar:after,.container.p85 .fill,.container.p86 .bar:after,.container.p86 .fill,.container.p87 .bar:after,.container.p87 .fill,.container.p88 .bar:after,.container.p88 .fill,.container.p89 .bar:after,.container.p89 .fill,.container.p90 .bar:after,.container.p90 .fill,.container.p91 .bar:after,.container.p91 .fill,.container.p92 .bar:after,.container.p92 .fill,.container.p93 .bar:after,.container.p93 .fill,.container.p94 .bar:after,.container.p94 .fill,.container.p95 .bar:after,.container.p95 .fill,.container.p96 .bar:after,.container.p96 .fill,.container.p97 .bar:after,.container.p97 .fill,.container.p98 .bar:after,.container.p98 .fill,.container.p99 .bar:after,.container.p99 .fill,.pie-fill{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.container{position:relative;font-size:120px;width:1em;height:1em;border-radius:50%}.container *,.container :after,.container :before{box-sizing:content-box}.container::before{position:absolute;top:0;left:0;opacity:.8;display:block;content:' ';padding:0;margin:0;border-radius:50%;border:.12em solid #666;background-color:transparent;width:.76em;height:.76em}.container.circle-light-gray::before{border:.12em solid rgba(151,151,151,.3)}.container .slice{position:absolute;width:1em;height:1em;clip:rect(0,1em,1em,.5em)}.container.p1 .bar{-webkit-transform:rotate(3.6deg);transform:rotate(3.6deg)}.container.p2 .bar{-webkit-transform:rotate(7.2deg);transform:rotate(7.2deg)}.container.p3 .bar{-webkit-transform:rotate(10.8deg);transform:rotate(10.8deg)}.container.p4 .bar{-webkit-transform:rotate(14.4deg);transform:rotate(14.4deg)}.container.p5 .bar{-webkit-transform:rotate(18deg);transform:rotate(18deg)}.container.p6 .bar{-webkit-transform:rotate(21.6deg);transform:rotate(21.6deg)}.container.p7 .bar{-webkit-transform:rotate(25.2deg);transform:rotate(25.2deg)}.container.p8 .bar{-webkit-transform:rotate(28.8deg);transform:rotate(28.8deg)}.container.p9 .bar{-webkit-transform:rotate(32.4deg);transform:rotate(32.4deg)}.container.p10 .bar{-webkit-transform:rotate(36deg);transform:rotate(36deg)}.container.p11 .bar{-webkit-transform:rotate(39.6deg);transform:rotate(39.6deg)}.container.p12 .bar{-webkit-transform:rotate(43.2deg);transform:rotate(43.2deg)}.container.p13 .bar{-webkit-transform:rotate(46.8deg);transform:rotate(46.8deg)}.container.p14 .bar{-webkit-transform:rotate(50.4deg);transform:rotate(50.4deg)}.container.p15 .bar{-webkit-transform:rotate(54deg);transform:rotate(54deg)}.container.p16 .bar{-webkit-transform:rotate(57.6deg);transform:rotate(57.6deg)}.container.p17 .bar{-webkit-transform:rotate(61.2deg);transform:rotate(61.2deg)}.container.p18 .bar{-webkit-transform:rotate(64.8deg);transform:rotate(64.8deg)}.container.p19 .bar{-webkit-transform:rotate(68.4deg);transform:rotate(68.4deg)}.container.p20 .bar{-webkit-transform:rotate(72deg);transform:rotate(72deg)}.container.p21 .bar{-webkit-transform:rotate(75.6deg);transform:rotate(75.6deg)}.container.p22 .bar{-webkit-transform:rotate(79.2deg);transform:rotate(79.2deg)}.container.p23 .bar{-webkit-transform:rotate(82.8deg);transform:rotate(82.8deg)}.container.p24 .bar{-webkit-transform:rotate(86.4deg);transform:rotate(86.4deg)}.container.p25 .bar{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.container.p26 .bar{-webkit-transform:rotate(93.6deg);transform:rotate(93.6deg)}.container.p27 .bar{-webkit-transform:rotate(97.2deg);transform:rotate(97.2deg)}.container.p28 .bar{-webkit-transform:rotate(100.8deg);transform:rotate(100.8deg)}.container.p29 .bar{-webkit-transform:rotate(104.4deg);transform:rotate(104.4deg)}.container.p30 .bar{-webkit-transform:rotate(108deg);transform:rotate(108deg)}.container.p31 .bar{-webkit-transform:rotate(111.6deg);transform:rotate(111.6deg)}.container.p32 .bar{-webkit-transform:rotate(115.2deg);transform:rotate(115.2deg)}.container.p33 .bar{-webkit-transform:rotate(118.8deg);transform:rotate(118.8deg)}.container.p34 .bar{-webkit-transform:rotate(122.4deg);transform:rotate(122.4deg)}.container.p35 .bar{-webkit-transform:rotate(126deg);transform:rotate(126deg)}.container.p36 .bar{-webkit-transform:rotate(129.6deg);transform:rotate(129.6deg)}.container.p37 .bar{-webkit-transform:rotate(133.2deg);transform:rotate(133.2deg)}.container.p38 .bar{-webkit-transform:rotate(136.8deg);transform:rotate(136.8deg)}.container.p39 .bar{-webkit-transform:rotate(140.4deg);transform:rotate(140.4deg)}.container.p40 .bar{-webkit-transform:rotate(144deg);transform:rotate(144deg)}.container.p41 .bar{-webkit-transform:rotate(147.6deg);transform:rotate(147.6deg)}.container.p42 .bar{-webkit-transform:rotate(151.2deg);transform:rotate(151.2deg)}.container.p43 .bar{-webkit-transform:rotate(154.8deg);transform:rotate(154.8deg)}.container.p44 .bar{-webkit-transform:rotate(158.4deg);transform:rotate(158.4deg)}.container.p45 .bar{-webkit-transform:rotate(162deg);transform:rotate(162deg)}.container.p46 .bar{-webkit-transform:rotate(165.6deg);transform:rotate(165.6deg)}.container.p47 .bar{-webkit-transform:rotate(169.2deg);transform:rotate(169.2deg)}.container.p48 .bar{-webkit-transform:rotate(172.8deg);transform:rotate(172.8deg)}.container.p49 .bar{-webkit-transform:rotate(176.4deg);transform:rotate(176.4deg)}.container.p50 .bar{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.container.p51 .bar{-webkit-transform:rotate(183.6deg);transform:rotate(183.6deg)}.container.p52 .bar{-webkit-transform:rotate(187.2deg);transform:rotate(187.2deg)}.container.p53 .bar{-webkit-transform:rotate(190.8deg);transform:rotate(190.8deg)}.container.p54 .bar{-webkit-transform:rotate(194.4deg);transform:rotate(194.4deg)}.container.p55 .bar{-webkit-transform:rotate(198deg);transform:rotate(198deg)}.container.p56 .bar{-webkit-transform:rotate(201.6deg);transform:rotate(201.6deg)}.container.p57 .bar{-webkit-transform:rotate(205.2deg);transform:rotate(205.2deg)}.container.p58 .bar{-webkit-transform:rotate(208.8deg);transform:rotate(208.8deg)}.container.p59 .bar{-webkit-transform:rotate(212.4deg);transform:rotate(212.4deg)}.container.p60 .bar{-webkit-transform:rotate(216deg);transform:rotate(216deg)}.container.p61 .bar{-webkit-transform:rotate(219.6deg);transform:rotate(219.6deg)}.container.p62 .bar{-webkit-transform:rotate(223.2deg);transform:rotate(223.2deg)}.container.p63 .bar{-webkit-transform:rotate(226.8deg);transform:rotate(226.8deg)}.container.p64 .bar{-webkit-transform:rotate(230.4deg);transform:rotate(230.4deg)}.container.p65 .bar{-webkit-transform:rotate(234deg);transform:rotate(234deg)}.container.p66 .bar{-webkit-transform:rotate(237.6deg);transform:rotate(237.6deg)}.container.p67 .bar{-webkit-transform:rotate(241.2deg);transform:rotate(241.2deg)}.container.p68 .bar{-webkit-transform:rotate(244.8deg);transform:rotate(244.8deg)}.container.p69 .bar{-webkit-transform:rotate(248.4deg);transform:rotate(248.4deg)}.container.p70 .bar{-webkit-transform:rotate(252deg);transform:rotate(252deg)}.container.p71 .bar{-webkit-transform:rotate(255.6deg);transform:rotate(255.6deg)}.container.p72 .bar{-webkit-transform:rotate(259.2deg);transform:rotate(259.2deg)}.container.p73 .bar{-webkit-transform:rotate(262.8deg);transform:rotate(262.8deg)}.container.p74 .bar{-webkit-transform:rotate(266.4deg);transform:rotate(266.4deg)}.container.p75 .bar{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.container.p76 .bar{-webkit-transform:rotate(273.6deg);transform:rotate(273.6deg)}.container.p77 .bar{-webkit-transform:rotate(277.2deg);transform:rotate(277.2deg)}.container.p78 .bar{-webkit-transform:rotate(280.8deg);transform:rotate(280.8deg)}.container.p79 .bar{-webkit-transform:rotate(284.4deg);transform:rotate(284.4deg)}.container.p80 .bar{-webkit-transform:rotate(288deg);transform:rotate(288deg)}.container.p81 .bar{-webkit-transform:rotate(291.6deg);transform:rotate(291.6deg)}.container.p82 .bar{-webkit-transform:rotate(295.2deg);transform:rotate(295.2deg)}.container.p83 .bar{-webkit-transform:rotate(298.8deg);transform:rotate(298.8deg)}.container.p84 .bar{-webkit-transform:rotate(302.4deg);transform:rotate(302.4deg)}.container.p85 .bar{-webkit-transform:rotate(306deg);transform:rotate(306deg)}.container.p86 .bar{-webkit-transform:rotate(309.6deg);transform:rotate(309.6deg)}.container.p87 .bar{-webkit-transform:rotate(313.2deg);transform:rotate(313.2deg)}.container.p88 .bar{-webkit-transform:rotate(316.8deg);transform:rotate(316.8deg)}.container.p89 .bar{-webkit-transform:rotate(320.4deg);transform:rotate(320.4deg)}.container.p90 .bar{-webkit-transform:rotate(324deg);transform:rotate(324deg)}.container.p91 .bar{-webkit-transform:rotate(327.6deg);transform:rotate(327.6deg)}.container.p92 .bar{-webkit-transform:rotate(331.2deg);transform:rotate(331.2deg)}.container.p93 .bar{-webkit-transform:rotate(334.8deg);transform:rotate(334.8deg)}.container.p94 .bar{-webkit-transform:rotate(338.4deg);transform:rotate(338.4deg)}.container.p95 .bar{-webkit-transform:rotate(342deg);transform:rotate(342deg)}.container.p96 .bar{-webkit-transform:rotate(345.6deg);transform:rotate(345.6deg)}.container.p97 .bar{-webkit-transform:rotate(349.2deg);transform:rotate(349.2deg)}.container.p98 .bar{-webkit-transform:rotate(352.8deg);transform:rotate(352.8deg)}.container.p99 .bar{-webkit-transform:rotate(356.4deg);transform:rotate(356.4deg)}.container.p100 .bar{-webkit-transform:rotate(360deg);transform:rotate(360deg)}.container.blue .bar,.container.blue .fill{border-color:#2357ff!important}.container.blue-stats::before{border:.12em solid rgba(151,151,151,.3)}.container.blue-stats .bar,.container.blue-stats .fill{border-color:#2357ff!important}.container.yellow::before{border:.12em solid #d8d8d8}.container.yellow .bar,.container.yellow .fill{border-color:#ffec00!important}.container.green::before{border:.12em solid #eaeaea}.container.green .bar,.container.green .fill{border-color:#11c75c!important}.container.orange::before{border:.12em solid #eaeaea}.container.orange .bar,.container.orange .fill{border-color:#ff642e!important}.container.black::before{border:.12em solid #eaeaea}.container.black .bar,.container.black .fill{border-color:#0f1112!important}"]
                }] }
    ];
    PercentageCircleComponent.propDecorators = {
        percentage: [{ type: Input }],
        color: [{ type: Input }],
        size: [{ type: Input }]
    };
    return PercentageCircleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PercentageCircleMetadata = {
    declarations: [PercentageCircleComponent],
    imports: [CommonModule],
    exports: [PercentageCircleComponent],
};
var PercentageCircleModule = /** @class */ (function () {
    function PercentageCircleModule() {
    }
    PercentageCircleModule.decorators = [
        { type: NgModule, args: [PercentageCircleMetadata,] }
    ];
    return PercentageCircleModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectComponent = /** @class */ (function () {
    function SelectComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this.clearable = false;
        this.searchable = false;
        this.binding = false;
        this.change = new EventEmitter();
        this.modelChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.checkIcon = this.sanitizer.bypassSecurityTrustHtml(icons['check']);
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    SelectComponent.prototype.onChange = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.change.emit(evt);
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    SelectComponent.prototype.onModelChange = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.modelChange.emit(evt);
    };
    SelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-select',
                    template: "<ng-container *ngIf=\"group\" [formGroup]=\"group\" (change)=\"onChange($event)\">\n  <ng-select\n    [items]=\"options\"\n    [ngClass]=\"className\"\n    [placeholder]=\"placeholder\"\n    [searchable]=\"searchable\"\n    [notFoundText]=\"notFoundText\"\n    [searchFn]=\"searchFn\"\n    [clearable]=\"clearable\"\n    clearAllText=\"R\u00E9initialiser\"\n    [disabled]=\"disabled\"\n    [formControlName]=\"controlName\"\n    (change)=\"onChange($event)\"\n  >\n    <ng-template ng-label-tmp let-item=\"item\">\n      <span>{{ item.label }}</span>\n    </ng-template>\n    <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"searchTerm\">\n      <span [ngOptionHighlight]=\"search\">{{ item.label }}</span>\n      <!-- <lib-icon class=\"icon\" icon=\"check\"></lib-icon> -->\n      <span class=\"icon\" [innerHTML]=\"checkIcon\"></span>\n    </ng-template>\n  </ng-select>\n  <ng-template ng-notfound-tmp let-searchTerm=\"searchTerm\">\n    <span class=\"ng-option disabled\">Aucun r\u00E9sultat pour \"{{ searchTerm }}\"</span>\n  </ng-template>\n</ng-container>\n\n<ng-container *ngIf=\"!group\">\n  <ng-select\n    [items]=\"options\"\n    [placeholder]=\"placeholder\"\n    [ngClass]=\"className\"\n    [notFoundText]=\"notFoundText\"\n    [searchable]=\"searchable\"\n    [searchFn]=\"searchFn\"\n    [clearable]=\"clearable\"\n    clearAllText=\"R\u00E9initialiser\"\n    [disabled]=\"disabled\"\n    [(ngModel)]=\"model\"\n    [bindValue]=\"binding ? 'value' : ''\"\n    (ngModelChange)=\"onModelChange($event)\"\n    (change)=\"onChange($event)\"\n  >\n    <ng-template ng-label-tmp let-item=\"item\">\n      <span [ngClass]=\"className\">{{ item.label }}</span>\n    </ng-template>\n    <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"searchTerm\">\n      <span [ngOptionHighlight]=\"search\">{{ item.label }}</span>\n      <!-- <lib-icon class=\"icon\" icon=\"check\"></lib-icon> -->\n      <span class=\"icon\" [innerHTML]=\"checkIcon\"></span>\n    </ng-template>\n    <ng-template ng-notfound-tmp let-searchTerm=\"searchTerm\">\n      <span class=\"ng-option disabled\">Aucun r\u00E9sultat pour \"{{ searchTerm }}\"</span>\n    </ng-template>\n  </ng-select>\n</ng-container>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}/deep/ .ng-select.ng-select-opened>.ng-select-container{background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}/deep/ .ng-select.ng-select-opened>.ng-select-container:hover{box-shadow:none}/deep/ .ng-select.ng-select-opened>.ng-select-container .ng-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}/deep/ .ng-select.ng-select-opened>.ng-select-container .ng-arrow:hover{border-color:transparent transparent #333}/deep/ .ng-select.ng-select-opened.ng-select-bottom>.ng-select-container{border-bottom-right-radius:0;border-bottom-left-radius:0}/deep/ .ng-select.ng-select-opened.ng-select-top>.ng-select-container{border-top-right-radius:0;border-top-left-radius:0}/deep/ .ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}/deep/ .ng-select.ng-select-disabled>.ng-select-container{background-color:#f9f9f9}/deep/ .ng-select .ng-has-value .ng-placeholder{display:none}/deep/ .ng-select .ng-select-container{background-color:#fff;border-radius:4px;border:1px solid #ccc;min-height:36px;align-items:center}/deep/ .ng-select .ng-select-container:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}/deep/ .ng-select .ng-select-container .ng-value-container{align-items:center;padding-left:10px}/deep/ [dir=rtl] .ng-select .ng-select-container .ng-value-container{padding-right:10px;padding-left:0}/deep/ .ng-select .ng-select-container .ng-value-container .ng-placeholder{color:#999}/deep/ .ng-select.ng-select-single .ng-select-container{height:36px}/deep/ .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{top:5px;left:0;padding-left:10px;padding-right:50px}/deep/ [dir=rtl] .ng-select.ng-select-single .ng-select-container .ng-value-container .ng-input{padding-right:10px;padding-left:50px}/deep/ .ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value{background-color:#f9f9f9;border:1px solid #e6e6e6}/deep/ .ng-select.ng-select-multiple.ng-select-disabled>.ng-select-container .ng-value-container .ng-value .ng-value-label{padding:0 5px}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-top:5px;padding-left:7px}/deep/ [dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container{padding-right:7px;padding-left:0}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{font-size:.9em;margin-bottom:5px;background-color:#ebf5ff;border-radius:2px;margin-right:5px}/deep/ [dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value{margin-right:0;margin-left:5px}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled{background-color:#f9f9f9}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled .ng-value-label{padding-left:5px}[dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value.ng-value-disabled /deep/ .ng-value-label{padding-left:0;padding-right:5px}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-label{display:inline-block;padding:1px 5px}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon{display:inline-block;padding:1px 5px}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon:hover{background-color:#d1e8ff}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-right:1px solid #b8dbff}/deep/ [dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.left{border-left:1px solid #b8dbff;border-right:none}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:1px solid #b8dbff}/deep/ [dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-value .ng-value-icon.right{border-left:0;border-right:1px solid #b8dbff}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 0 3px 3px}/deep/ [dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input{padding:0 3px 3px 0}/deep/ .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{top:5px;padding-bottom:5px;padding-left:3px}/deep/ [dir=rtl] .ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-placeholder{padding-right:3px;padding-left:0}/deep/ .ng-select .ng-clear-wrapper{color:#999}/deep/ .ng-select .ng-clear-wrapper:hover .ng-clear{color:#d0021b}/deep/ .ng-select .ng-spinner-zone{padding:5px 5px 0 0}/deep/ [dir=rtl] .ng-select .ng-spinner-zone{padding:5px 0 0 5px}/deep/ .ng-select .ng-arrow-wrapper{width:25px;padding-right:5px}/deep/ [dir=rtl] .ng-select .ng-arrow-wrapper{padding-left:5px;padding-right:0}/deep/ .ng-select .ng-arrow-wrapper:hover .ng-arrow{border-top-color:#666}/deep/ .ng-select .ng-arrow-wrapper .ng-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px}/deep/ .ng-dropdown-panel{background-color:#fff;border:1px solid #ccc;box-shadow:0 1px 0 rgba(0,0,0,.06);left:0}/deep/ .ng-dropdown-panel.ng-select-bottom{top:100%;border-bottom-right-radius:4px;border-bottom-left-radius:4px;border-top-color:#e6e6e6;margin-top:-1px}/deep/ .ng-dropdown-panel.ng-select-bottom .ng-dropdown-panel-items .ng-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}/deep/ .ng-dropdown-panel.ng-select-top{bottom:100%;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-color:#e6e6e6;margin-bottom:-1px}/deep/ .ng-dropdown-panel.ng-select-top .ng-dropdown-panel-items .ng-option:first-child{border-top-right-radius:4px;border-top-left-radius:4px}/deep/ .ng-dropdown-panel .ng-dropdown-header{border-bottom:1px solid #ccc;padding:5px 7px}/deep/ .ng-dropdown-panel .ng-dropdown-footer{border-top:1px solid #ccc;padding:5px 7px}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items{margin-bottom:1px}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:8px 10px;font-weight:500;color:rgba(0,0,0,.54);cursor:pointer}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-disabled{cursor:default}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-marked{background-color:#f5faff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected,/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-optgroup.ng-option-selected.ng-option-marked{background-color:#ebf5ff;font-weight:600}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{background-color:#fff;color:rgba(0,0,0,.87);padding:8px 10px}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected,/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked{color:#333;background-color:#ebf5ff}.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .ng-option-label,/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .ng-option-label{font-weight:600}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:#f5faff;color:#333}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{color:#ccc}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-left:22px}/deep/ [dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-child{padding-right:22px;padding-left:0}/deep/ .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{font-size:80%;font-weight:400;padding-right:5px}/deep/ [dir=rtl] .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .ng-tag-label{padding-left:5px;padding-right:0}/deep/ [dir=rtl] .ng-dropdown-panel{direction:rtl;text-align:right}:host{position:relative;display:block}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}:host{display:flex}}@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){:host{min-width:150px}}.select{-moz-appearance:none;-webkit-appearance:none;appearance:none;color:#657478;background-color:transparent;border:1px solid rgba(15,17,18,.16);border-radius:4px;width:100%;height:48px;padding:4px 44px 4px 8px;font-family:Poppins,sans-serif}.select:disabled{cursor:not-allowed;color:rgba(15,17,18,.3)}.select.filter-select{min-width:168px}.select::-ms-expand{display:none}.select-arrow{position:absolute;z-index:1;width:48px;height:48px;background:url(assets/icons/dropdown-expand.svg) center center no-repeat;right:0;pointer-events:none}/deep/ .ng-select.ng-select.ng-select{width:100%}/deep/ .ng-select.ng-select.ng-select .ng-arrow-wrapper{width:35px}/deep/ .ng-select.ng-select.ng-select .ng-arrow-wrapper .ng-arrow{border-color:#0f1112 transparent transparent}/deep/ .ng-select.ng-select.ng-select.ng-select-opened>.ng-select-container .ng-arrow{border-color:transparent transparent #0f1112}/deep/ .ng-select.ng-select.ng-select.ng-select-focused:not(.ng-select-opened)>.ng-select-container{border-color:#657478}/deep/ .ng-select.ng-select.ng-select.ng-select-disabled>.ng-select-container{cursor:not-allowed;color:rgba(15,17,18,.3)}/deep/ .ng-select.ng-select.ng-select .ng-select-container{height:48px;line-height:48px;border-color:rgba(15,17,18,.16)}/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container{padding-left:16px}/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-input,/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-placeholder,/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-value{top:0}/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-input>input,/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-value>span{color:#657478;font-weight:500;font-size:1.4rem}/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-input>input.editor-select,/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-value>span.editor-select{font-weight:700;font-size:2rem;color:#0f1112;position:relative;top:2px}/deep/ .ng-select.ng-select.ng-select .ng-select-container .ng-value-container .ng-input{top:-1px;padding-left:16px}/deep/ .ng-select.ng-select.ng-select .ng-clear-wrapper{height:44px}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel{width:auto;min-width:100%;border-color:rgba(15,17,18,.16);z-index:10000}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items{margin-bottom:0}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option{color:#657478;background-color:#fff;font-weight:500;height:50px;line-height:50px;padding:0 16px;position:relative;display:flex;justify-content:space-between}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option:after{content:'';background-color:rgba(15,17,18,.16);position:absolute;height:1px;left:16px;right:16px;bottom:0}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option:last-child:after{display:none}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled{cursor:not-allowed;color:#979797;font-weight:100}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-marked{background-color:rgba(15,17,18,.05)}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected,/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked{color:#fff;background-color:#000}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected .icon,/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-selected.ng-option-marked .icon{display:inline-flex;align-items:center}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-dropdown-panel-items .ng-option .icon{display:none;right:0}/deep/ .ng-select.ng-select.ng-select .ng-dropdown-panel .ng-select-bottom{border-top-color:#fff}/deep/ .filter-modal.ng-select.ng-select.ng-select .ng-select-container{background-color:transparent;color:#fff;border:1px solid rgba(255,255,255,.72)}/deep/ .filter-modal.ng-select.ng-select.ng-select .ng-select-container .ng-arrow{border-color:#444 transparent transparent}/deep/ .filter-modal.ng-select.ng-select.ng-select.ng-select-opened .ng-select-container .ng-arrow{border-color:transparent transparent #444}"]
                }] }
    ];
    /** @nocollapse */
    SelectComponent.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    SelectComponent.propDecorators = {
        options: [{ type: Input }],
        ngClassName: [{ type: Input }],
        placeholder: [{ type: Input }],
        controlName: [{ type: Input }],
        group: [{ type: Input }],
        className: [{ type: Input }],
        disabled: [{ type: Input }],
        notFoundText: [{ type: Input }],
        clearable: [{ type: Input }],
        searchable: [{ type: Input }],
        searchFn: [{ type: Input }],
        binding: [{ type: Input }],
        change: [{ type: Output }],
        modelChange: [{ type: Output }],
        model: [{ type: Input }]
    };
    return SelectComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SelectMetadata = {
    declarations: [SelectComponent],
    imports: [CommonModule, FormsModule, IconModule, NgSelectModule, ReactiveFormsModule],
    // providers: [NgControl],
    exports: [SelectComponent],
};
var SelectModule = /** @class */ (function () {
    function SelectModule() {
    }
    SelectModule.decorators = [
        { type: NgModule, args: [SelectMetadata,] }
    ];
    return SelectModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TitleComponent = /** @class */ (function () {
    function TitleComponent() {
    }
    TitleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-title',
                    template: "<h1 class=\"title\">{{ content }}</h1>",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.title{margin:0;font-family:\"Roboto Slab\",serif;font-size:3.2rem;font-weight:300;line-height:1.25;color:#0f1112}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.title{font-size:4rem;line-height:1.2}}"]
                }] }
    ];
    /** @nocollapse */
    TitleComponent.ctorParameters = function () { return []; };
    TitleComponent.propDecorators = {
        content: [{ type: Input }]
    };
    return TitleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TitleMetadata = {
    declarations: [TitleComponent],
    imports: [CommonModule],
    exports: [TitleComponent],
};
var TitleModule = /** @class */ (function () {
    function TitleModule() {
    }
    TitleModule.decorators = [
        { type: NgModule, args: [TitleMetadata,] }
    ];
    return TitleModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationComponent = /** @class */ (function () {
    function PaginationComponent() {
        // @Input()
        this.numberOfDisplayedPage = 4;
        this.fromModal = false;
        this.pageChange = new EventEmitter();
    }
    Object.defineProperty(PaginationComponent.prototype, "numberOfItems", {
        get: /**
         * @return {?}
         */
        function () {
            return this._numberOfItems;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._numberOfItems = value;
            this.calculateNumberOfPage();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "itemsPerPage", {
        get: /**
         * @return {?}
         */
        function () {
            return this._itemsPerPage;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._itemsPerPage = value;
            this.calculateNumberOfPage();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaginationComponent.prototype, "currentPage", {
        get: /**
         * @return {?}
         */
        function () {
            return this._currentPage;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value < 1) {
                this._currentPage = 1;
            }
            else if (this.numberOfPage && value > this.numberOfPage) {
                this._currentPage = this.numberOfPage;
            }
            else {
                this._currentPage = value;
            }
            this.setFirstPages();
            this.setMiddlePages();
            this.setLastPages();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PaginationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.calculateNumberOfPage = /**
     * @return {?}
     */
    function () {
        this.numberOfPage = null;
        this.pages = null;
        if (this._numberOfItems) {
            this.numberOfPage = 1;
            if (this._itemsPerPage) {
                this.numberOfPage = Math.ceil(this._numberOfItems / this._itemsPerPage);
            }
            this.setPages();
        }
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.setPages = /**
     * @return {?}
     */
    function () {
        this.pages = [];
        for (var index = 1; index <= this.numberOfPage; index++) {
            this.pages.push(index);
        }
        this.setFirstPages();
        this.setMiddlePages();
        this.setLastPages();
    };
    /**
     * Determine the first pages display in the pagination module
     */
    /**
     * Determine the first pages display in the pagination module
     * @return {?}
     */
    PaginationComponent.prototype.setFirstPages = /**
     * Determine the first pages display in the pagination module
     * @return {?}
     */
    function () {
        /** @type {?} */
        var length = Math.ceil(this.numberOfDisplayedPage / 2);
        this.firstPages = [];
        /** @type {?} */
        var numberOfMembers = this.numberOfDisplayedPage >= this.numberOfPage ? this.numberOfPage : length;
        if (this.currentPage > numberOfMembers && this.currentPage <= this.numberOfPage - length) {
            numberOfMembers = 1;
        }
        for (var index = 0; index < numberOfMembers; index++) {
            this.firstPages.push(this.pages[index]);
        }
    };
    /**
     * Determine the middle pages display in the pagination module
     */
    /**
     * Determine the middle pages display in the pagination module
     * @return {?}
     */
    PaginationComponent.prototype.setMiddlePages = /**
     * Determine the middle pages display in the pagination module
     * @return {?}
     */
    function () {
        /** @type {?} */
        var length = Math.ceil(this.numberOfDisplayedPage / 2);
        this.middlePages = null;
        if (this.numberOfDisplayedPage < this.numberOfPage) {
            if (this.currentPage > this.firstPages.length && this.currentPage <= this.numberOfPage - length) {
                this.middlePages = [];
                this.middlePages.push(this.pages[this.currentPage - 1]);
            }
        }
    };
    /**
     * Determine the last pages display in the pagination module
     */
    /**
     * Determine the last pages display in the pagination module
     * @return {?}
     */
    PaginationComponent.prototype.setLastPages = /**
     * Determine the last pages display in the pagination module
     * @return {?}
     */
    function () {
        /** @type {?} */
        var length = Math.ceil(this.numberOfDisplayedPage / 2);
        this.lastPages = null;
        /** @type {?} */
        var startIndex = this.numberOfDisplayedPage < this.numberOfPage ? this.numberOfPage - length : null;
        if (startIndex && this.currentPage > this.firstPages.length && this.currentPage <= this.numberOfPage - length) {
            startIndex = this.numberOfPage - 1;
        }
        if (startIndex) {
            this.lastPages = [];
            for (var index = startIndex; index < this.numberOfPage; index++) {
                this.lastPages.push(this.pages[index]);
            }
        }
    };
    /**
     * Determine the selected page in the pagination module
     */
    /**
     * Determine the selected page in the pagination module
     * @param {?} page
     * @return {?}
     */
    PaginationComponent.prototype.setCurrentPage = /**
     * Determine the selected page in the pagination module
     * @param {?} page
     * @return {?}
     */
    function (page) {
        if (this.currentPage !== page) {
            this.currentPage = page;
            this.pageChange.emit(this.currentPage);
        }
    };
    PaginationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-pagination',
                    template: "<ul class=\"page-list\">\n  <li class=\"page btn\" [ngClass]=\"{'disabled': currentPage === 1, 'modal-btn-prev': fromModal, 'btn-prev': !fromModal}\"\n    (click)=\"setCurrentPage(currentPage-1)\"></li>\n\n  <li class=\"page\" *ngFor=\"let page of firstPages\">\n    <a class=\"content\" (click)=\"setCurrentPage(page)\" [ngClass]=\"{ active: currentPage === page }\">{{ page }}</a>\n  </li>\n\n  <ng-container *ngIf=\"middlePages\">\n    <li class=\"page\">\n      <a class=\"content\" (click)=\"setCurrentPage(currentPage-1)\">...</a>\n    </li>\n\n    <li class=\"page\" *ngFor=\"let page of middlePages\">\n      <a class=\"content\" (click)=\"setCurrentPage(page)\" [ngClass]=\"{ active: currentPage === page }\">{{ page }}</a>\n    </li>\n\n    <li class=\"page\">\n      <a class=\"content\" (click)=\"setCurrentPage(currentPage+1)\">...</a>\n    </li>\n  </ng-container>\n\n  <ng-container *ngIf=\"lastPages\">\n    <li class=\"page\" *ngIf=\"!middlePages\">\n      <a class=\"content disabled\">...</a>\n    </li>\n\n    <li class=\"page\" *ngFor=\"let page of lastPages\">\n      <a class=\"content\" (click)=\"setCurrentPage(page)\" [ngClass]=\"{ active: currentPage === page }\">{{ page }}</a>\n    </li>\n  </ng-container>\n\n  <li class=\"page btn\" [ngClass]=\"{'disabled': currentPage === numberOfPage, 'modal-btn-next': fromModal, 'btn-next': !fromModal}\"\n    (click)=\"setCurrentPage(currentPage+1)\"></li>\n</ul>\n\n<!-- <pre> currentPage {{ currentPage }}</pre>\n<pre> firstPages {{ firstPages | json }}</pre>\n<pre> middlePages {{ middlePages | json }}</pre>\n<pre> lastPages {{ lastPages | json }}</pre>\n<pre> length {{ this.numberOfDisplayedPage / 2 }}</pre>\n<pre> numberOfPage {{ this.numberOfPage }}</pre> -->\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}a,a:active,a:hover,a:visited{text-decoration:none}.page-list{display:inline-flex;flex-wrap:wrap;list-style:none;margin:0;padding:0}.page{cursor:pointer;width:48px;height:48px;border:1px solid #d8d9d8}.content{display:flex;justify-content:center;align-items:center;width:100%;height:100%;color:#657478}.content:focus,.content:hover{background-color:#fff}.content.active{font-weight:700;color:#0f1112;background-color:#ebedf3}.content.disabled{cursor:not-allowed}.content.disabled:focus,.content.disabled:hover{background-color:initial}.btn{position:relative}.btn::before{content:\"\";position:absolute;top:calc(50% - 6px);border-width:6px;border-style:solid}.btn.btn-prev{border-radius:3.3px 0 0 3.3px}.btn.btn-prev::before{left:calc(50% - 9px);border-color:transparent #657478 transparent transparent}.btn.modal-btn-prev{border-radius:3.3px 0 0 3.3px}.btn.modal-btn-prev::before{left:calc(50% - 9px);border-color:transparent #fff transparent transparent}.btn.btn-next{border-radius:0 3.3px 3.3px 0}.btn.btn-next::before{right:calc(50% - 9px);border-color:transparent transparent transparent #657478}.btn.modal-btn-next{border-radius:0 3.3px 3.3px 0}.btn.modal-btn-next::before{right:calc(50% - 9px);border-color:transparent transparent transparent #fff}.btn.disabled{cursor:not-allowed}.btn.disabled:focus,.btn.disabled:hover{background-color:initial}.btn.disabled.btn-prev::before{border-color:transparent #d8d9d8 transparent transparent}.btn.disabled.modal-btn-prev::before{border-color:transparent #657478 transparent transparent}.btn.disabled.btn-next::before{border-color:transparent transparent transparent #d8d9d8}.btn.disabled.modal-btn-next::before{border-color:transparent transparent transparent #657478}"]
                }] }
    ];
    /** @nocollapse */
    PaginationComponent.ctorParameters = function () { return []; };
    PaginationComponent.propDecorators = {
        fromModal: [{ type: Input }],
        numberOfItems: [{ type: Input }],
        itemsPerPage: [{ type: Input }],
        currentPage: [{ type: Input }],
        pageChange: [{ type: Output }]
    };
    return PaginationComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PaginationMetadata = {
    declarations: [PaginationComponent],
    imports: [CommonModule],
    exports: [PaginationComponent],
};
var PaginationModule = /** @class */ (function () {
    function PaginationModule() {
    }
    PaginationModule.decorators = [
        { type: NgModule, args: [PaginationMetadata,] }
    ];
    return PaginationModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconButtonComponent = /** @class */ (function () {
    function IconButtonComponent() {
        this.buttonType = 'button';
        this.click = new EventEmitter();
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    IconButtonComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.click.emit(evt);
    };
    IconButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-icon-button',
                    template: "\n    <button class=\"button\" [type]=\"buttonType\" (click)=\"handleClicked($event)\">\n      <lib-icon class=\"icon\" [icon]=\"icon\" [altText]=\"iconAlt\"></lib-icon>\n    </button>\n  ",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;color:inherit}.button{display:inline-flex;height:100%;width:100%;color:inherit;background-color:transparent}.button,.button[type=button],.button[type=menu],.button[type=reset],.button[type=submit]{outline:0;border:none;line-height:normal;margin:0;padding:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit}.button[type=menu]{width:auto}.button::-moz-focus-inner{border:0;padding:0}.icon{width:100%;height:100%}"]
                }] }
    ];
    IconButtonComponent.propDecorators = {
        buttonType: [{ type: Input }],
        icon: [{ type: Input }],
        iconAlt: [{ type: Input }],
        click: [{ type: Output }]
    };
    return IconButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var IconButtonMetadata = {
    declarations: [IconButtonComponent],
    imports: [CommonModule, IconModule],
    exports: [IconButtonComponent],
};
var IconButtonModule = /** @class */ (function () {
    function IconButtonModule() {
    }
    IconButtonModule.decorators = [
        { type: NgModule, args: [IconButtonMetadata,] }
    ];
    return IconButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IncidentsListComponent = /** @class */ (function () {
    function IncidentsListComponent() {
        this.seeMore = false;
        this.seeMoreString = 'Afficher les détails';
    }
    /**
     * @return {?}
     */
    IncidentsListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.getWarehousesList();
    };
    /**
     * @return {?}
     */
    IncidentsListComponent.prototype.getWarehousesList = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.warehousesList = [];
        this.impactedWarehouses.map(function (warehouse) { return _this.warehousesList.push(warehouse.warehouseName); });
    };
    /**
     * @return {?}
     */
    IncidentsListComponent.prototype.onSeeMore = /**
     * @return {?}
     */
    function () {
        this.seeMore = !this.seeMore;
        this.seeMore ? (this.seeMoreString = 'Cacher les détails') : (this.seeMoreString = 'Afficher les détails');
    };
    IncidentsListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-incidents-list',
                    template: "<div class=\"incidents-list\">\n  <!-- TODO: Wording -->\n  <div class=\"incidents-list-title\">Informations de distribution</div>\n  <div class=\"incidents-list-warehouses\">\n    {{ warehousesList?.length > 0 ? warehousesList?.length : 'Aucun' }} d\u00E9p\u00F4t{{\n      warehousesList?.length > 1 ? 's' : ''\n    }}\n    en anomalie{{ warehousesList?.length > 1 ? ' :' : '.' }}\n    {{ warehousesList | arrayJoin: ', ' }}\n  </div>\n  <div class=\"incidents-list-message\">\n    <span class=\"only-mobile-details\" (click)=\"onSeeMore()\" *ngIf=\"globalMessage?.length > 0\">\n      {{ seeMoreString }}\n      <span class=\"see-more-details-arrow\" [ngClass]=\"{ up: seeMore }\"></span>\n    </span>\n    <div class=\"incidents-list-message-details\" [innerHTML]=\"globalMessage | sanitizeHtml\" *ngIf=\"seeMore\"></div>\n    <div\n      class=\"incidents-list-message-desktop\"\n      *ngIf=\"globalMessage?.length > 0 && !seeMore\"\n      [innerHTML]=\"globalMessage | truncate: 400:'...':true | sanitizeHtml\"\n    ></div>\n    <span class=\"see-more\" (click)=\"onSeeMore()\" *ngIf=\"globalMessage?.length > 400\">{{ seeMoreString }}</span>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.incidents-list{color:#0f1112;margin-top:16px}.incidents-list .incidents-list-title{font-size:2rem;font-weight:600;line-height:1.6;margin-right:16px;margin-left:16px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.incidents-list{margin-top:0;max-width:655px}.incidents-list .incidents-list-title{margin-left:0}}.incidents-list .incidents-list-warehouses{font-size:1.4rem;font-weight:500;line-height:1.43;margin:16px 16px 0;text-align:justify}.incidents-list .incidents-list-message{font-size:1.4rem;line-height:1.71;padding-left:21px;margin-top:24px;color:#657478;border-left:1px solid #657478;text-align:justify}.incidents-list .incidents-list-message .only-mobile-details{display:flex;justify-content:center;color:#ff642e;background:#ffede6;padding:14px;font-weight:500;cursor:pointer}.incidents-list .incidents-list-message .only-mobile-details .see-more-details-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #ff642e;position:relative;left:13px;top:8px}.incidents-list .incidents-list-message .only-mobile-details .see-more-details-arrow.up{border-top:none;border-bottom:5px solid #ff642e}.incidents-list .incidents-list-message .incidents-list-message-details{margin:16px 0 0 16px}.incidents-list .incidents-list-message .see-more{float:right;cursor:pointer;text-decoration:underline}@media (max-width:1139px){.incidents-list .incidents-list-message{padding-left:0;border-left:none}.incidents-list .incidents-list-message .incidents-list-message-details{margin-right:16px}.incidents-list .incidents-list-message .incidents-list-message-desktop,.incidents-list .incidents-list-message .see-more{display:none}}@media (min-width:1140px){.incidents-list .incidents-list-warehouses{margin-left:0;margin-right:0}.incidents-list .incidents-list-message .only-mobile-details{display:none}.incidents-list .incidents-list-message .see-more{margin-top:16px}}"]
                }] }
    ];
    IncidentsListComponent.propDecorators = {
        globalMessage: [{ type: Input }],
        impactedWarehouses: [{ type: Input }]
    };
    return IncidentsListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var IncidentsListMetadata = {
    declarations: [IncidentsListComponent],
    imports: [BrowserModule, CommonModule, HttpClientModule, PipesModule.forRoot()],
    exports: [IncidentsListComponent],
};
var IncidentsListModule = /** @class */ (function () {
    function IncidentsListModule() {
    }
    IncidentsListModule.decorators = [
        { type: NgModule, args: [IncidentsListMetadata,] }
    ];
    return IncidentsListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuButtonComponent = /** @class */ (function () {
    function MenuButtonComponent() {
        this.logout = new EventEmitter();
        this.changePage = new EventEmitter();
        this.iconDefault = 'menu';
        this.iconClose = 'close';
    }
    /**
     * @return {?}
     */
    MenuButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.isClicked = false;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    MenuButtonComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.isClicked = !this.isClicked;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    MenuButtonComponent.prototype.handleChangePage = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.isClicked = !this.isClicked;
        this.changePage.emit(evt);
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    MenuButtonComponent.prototype.handleLogout = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.logout.emit(evt);
    };
    MenuButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-menu-button',
                    template: "<div *ngIf=\"!isClicked; then thenBlock; else elseBlock\"></div>\n<ng-template #thenBlock>\n  <a role=\"button\" class=\"button-open-menu\" (click)=\"handleClicked($event)\"><img src=\"assets/icons/menu.svg\"/></a>\n</ng-template>\n<ng-template #elseBlock>\n  <a role=\"button\" class=\"button-close-menu\" (click)=\"handleClicked($event)\"><img src=\"assets/icons/close.svg\"/></a>\n</ng-template>\n\n<div *ngIf=\"isClicked\">\n  <lib-menu-mobile\n    class=\"menu\"\n    [menu]=\"menu\"\n    (logout)=\"handleLogout($event)\"\n    (changePage)=\"handleChangePage($event)\"\n    [currentPage]=\"currentPage\"\n  ></lib-menu-mobile>\n  <div class=\"arrow-up\"><div class=\"arrow-up-background\"></div></div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.arrow-up{width:0;height:0;border-left:11px solid transparent;border-right:11px solid transparent;border-bottom:10px solid rgba(15,17,18,.08);position:absolute;z-index:10100;top:85px;right:-1px}.arrow-up-background{width:0;height:0;border-bottom:8px solid #fff;border-left:9px solid transparent;border-right:9px solid transparent;position:absolute;right:-9px;top:2px}.menu{position:fixed;background-position:center center}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.menu{right:0;display:none}}.button-close-menu,.button-open-menu{position:relative;display:inline-flex;justify-content:center;align-self:center;width:32px;height:32px;border-radius:16px;cursor:default}.button-close-menu:hover,.button-open-menu:hover{background-color:rgba(101,116,120,.2)}@media (min-width:1140px){.button-close-menu,.button-open-menu{display:none}}"]
                }] }
    ];
    /** @nocollapse */
    MenuButtonComponent.ctorParameters = function () { return []; };
    MenuButtonComponent.propDecorators = {
        currentPage: [{ type: Input }],
        menu: [{ type: Input }],
        logout: [{ type: Output }],
        changePage: [{ type: Output }]
    };
    return MenuButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MenuButtonMetadata = {
    declarations: [MenuButtonComponent],
    imports: [CommonModule, IconButtonModule, MenuMobileModule],
    exports: [MenuButtonComponent],
};
var MenuButtonModule = /** @class */ (function () {
    function MenuButtonModule() {
    }
    MenuButtonModule.decorators = [
        { type: NgModule, args: [MenuButtonMetadata,] }
    ];
    return MenuButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParutionComponent = /** @class */ (function () {
    function ParutionComponent(router) {
        this.router = router;
        this.isModal = false;
        this.useMirror = false;
        this.isMirror = false;
        this.isFromComparator = false;
        this.isFrontpage = false;
        this.click = new EventEmitter();
        this.showTooltip = false;
    }
    Object.defineProperty(ParutionComponent.prototype, "mevDelayDelta", {
        /**
         * Display the content of the MEV Delta
         * MEV Delta is the difference btw the actual day and the selling start day
         */
        get: /**
         * Display the content of the MEV Delta
         * MEV Delta is the difference btw the actual day and the selling start day
         * @return {?}
         */
        function () {
            if (typeof this.publication.soldDuration === 'number') {
                this.mevDelay = this.publication.soldDuration;
            }
            else {
                this.mevDelay = null;
                return;
            }
            // On a pas d'anomalies OU on est au jour de mise en vente => J
            // On a des anomalies ET on est au-dealà du jour de mise en vente => J+
            return this.mevDelay === 0 || !this.publication.nbWarehousesInAlert
                ? this.mevDelay.toString() === '0'
                    ? ' '
                    : this.mevDelay.toString()
                : "+" + this.mevDelay;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParutionComponent.prototype, "publicationNumberNTile", {
        /**
         * Display 1st part of publication id & publication number
         */
        get: /**
         * Display 1st part of publication id & publication number
         * @return {?}
         */
        function () {
            return (this.publication &&
                this.publication.publicationId.toString().split('-', 1) + " \u2022 " + this.publication.name + " n\u00B0" + this.publication.publicationNumber);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Open the parution details page (only from 'en vente')
     */
    /**
     * Open the parution details page (only from 'en vente')
     * @param {?} mevDelayDelta
     * @return {?}
     */
    ParutionComponent.prototype.goToParutionDetails = /**
     * Open the parution details page (only from 'en vente')
     * @param {?} mevDelayDelta
     * @return {?}
     */
    function (mevDelayDelta) {
        var _this = this;
        if (this.publication && this.publication.publicationId && !this.isFrontpage && !this.isModal) {
            /*this.router.routeReuseStrategy.shouldReuseRoute = function() {
              return false;
            };*/
            this.router
                .navigate(['/page/temps-reel'], {
                queryParams: {
                    publicationId: this.publication.publicationId,
                    mevDelay: mevDelayDelta,
                },
            })
                .then(function (_) {
                _this.router.routeReuseStrategy.shouldReuseRoute = function () {
                    return true;
                };
            });
        }
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    ParutionComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.click.emit(evt);
    };
    /**
     * @return {?}
     */
    ParutionComponent.prototype.mouseHovering = /**
     * @return {?}
     */
    function () {
        this.showTooltip = true;
    };
    /**
     * @return {?}
     */
    ParutionComponent.prototype.mouseLeft = /**
     * @return {?}
     */
    function () {
        this.showTooltip = false;
    };
    /**
     * Return false if the publication has 0 anomalies to display
     */
    /**
     * Return false if the publication has 0 anomalies to display
     * @param {?} value
     * @param {?} label
     * @return {?}
     */
    ParutionComponent.prototype.checkAnomalies = /**
     * Return false if the publication has 0 anomalies to display
     * @param {?} value
     * @param {?} label
     * @return {?}
     */
    function (value, label) {
        if (!value && label === 'Dépôts en anomalie') {
            return false;
        }
        return true;
    };
    ParutionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parution',
                    template: "<article class=\"container\"\n         [ngClass]=\"{ 'is-frontpage': isFrontpage, 'no-mirror': !isMirror && useMirror, 'is-modal': isModal }\"\n         (click)=\"goToParutionDetails(mevDelayDelta)\">\n  <div class=\"parution-cover\" [ngStyle]=\"{ 'background-image': 'url(' + publication?.coverUrl + ')' }\"\n       [ngClass]=\"{'mirror-parution': isMirror, 'no-mirror-parution': !isMirror}\" (mouseenter)=\"mouseHovering()\"\n       (mouseleave)=\"mouseLeft()\">\n    <div class=\"top-status\" *ngIf=\"leftStatus || rightStatus\">\n      <span class=\"day-alert\" *ngIf=\"mevDelayDelta && !isFromComparator\">J{{ mevDelayDelta }}</span>\n      <span class=\"day-alert\" *ngIf=\"isFromComparator\">{{ mevDelayDeltaComparator }}</span>\n      <span class=\"comparaison-button\"\n            *ngIf=\"apiUrlForCompare && publication?.canCompare && publication?.displayCode?.canCompare === 1\">\n        <lib-comparator [apiUrl]=\"apiUrlForCompare + '/compare?publicationId=' + publication?.publicationId\">\n        </lib-comparator>\n      </span>\n    </div>\n    <div class=\"bottom-status\" *ngIf=\"leftStatus || rightStatus\">\n      <lib-button-gold\n        *ngIf=\"publication?.displayCode && publication?.displayCode[leftStatus?.code] && publication?.displayCode[leftStatus?.code] > 1\"\n        [subscription]=\"publication?.displayCode?.soldRate\" [text]=\"leftStatus?.label\" [accountUrl]=\"accountUrl\"\n        [blur]=\"false\" [center]=\"false\" [goldUrl]=\"goldUrl\" type=\"button\"></lib-button-gold>\n      <lib-publication-state class=\"left-status\" [value]=\"leftStatus?.value\" [label]=\"leftStatus?.label\"\n                             [isPercent]=\"leftStatus?.isPercent\" [alertColor]=\"leftStatus?.alertColor\"\n                             [withCircle]=\"leftStatus?.withCircle\"\n                             [circleColor]=\"leftStatus?.circleColor\" [icon]=\"leftStatus?.icon\"\n                             [tooltipContentType]=\"leftStatus?.tooltipContentType\"\n                             [tooltipContent]=\"leftStatus?.tooltipContent\"\n                             *ngIf=\"leftStatus && (!publication?.displayCode || !publication?.displayCode[leftStatus?.code] || publication?.displayCode[leftStatus?.code] === 1)\">\n      </lib-publication-state>\n      <lib-publication-state class=\"right-status\" [value]=\"rightStatus?.value\" [label]=\"rightStatus?.label\"\n                             [isPercent]=\"rightStatus?.isPercent\" [alertColor]=\"rightStatus?.alertColor\"\n                             [withCircle]=\"rightStatus?.withCircle\" [circleColor]=\"rightStatus?.circleColor\"\n                             [icon]=\"rightStatus?.icon\"\n                             [tooltipContentType]=\"rightStatus?.tooltipContentType\"\n                             [tooltipContent]=\"rightStatus?.tooltipContent\"\n                             [tooltipPosition]=\"rightStatus?.tooltipPosition\" [showTooltip]=\"showTooltip\"\n                             *ngIf=\"checkAnomalies(rightStatus?.value, rightStatus?.label)\">\n      </lib-publication-state>\n    </div>\n    <div *ngIf=\"!leftStatus && !rightStatus && subFamily && !isMirror\" class=\"container-sub-family\">\n      <div class=\"sub-family\">\n        {{subFamily}}\n      </div>\n    </div>\n  </div>\n  <div class=\"parution-info\">\n    <div class=\"number-n-title\" [ngClass]=\"{ 'is-comparator': isFromComparator }\" *ngIf=\"leftStatus || rightStatus\">\n      {{ publication?.publicationId | RemoveAfterHyphenPipe }} \u2022 {{ publication?.name }} n\u00B0{{\n      publication?.publicationNumber\n      }}\n      <ng-container *ngIf=\"publication?.price\"> \u2022 {{ publication?.price | number: '.2':'fr-FR' }} \u20AC</ng-container>\n    </div>\n    <div class=\"number-n-title\" [ngClass]=\"{ 'is-comparator': isFromComparator || isModal }\"\n         *ngIf=\"(isFrontpage || isModal) && !isMirror\">\n      {{ publication?.publicationId | RemoveAfterHyphenPipe }} \u2022 {{ publication?.name }}\n      n\u00B0{{ publication?.publicationNumber }}\n      <ng-container *ngIf=\"publication?.price\"> \u2022 {{ publication?.price | number: '.2':'fr-FR' }} \u20AC</ng-container>\n    </div>\n    <div class=\"mev-dates\" *ngIf=\"!isMirror\">\n      <span class=\"promo\" *ngIf=\"publication?.isPromo\">{{ 'promo' }}</span>\n      <ng-container *ngIf=\"publication?.sellingEndDate; else noEndDate\">\n        <span *ngIf=\"!isHomologous\">MEV du {{ publication?.sellingStartDate | date: 'dd/MM' }} au\n          {{ publication?.sellingEndDate | date: 'dd/MM' }}</span>\n        <span *ngIf=\"isHomologous\">MEV du {{ publication?.sellingStartDate | date: 'dd/MM/yy' }} au\n          {{ publication?.sellingEndDate | date: 'dd/MM/yy' }}</span>\n      </ng-container>\n      <ng-template #noEndDate>\n        <span>MEV \u00E0 partir du {{ publication?.sellingStartDate | date: 'dd/MM' }}</span>\n      </ng-template>\n    </div>\n    <div class=\"return-date\" *ngIf=\"publication?.returnRate\">\n      {{ publication?.returnRate | percent }}\n      <span>Tx de retour</span>\n    </div>\n    <div class=\"cde-reassort\" *ngIf=\"publication?.ordersCount\">\n      {{ publication?.ordersCount }} <span>ex. cde R\u00E9assort</span>\n    </div>\n  </div>\n</article>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.container{width:168px;cursor:pointer}.container.is-frontpage{cursor:default}.container.is-modal{cursor:pointer}.container.no-mirror{position:relative;z-index:1000;cursor:default}.mirror-parution{opacity:.4}.no-mirror-parution{box-shadow:12px 0 14px 0 rgba(0,0,0,.5)}.parution-cover{position:relative;height:221px;border-radius:2.7px;background-repeat:no-repeat;background-position:center;background-size:cover}.parution-cover .container-sub-family{display:inline-block;position:absolute;bottom:10px;left:15px}.parution-cover .container-sub-family .sub-family{padding:7px 15px;background-color:#d8d8d8;font-size:1.4rem;font-weight:600;max-width:85%;font-family:Poppins,sans-serif;color:#0f1112}.top-status{display:flex;justify-content:flex-end;padding:0 8px}.top-status .day-alert{display:block;justify-content:center;align-items:center;height:20px;margin:0 2px;padding:8px;border-radius:0 0 4px 4px;text-align:right;font-family:\"Roboto Slab\",serif;font-size:1.6rem;line-height:1.33;color:#0f1112;box-shadow:0 2px 6px 0 rgba(122,140,145,.5);background-color:#ffec00}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container{width:249px}.parution-cover{height:328px;border-radius:4px}.top-status .day-alert{height:24px;font-size:1.8rem}}.bottom-status{position:absolute;display:flex;left:0;right:0;bottom:0;padding:16px 8px;border-radius:0 0 4px 4px;align-items:center;background-image:linear-gradient(to top,#000,rgba(0,0,0,.9),rgba(0,0,0,.8),rgba(0,0,0,.7),rgba(0,0,0,.6),rgba(0,0,0,.4),rgba(0,0,0,0))}.bottom-status .left-status{align-self:flex-start}.bottom-status .right-status{margin-left:auto}.parution-info{margin-top:8px}.parution-info .number-n-title{min-height:40px;font-family:\"Roboto Slab\",serif;font-size:1.4rem;line-height:1.43;color:#0f1112}@media (min-width:1140px){.bottom-status{padding:16px}.parution-info{margin-top:16px}.parution-info .number-n-title{min-height:inherit;margin-bottom:4px;font-size:1.8rem}}.parution-info .number-n-title.is-comparator{color:#fff}.parution-info .mev-dates{display:flex;align-items:center;font-family:Poppins,sans-serif;font-size:1.3rem;line-height:1.23;color:#7a8c91;font-weight:300}@media (min-width:1140px){.parution-info .mev-dates{font-size:1.4rem}.is-frontpage{width:170px}.is-frontpage .parution-cover{height:224px}}.parution-info .promo{display:inline-block;padding:4px;margin-right:8px;border-radius:2px;background-color:#7a8c91;font-family:Poppins,sans-serif;font-size:1.1rem;font-weight:600;line-height:1.27;text-align:center;text-transform:uppercase;color:#fff}.parution-info .return-date{font-size:2.2rem;font-family:\"Roboto Slab\",serif;line-height:1.09;margin-top:6px}.parution-info .return-date span{display:block;font-size:1.2rem;font-weight:500;font-family:Poppins,sans-serif}.parution-info .cde-reassort{font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:600;color:#fff;background-color:#282727;border-radius:2px;padding:5px;text-align:center;margin-top:5px}.text-white{color:#fff}"]
                }] }
    ];
    /** @nocollapse */
    ParutionComponent.ctorParameters = function () { return [
        { type: Router }
    ]; };
    ParutionComponent.propDecorators = {
        publication: [{ type: Input }],
        leftStatus: [{ type: Input }],
        rightStatus: [{ type: Input }],
        subFamily: [{ type: Input }],
        isModal: [{ type: Input }],
        useMirror: [{ type: Input }],
        isMirror: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        apiUrlForCompare: [{ type: Input }],
        isFromComparator: [{ type: Input }],
        isFrontpage: [{ type: Input }],
        mevDelayDeltaComparator: [{ type: Input }],
        isHomologous: [{ type: Input }],
        click: [{ type: Output }]
    };
    return ParutionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var BUBBLE_POSITION = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left',
};
var TooltipComponent = /** @class */ (function () {
    function TooltipComponent() {
        this.contentType = 'text';
        this.tooltipPosition = BUBBLE_POSITION.TOP;
        this.clicked = new EventEmitter();
        this.isOpen = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    TooltipComponent.prototype.onClickOutside = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.isOpen &&
            event.target !== this.tooltipRef.nativeElement &&
            !this.tooltipRef.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    };
    /**
     * @return {?}
     */
    TooltipComponent.prototype.onMouseOver = /**
     * @return {?}
     */
    function () {
        this.relocateBubble();
    };
    /**
     * @return {?}
     */
    TooltipComponent.prototype.toggleBuble = /**
     * @return {?}
     */
    function () {
        this.isOpen = !this.isOpen;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    TooltipComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        evt.stopPropagation();
        this.toggleBuble();
        this.clicked.emit(evt);
    };
    /**
     * Reposition the bubble according to its position relative to the viewport
     */
    /**
     * Reposition the bubble according to its position relative to the viewport
     * @return {?}
     */
    TooltipComponent.prototype.relocateBubble = /**
     * Reposition the bubble according to its position relative to the viewport
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.isPositionableto(this.tooltipPosition)) {
            Object.keys(BUBBLE_POSITION).forEach(function (item) {
                /** @type {?} */
                var position = BUBBLE_POSITION[item];
                if (position !== _this.tooltipPosition) {
                    if (_this.isPositionableto(position)) {
                        return;
                    }
                }
            });
        }
    };
    /**
     * Determine if the bubble can be positioned based on the suggested orientation. If not, choose the better automatically
     * @param position orientation of the bubble
     */
    /**
     * Determine if the bubble can be positioned based on the suggested orientation. If not, choose the better automatically
     * @param {?} position orientation of the bubble
     * @return {?}
     */
    TooltipComponent.prototype.isPositionableto = /**
     * Determine if the bubble can be positioned based on the suggested orientation. If not, choose the better automatically
     * @param {?} position orientation of the bubble
     * @return {?}
     */
    function (position) {
        /** @type {?} */
        var tooltipCoordonates = this.tooltipRef.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var bubbleCoordonates = ((/** @type {?} */ (this.bubbleRef))).el.nativeElement.getBoundingClientRect();
        /** @type {?} */
        var viewPortWidth = document.documentElement.clientWidth;
        /** @type {?} */
        var viewPortHeight = document.documentElement.clientHeight;
        /** @type {?} */
        var conditionsForTopPosition = tooltipCoordonates.top > bubbleCoordonates.height;
        /** @type {?} */
        var conditionsForLeftPosition = tooltipCoordonates.left > bubbleCoordonates.width;
        /** @type {?} */
        var conditionsForBottomPosition = tooltipCoordonates.bottom + bubbleCoordonates.height < viewPortHeight;
        /** @type {?} */
        var conditionsForRightPosition = tooltipCoordonates.right + bubbleCoordonates.width < viewPortWidth;
        /** @type {?} */
        var test = false;
        switch (position) {
            case BUBBLE_POSITION.TOP:
                test = conditionsForTopPosition && conditionsForLeftPosition && conditionsForRightPosition;
                break;
            case BUBBLE_POSITION.LEFT:
                test = conditionsForLeftPosition && conditionsForTopPosition && conditionsForBottomPosition;
                break;
            case BUBBLE_POSITION.RIGHT:
                test = conditionsForRightPosition && conditionsForTopPosition && conditionsForBottomPosition;
                break;
            case BUBBLE_POSITION.BOTTOM:
                test = conditionsForBottomPosition && conditionsForLeftPosition && conditionsForRightPosition;
                break;
        }
        if (test) {
            this.tooltipPosition = position;
        }
        return test;
    };
    TooltipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-tooltip',
                    template: "<div #tooltip class=\"container\" [class.is-open]=\"isOpen\" [ngClass]=\"tooltipPosition\" (click)=\"handleClicked($event)\">\n  <lib-icon-button #button class=\"tooltip-button\" [icon]=\"icon\"></lib-icon-button>\n  <lib-bubble #bubble class=\"tooltip-bubble\" [contentType]=\"contentType\" [content]=\"content\"></lib-bubble>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:inline-flex;width:24px;height:24px;color:inherit}.container{display:inline-block;position:relative;width:100%;height:100%;color:inherit}.container::after{content:'';display:none;position:absolute;border-width:8px;border-style:solid;z-index:10500}.container:hover .tooltip-bubble,.container:hover::after{display:block}.tooltip-button{width:100%;height:100%}.tooltip-bubble{display:none;position:absolute;z-index:10500}.top::after{top:-8px;left:6px;border-color:#657478 transparent transparent}.top .tooltip-bubble{bottom:32px;left:0}.left::after{top:0;left:-8px;margin-top:6px;border-color:transparent transparent transparent #657478}.left .tooltip-bubble{top:0;right:32px}.bottom::after{bottom:-8px;left:6px;border-color:transparent transparent #657478}.bottom .tooltip-bubble{top:32px;left:0}.right::after{top:0;right:-8px;margin-top:6px;border-color:transparent #657478 transparent transparent}.right .tooltip-bubble{top:0;left:32px}.is-open .tooltip-bubble,.is-open::after{display:block}"]
                }] }
    ];
    TooltipComponent.propDecorators = {
        icon: [{ type: Input }],
        iconAlt: [{ type: Input }],
        contentType: [{ type: Input }],
        content: [{ type: Input }],
        tooltipPosition: [{ type: Input }],
        clicked: [{ type: Output }],
        tooltipRef: [{ type: ViewChild, args: ['tooltip',] }],
        bubbleRef: [{ type: ViewChild, args: ['bubble',] }],
        onClickOutside: [{ type: HostListener, args: ['document:click', ['$event'],] }, { type: HostListener, args: ['document:touchstart', ['$event'],] }],
        onMouseOver: [{ type: HostListener, args: ['mouseenter',] }, { type: HostListener, args: ['touchstart',] }]
    };
    return TooltipComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TooltipMetadata = {
    declarations: [TooltipComponent],
    imports: [CommonModule, BubbleModule, IconButtonModule],
    exports: [TooltipComponent],
};
var TooltipModule = /** @class */ (function () {
    function TooltipModule() {
    }
    TooltipModule.decorators = [
        { type: NgModule, args: [TooltipMetadata,] }
    ];
    return TooltipModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PublicationStateComponent = /** @class */ (function () {
    function PublicationStateComponent() {
        this.click = new EventEmitter();
    }
    Object.defineProperty(PublicationStateComponent.prototype, "alertIcon", {
        get: /**
         * @return {?}
         */
        function () {
            return this.icon && this.icon.trim();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} evt
     * @return {?}
     */
    PublicationStateComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.click.emit(evt);
    };
    PublicationStateComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-publication-state',
                    template: "<ng-container *ngIf=\"withCircle\">\n  <lib-percentage-circle class=\"circle\" [percentage]=\"value * 100\" [color]=\"circleColor\"></lib-percentage-circle>\n</ng-container>\n<div class=\"value-n-label\" [ngClass]=\"{ upcoming: isFromUpcoming }\">\n  <div *ngIf=\"tooltipContent; else normalLabel\">\n    <div class=\"value-n-tooltip\" [ngClass]=\"alertColor\">\n      <ng-container *ngIf=\"showTooltip; else showWarning\">\n        <lib-tooltip\n          class=\"tooltip\"\n          [icon]=\"icon\"\n          [contentType]=\"tooltipContentType\"\n          [content]=\"tooltipContent\"\n          [tooltipPosition]=\"tooltipPosition\"\n          *ngIf=\"alertIcon\"\n        ></lib-tooltip>\n      </ng-container>\n      <ng-template #showWarning>\n        <img src=\"/assets/icons/alerts.svg\" class=\"tooltip warning\" />\n      </ng-template>\n      <span class=\"value\">\n        <ng-container>{{ value }}</ng-container>\n      </span>\n    </div>\n    <div class=\"label\">{{ label }}</div>\n  </div>\n  <ng-template #normalLabel>\n    <div class=\"value-n-tooltip\" [ngClass]=\"alertColor\">\n      <img *ngIf=\"icon\" src=\"/assets/icons/alerts.svg\" class=\"tooltip warning\" />\n      <span class=\"value\">\n        <ng-container *ngIf=\"isPercent; else normalValue\">\n          <span title=\"{{ value | percent: '.0-2':'fr' }}\">{{ value | floorPercent }}</span>\n        </ng-container>\n        <ng-template #normalValue>{{ value | number: '.0-0':'fr-FR' }}</ng-template>\n      </span>\n    </div>\n    <div class=\"label\">{{ label }}</div>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:flex;align-items:center;color:#fff}.circle{display:none}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.circle{display:block;margin-right:10px}}.value-n-tooltip{display:flex;align-items:center;color:#0f1112}.value-n-tooltip.tooltip{margin-right:4px}.value-n-tooltip.tooltip.warning{height:22px}.value-n-tooltip.value{font-family:\"Roboto Slab\",serif;font-size:2.2rem;line-height:1.09}.value-n-tooltip.white{color:#fff;font-size:2rem}.value-n-tooltip.orange{color:#ff642e;font-size:2rem}.label{font-size:1.2rem;font-weight:500;line-height:1;text-overflow:ellipsis;width:68px;white-space:nowrap;overflow:hidden}.upcoming{color:#0f1112;font-size:2rem}@media (min-width:1140px){.label{text-overflow:clip;width:auto;white-space:normal;overflow:clip}.upcoming{font-size:2.2rem}}.upcoming .label{color:#657478}"]
                }] }
    ];
    PublicationStateComponent.propDecorators = {
        value: [{ type: Input }],
        label: [{ type: Input }],
        icon: [{ type: Input }],
        isPercent: [{ type: Input }],
        alertColor: [{ type: Input }],
        tooltipContentType: [{ type: Input }],
        tooltipContent: [{ type: Input }],
        tooltipPosition: [{ type: Input }],
        withCircle: [{ type: Input }],
        circleColor: [{ type: Input }],
        isFromUpcoming: [{ type: Input }],
        showTooltip: [{ type: Input }],
        click: [{ type: Output }]
    };
    return PublicationStateComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PublicationStateMetadata = {
    declarations: [PublicationStateComponent],
    imports: [CommonModule, TooltipModule, PercentageCircleModule, IconModule, PipesModule.forRoot()],
    exports: [PublicationStateComponent],
};
var PublicationStateModule = /** @class */ (function () {
    function PublicationStateModule() {
    }
    PublicationStateModule.decorators = [
        { type: NgModule, args: [PublicationStateMetadata,] }
    ];
    return PublicationStateModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ComparatorComponent = /** @class */ (function () {
    function ComparatorComponent(http, datePipe) {
        this.http = http;
        this.datePipe = datePipe;
        this.modalToggled = false;
        this.comparedValue = 'previous';
        this.tabsList = [
            { label: 'année -1', returnValue: 'homologous', isActive: false },
            { label: 'numéro -1', returnValue: 'previous', isActive: true },
        ];
    }
    Object.defineProperty(ComparatorComponent.prototype, "mevDelayDelta", {
        /**
         * Display the content of the MEV Delta
         * MEV Delta is the difference btw the actual day and the selling start day
         */
        get: /**
         * Display the content of the MEV Delta
         * MEV Delta is the difference btw the actual day and the selling start day
         * @return {?}
         */
        function () {
            /** @type {?} */
            var mevDelay = Math.floor((new Date().getTime() - new Date(this.comparedParutions.current.sellingStartDate).getTime()) / (3600000 * 24));
            // const sign = mevDelay >= 0 ? '+' : '';
            // return `J${sign}${mevDelay}`;
            return "J" + mevDelay;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} evt
     * @return {?}
     */
    ComparatorComponent.prototype.onToggleModal = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (evt) {
                            evt.stopPropagation();
                        }
                        this.modalToggled = !this.modalToggled;
                        if (!(this.apiUrl && this.modalToggled === true)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.apiUrl).toPromise()];
                    case 2:
                        _a.comparedParutions = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.modalToggled = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Année -1 / Numéro -1
     */
    /**
     * Année -1 / Numéro -1
     * @param {?} event
     * @return {?}
     */
    ComparatorComponent.prototype.onSelectTab = /**
     * Année -1 / Numéro -1
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.comparedValue = event.returnValue;
    };
    // Stop click event in parution component in order to not display publication details
    // Stop click event in parution component in order to not display publication details
    /**
     * @param {?} evt
     * @return {?}
     */
    ComparatorComponent.prototype.stopClickEventParution = 
    // Stop click event in parution component in order to not display publication details
    /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        evt.stopPropagation();
    };
    ComparatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-comparator',
                    template: "<div class=\"container\" (click)=\"stopClickEventParution($event)\">\n  <div class=\"container-modal-button\" (click)=\"onToggleModal($event)\">\n    <div class=\"container-modal-button-icon\">\n      <img src=\"/assets/icons/shape.svg\" />\n    </div>\n  </div>\n  <div class=\"container-modal-overlay\" *ngIf=\"modalToggled\"></div>\n  <div class=\"container-modal-content\" *ngIf=\"modalToggled && comparedParutions\">\n    <div class=\"container-modal-content-header\">\n      <div class=\"container-modal-content-title\">Comparaison \u00E0 {{ mevDelayDelta }}</div>\n      <div class=\"container-modal-content-close\" (click)=\"onToggleModal($event)\">X</div>\n    </div>\n    <div class=\"container-modal-content-main\">\n      <div class=\"container-modal-content-selector\">\n        <div class=\"container-modal-content-selector-title\">Comparer avec</div>\n        <div class=\"container-modal-content-selector-navigator\">\n          <lib-nav-tabs [tabs]=\"tabsList\" (tabSelected)=\"onSelectTab($event)\"></lib-nav-tabs>\n        </div>\n      </div>\n      <ng-container *ngIf=\"comparedParutions.previous; else noParutionsToCompare\">\n        <div class=\"container-modal-content-parutions\" *ngIf=\"comparedValue === 'previous'; else homologous\">\n          <lib-parution\n            class=\"container-modal-content-now\"\n            [publication]=\"comparedParutions.current\"\n            [mevDelayDeltaComparator]=\"mevDelayDelta\"\n            [leftStatus]=\"{ value: comparedParutions.current.nbSold, label: 'Ex. vendus', alertColor: 'white' }\"\n            [rightStatus]=\"{\n              value: comparedParutions.current.ruptureRate,\n              label: 'Tx rupture',\n              isPercent: true,\n              alertColor: 'orange'\n            }\"\n            [isFromComparator]=\"true\"\n          ></lib-parution>\n          <lib-parution\n            class=\"container-modal-content-previous\"\n            [publication]=\"comparedParutions.previous\"\n            [mevDelayDeltaComparator]=\"mevDelayDelta\"\n            [leftStatus]=\"{ value: comparedParutions?.previous?.nbSold, label: 'Ex. vendus', alertColor: 'white' }\"\n            [rightStatus]=\"{\n              value: comparedParutions?.previous?.ruptureRate,\n              label: 'Tx rupture',\n              isPercent: true,\n              alertColor: 'white'\n            }\"\n            [isFromComparator]=\"true\"\n          ></lib-parution>\n        </div>\n        <ng-template class=\"container-modal-content-parutions\" #homologous>\n          <ng-container *ngIf=\"comparedParutions.homologous\">\n            <div class=\"container-modal-content-parutions\">\n              <lib-parution\n                class=\"container-modal-content-now\"\n                [publication]=\"comparedParutions.current\"\n                [mevDelayDeltaComparator]=\"mevDelayDelta\"\n                [isHomologous]=\"true\"\n                [leftStatus]=\"{ value: comparedParutions.current.nbSold, label: 'Ex. vendus', alertColor: 'white' }\"\n                [rightStatus]=\"{\n                  value: comparedParutions.current.ruptureRate,\n                  label: 'Tx rupture',\n                  isPercent: true,\n                  alertColor: 'orange'\n                }\"\n                [isFromComparator]=\"true\"\n              ></lib-parution>\n              <lib-parution\n                class=\"container-modal-content-previous\"\n                [publication]=\"comparedParutions.homologous\"\n                [mevDelayDeltaComparator]=\"mevDelayDelta\"\n                [isHomologous]=\"true\"\n                [leftStatus]=\"{\n                  value: comparedParutions?.homologous?.nbSold,\n                  label: 'Ex. vendus',\n                  alertColor: 'white'\n                }\"\n                [rightStatus]=\"{\n                  value: comparedParutions?.homologous?.ruptureRate,\n                  label: 'Tx rupture',\n                  isPercent: true,\n                  alertColor: 'white'\n                }\"\n                [isFromComparator]=\"true\"\n              ></lib-parution>\n            </div>\n          </ng-container>\n          <ng-container *ngIf=\"!comparedParutions.homologous\">\n            <div class=\"container-modal-content-parutions\">\n              <lib-parution\n                class=\"container-modal-content-now\"\n                [publication]=\"comparedParutions.current\"\n                [mevDelayDeltaComparator]=\"mevDelayDelta\"\n                [leftStatus]=\"{ value: comparedParutions.current.nbSold, label: 'Ex. vendus', alertColor: 'white' }\"\n                [rightStatus]=\"{\n                  value: comparedParutions.current.ruptureRate,\n                  label: 'Tx rupture',\n                  isPercent: true,\n                  alertColor: 'orange'\n                }\"\n                [isFromComparator]=\"true\"\n              ></lib-parution>\n              <div class=\"container-modal-content-previous no-homologous\">\n                Pas de parution \u00E0 cette date l'ann\u00E9e pr\u00E9c\u00E9dente\n              </div>\n            </div>\n          </ng-container>\n        </ng-template>\n      </ng-container>\n      <ng-template #noParutionsToCompare>\n        <div class=\"no-parutions-to-compare\">Pas de parutions disponibles \u00E0 la comparaison pour cette parution</div>\n      </ng-template>\n    </div>\n  </div>\n</div>\n",
                    providers: [DatePipe],
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container .container-modal-button{cursor:pointer}.container .container-modal-button .container-modal-button-icon{background-color:rgba(15,17,18,.8);display:flex;justify-content:center;align-items:center;width:38px;height:40px;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.container .container-modal-overlay{opacity:1;background-color:#0f1112;position:fixed;top:0;left:0;width:100%;height:100%;z-index:10200}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container .container-modal-overlay{height:100vw}}.container .container-modal-content{opacity:1;position:fixed;left:15px;top:44px;background-color:#0f1112;color:#fff;overflow:auto;height:100%;z-index:10300}.container .container-modal-content .container-modal-content-header{display:flex;justify-content:space-between;font-size:2rem}.container .container-modal-content .container-modal-content-header .container-modal-content-title{width:100%;text-align:center;font-weight:500}.container .container-modal-content .container-modal-content-header .container-modal-content-close{cursor:pointer}.container .container-modal-content .container-modal-content-selector{text-align:center;margin:64px auto}.container .container-modal-content .container-modal-content-selector .container-modal-content-selector-title{font-size:1.6rem;color:#657478;margin-bottom:16px}@media (min-width:1140px){.container .container-modal-content{width:90%;top:0;background-color:#0f1112;padding:45px 16px}.container .container-modal-content .container-modal-content-selector{display:flex;justify-content:center;align-items:center;margin:98px auto;text-align:left}.container .container-modal-content .container-modal-content-selector .container-modal-content-selector-title{margin-bottom:0;margin-right:16px}}.container .container-modal-content .container-modal-content-parutions,.container .container-modal-content .container-modal-content-selector .container-modal-content-selector-navigator{display:flex;justify-content:center}.container .container-modal-content .container-modal-content-parutions .container-modal-content-now{margin-right:4px}.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous{margin-left:4px}.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous.no-homologous{margin-top:8%;text-align:center;width:168px}@media (min-width:1140px){.container .container-modal-content .container-modal-content-parutions .container-modal-content-now{margin-right:24px}.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous{margin-left:24px}.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous.no-homologous{width:249px}}::-webkit-scrollbar{display:none}.no-parutions-to-compare{display:flex;justify-content:center}"]
                }] }
    ];
    /** @nocollapse */
    ComparatorComponent.ctorParameters = function () { return [
        { type: HttpClient },
        { type: DatePipe }
    ]; };
    ComparatorComponent.propDecorators = {
        apiUrl: [{ type: Input }]
    };
    return ComparatorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavTabsComponent = /** @class */ (function () {
    function NavTabsComponent() {
        this.background = 'yellow';
        this.updateMessage = false;
        this.tabSelected = new EventEmitter();
    }
    Object.defineProperty(NavTabsComponent.prototype, "tabs", {
        get: /**
         * @return {?}
         */
        function () {
            return this._tabs;
        },
        set: /**
         * @param {?} tabs
         * @return {?}
         */
        function (tabs) {
            this._tabs = tabs;
            /** @type {?} */
            var activeIndex = this._tabs.findIndex(function (tab) { return tab.isActive === true; });
            this.activeTab = activeIndex === -1 ? 0 : activeIndex;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NavTabsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} tabIndex
     * @return {?}
     */
    NavTabsComponent.prototype.onSelectTab = /**
     * @param {?} tabIndex
     * @return {?}
     */
    function (tabIndex) {
        var _this = this;
        this.activeTab = tabIndex;
        this.tabs.forEach(function (tab, index) {
            if (tabIndex === index) {
                tab.isActive = true;
                _this.tabSelected.emit(tab);
            }
            else {
                tab.isActive = false;
            }
        });
    };
    NavTabsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-nav-tabs',
                    template: "<ng-container *ngIf=\"updateMessage\">\n  <div class=\"status mobile\">\n    <div [ngClass]=\"{'not-updated': !tabs[activeTab].isUpToDate}\">{{ tabs[activeTab].updateLabel }}</div>\n    <div class=\"not-updated\" *ngIf=\"!tabs[activeTab].isUpToDate\">Donn\u00E9es non remises \u00E0 jour</div>\n    <div class=\"details\">{{ tabs[activeTab].tooltip }}</div>\n  </div>\n</ng-container>\n<div class=\"nav-tabs\">\n  <div class=\"tabs\">\n    <ng-container *ngFor=\"let tab of tabs; let i = index\">\n      <a\n        role=\"button\"\n        class=\"nav-tabs-tab\"\n        [ngClass]=\"[background, tab.isActive ? 'active' : '']\"\n        (click)=\"onSelectTab(i)\"\n      >\n        {{ tab.label }}\n      </a>\n    </ng-container>\n  </div>\n  <ng-container *ngIf=\"updateMessage\">\n    <div class=\"status desktop\">\n      <div [ngClass]=\"{'not-updated': !tabs[activeTab].isUpToDate}\">{{ tabs[activeTab].updateLabel }}</div>\n      <div class=\"not-updated\" *ngIf=\"!tabs[activeTab].isUpToDate\">Donn\u00E9es non remises \u00E0 jour</div>\n      <div class=\"details\">{{ tabs[activeTab].tooltip }}</div>\n    </div>\n  </ng-container>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.nav-tabs{display:flex;color:#000;height:40px;justify-content:space-between}.nav-tabs .nav-tabs-tab{font-size:1.4rem;font-weight:600;padding:9px 16px;margin-right:9px;color:#657478;display:flex;align-items:center;justify-content:center;line-height:14px;cursor:pointer}.nav-tabs .nav-tabs-tab.active{color:#0f1112;border-radius:24px}.nav-tabs .nav-tabs-tab.active.slategray{background:rgba(122,140,145,.16)}.nav-tabs .nav-tabs-tab.active.yellow{background:#ffec00}.nav-tabs .nav-tabs-tab.active.alabster{background:#f7f7f7}.tabs{display:flex;align-items:center}.status{margin-right:10px;font-size:1.4rem;font-weight:500;color:#657478;align-items:center}.status.desktop{display:none}.status.mobile{display:block;margin-bottom:24px;justify-content:end;text-align:right}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.nav-tabs .nav-tabs-tab{padding:11px 24px;font-size:1.6rem}.status.desktop{display:block}.status.mobile{display:none}}.status .not-updated{color:#ee3251;text-align:right}.details{font-size:1.3rem;font-weight:100;color:#657478;text-align:right}"]
                }] }
    ];
    /** @nocollapse */
    NavTabsComponent.ctorParameters = function () { return []; };
    NavTabsComponent.propDecorators = {
        tabs: [{ type: Input, args: ['tabs',] }],
        background: [{ type: Input }],
        updateMessage: [{ type: Input }],
        tabSelected: [{ type: Output }]
    };
    return NavTabsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var NavTabsMetadata = {
    declarations: [NavTabsComponent],
    imports: [CommonModule, TooltipModule],
    exports: [NavTabsComponent],
};
var NavTabsModule = /** @class */ (function () {
    function NavTabsModule() {
    }
    NavTabsModule.decorators = [
        { type: NgModule, args: [NavTabsMetadata,] }
    ];
    return NavTabsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ParutionMetadata = {
    declarations: [ParutionComponent, ComparatorComponent],
    imports: [CommonModule, PublicationStateModule, HttpClientModule, NavTabsModule, IconModule, PipesModule.forRoot(), ButtonGoldModule],
    exports: [ParutionComponent, ComparatorComponent],
};
var ParutionModule = /** @class */ (function () {
    function ParutionModule() {
    }
    ParutionModule.decorators = [
        { type: NgModule, args: [ParutionMetadata,] }
    ];
    return ParutionModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RankingComponent = /** @class */ (function () {
    function RankingComponent() {
        this.displayMore = false;
        this.tab = 'top';
    }
    Object.defineProperty(RankingComponent.prototype, "top", {
        get: /**
         * @return {?}
         */
        function () {
            return this._top;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._top = value;
            if (this.tab === 'top') {
                this.data = this._top;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RankingComponent.prototype, "flop", {
        get: /**
         * @return {?}
         */
        function () {
            return this._flop;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._flop = value;
            if (this.tab === 'flop') {
                this.data = this._flop;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RankingComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.data = this.top;
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    RankingComponent.prototype.onSelectTab = /**
     * @param {?} tab
     * @return {?}
     */
    function (tab) {
        this.tab = tab;
        if (tab === 'top') {
            this.data = this.top;
        }
        else {
            this.data = this.flop;
        }
    };
    RankingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ranking',
                    template: "<div class=\"ranking-container\">\n  <div class=\"ranking-tabs\" [ngSwitch]=\"type\">\n    <lib-nav-switch\n      *ngSwitchCase=\"'resellers'\"\n      [tabs]=\"[\n        { label: 'Top 100 vendeurs*', value: 'top', isActive: true, iconArrow: 'up' },\n        { label: 'Top 100 vendeurs', value: 'flop', isActive: false, iconArrow: 'down' }\n      ]\"\n      background=\"slategray\"\n      (tabSelected)=\"onSelectTab($event)\"\n    ></lib-nav-switch>\n    <lib-nav-switch\n      *ngSwitchCase=\"'publications'\"\n      [tabs]=\"[\n        { label: 'Top parutions', value: 'top', isActive: true },\n        { label: 'Flop parutions', value: 'flop', isActive: false }\n      ]\"\n      background=\"slategray\"\n      (tabSelected)=\"onSelectTab($event)\"\n    ></lib-nav-switch>\n    <lib-nav-switch\n      *ngSwitchCase=\"'titles'\"\n      [tabs]=\"[\n        { label: 'Top titres', value: 'top', isActive: true },\n        { label: 'Flop titres', value: 'flop', isActive: false }\n      ]\"\n      background=\"slategray\"\n      (tabSelected)=\"onSelectTab($event)\"\n    ></lib-nav-switch>\n  </div>\n  <div *ngFor=\"let item of data; let i = index; let first = first\" class=\"relative\">\n    <lib-button-gold\n      [subscription]=\"displayCode?.rankings\"\n      [text]=\"type === 'resellers' ? 'Top vendeurs' : type === 'publications' ? 'Top parutions' : 'Top titres'\"\n      [center]=\"true\"\n      type=\"button\"\n      *ngIf=\"displayCode?.rankings > 1 && i > 4 && (i < 8 || displayMore)\"\n    ></lib-button-gold>\n    <lib-ranking-item\n      *ngIf=\"i < 8 || displayMore\"\n      [blur]=\"displayCode?.rankings > 1 && i > 4 && (i < 8 || displayMore)\"\n      [type]=\"type\"\n      [index]=\"i + 1\"\n      [item]=\"item\"\n      [expanded]=\"first\"\n      [compareMode]=\"compareMode\"\n      [ngClass]=\"{ 'ranking-item': true, 'ranking-item-first': first }\"\n    ></lib-ranking-item>\n  </div>\n  <div *ngIf=\"type === 'resellers'\" class=\"ranking-asterisk-label\">*Bas\u00E9 sur les 100 plus gros vendeurs.</div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.ranking-item{margin-bottom:18px}.ranking-tabs{border-bottom:1px solid #f7f7f7;margin-bottom:12px;padding:0 16px 23px}.ranking-container{margin:0 16px}.ranking-container .relative{position:relative}.ranking-asterisk-label{color:#657478;font-size:1.3rem;margin-top:30px;margin-bottom:12px;padding:0 16px}.ranking-item-first{margin-bottom:30px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.ranking-asterisk-label{margin-top:20px}.ranking-item-first{margin-bottom:28px}}"]
                }] }
    ];
    /** @nocollapse */
    RankingComponent.ctorParameters = function () { return []; };
    RankingComponent.propDecorators = {
        type: [{ type: Input }],
        displayMore: [{ type: Input }],
        displayCode: [{ type: Input }],
        compareMode: [{ type: Input }],
        top: [{ type: Input }],
        flop: [{ type: Input }]
    };
    return RankingComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RankingItemComponent = /** @class */ (function () {
    function RankingItemComponent() {
        this.blur = false;
    }
    /**
     * @return {?}
     */
    RankingItemComponent.prototype.getColor = /**
     * @return {?}
     */
    function () {
        return this.index === 1 ? 'yellow' : 'white';
    };
    RankingItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ranking-item',
                    template: "<div class=\"container\" [ngClass]=\"{'text-blur': blur}\">\n  <ng-container *ngIf=\"expanded; else closeItem\">\n    <lib-badge [content]=\"index\" [background]=\"getColor()\"></lib-badge>\n    <div class=\"ranking-item-wrap expanded\">\n      <div class=\"ranking-item-name expanded\">{{ item.name }}</div>\n      <div *ngIf=\"type === 'resellers'\" class=\"ranking-item-location\">{{ item.display }}</div>\n      <div class=\"ranking-item-wrap-expanded\">\n        <div *ngIf=\"type === 'publications'\" class=\"ranking-item-image\">\n          <img [src]=\"item.display\" alt=\"Cover\" />\n        </div>\n        <div>\n          <div class=\"ranking-item-data-value value-expanded\">{{ item.values.value | number: '':'fr-FR' }}</div>\n          <div class=\"ranking-item-number-sold-expanded\">Exemplaires Vendus</div>\n          <div>\n            <span class=\"ranking-item-data-value mirror-expanded\">{{ item.values.mirror | versuspercent }}</span>\n            <span *ngIf=\"!compareMode\" class=\"ranking-item-data-label mirror-expanded\"> VS ann\u00E9e-1</span>\n            <span *ngIf=\"compareMode\" class=\"ranking-item-data-label mirror-expanded\"> VS parution comp.</span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n\n  <ng-template #closeItem>\n    <div class=\"ranking-item-wrap-close\">\n      <lib-badge [content]=\"index\" [background]=\"getColor()\" [blur]=\"blur\"></lib-badge>\n      <div class=\"ranking-item-wrap\">\n        <div class=\"ranking-item-name\">{{ item.name }}</div>\n        <div *ngIf=\"type === 'resellers'\" class=\"ranking-item-location\">{{ item.display }}</div>\n        <span class=\"ranking-item-data-label\">vte </span>\n        <span class=\"ranking-item-data-value closed\">{{ item.values.value | number: '':'fr-FR' }} ex</span>\n        <span class=\"ranking-item-data-value\">{{ item.values.mirror | versuspercent }}</span>\n        <span *ngIf=\"!compareMode\" class=\"ranking-item-data-label\"> VS ann\u00E9e-1</span>\n        <span *ngIf=\"compareMode\" class=\"ranking-item-data-label\"> VS parution comp.</span>\n      </div>\n    </div>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{display:flex;max-width:288px;padding:0 16px}.ranking-item-wrap-close{display:flex;align-items:center;height:70px}.ranking-item-wrap{display:inline-block;margin-left:16px;color:#0f1112;position:relative}.ranking-item-wrap.expanded{min-height:165px}.ranking-item-wrap-expanded{display:flex;align-items:center;height:104px;margin-top:11px}.ranking-item-image{align-items:center;display:flex;justify-content:center;width:80px;height:104px;margin-right:16px}.ranking-item-image>img{max-width:100%;max-height:100%}.ranking-item-name{font-size:1.4rem;font-weight:500;line-height:1.2}.ranking-item-name.expanded{font-size:1.6rem;line-height:1.3}.ranking-item-location{color:#657478;font-size:1.2rem;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:200px}.ranking-item-number-sold-expanded{font-size:1.3rem;font-weight:500;margin-bottom:8px}.ranking-item-data-value{font-family:\"Roboto Slab\",serif;color:#2d54d2;font-size:1.6rem;font-weight:300}.ranking-item-data-value.mirror-expanded{font-size:2rem}.ranking-item-data-value.value-expanded{font-size:2.4rem}.ranking-item-data-label{font-size:1.3rem;color:#657478}.ranking-item-data-label.mirror-expanded{font-size:1.4rem}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container{max-width:100%;padding:0}.ranking-item-location{width:253px}.ranking-item-data-label{font-size:1.4rem}}.closed{border-right:1px solid rgba(15,17,18,.12);padding-right:7px;margin-right:7px}.text-blur .ranking-item-data-label,.text-blur .ranking-item-data-value,.text-blur .ranking-item-location,.text-blur .ranking-item-wrap{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}"]
                }] }
    ];
    /** @nocollapse */
    RankingItemComponent.ctorParameters = function () { return []; };
    RankingItemComponent.propDecorators = {
        index: [{ type: Input }],
        expanded: [{ type: Input }],
        item: [{ type: Input }],
        type: [{ type: Input }],
        blur: [{ type: Input }],
        compareMode: [{ type: Input }]
    };
    return RankingItemComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RankingItemMetadata = {
    declarations: [RankingItemComponent],
    imports: [CommonModule, FormsModule, BadgeModule, PipesModule.forRoot()],
    exports: [RankingItemComponent],
};
var RankingItemModule = /** @class */ (function () {
    function RankingItemModule() {
    }
    RankingItemModule.decorators = [
        { type: NgModule, args: [RankingItemMetadata,] }
    ];
    return RankingItemModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RankingMetadata = {
    declarations: [RankingComponent],
    imports: [CommonModule, HttpClientModule, RankingItemModule, NavSwitchModule, ButtonGoldModule],
    exports: [RankingComponent],
};
var RankingModule = /** @class */ (function () {
    function RankingModule() {
    }
    RankingModule.decorators = [
        { type: NgModule, args: [RankingMetadata,] }
    ];
    return RankingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SalesSegmentLineComponent = /** @class */ (function () {
    function SalesSegmentLineComponent() {
        this.line = 0;
    }
    Object.defineProperty(SalesSegmentLineComponent.prototype, "salesSegmentLine", {
        get: /**
         * @return {?}
         */
        function () {
            return this._salesSegmentLine;
        },
        set: /**
         * @param {?} salesSegmentLine
         * @return {?}
         */
        function (salesSegmentLine) {
            this._salesSegmentLine = salesSegmentLine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentLineComponent.prototype, "orientation", {
        get: /**
         * @return {?}
         */
        function () {
            return this.salesSegmentLine.values.value > this.salesSegmentLine.values.mirror ? 'up' : 'down';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentLineComponent.prototype, "marketEvolution", {
        get: /**
         * @return {?}
         */
        function () {
            return this.salesSegmentLine.values[this.filterMarket] > this.salesSegmentLine.values.value ? 'up' : 'down';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentLineComponent.prototype, "circleColor", {
        get: /**
         * @return {?}
         */
        function () {
            return this.salesSegmentLine.values.value > this.salesSegmentLine.values.mirror ? 'green' : 'orange';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentLineComponent.prototype, "marketCircle", {
        get: /**
         * @return {?}
         */
        function () {
            return this.salesSegmentLine.values[this.filterMarket] > this.salesSegmentLine.values.value ? 'green' : 'orange';
        },
        enumerable: true,
        configurable: true
    });
    SalesSegmentLineComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-sales-segment-line',
                    template: "<div class=\"container\" *ngIf=\"salesSegmentLine\">\n  <div class=\"container-line\" [ngClass]=\"{ main: isMain }\">\n    <!-- TITLE -->\n    <div class=\"container-line-title\" *ngIf=\"isMain\">\n      <div class=\"desktop-title\">{{ salesSegmentLine?.salesPointType }}</div>\n      <div class=\"mobile-title\">{{ salesSegmentLine?.salesPointType }}</div>\n    </div>\n    <div class=\"container-line-title\" *ngIf=\"!isMain\">{{ salesSegmentLine?.salesPointType }}</div>\n    <div class=\"container-line-content\">\n      <!-- SALES -->\n      <div class=\"container-line-global\" [ngClass]=\"{'text-blur': salesSegmentLine?.values?.displayCode['value'] > 1}\">\n        <lib-button-gold\n          [column]=\"true\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [subscription]=\"salesSegmentLine?.values?.displayCode['value']\"\n          [text]=\"'Ventes'\"\n          [center]=\"true\"\n          type=\"button\"\n          *ngIf=\"(line === 2 || line === 0) && salesSegmentLine?.values?.displayCode['value'] > 1\"\n        ></lib-button-gold>\n        <div class=\"container-line-global-label\" *ngIf=\"isMain\">Ventes</div>\n        <div class=\"container-line-global-data\">\n          <lib-percentage-circle\n            *ngIf=\"isMain && salesSegmentLine?.values?.displayCode['value'] === 1\"\n            [percentage]=\"salesSegmentLine?.values?.value * 100\"\n            [color]=\"circleColor\"\n            [size]=\"55\"\n            class=\"no-mobile-display main-circle\"\n          ></lib-percentage-circle>\n          <lib-arrow-indicator\n            *ngIf=\"isMain\"\n            [content]=\"salesSegmentLine?.values?.value\"\n            [orientation]=\"orientation\"\n            [blur]=\"salesSegmentLine?.values?.displayCode['value'] > 1\"\n            size=\"28\"\n            class=\"main-height no-mobile-display\"\n          ></lib-arrow-indicator>\n          <lib-arrow-indicator\n            *ngIf=\"isMain\"\n            [content]=\"salesSegmentLine?.values?.value\"\n            [orientation]=\"orientation\"\n            size=\"24\"\n            class=\" main-height no-desktop-display \"\n          ></lib-arrow-indicator>\n          <lib-arrow-indicator\n            *ngIf=\"!isMain\"\n            [content]=\"salesSegmentLine?.values?.value\"\n            [blur]=\"salesSegmentLine?.values?.displayCode['value'] > 1\"\n            [orientation]=\"orientation\"\n          ></lib-arrow-indicator>\n        </div>\n      </div>\n\n      <!-- PREVIOUS YEAR -->\n      <div class=\"container-line-previous\" [ngClass]=\"{'text-blur': salesSegmentLine?.values?.displayCode['mirror'] > 1}\">\n        <lib-button-gold\n          [column]=\"true\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [subscription]=\"salesSegmentLine.values.displayCode['mirror']\"\n          [text]=\"'Ann\u00E9e-1'\"\n          [center]=\"true\"\n          type=\"button\"\n          *ngIf=\"(line === 2 || line === 0) && salesSegmentLine?.values?.displayCode['mirror'] > 1\"\n        ></lib-button-gold>\n        <div class=\"container-line-previous-label\" *ngIf=\"!compareMode\">Ann\u00E9e-1</div>\n        <div class=\"container-line-previous-label\" *ngIf=\"compareMode\">Parution comp.</div>\n        <lib-percentage-circle\n          *ngIf=\"isMain && salesSegmentLine?.values?.displayCode['value'] === 1\"\n          [percentage]=\"salesSegmentLine?.values?.mirror * 100\"\n          color=\"black\"\n          [size]=\"55\"\n          class=\"no-mobile-display main-circle\"\n        ></lib-percentage-circle>\n        <div class=\"container-line-previous-data main-height\">\n          {{ salesSegmentLine?.values?.mirror | percent: '.0-1' }}\n        </div>\n      </div>\n\n      <!-- MARKET COMPARE -->\n      <div class=\"container-line-market\" [ngClass]=\"{'text-blur': (salesSegmentLine?.values?.displayCode)[filterMarket] > 1}\">\n        <lib-button-gold\n          [column]=\"true\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [subscription]=\"(salesSegmentLine?.values?.displayCode)[filterMarket]\"\n          [text]=\"marketLabel\"\n          [center]=\"true\"\n          type=\"button\"\n          *ngIf=\"(line === 2 || line === 0) && (salesSegmentLine?.values?.displayCode)[filterMarket] > 1\"\n        ></lib-button-gold>\n        <div class=\"container-line-market-label\">{{ marketLabel }}</div>\n        <lib-percentage-circle\n          *ngIf=\"isMain && salesSegmentLine?.values?.displayCode['value'] === 1\"\n          [percentage]=\"(salesSegmentLine?.values)[filterMarket] * 100\"\n          [color]=\"marketCircle\"\n          [size]=\"55\"\n          class=\"no-mobile-display main-circle\"\n        ></lib-percentage-circle>\n        <div class=\"container-line-market-data main-height\">\n          {{ (salesSegmentLine?.values)[filterMarket] | percent: '.0-1' }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{color:#0f1112}.container .text-blur{min-width:70px}.container .container-line .container-line-title{display:inline-block;font-weight:500;font-size:1.4rem;margin-bottom:4px}.container .container-line .container-line-title .mobile-title{display:block}.container .container-line .container-line-title .desktop-title{display:none}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container .container-line{display:flex;align-items:flex-end;justify-content:space-between}.container .container-line .container-line-title{max-width:100px}.container .container-line .container-line-title .desktop-title{display:flex;align-items:center}.container .container-line .container-line-title .desktop-title .container-line-title-badge{margin-right:13px}.container .container-line .container-line-title .mobile-title{display:none}}.container .container-line .container-line-content{display:flex;align-items:center;width:260px;justify-content:flex-end;position:relative}.container .container-line .container-line-content .container-line-global-label{display:none}.container .container-line .container-line-content .container-line-global-label.text-blur,.container .container-line .container-line-content .container-line-global.text-blur,.container .container-line .container-line-content .container-line-market.text-blur,.container .container-line .container-line-content .container-line-previous.text-blur{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}.container .container-line .container-line-content .container-line-previous{padding-left:57px;padding-right:14px;color:#657478;border-right:1px solid #657478}@media (min-width:1140px){.container .container-line .container-line-content{width:auto;justify-content:flex-start}.container .container-line .container-line-content .container-line-global,.container .container-line .container-line-content .container-line-global-label,.container .container-line .container-line-content .container-line-market,.container .container-line .container-line-content .container-line-previous{position:relative}.container .container-line .container-line-content .container-line-previous{color:#0f1112;padding-left:21px;justify-content:flex-end}.container .container-line .container-line-content .container-line-market-label,.container .container-line .container-line-content .container-line-previous-label{display:none}}.container .container-line .container-line-content .container-line-market{padding-left:14px}.container .container-line .container-line-content .container-line-market-label,.container .container-line .container-line-content .container-line-previous-label{font-size:1.2rem}.container .container-line .container-line-content .container-line-market-data,.container .container-line .container-line-content .container-line-previous-data{font-family:\"Roboto Slab\",serif;font-size:1.6rem;font-weight:300}.container .container-line .container-line-content .container-line-market.text-blur .container-line-market-data,.container .container-line .container-line-content .container-line-market.text-blur .container-line-previous-data,.container .container-line .container-line-content .container-line-previous.text-blur .container-line-market-data,.container .container-line .container-line-content .container-line-previous.text-blur .container-line-previous-data{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}.container .container-line .no-mobile-display{display:none}@media (min-width:1140px){.container .container-line .container-line-content .container-line-market-data,.container .container-line .container-line-content .container-line-previous-data{font-size:1.8rem;width:45px;color:#0f1112}.container .container-line .no-mobile-display{display:flex;justify-content:center}.container .main{display:block}.container .main .container-line-title{max-width:none;font-size:2.1rem;margin-bottom:21px}.container .main .container-line-content{align-items:flex-end}.container .main .container-line-content .container-line-global-label,.container .main .container-line-content .container-line-market-label,.container .main .container-line-content .container-line-previous-label{display:flex;justify-content:center;font-size:1.2rem;margin-bottom:18px}.container .main .container-line-content .container-line-market-data,.container .main .container-line-content .container-line-previous-data{font-size:2.4rem;width:auto}.container .main .container-line-content .container-line-previous{border-right:none}.container .main .main-circle{margin-bottom:16px}.container .main .main-height{height:40px;align-items:flex-end;display:flex;justify-content:center}.container .main .main-height.no-desktop-display{display:none}}"]
                }] }
    ];
    SalesSegmentLineComponent.propDecorators = {
        salesSegmentLine: [{ type: Input }],
        isMain: [{ type: Input }],
        filterMarket: [{ type: Input }],
        marketLabel: [{ type: Input }],
        line: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        compareMode: [{ type: Input }]
    };
    return SalesSegmentLineComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SalesSegmentLineMetadata = {
    declarations: [SalesSegmentLineComponent],
    imports: [CommonModule, ArrowIndicatorModule, BadgeModule, PercentageCircleModule, PipesModule.forRoot(), ButtonGoldModule],
    exports: [SalesSegmentLineComponent],
};
var SalesSegmentLineModule = /** @class */ (function () {
    function SalesSegmentLineModule() {
    }
    SalesSegmentLineModule.decorators = [
        { type: NgModule, args: [SalesSegmentLineMetadata,] }
    ];
    return SalesSegmentLineModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ToasterComponent = /** @class */ (function () {
    function ToasterComponent() {
    }
    /**
     * @return {?}
     */
    ToasterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} toast
     * @return {?}
     */
    ToasterComponent.prototype.onCloseToastClicked = /**
     * @param {?} toast
     * @return {?}
     */
    function (toast) {
        // Remove the clicked toast.
        /** @type {?} */
        var toastIndex = this.toasts.indexOf(toast);
        if (toastIndex > -1) {
            this.toasts.splice(toastIndex, 1);
        }
    };
    ToasterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-toaster',
                    template: "<!-- <div @list class=\"list-container\"> -->\n<div @items *ngFor=\"let toast of toasts\" class=\"toast {{ toast.messageType }}\" (click)=\"onCloseToastClicked(toast)\">\n  <span class=\"toast-message\" [innerHTML]=\"toast.message\"></span>\n  <div class=\"toast-timer\" [style.animation-duration]=\"toast.timeoutInMs + 'ms'\"></div>\n  <button class=\"toast-close\" (click)=\"onCloseToastClicked(toast)\">x</button>\n</div>\n<!-- </div> -->\n",
                    animations: [
                        trigger('items', [
                            // cubic-bezier for a tiny bouncing feel
                            transition(':enter', [
                                style({ transform: 'translateY(-100%)', opacity: 0 }),
                                animate('300ms', style({ transform: 'translateY(0)', opacity: 1 })),
                            ]),
                            transition(':leave', [
                                style({ transform: 'translateY(0)', opacity: 1 }),
                                animate('300ms', style({ transform: 'translateY(-100%)', opacity: 0.3 })),
                            ]),
                        ]),
                    ],
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}@-webkit-keyframes toast-timer{0%{-webkit-transform:scaleX(0);transform:scaleX(0)}100%{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes toast-timer{0%{-webkit-transform:scaleX(0);transform:scaleX(0)}100%{-webkit-transform:scaleX(1);transform:scaleX(1)}}:host{position:fixed;top:0;left:0;right:0;z-index:10400}.toast{display:block;position:relative;box-sizing:border-box;padding:16px 60px;text-align:center;box-shadow:0 5px 10px rgba(15,17,18,.2);opacity:.9;-webkit-transform-origin:0 0;transform-origin:0 0;margin-bottom:4px;overflow:hidden}.toast.error{background-color:#7a8c91}.toast.success{background-color:#50a747}.toast-message{color:#fff}.toast-close{color:rgba(15,17,18,.5);position:absolute;width:50px;top:0;bottom:0;right:0;background-color:transparent;border:none;border-radius:0;font-weight:700;font-size:1.6rem;cursor:default}.toast-close:focus,.toast-close:hover{outline:0;background-color:rgba(0,0,0,.2)}.toast-timer{position:absolute;bottom:0;left:0;right:0;height:5px;background-color:rgba(0,0,0,.2);-webkit-transform-origin:left;transform-origin:left;-webkit-animation:linear both toast-timer;animation:linear both toast-timer}"]
                }] }
    ];
    /** @nocollapse */
    ToasterComponent.ctorParameters = function () { return []; };
    ToasterComponent.propDecorators = {
        toasts: [{ type: Input }]
    };
    return ToasterComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ToasterMetadata = {
    declarations: [ToasterComponent],
    imports: [BrowserAnimationsModule, CommonModule, HttpClientModule, SelectModule],
    exports: [ToasterComponent],
};
var ToasterModule = /** @class */ (function () {
    function ToasterModule() {
    }
    ToasterModule.decorators = [
        { type: NgModule, args: [ToasterMetadata,] }
    ];
    return ToasterModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var TAB_ITEMS_ENUM = {
    ALL: 'all',
    WAREHOUSE: 'warehouse',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MapWarehouseDetailsComponent = /** @class */ (function () {
    function MapWarehouseDetailsComponent(http) {
        this.http = http;
        this.tabItemsEnum = TAB_ITEMS_ENUM;
        this.currentTab = TAB_ITEMS_ENUM.ALL;
        this.displayAll = false;
        this.loadingMessage = 'Chargement...';
        this.selectedSegmentId = null;
        this.filters = {
            all: {
                filterOptions: [{ value: null, label: 'Tous les segments' }],
                filterPlaceholder: 'Tous les segments',
                selectedFilterItem: null,
                tipsText: '*Les données France entière sont  extrapolées',
            },
            warehouse: {
                filterOptions: [],
                filterPlaceholder: 'Sélectionner un dépôt',
                selectedFilterItem: null,
                tipsText: '',
            },
        };
        // TMP, used to change between previous, homologous but now attribute name doesn't change
        this.numberToCompare = 'comparePublication';
        this.isSegmentLoading = false;
        this.displayCode = 1;
        this.tabChange = new EventEmitter();
        this.warehouseChange = new EventEmitter();
        this.segmentChange = new EventEmitter();
    }
    Object.defineProperty(MapWarehouseDetailsComponent.prototype, "currentParution", {
        get: /**
         * @return {?}
         */
        function () {
            return this._currentParution;
        },
        set: /**
         * @param {?} parution
         * @return {?}
         */
        function (parution) {
            this._currentParution = parution;
            this.JNbr = (this._currentParution.soldDuration ? this._currentParution.soldDuration.toString() : '*');
            this.currentParutionJText = 'PDV vendeurs à J' + this.JNbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapWarehouseDetailsComponent.prototype, "market", {
        get: /**
         * @return {?}
         */
        function () {
            return this._market;
        },
        set: /**
         * @param {?} currentMarket
         * @return {?}
         */
        function (currentMarket) {
            this._market = currentMarket;
            this.marketSoldItems = this.market === 'family' ? 'familySoldItems' : 'marketSoldItems';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapWarehouseDetailsComponent.prototype, "warehouseDetails", {
        get: /**
         * @return {?}
         */
        function () {
            return this._warehouseDetails;
        },
        set: /**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            this._warehouseDetails = data;
            this.displayCode = data.displayCode.all;
            this.filters.warehouse.tipsText = "Les donn\u00E9es d\u00E9p\u00F4t sont bas\u00E9es sur un panel significatif de " + data.nbSellers + " diffuseurs.";
            this.currentStats = this.getCurrentStats(this.currentTab, this._currentWarehouse);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapWarehouseDetailsComponent.prototype, "currentWarehouse", {
        get: /**
         * @return {?}
         */
        function () {
            return this._currentWarehouse;
        },
        set: /**
         * @param {?} currentWarehouse
         * @return {?}
         */
        function (currentWarehouse) {
            if (currentWarehouse && !isNull(currentWarehouse)) {
                this._currentWarehouse = currentWarehouse;
                this.currentTab = TAB_ITEMS_ENUM.WAREHOUSE;
                this.filters.warehouse.selectedFilterItem = this.getSelectedWarehouseItem(this._currentWarehouse);
            }
            else {
                this._currentWarehouse = null;
                this.currentTab = TAB_ITEMS_ENUM.ALL;
                this.filters.warehouse.selectedFilterItem = null;
            }
            this.currentStats = this.getCurrentStats(this.currentTab, this._currentWarehouse);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.filters.all.filterOptions = __spread(this.filters.all.filterOptions, this.getSegmentList());
        this.filters.warehouse.filterOptions = __spread(this.filters.warehouse.filterOptions, this.getWarehouseList());
        if (this.selectedSegmentId) {
            /** @type {?} */
            var selectedFilter = void 0;
            for (var i = 0; i < this.filters.all.filterOptions.length; i++) {
                /** @type {?} */
                var currentFilter = this.filters.all.filterOptions[i];
                if (currentFilter.value && currentFilter.value === this.selectedSegmentId) {
                    selectedFilter = currentFilter;
                    break;
                }
            }
            this.filters.all.selectedFilterItem = selectedFilter;
        }
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.handleTabChange = /**
     * @param {?} tab
     * @return {?}
     */
    function (tab) {
        this.currentTab = tab;
        this.displayAll = false;
        if (this.currentTab === TAB_ITEMS_ENUM.ALL) {
            this.currentWarehouse = null;
            this.warehouseChange.emit(this.currentWarehouse);
            this.filters.all.selectedFilterItem = null;
            this.segmentChange.emit(null);
        }
        else {
            this.currentStats = this.getCurrentStats(this.currentTab, this.currentWarehouse);
        }
        this.tabChange.emit(this.currentTab);
    };
    /**
     * @param {?} filterValue
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.handleFilterChange = /**
     * @param {?} filterValue
     * @return {?}
     */
    function (filterValue) {
        switch (this.currentTab) {
            case TAB_ITEMS_ENUM.WAREHOUSE:
                if (filterValue) {
                    this.currentWarehouse = filterValue.value || isNull(filterValue.value) ? filterValue.value : filterValue;
                }
                else {
                    this.currentWarehouse = null;
                }
                this.warehouseChange.emit(this.currentWarehouse);
                break;
            case TAB_ITEMS_ENUM.ALL:
                this.filters.all.selectedFilterItem = filterValue;
                this.segmentChange.emit(filterValue.value || isNull(filterValue.value) ? filterValue.value : filterValue);
                break;
        }
    };
    /**
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.getWarehouseList = /**
     * @return {?}
     */
    function () {
        return (this.warehouseDetails &&
            this.warehouseDetails.warehouses &&
            this.warehouseDetails.warehouses.map(function (item) {
                return { value: item.warehouse.id, label: item.warehouse.name };
            }));
    };
    /**
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.getSegmentList = /**
     * @return {?}
     */
    function () {
        return (this.warehouseDetails &&
            this.warehouseDetails.segments &&
            this.warehouseDetails.segments.map(function (item) {
                return { value: item.id, label: item.label };
            }));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.getSelectedWarehouseItem = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this.getWarehouseList().find(function (item) { return item.value === value; });
    };
    /**
     * @param {?} currentTab
     * @param {?=} currentWarehouse
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.getCurrentStats = /**
     * @param {?} currentTab
     * @param {?=} currentWarehouse
     * @return {?}
     */
    function (currentTab, currentWarehouse) {
        if (currentWarehouse === void 0) { currentWarehouse = null; }
        /** @type {?} */
        var data;
        switch (currentTab) {
            case TAB_ITEMS_ENUM.ALL:
                data = this.warehouseDetails.all;
                break;
            case TAB_ITEMS_ENUM.WAREHOUSE:
                data =
                    currentWarehouse &&
                        this.warehouseDetails.warehouses.find(function (warehouse) { return currentWarehouse === warehouse.warehouse.id; });
                break;
        }
        return data;
    };
    /**
     * @return {?}
     */
    MapWarehouseDetailsComponent.prototype.displayMore = /**
     * @return {?}
     */
    function () {
        this.displayAll = !this.displayAll;
    };
    MapWarehouseDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-map-warehouse-details',
                    template: "<div class=\"container\" [ngClass]=\"{ 'without-data': !currentStats }\">\r\n  <ul class=\"tabs-label-list\">\r\n    <li\r\n      class=\"tab-label-item\"\r\n      [ngClass]=\"{ active: currentTab === tabItemsEnum.ALL }\"\r\n      (click)=\"handleTabChange(tabItemsEnum.ALL)\"\r\n    >\r\n      {{ 'France enti\u00E8re' }}\r\n    </li>\r\n    <li\r\n      class=\"tab-label-item\"\r\n      [ngClass]=\"{ active: currentTab === tabItemsEnum.WAREHOUSE }\"\r\n      (click)=\"handleTabChange(tabItemsEnum.WAREHOUSE)\"\r\n    >\r\n      {{ 'D\u00E9tails par d\u00E9p\u00F4t' }}\r\n    </li>\r\n  </ul>\r\n  <section class=\"tabs-content\">\r\n    <div class=\"filter-container\">\r\n      <lib-select\r\n        [options]=\"filters[currentTab].filterOptions\"\r\n        [placeholder]=\"filters[currentTab].filterPlaceholder\"\r\n        [(model)]=\"filters[currentTab].selectedFilterItem\"\r\n        (change)=\"handleFilterChange($event)\"\r\n        [disabled]=\"displayCode > 1\"\r\n        class=\"filter\"\r\n      ></lib-select>\r\n      <div class=\"select-tips\">\r\n        <span class=\"tips-text\">\r\n          {{ filters[currentTab].tipsText }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div class=\"main-content\" *ngIf=\"currentStats\">\r\n      <ng-container *ngIf=\"isSegmentLoading && currentTab === tabItemsEnum.ALL; else table\">\r\n        <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"medium\"></lib-loader>\r\n      </ng-container>\r\n\r\n      <ng-template #table>\r\n        <div class=\"flex-table\">\r\n          <div class=\"flex-row row-header first\">Donn\u00E9es cumul\u00E9es \u00E0 J{{ JNbr || mevDelay }}</div>\r\n          <div class=\"flex-row row-header\">Num. en vente</div>\r\n          <div\r\n            class=\"flex-row row-header\">{{ comparedParution?.previous ? 'Num. pr\u00E9c.' : comparedParution?.homologous ? 'Num. homo.' : 'Num. comp.' }}</div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            text=\"Part de march\u00E9\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            Part de march\u00E9*\r\n            <span class=\"market\">{{ market === 'family' ? 'sous famille' : 'March\u00E9 SPRINT' }}</span>\r\n          </div>\r\n          <div class=\"flex-row number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats[market]?.currentPublication?.value | percent: '.0-1':'fr-FR' }}\r\n          </div>\r\n          <div class=\"flex-row previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n                  <span>\r\n                    {{ currentStats[market] && (currentStats[market][numberToCompare]?.value | percent: '.0-1':'fr-fr') }}\r\n                  </span>\r\n              <span class=\"points\"\r\n              >{{ currentStats[market] && (currentStats[market][numberToCompare]?.mirror | addSign) }}pts</span\r\n              >\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            text=\"Taux de vente\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            Taux de vente*\r\n          </div>\r\n          <div class=\"flex-row number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats?.soldRate?.currentPublication?.value | percent: '.0-1':'fr-fr' }}\r\n          </div>\r\n          <div class=\"flex-row previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n              <span>{{ (currentStats?.soldRate)[numberToCompare]?.value | percent: '.0-1':'fr-fr' }}</span>\r\n              <span class=\"points\">{{ (currentStats?.soldRate)[numberToCompare]?.mirror | addSign }}pts</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            text=\"Taux de rupture\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            Taux de rupture*\r\n          </div>\r\n          <div class=\"flex-row number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats?.soldOutRate?.currentPublication?.value | percent: '.0-1':'fr-fr' }}\r\n          </div>\r\n          <div class=\"flex-row previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n              <span>{{ (currentStats?.soldOutRate)[numberToCompare]?.value | percent: '.0-1':'fr-fr' }}</span>\r\n              <span class=\"points\">{{ (currentStats?.soldOutRate)[numberToCompare]?.mirror | addSign }}pts</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\" *ngIf=\"displayAll\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            text=\"Ex. fournis\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row flex-row-footer cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            Ex. fournis\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats?.deliveredItems?.currentPublication?.value | number: '':'fr-FR' }}\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n              <span>{{ (currentStats?.deliveredItems)[numberToCompare]?.value | number: '':'fr-FR' }}</span>\r\n              <span class=\"points\">{{\r\n                (currentStats?.deliveredItems)[numberToCompare]?.mirror | custompercent}}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\" *ngIf=\"displayAll\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            text=\"Ex. vendus\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row flex-row-footer cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            Ex. vendus*\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats?.soldItems?.currentPublication?.value | number: '':'fr-FR' }}\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n              <span>{{ (currentStats?.soldItems)[numberToCompare]?.value | number: '':'fr-FR' }}</span>\r\n              <span class=\"points\">{{ (currentStats?.soldItems)[numberToCompare]?.mirror | custompercent }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\" *ngIf=\"displayAll\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            [text]=\"market === 'family' ? 'Ex. vendus ss famille*' : 'Ex. vendus march\u00E9*'\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row flex-row-footer cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ market === 'family' ? 'Ex. vendus ss famille*' : 'Ex. vendus march\u00E9*' }}\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats[marketSoldItems].currentPublication?.value | number: '':'fr-FR' }}\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n              <span>{{ currentStats[marketSoldItems][numberToCompare]?.value | number: '':'fr-FR' }}</span>\r\n              <span class=\"points\">{{\r\n                currentStats[marketSoldItems][numberToCompare]?.mirror | custompercent\r\n                }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\" *ngIf=\"displayAll\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            text=\"PDV servis\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row flex-row-footer cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"pdv\">\r\n              <span>PDV servis</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats?.deliveredResselers?.currentPublication?.value | number: '':'fr-FR' }}\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n              <span>{{ (currentStats?.deliveredResselers)[numberToCompare]?.value | number: '':'fr-FR' }}</span>\r\n              <span class=\"points\">{{\r\n                (currentStats?.deliveredResselers)[numberToCompare]?.mirror | custompercent\r\n                }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"flex-table\" *ngIf=\"displayAll\">\r\n          <lib-button-gold\r\n            [subscription]=\"displayCode\"\r\n            *ngIf=\"displayCode > 1\"\r\n            [text]=\"currentParutionJText\"\r\n            [goldUrl]=\"goldUrl\"\r\n            [accountUrl]=\"accountUrl\"\r\n            [center]=\"true\"\r\n            type=\"button\">\r\n          </lib-button-gold>\r\n          <div class=\"flex-row flex-row-footer cumulative-data first\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"pdv\">\r\n              <span>{{currentParutionJText}}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer number-for-sale\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            {{ currentStats?.sellersCount?.currentPublication?.value | number: '':'fr-FR' }}\r\n          </div>\r\n          <div class=\"flex-row flex-row-footer previous-number\" [ngClass]=\"{'text-blur': displayCode > 1}\">\r\n            <div class=\"previous-number-container\">\r\n              <span>{{ (currentStats?.sellersCount)[numberToCompare]?.value | number: '':'fr-FR' }}</span>\r\n              <span class=\"points\">{{\r\n                (currentStats?.sellersCount)[numberToCompare]?.mirror | custompercent\r\n                }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <button type=\"button\" class=\"button display-more-button\" (click)=\"displayMore()\">\r\n          {{ displayAll ? 'Moins de d\u00E9tails' : 'Plus de d\u00E9tails' }}\r\n          <span class=\"arrow\" [ngClass]=\"[displayAll ? 'up' : 'down']\"></span>\r\n        </button>\r\n      </ng-template>\r\n    </div>\r\n  </section>\r\n</div>\r\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.container{background-color:#f3f5fb}.container.without-data{padding-bottom:12px}.flex-table{display:flex;flex-flow:row wrap;align-items:center;justify-content:space-between;margin-bottom:20px;position:relative}.flex-table .flex-row{width:28.5%;box-sizing:border-box}.flex-table .flex-row.flex-row-footer.number-for-sale{font-size:1.6rem;line-height:1.63}.flex-table .flex-row .pdv{display:flex;align-items:center}.flex-table .flex-row .pdv-tooltips{margin-left:5px}.flex-table .flex-row.first{width:43%}.flex-table .flex-row.row-header{font-size:1.2rem;font-weight:700;line-height:1.33;font-family:Poppins,sans-serif}.flex-table .flex-row.previous-number{font-size:1.6rem;font-weight:300;line-height:1.5;color:#657478;font-family:\"Roboto Slab\",serif}.flex-table .flex-row.previous-number .previous-number-container{display:flex;justify-content:space-between;align-items:baseline}.flex-table .flex-row.previous-number .previous-number-container .points{margin-left:10px;font-size:1.2rem;line-height:2;color:#0f1112}.flex-table .flex-row.previous-number.text-blur .previous-number-container .points{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}.flex-table .flex-row.number-for-sale{font-size:2.4rem;line-height:2.33;font-weight:300;color:#2d54d2;font-family:\"Roboto Slab\",serif}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container.without-data{padding-bottom:24px}.flex-table .flex-row.previous-number .previous-number-container .points{font-size:1.4rem;line-height:1.71}.flex-table .flex-row.number-for-sale{font-size:2.8rem;line-height:2}}.flex-table .flex-row.cumulative-data{font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500;line-height:1.43}.flex-table .flex-row.cumulative-data .market{display:none}.flex-table .flex-row.cumulative-data.text-blur .market,.flex-table .flex-row.text-blur{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}.tabs-label-list{display:flex;list-style:none;margin:0;padding:0;border-radius:4px 4px 0 0;background-color:#a3a9bf}.tab-label-item{cursor:pointer;flex:1;display:flex;align-items:center;justify-content:center;height:60px;padding:0 18px;font-family:Poppins,sans-serif;font-size:1.7rem;font-weight:500;line-height:1.18}.tab-label-item.active{border-radius:4px 4px 0 0;background-color:#f3f5fb}@media (min-width:1140px){.flex-table .flex-row.cumulative-data .market{display:block;font-family:Poppins,sans-serif;font-size:1.2rem;line-height:1.67}.filter-container{display:flex;align-items:center;justify-content:space-between}}.filter-container .filter{flex-grow:1;display:block;margin-bottom:13px}@media (min-width:1140px){.filter-container .filter{margin-bottom:0;margin-right:26px}}.filter-container .select-tips{display:flex;align-items:center}.filter-container .tips-text{margin-right:8px;font-family:Poppins,sans-serif;font-size:1.1rem;line-height:1.18}.filter-container .tips-tooltips{flex-shrink:0}.tabs-content{padding:15px 15px 0}@media (min-width:1140px){.tabs-content{padding:24px 24px 0}}.main-content{position:relative;margin-top:30px;padding-bottom:95px}.display-more-button{position:absolute;display:flex;justify-content:center;align-items:center;bottom:0;left:calc(50% - 81px);width:192px;height:48px;border:none;border-radius:4px 4px 0 0;font-size:1.4rem;font-weight:500;color:#fff;background-color:#a3a9bf;-webkit-appearance:none;-moz-appearance:none;appearance:none}.display-more-button:hover{cursor:pointer}.display-more-button .arrow{width:0;height:0;border-style:solid;margin-left:7px;margin-top:3px}.display-more-button .arrow.up{border-width:0 5px 5px;border-color:transparent transparent #fff}.display-more-button .arrow.down{border-width:5px 5px 0;border-color:#fff transparent transparent}.table-content{width:100%;border-collapse:separate;font-family:\"Roboto Slab\",serif}.table-content .table-head{margin-bottom:15px;text-align:left;font-size:1.2rem;font-weight:500;line-height:1.33;font-family:Poppins,sans-serif;vertical-align:top}.table-content .table-head:after{content:'.';display:block;font-size:10px;color:transparent}.table-content .table-row-cell.cumulative-data{font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500;line-height:1.43}.table-content .table-row-cell.cumulative-data .market{display:none}@media (min-width:1140px){.main-content{margin-top:35px;padding-bottom:80px}.table-content .table-head .first-column{max-width:135px}.table-content .table-row-cell.cumulative-data .market{display:block;font-family:Poppins;font-size:1.2rem;line-height:1.67}}.table-content .table-row-cell.number-for-sale{font-weight:300;color:#2d54d2}.table-content .table-row-cell.previous-number{font-size:1.6rem;font-weight:300;line-height:1.5;color:#657478}.table-content .table-row-cell.previous-number .previous-number-container{display:flex;justify-content:space-between;align-items:baseline}.table-content .table-row-cell.previous-number .previous-number-container .points{margin-left:10px;font-size:1.2rem;line-height:2;color:#0f1112}.warehouse-details .table-row{padding:15px 0}.warehouse-details .table-row:not(:first-child){border-top:1px solid #dcdee4}.warehouse-details .table-row-cell.number-for-sale{font-size:2.4rem;line-height:2.33}.warehouse-advance-details{border-top:2px solid #0f1112}.warehouse-advance-details:before{content:'.';display:block;font-size:20px;color:transparent}@media (min-width:1140px){.table-content .table-row-cell.previous-number .previous-number-container .points{font-size:1.4rem;line-height:1.71}.warehouse-details .table-row-cell.number-for-sale{font-size:2.8rem;line-height:2}.warehouse-advance-details:before{font-size:15px}}.warehouse-advance-details .table-row-cell.number-for-sale{font-size:1.6rem;line-height:1.63}.warehouse-advance-details .pdv{display:flex;align-items:center}.warehouse-advance-details .pdv-tooltips{margin-left:5px}"]
                }] }
    ];
    /** @nocollapse */
    MapWarehouseDetailsComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    MapWarehouseDetailsComponent.propDecorators = {
        currentParution: [{ type: Input }],
        comparedParution: [{ type: Input }],
        comparableParutions: [{ type: Input }],
        selectedSegmentId: [{ type: Input }],
        publicationId: [{ type: Input }],
        market: [{ type: Input }],
        isSegmentLoading: [{ type: Input }],
        mevDelay: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        warehouseDetails: [{ type: Input }],
        currentWarehouse: [{ type: Input, args: ['currentWarehouse',] }],
        tabChange: [{ type: Output }],
        warehouseChange: [{ type: Output }],
        segmentChange: [{ type: Output }]
    };
    return MapWarehouseDetailsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MapWarehouseDetailsMetadata = {
    declarations: [MapWarehouseDetailsComponent],
    imports: [CommonModule, HttpClientModule, SelectModule, LoaderModule, PipesModule.forRoot(), ButtonGoldModule],
    exports: [MapWarehouseDetailsComponent],
};
var MapWarehouseDetailsModule = /** @class */ (function () {
    function MapWarehouseDetailsModule() {
    }
    MapWarehouseDetailsModule.decorators = [
        { type: NgModule, args: [MapWarehouseDetailsMetadata,] }
    ];
    return MapWarehouseDetailsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompareParutionsComponent = /** @class */ (function () {
    function CompareParutionsComponent() {
        this.selectOptions = [];
        this.selectIsOpen = false;
        this.changeComparedParution = new EventEmitter();
        this.openModal = new EventEmitter();
        this.showPreviousParution = false;
        this.showHomologousParution = false;
        this.bisSelectIsOpen = false;
    }
    /**
     * @return {?}
     */
    CompareParutionsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.comparedParution) {
            this.comparedParutionType = this.comparedParution.previous ? 'précédent' : this.comparedParution.homologous ? 'homologue' : 'comparé';
        }
        this.previousParution = this.comparableParutions.find(function (parution) { return parution.previous === true; });
        if (this.previousParution && this.previousParution.publicationId) {
            this.showPreviousParution = true;
            this.selectOptions.push({ label: 'Numéro précédent', value: this.previousParution.publicationId });
        }
        this.homologousParution = this.comparableParutions.find(function (parution) { return parution.homologous === true; });
        if (this.homologousParution && this.homologousParution.publicationId) {
            this.showHomologousParution = true;
            this.selectOptions.push({ label: 'Numéro homologue', value: this.homologousParution.publicationId });
        }
        this.selectOptions.push({ label: 'Choisir une parution', value: '-1' });
    };
    /**
     * @param {?} publicationId
     * @param {?=} modifyRefParution
     * @return {?}
     */
    CompareParutionsComponent.prototype.onChangeComparedParution = /**
     * @param {?} publicationId
     * @param {?=} modifyRefParution
     * @return {?}
     */
    function (publicationId, modifyRefParution) {
        if (publicationId === '-1') {
            this.openModal.emit(modifyRefParution);
        }
        else {
            if (this.comparedParution.publicationId && this.comparedParution.publicationId.toString() !== publicationId) {
                this.changeComparedParution.emit(publicationId);
            }
        }
        this.closeSelect();
    };
    /**
     * @param {?} id
     * @param {?=} bis
     * @return {?}
     */
    CompareParutionsComponent.prototype.openSelect = /**
     * @param {?} id
     * @param {?=} bis
     * @return {?}
     */
    function (id, bis) {
        var _this = this;
        if (bis) {
            this.bisSelectIsOpen = true;
            this.selectIsOpen = false;
        }
        else {
            this.selectIsOpen = true;
            this.bisSelectIsOpen = false;
        }
        document.addEventListener('click', function (event) {
            /** @type {?} */
            var el = document.getElementById(id);
            if (el) {
                /** @type {?} */
                var isClickInside = el.contains(event.target);
                if (!isClickInside) {
                    _this.closeSelect(bis);
                }
            }
        });
    };
    /**
     * @param {?=} bis
     * @return {?}
     */
    CompareParutionsComponent.prototype.closeSelect = /**
     * @param {?=} bis
     * @return {?}
     */
    function (bis) {
        if (bis) {
            this.bisSelectIsOpen = false;
        }
        else {
            this.selectIsOpen = false;
        }
    };
    CompareParutionsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-compare-parutions',
                    template: "<div class=\"global-container\">\n  <div class=\"container\">\n    <div class=\"title-container\">\n      <span class=\"title\">\n        comparer:\n      </span>\n    </div>\n    <div class=\"parution-container border\">\n      <div class=\"parution\">\n        <div class=\"cover\">\n          <img [src]=\"currentParution?.coverUrl\"/>\n        </div>\n        <div class=\"infos-container\">\n          <div class=\"name-container\">\n            <span *ngIf=\"currentParution?.publicationId\">{{ currentParution.publicationId | RemoveAfterHyphenPipe }}\n              \u2022</span>\n            <span *ngIf=\"currentParution?.name\" class=\"name\"> {{ currentParution.name }} </span>\n            <span *ngIf=\"currentParution?.publicationNumber\">n\u00B0{{ currentParution.publicationNumber }}</span>\n          </div>\n          <div class=\"price-mev-container\">\n            <div class=\"price-container\">\n              <div class=\"subtitle\">\n                Prix\n              </div>\n              <div class=\"value\" *ngIf=\"currentParution?.price\">\n                {{ currentParution.price | number: '.2':'fr-FR' }} \u20AC\n              </div>\n            </div>\n            <div class=\"mev-container\">\n              <div class=\"subtitle\">\n                Dates de MEV:\n              </div>\n              <div class=\"value\" *ngIf=\"currentParution?.sellingStartDate && currentParution?.sellingEndDate\">\n                Du {{ currentParution.sellingStartDate | date: 'dd/MM/yy' }} au\n                {{ currentParution.sellingEndDate | date: 'dd/MM/yy' }}\n              </div>\n            </div>\n          </div>\n          <div class=\"ref-container\">\n            <span class=\"type\">\n              Num\u00E9ro \u00E9tudi\u00E9\n            </span>\n          </div>\n          <div *ngIf=\"additonalModifyButton\" class=\"modify-button-container\">\n            <div id=\"bis-responsive-compare-selector\" class=\"modify-button\">\n              <span class=\"modify\" (click)=\"openSelect('bis-responsive-compare-selector', true)\">modifier</span>\n              <div *ngIf=\"bisSelectIsOpen\" class=\"options-container\" (blur)=\"closeSelect()\">\n                <div class=\"option\" (click)=\"onChangeComparedParution(option.value, true)\"\n                     *ngFor=\"let option of selectOptions\">\n                  <span class=\"option-label\">{{ option.label}} </span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"parution-container\">\n      <div class=\"parution\">\n        <div class=\"cover\">\n          <img [src]=\"comparedParution?.coverUrl\"/>\n        </div>\n        <div class=\"infos-container\">\n          <div class=\"name-container\">\n            <span *ngIf=\"comparedParution?.publicationId\">{{ comparedParution.publicationId | RemoveAfterHyphenPipe }}\n              \u2022</span>\n            <span *ngIf=\"comparedParution?.name\" class=\"name\"> {{ comparedParution.name }} </span>\n            <span *ngIf=\"comparedParution?.publicationNumber\">n\u00B0{{ comparedParution.publicationNumber }}</span>\n          </div>\n          <div class=\"price-mev-container\">\n            <div class=\"price-container\">\n              <div class=\"subtitle\">\n                Prix\n              </div>\n              <div class=\"value\" *ngIf=\"comparedParution?.price\">\n                {{ comparedParution.price | number: '.2':'fr-FR' }} \u20AC\n              </div>\n            </div>\n            <div class=\"mev-container\">\n              <div class=\"subtitle\">\n                Dates de MEV:\n              </div>\n              <div class=\"value\" *ngIf=\"comparedParution?.sellingStartDate && comparedParution?.sellingEndDate\">\n                Du {{ comparedParution.sellingStartDate | date: 'dd/MM/yy' }} au\n                {{ comparedParution.sellingEndDate | date: 'dd/MM/yy' }}\n              </div>\n            </div>\n          </div>\n          <div class=\"ref-container\">\n            <span class=\"type\">\n              Num\u00E9ro {{ comparedParutionType }}\n            </span>\n          </div>\n          <div class=\"modify-button-container\">\n            <div id=\"compare-selector\" class=\"modify-button\">\n              <span class=\"modify\" (click)=\"openSelect('compare-selector')\">modifier</span>\n              <div *ngIf=\"selectIsOpen\" class=\"options-container\" (blur)=\"closeSelect()\">\n                <div class=\"option\" (click)=\"onChangeComparedParution(option.value)\"\n                     *ngFor=\"let option of selectOptions\">\n                  <span class=\"option-label\">{{ option.label}} </span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.global-container{display:flex;flex-direction:column}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.global-container{margin:24px 24px 44px 64px}.global-container .container .title-container{margin-right:50px}}.global-container .container{display:flex;flex-direction:row}@media (max-width:1139px){.global-container{margin-bottom:20px}.global-container .container{flex-direction:column}.global-container .container .border{border-bottom:1px solid rgba(15,17,18,.4);padding-bottom:10px}}.global-container .container .title-container{display:flex;flex-grow:1;align-items:center}.global-container .container .title-container .title{font-family:\"Roboto Slab\",serif;font-size:2.6rem;font-weight:700;color:#0f1112}@media (min-width:1140px){.global-container .container .border{border-right:1px solid rgba(15,17,18,.4);margin-right:30px}}.global-container .container .parution-container{display:flex;flex-grow:1}@media (max-width:1139px){.global-container .container .parution-container{margin:10px 0;flex-direction:column}}.global-container .container .parution-container .parution{display:flex}.global-container .container .parution-container .parution .cover{max-width:86px;max-height:112px}.global-container .container .parution-container .parution .cover img{width:100%;height:100%}.global-container .container .parution-container .parution .infos-container{margin-left:15px}.global-container .container .parution-container .parution .infos-container .name-container{font-family:\"Roboto Slab\",serif;font-size:1.8rem;font-weight:300;color:#0f1112}.global-container .container .parution-container .parution .infos-container .price-mev-container{display:flex;flex-direction:row;padding:10px 0}.global-container .container .parution-container .parution .infos-container .price-mev-container .subtitle{font-family:Poppins,sans-serif;font-size:1.2rem;color:#657478}.global-container .container .parution-container .parution .infos-container .price-mev-container .value{font-family:\"Roboto Slab\",serif;font-size:1.4rem;color:#0f1112;font-weight:400}.global-container .container .parution-container .parution .infos-container .price-mev-container .price-container{width:70px;border-right:1px solid rgba(15,17,18,.12);margin-right:30px}.global-container .container .parution-container .parution .infos-container .ref-container{margin-top:5px}.global-container .container .parution-container .parution .infos-container .ref-container .type{font-family:Poppins,sans-serif;font-size:1.2rem;font-style:italic;color:#0f1112}.global-container .container .compared-parution-container{display:flex;flex-grow:1}.global-container .modify-button-container{display:flex}@media (min-width:1140px){.global-container .modify-button-container{margin-right:20px;justify-content:flex-end}}@media (max-width:1139px){.global-container .modify-button-container{justify-content:flex-start}}.global-container .modify-button{display:flex}.global-container .modify-button .modify{margin-right:10px;font-family:Poppins,sans-serif;font-style:1.6rem;font-stretch:normal;color:#0f1112;text-decoration:underline}.global-container .modify-button .modify:hover{cursor:pointer}.global-container .modify-button .options-container{position:absolute;min-width:100px;z-index:9999;background-color:#fff;border:1px solid rgba(15,17,18,.16);border-radius:4px}.global-container .modify-button .options-container .option{cursor:pointer;border-bottom:1px solid rgba(15,17,18,.16);padding:0 16px;line-height:40px}.global-container .modify-button .options-container .option:hover{background-color:rgba(15,17,18,.05)}.global-container .modify-button .options-container .option .option-label{font-family:Poppins,sans-serif;font-size:1.4rem;color:#657478}"]
                }] }
    ];
    /** @nocollapse */
    CompareParutionsComponent.ctorParameters = function () { return []; };
    CompareParutionsComponent.propDecorators = {
        additonalModifyButton: [{ type: Input }],
        currentParution: [{ type: Input }],
        comparedParution: [{ type: Input }],
        comparableParutions: [{ type: Input }],
        currentPublicationId: [{ type: Input }],
        changeComparedParution: [{ type: Output }],
        openModal: [{ type: Output }]
    };
    return CompareParutionsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompareParutionsModule = /** @class */ (function () {
    function CompareParutionsModule() {
    }
    CompareParutionsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [CompareParutionsComponent],
                    imports: [
                        CommonModule,
                        SelectModule,
                        PipesModule.forRoot()
                    ],
                    exports: [CompareParutionsComponent]
                },] }
    ];
    return CompareParutionsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompareParutionsListComponent = /** @class */ (function () {
    function CompareParutionsListComponent(http) {
        this.http = http;
        this.closeModal = new EventEmitter();
        this.toCompareParution = new EventEmitter();
        this.publicationsPages = [];
        this.currentPage = 1;
        this.nbItemPerPage = 60;
        this.savedOrder = null;
    }
    Object.defineProperty(CompareParutionsListComponent.prototype, "comparablePublications", {
        get: /**
         * @return {?}
         */
        function () {
            return this._comparablePublications;
        },
        set: /**
         * @param {?} parutionList
         * @return {?}
         */
        function (parutionList) {
            this._comparablePublications = parutionList;
            if (parutionList) {
                this.parutionsList = {
                    nbSellers: 0,
                    publicationNumber: this.comparablePublications.length ? this.comparablePublications.length : 0,
                    publications: this.comparablePublications,
                    filters: null,
                };
                this.isLoading = false;
                this.setPublicationsPages(this.parutionsList.publications);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CompareParutionsListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // Scroll to the top before removing the scrollbar from body
        window.scrollTo(0, 0);
    };
    /**
     * Navigate btw pages set by pagination
     * @param page Page number clicked (or set in queryparams)
     */
    /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    CompareParutionsListComponent.prototype.paginationPageChange = /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    function (page) {
        this.currentPage = page;
        /** @type {?} */
        var scrollSize = this.anchorForScroll.nativeElement.offsetTop - 110;
        window.scroll({ top: scrollSize, left: 0 });
    };
    /**
     * Divide publications in multiple arrays based on itemsPerPage if necessary
     * @param publications Publications List
     */
    /**
     * Divide publications in multiple arrays based on itemsPerPage if necessary
     * @param {?} publications Publications List
     * @return {?}
     */
    CompareParutionsListComponent.prototype.setPublicationsPages = /**
     * Divide publications in multiple arrays based on itemsPerPage if necessary
     * @param {?} publications Publications List
     * @return {?}
     */
    function (publications) {
        var _this = this;
        this.currentPage = 1;
        this.publicationsPages = [[]];
        if (publications) {
            this.publicationsPages = publications.reduce(function (acc, parution) {
                /** @type {?} */
                var lastIndex = acc.length > 0 ? acc.length - 1 : 0;
                if (acc[lastIndex] && acc[lastIndex].length < _this.nbItemPerPage) {
                    acc[lastIndex].push(parution);
                }
                else {
                    acc.push([parution]);
                }
                return acc;
            }, [[]]);
        }
    };
    /**
     * Sort publications when an order is selected
     * @param order Filter from the select
     */
    /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    CompareParutionsListComponent.prototype.onOrderByItems = /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    function (order) {
        this.savedOrder = order ? order : null;
        if (order) {
            this.orderPublicationsBy(this.comparablePublications, order.filterTerm, order.operator);
        }
        else {
            this.resetParutionsList();
        }
        this.setPublicationsPages(this.parutionsList.publications);
    };
    /**
     * Reset publications to initial state (construct in ngOnInit)
     */
    /**
     * Reset publications to initial state (construct in ngOnInit)
     * @private
     * @return {?}
     */
    CompareParutionsListComponent.prototype.resetParutionsList = /**
     * Reset publications to initial state (construct in ngOnInit)
     * @private
     * @return {?}
     */
    function () {
        if (this.parutionsList) {
            this.parutionsList.publications = [];
            this.parutionsList.publications = this.comparablePublications;
        }
    };
    /**
     * Specifically sort the publications
     * @param publications Publications to be sort
     * @param filter Filter property name
     * @param operator Order to apply
     */
    /**
     * Specifically sort the publications
     * @param {?} publications Publications to be sort
     * @param {?} filters
     * @param {?} operator Order to apply
     * @return {?}
     */
    CompareParutionsListComponent.prototype.orderPublicationsBy = /**
     * Specifically sort the publications
     * @param {?} publications Publications to be sort
     * @param {?} filters
     * @param {?} operator Order to apply
     * @return {?}
     */
    function (publications, filters, operator) {
        /** @type {?} */
        var pubs = Object.assign([], publications);
        pubs.sort(function (a, b) {
            /** @type {?} */
            var result = 0;
            /** @type {?} */
            var idx = 0;
            while (result === 0 && idx < filters.length) {
                if (a[filters[idx]] < b[filters[idx]]) {
                    result = operator === 'ASC' ? -1 : 1;
                }
                else if (a[filters[idx]] > b[filters[idx]]) {
                    result = operator === 'ASC' ? 1 : -1;
                }
                else {
                    idx++;
                }
            }
            return result;
        });
        this.parutionsList.publications = pubs;
    };
    /**
     * @param {?} selectedParution
     * @return {?}
     */
    CompareParutionsListComponent.prototype.selectParution = /**
     * @param {?} selectedParution
     * @return {?}
     */
    function (selectedParution) {
        this.toCompareParution.emit(selectedParution);
    };
    /**
     * @return {?}
     */
    CompareParutionsListComponent.prototype.onCloseModal = /**
     * @return {?}
     */
    function () {
        this.closeModal.emit();
    };
    CompareParutionsListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-compare-parutions-list',
                    template: "<div id=\"scrollAnchor\" class=\"container\">\n  <div class=\"parutions-list-overlay\"></div>\n  <ng-container *ngIf=\"!isLoading; else noLoading\">\n    <div class=\"parutions-list\">\n      <div class=\"close-button\" (click)=\"onCloseModal()\">X</div>\n      <div class=\"parutions-list-header\">\n        <div class=\"parutions-list-header-top\">\n          <div class=\"parutions-list-header-top-title\">\n            <span class=\"parutions-list-header-top-nbpublications\">{{ parutionsList.publicationNumber }} num\u00E9ros</span>\n          </div>\n          <div *ngIf=\"currentParution && !newRefParution\" class=\"parutions-list-header-top-update\">\n            Choisissez la parution que vous souhaitez comparer \u00E0 {{ currentParution.name }}\n            n\u00B0{{ currentParution.publicationNumber }}\n          </div>\n          <div *ngIf=\"(currentTitle && !currentParution) || newRefParution\" class=\"parutions-list-header-top-update\">\n            Choisissez la parution {{currentTitle}} que vous souhaitez analyser\n          </div>\n        </div>\n      </div>\n      <div class=\"parutions-list-display\">\n        <ng-container *ngFor=\"let publication of publicationsPages[currentPage - 1]\">\n          <lib-parution class=\"parutions-list-display-item\" [isModal]=\"true\" isHomologous=\"true\" (click)=\"selectParution(publication)\"\n                        [publication]=\"publication\">\n          </lib-parution>\n        </ng-container>\n      </div>\n      <div class=\"pagination-container\">\n        <lib-pagination [numberOfItems]=\"parutionsList.publications.length\" [itemsPerPage]=\"nbItemPerPage\"\n                        [currentPage]=\"currentPage\" [fromModal]=\"true\" (pageChange)=\"paginationPageChange($event)\"\n                        *ngIf=\"publicationsPages && publicationsPages.length > 1\"></lib-pagination>\n      </div>\n    </div>\n  </ng-container>\n  <ng-template #noLoading>\n    <lib-loader class=\"loader\" loaderTheme=\"light\"></lib-loader>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.close-button{position:absolute;top:20px;right:35px;cursor:pointer;color:#fff;font-size:2rem}.container{position:absolute;top:0;left:0;right:0;bottom:0;z-index:10200}.container .parutions-list-overlay{position:fixed;top:0;left:0;height:100vh;background-color:#0f1112;width:100vw}.container .parutions-list{-webkit-animation:2s fadein;animation:2s fadein;color:#0f1112;font-family:Poppins,sans-serif;font-weight:500;font-size:1.4rem;position:relative;height:100vh;overflow:hidden auto}.container .parutions-list .parutions-list-header{max-width:1100px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container .parutions-list .parutions-list-header-filters,.container .parutions-list .parutions-list-header-top{display:flex}.container .parutions-list .parutions-list-header{margin:0 auto 15px}}@media (max-width:1139px){.container .parutions-list .parutions-list-header{margin:10px 30px}}.container .parutions-list .parutions-list-header-top{color:#fff;display:flex;flex-direction:column;justify-content:space-between;text-align:center;align-items:center;margin-bottom:24px}.container .parutions-list .parutions-list-header-top-title{font-size:2rem;font-weight:600}.container .parutions-list .parutions-list-header-top-title .parutions-list-header-top-nbpublications{font-family:\"Roboto Slab\",serif;font-weight:100;font-size:5.6rem;margin-right:8px}@media (max-width:1139px){.container .parutions-list .parutions-list-header-top-title{font-size:1.6rem}.container .parutions-list .parutions-list-header-top-title .parutions-list-header-top-nbpublications{font-size:4rem}}.container .parutions-list .display-on-desktop{display:none}.container .parutions-list .parutions-list-header-top-update{color:#fff;font-size:2rem;font-weight:600}@media (min-width:1140px){.container .parutions-list .parutions-list-header-top-title{flex-shrink:0;margin-right:12px}.container .parutions-list .display-on-desktop{display:inline}.container .parutions-list .parutions-list-header-top-update{text-align:right}}.container .parutions-list .parutions-list-header-filters{margin-bottom:40px}@media (max-width:1139px){.container .parutions-list .parutions-list-header-filters{display:flex;margin-bottom:16px}}.container .parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:50%;margin-right:7px}@media (min-width:1140px){.container .parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:400px;margin-right:24px}}.container .parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:50%}.container .parutions-list .parutions-list-display{max-width:1100px;margin:0 auto;display:flex;flex-wrap:wrap}.container .parutions-list .parutions-list-display .parutions-list-display-item{cursor:pointer}@media (max-width:1139px){.container .parutions-list .parutions-list-display{justify-content:center;margin:10px 30px}.container .parutions-list .parutions-list-display .parutions-list-display-item{margin:0 7px 24px}}@media (min-width:1140px){.container .parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:400px}.container .parutions-list .parutions-list-display .parutions-list-display-item{margin:0 17px 64px}.container .parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n+1){margin:0 17px 64px 0}.container .parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n){margin:0 0 64px 17px}}.container .pagination-container{display:flex;max-width:1100px;margin:0 auto}.container .loader{margin-top:400px}"]
                }] }
    ];
    /** @nocollapse */
    CompareParutionsListComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    CompareParutionsListComponent.propDecorators = {
        currentParution: [{ type: Input }],
        currentTitle: [{ type: Input }],
        closeModal: [{ type: Output }],
        comparablePublications: [{ type: Input }],
        toCompareParution: [{ type: Output }],
        isLoading: [{ type: Input }],
        anchorForScroll: [{ type: ViewChild, args: ['scrollAnchor',] }],
        newRefParution: [{ type: Input }]
    };
    return CompareParutionsListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CompareParutionsListModule = /** @class */ (function () {
    function CompareParutionsListModule() {
    }
    CompareParutionsListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [CompareParutionsListComponent],
                    imports: [
                        CommonModule, HttpClientModule, SelectModule, ParutionModule, LoaderModule, PaginationModule
                    ],
                    exports: [CompareParutionsListComponent]
                },] }
    ];
    return CompareParutionsListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccountInchargeComponent = /** @class */ (function () {
    function AccountInchargeComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.accountIncharge = {};
        this.isLoading = true;
    }
    Object.defineProperty(AccountInchargeComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AccountInchargeComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    AccountInchargeComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.accountIncharge = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AccountInchargeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-account-incharge',
                    template: "<ng-container *ngIf=\"isLoading; else isLoaded\">\n  <lib-loader [loaderText]=\"loadingMessage\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div class=\"account-incharge-data\">\n    <div class=\"account-incharge-title\">Charg\u00E9 de compte</div>\n    <div class=\"account-incharge-name\">{{ accountIncharge.firstName }} {{ accountIncharge.lastName }}</div>\n    <div class=\"account-incharge-phone\">{{ accountIncharge.phoneNumber }}</div>\n  </div>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{background:#fff;display:flex;justify-content:space-between;padding:16px;border-radius:4px;box-sizing:border-box}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}:host{padding:16px 23px 20px}}:host .account-incharge-data{display:inline-block;-webkit-animation:2s fadein;animation:2s fadein}:host .account-incharge-data .account-incharge-name{font-size:1.4rem;font-weight:500;line-height:1.43;margin-top:8px}:host .account-incharge-data .account-incharge-phone,:host .account-incharge-data .account-incharge-title{font-size:1.2rem;font-weight:500;line-height:1.67;color:#7a8c91}@media (max-width:1139px){:host .account-incharge-data .account-incharge-phone{display:none}}"]
                }] }
    ];
    /** @nocollapse */
    AccountInchargeComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    AccountInchargeComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        groupId: [{ type: Input, args: ['brandEditor',] }]
    };
    return AccountInchargeComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var AccountInchargeMetadata = {
    declarations: [AccountInchargeComponent],
    imports: [CommonModule, HttpClientModule, LoaderModule],
    exports: [AccountInchargeComponent],
};
var AccountInchargeModule = /** @class */ (function () {
    function AccountInchargeModule() {
    }
    AccountInchargeModule.decorators = [
        { type: NgModule, args: [AccountInchargeMetadata,] }
    ];
    return AccountInchargeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AnnualSalesComponent = /** @class */ (function () {
    function AnnualSalesComponent(datePipe, http) {
        this.datePipe = datePipe;
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.isLoading = true;
    }
    Object.defineProperty(AnnualSalesComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AnnualSalesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    AnnualSalesComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .pipe(finalize(function () {
                                _this.isLoading = false;
                            }))
                                .toPromise()];
                    case 1:
                        _a.annualSalesWSResponse = _b.sent();
                        this.setTooltipsContent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Set content of the tooltip displayed in the component, based on start & end date of the calculated sales
     */
    /**
     * Set content of the tooltip displayed in the component, based on start & end date of the calculated sales
     * @return {?}
     */
    AnnualSalesComponent.prototype.setTooltipsContent = /**
     * Set content of the tooltip displayed in the component, based on start & end date of the calculated sales
     * @return {?}
     */
    function () {
        this.todaysDate = new Date();
        if (this.annualSalesWSResponse.startDate && this.annualSalesWSResponse.endDate) {
            this.tooltipContent = "CA annuel calcul\u00E9 du " + this.datePipe.transform(this.annualSalesWSResponse.startDate, 'dd/MM/yyyy') + " au " + this.datePipe.transform(this.annualSalesWSResponse.endDate, 'dd/MM/yyyy') + " bas\u00E9 sur les donn\u00E9es comptables.";
        }
    };
    AnnualSalesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-annual-sales',
                    template: "<ng-container *ngIf=\"isLoading; else isLoaded\">\n  <lib-loader [loaderText]=\"loadingMessage\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div class=\"annual-sales-left-wrapper\">\n    <div class=\"annual-sales-amount-label\">\n      <!-- TODO : traductions -->\n      CA annuel au {{ todaysDate | date: 'dd/MM/yyyy' }}\n      <lib-tooltip contentType=\"text\" [content]=\"tooltipContent\" icon=\"info\"></lib-tooltip>\n    </div>\n    <div class=\"annual-sales-amount-amount\">\n      {{ annualSalesWSResponse?.amount | currency: annualSalesWSResponse?.currency:'symbol':'.0-0':'fr' }}\n    </div>\n  </div>\n  <div class=\"annual-sales-right-wrapper\">\n    <div class=\"annual-sales-versus-label\">Versus A-1</div>\n    <div class=\"annual-sales-percentage-value\">\n      {{ annualSalesWSResponse?.mirror | versuspercent }}\n    </div>\n  </div>\n</ng-template>\n",
                    providers: [DatePipe],
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{background-color:#fff;padding:12px 0;display:flex;flex-direction:row;justify-content:space-around;border-radius:4px;box-sizing:border-box}:host .annual-sales-left-wrapper{-webkit-animation:2s fadein;animation:2s fadein}:host .annual-sales-left-wrapper .annual-sales-amount-label{display:flex;align-items:center;font-size:1.2rem;font-weight:500;color:#7a8c91}:host .annual-sales-left-wrapper .annual-sales-amount-label lib-tooltip{margin-left:10px}:host .annual-sales-left-wrapper .annual-sales-amount-amount{font-size:3.6rem;font-weight:300;color:#0f1112;font-family:\"Roboto Slab\",serif;margin-top:4px}@media (min-width:1140px){:host .annual-sales-left-wrapper .annual-sales-amount-amount{margin-top:8px}}:host .annual-sales-right-wrapper{-webkit-animation:2s fadein;animation:2s fadein}:host .annual-sales-right-wrapper .annual-sales-versus-label{font-size:1.2rem;font-weight:500;color:#7a8c91;text-align:center;line-height:24px}:host .annual-sales-right-wrapper .annual-sales-percentage-value{font-size:3.6rem;font-weight:300;color:#0f1112;font-family:\"Roboto Slab\",serif;margin-top:4px}@media (min-width:1140px){:host .annual-sales-right-wrapper .annual-sales-percentage-value{margin-top:8px}}"]
                }] }
    ];
    /** @nocollapse */
    AnnualSalesComponent.ctorParameters = function () { return [
        { type: DatePipe },
        { type: HttpClient }
    ]; };
    AnnualSalesComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        groupId: [{ type: Input, args: ['brandEditor',] }]
    };
    return AnnualSalesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var AnnualSalesMetadata = {
    declarations: [AnnualSalesComponent],
    imports: [CommonModule, PipesModule.forRoot(), TooltipModule, HttpClientModule, LoaderModule],
    exports: [AnnualSalesComponent],
};
var AnnualSalesModule = /** @class */ (function () {
    function AnnualSalesModule() {
    }
    AnnualSalesModule.decorators = [
        { type: NgModule, args: [AnnualSalesMetadata,] }
    ];
    return AnnualSalesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StaticInputProccesor = /** @class */ (function () {
    function StaticInputProccesor() {
    }
    /**
     * @param {?} inputFilters
     * @param {?} params
     * @return {?}
     */
    StaticInputProccesor.processMultipleFilters = /**
     * @param {?} inputFilters
     * @param {?} params
     * @return {?}
     */
    function (inputFilters, params) {
        /** @type {?} */
        var editorValue = inputFilters.brandEditor.editor && inputFilters.brandEditor.editor.value;
        /** @type {?} */
        var brandValue = inputFilters.brandEditor.brand && inputFilters.brandEditor.brand.value;
        params.groupId = editorValue;
        if (!editorValue) {
            delete params.groupId;
        }
        params.brand = brandValue;
        if (!brandValue) {
            delete params.brand;
        }
        /** @type {?} */
        var titleValue = inputFilters.titleId;
        params.titleId = titleValue;
        if (!titleValue) {
            delete params.titleId;
        }
        /** @type {?} */
        var periodValue = inputFilters.periodId;
        params.periodId = periodValue;
        if (!periodValue) {
            delete params.periodId;
        }
        return params;
    };
    return StaticInputProccesor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BusinessOperationsComponent = /** @class */ (function () {
    function BusinessOperationsComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.showModal = false;
        this.isLoading = true;
        this.specifiedOperation = null;
    }
    Object.defineProperty(BusinessOperationsComponent.prototype, "mulitpleFilters", {
        set: /**
         * @param {?} filters
         * @return {?}
         */
        function (filters) {
            this._mulitpleFilters = filters;
            if (filters) {
                StaticInputProccesor.processMultipleFilters(filters, this._wsRequestParams);
                if (!this.isfirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOperationsComponent.prototype, "multipleFilters", {
        get: /**
         * @return {?}
         */
        function () {
            return this._mulitpleFilters;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOperationsComponent.prototype, "includeHS", {
        get: /**
         * @return {?}
         */
        function () {
            return this._includeHS;
        },
        set: /**
         * @param {?} includeHS
         * @return {?}
         */
        function (includeHS) {
            this._wsRequestParams.includeHS = includeHS;
            this._includeHS = includeHS;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOperationsComponent.prototype, "brandEditor", {
        get: /**
         * @return {?}
         */
        function () {
            return this._wsRequestParams;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOperationsComponent.prototype, "titleId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._titleId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOperationsComponent.prototype, "periodId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._periodId;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BusinessOperationsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    BusinessOperationsComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.businessOperationsWS = _b.sent();
                        this.totalOpeNbr = this.countOpe(this.businessOperationsWS);
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?=} e
     * @param {?=} opeNbr
     * @return {?}
     */
    BusinessOperationsComponent.prototype.handleModal = /**
     * @param {?=} e
     * @param {?=} opeNbr
     * @return {?}
     */
    function (e, opeNbr) {
        this.specifiedOperation = e ? e.target.innerText : null;
        this.opeNbr = typeof opeNbr === 'number' && isFinite(opeNbr) ? opeNbr : this.totalOpeNbr;
        this.showModal = !this.showModal;
        if (this.showModal) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
    };
    /**
     * @private
     * @param {?} businessOperationsWS
     * @return {?}
     */
    BusinessOperationsComponent.prototype.countOpe = /**
     * @private
     * @param {?} businessOperationsWS
     * @return {?}
     */
    function (businessOperationsWS) {
        return businessOperationsWS.marketingStudies + businessOperationsWS.promotionalOperations
            + businessOperationsWS.terrainOperations + businessOperationsWS.titleNews;
    };
    BusinessOperationsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-business-operations',
                    template: "<div class=\"business-operations-container\">\n  <ng-container>\n    <lib-loader [loaderText]=\"loadingMessage\" *ngIf=\"isLoading;else isLoaded\"></lib-loader>\n  </ng-container>\n  <ng-template #isLoaded>\n    <ng-container *ngIf=\"!showModal; else BusinessOpeModal\">\n      <div class=\"business-operations-main\">\n        <div class=\"business-operations-title\" (click)=\"handleModal()\">Actions mises en place</div>\n        <div>\n          <div class=\"business-operations-values-container\">\n            <div class=\"business-operations-wrapper\">\n              <div class=\"business-operations-values\">\n                <div class=\"business-operations-number\">{{ businessOperationsWS?.promotionalOperations }}</div>\n                <div class=\"underline\" (click)=\"handleModal($event, businessOperationsWS.promotionalOperations)\">Op\u00E9rations promotionnelles</div>\n              </div>\n              <div class=\"business-operations-values\">\n                <div class=\"business-operations-number\">{{ businessOperationsWS?.terrainOperations }}</div>\n                <div class=\"underline\" (click)=\"handleModal($event, businessOperationsWS.terrainOperations)\">Op\u00E9rations terrain</div>\n              </div>\n            </div>\n            <div class=\"business-operations-wrapper\">\n              <div class=\"business-operations-values\">\n                <div class=\"business-operations-number\">{{ businessOperationsWS?.titleNews }}</div>\n                <div class=\"underline\" (click)=\"handleModal($event, businessOperationsWS.titleNews)\">Titres infos</div>\n              </div>\n              <div class=\"business-operations-values\">\n                <div class=\"business-operations-number\">{{ businessOperationsWS?.marketingStudies }}</div>\n                <div class=\"underline\" (click)=\"handleModal($event, businessOperationsWS.marketingStudies)\">R\u00E9glages</div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n    <ng-template #BusinessOpeModal>\n      <lib-business-operations-modal [includeHS]=\"includeHS\" [multipleFilters]=\"multipleFilters\" [apiUrl]=\"apiUrl\" [opeNbr]=\"opeNbr\" [specifiedOperation]=\"specifiedOperation\"\n                                     (closeModal)=\"handleModal()\"></lib-business-operations-modal>\n    </ng-template>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block;background-color:#fff;padding-top:24px;padding-bottom:24px;font-weight:500}.business-operations-main .underline{text-decoration:underline}.business-operations-main .underline:hover{cursor:pointer}.business-operations-title{text-decoration:underline;font-size:1.6rem;color:#657478;margin-left:16px;margin-bottom:24px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.business-operations-main{min-height:200px}.business-operations-title{margin-left:24px}}.business-operations-title:hover{cursor:pointer}.business-operations-values{font-size:1.4rem;color:#0f1112;margin-bottom:16px;align-items:center;display:flex;margin-left:30px}.business-operations-number{font-family:\"Roboto Slab\",serif;color:#2d54d2;font-size:4.8rem;font-weight:100;margin-right:23px;display:inline-block;text-align:right;min-width:80px}@media (min-width:1140px){.business-operations-values{margin-left:24px}.business-operations-number{margin-right:25px}.business-operations-values-container{display:flex}.business-operations-wrapper{width:50%}}"]
                }] }
    ];
    /** @nocollapse */
    BusinessOperationsComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    BusinessOperationsComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        mulitpleFilters: [{ type: Input, args: ['multipleFilters',] }],
        includeHS: [{ type: Input }]
    };
    return BusinessOperationsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StaticFilters = /** @class */ (function () {
    function StaticFilters() {
    }
    // tslint:disable-next-line:no-shadowed-variable
    // tslint:disable-next-line:no-shadowed-variable
    /**
     * @param {?} filter
     * @param {?=} initialPublications
     * @param {?=} list
     * @param {?=} savedOrder
     * @param {?=} nbItemsPerPage
     * @param {?=} isUpcomingParution
     * @return {?}
     */
    StaticFilters.filterByItems = 
    // tslint:disable-next-line:no-shadowed-variable
    /**
     * @param {?} filter
     * @param {?=} initialPublications
     * @param {?=} list
     * @param {?=} savedOrder
     * @param {?=} nbItemsPerPage
     * @param {?=} isUpcomingParution
     * @return {?}
     */
    function (filter, initialPublications, list, savedOrder, nbItemsPerPage, isUpcomingParution) {
        if (isUpcomingParution === void 0) { isUpcomingParution = false; }
        /** @type {?} */
        var savedFilter = filter ? filter : null;
        if (filter) {
            list = StaticFilters.filterPublicationsBy(initialPublications, filter.filterTerm, filter.value, filter.operator);
        }
        else {
            list = initialPublications;
        }
        if (savedOrder) {
            list = StaticFilters.orderPublicationsBy(list, savedOrder.filterTerm, savedOrder.operator, isUpcomingParution);
        }
        /** @type {?} */
        var result = StaticFilters.setPublicationsPages(list, nbItemsPerPage);
        /** @type {?} */
        var listPages = result.listPages;
        /** @type {?} */
        var currentPage = result.currentPage;
        return {
            list: list,
            savedFilter: savedFilter,
            listPages: listPages,
            currentPage: currentPage,
        };
    };
    /**
     * @param {?} order
     * @param {?=} initialList
     * @param {?=} list
     * @param {?=} savedFilter
     * @param {?=} nbItemsPerPage
     * @param {?=} isUpcomingParution
     * @param {?=} hasMirror
     * @return {?}
     */
    StaticFilters.orderByItems = /**
     * @param {?} order
     * @param {?=} initialList
     * @param {?=} list
     * @param {?=} savedFilter
     * @param {?=} nbItemsPerPage
     * @param {?=} isUpcomingParution
     * @param {?=} hasMirror
     * @return {?}
     */
    function (order, initialList, list, savedFilter, nbItemsPerPage, isUpcomingParution, hasMirror) {
        if (isUpcomingParution === void 0) { isUpcomingParution = false; }
        if (hasMirror === void 0) { hasMirror = false; }
        /** @type {?} */
        var savedOrder = order ? order : null;
        if (order) {
            list = StaticFilters.orderPublicationsBy(initialList, order.filterTerm, order.operator, isUpcomingParution);
        }
        else {
            list = initialList;
        }
        if (savedFilter) {
            list = this.filterPublicationsBy(list, savedFilter.filterTerm, savedFilter.value, savedFilter.operator);
        }
        /** @type {?} */
        var result = StaticFilters.setPublicationsPages(list, nbItemsPerPage, hasMirror);
        /** @type {?} */
        var listPages = result.listPages;
        /** @type {?} */
        var currentPage = result.currentPage;
        return {
            list: list,
            savedOrder: savedOrder,
            listPages: listPages,
            currentPage: currentPage,
        };
    };
    /**
     * @private
     * @param {?} list
     * @param {?} filters
     * @param {?} operator
     * @param {?=} isUpcomingParution
     * @return {?}
     */
    StaticFilters.orderPublicationsBy = /**
     * @private
     * @param {?} list
     * @param {?} filters
     * @param {?} operator
     * @param {?=} isUpcomingParution
     * @return {?}
     */
    function (list, filters, operator, isUpcomingParution) {
        if (isUpcomingParution === void 0) { isUpcomingParution = false; }
        /** @type {?} */
        var pubs = Object.assign([], list);
        pubs.sort(function (a, b) {
            if (isUpcomingParution) {
                a = a.publication;
                b = b.publication;
            }
            /** @type {?} */
            var result = 0;
            /** @type {?} */
            var idx = 0;
            while (result === 0 && idx < filters.length) {
                if (a[filters[idx]] < b[filters[idx]]) {
                    result = operator === 'ASC' ? -1 : 1;
                }
                else if (a[filters[idx]] > b[filters[idx]]) {
                    result = operator === 'ASC' ? 1 : -1;
                }
                else {
                    idx++;
                }
            }
            return result;
        });
        return pubs;
    };
    /**
     * @private
     * @param {?} list
     * @param {?} filterTerm
     * @param {?} filterValue
     * @param {?=} operator
     * @return {?}
     */
    StaticFilters.filterPublicationsBy = /**
     * @private
     * @param {?} list
     * @param {?} filterTerm
     * @param {?} filterValue
     * @param {?=} operator
     * @return {?}
     */
    function (list, filterTerm, filterValue, operator) {
        /** @type {?} */
        var results = [];
        list.filter(function (publication) {
            /** @type {?} */
            var isFilterOk = Object.keys(publication).includes(filterTerm);
            if (isFilterOk) {
                switch (operator) {
                    case '=': {
                        if (String(publication[filterTerm]) === filterValue) {
                            results.push(publication);
                        }
                        break;
                    }
                    case '!=': {
                        if (String(publication[filterTerm]) !== filterValue) {
                            results.push(publication);
                        }
                        break;
                    }
                    case 'contains': {
                        if (String(publication[filterTerm]).search(filterValue) !== -1) {
                            results.push(publication);
                        }
                        break;
                    }
                    case '>': {
                        if (publication[filterTerm] > filterValue) {
                            results.push(publication);
                        }
                        break;
                    }
                    case '<': {
                        if (publication[filterTerm] < filterValue) {
                            results.push(publication);
                        }
                        break;
                    }
                    case '<=': {
                        if (publication[filterTerm] <= filterValue) {
                            results.push(publication);
                        }
                        break;
                    }
                    case '>=': {
                        if (publication[filterTerm] >= filterValue) {
                            results.push(publication);
                        }
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        });
        return results;
    };
    /**
     * @param {?} list
     * @param {?} nbItemPerPage
     * @param {?=} hasMirror
     * @return {?}
     */
    StaticFilters.setPublicationsPages = /**
     * @param {?} list
     * @param {?} nbItemPerPage
     * @param {?=} hasMirror
     * @return {?}
     */
    function (list, nbItemPerPage, hasMirror) {
        if (hasMirror === void 0) { hasMirror = false; }
        /** @type {?} */
        var currentPage = 1;
        /** @type {?} */
        var listPages;
        if (list) {
            listPages = list.reduce(function (acc, parution) {
                if (hasMirror) {
                    parution.isMirror = false;
                    if (parution.mirror) {
                        parution.mirror.isMirror = true;
                    }
                }
                /** @type {?} */
                var lastIndex = acc.length > 0 ? acc.length - 1 : 0;
                if (acc[lastIndex] && acc[lastIndex].length < nbItemPerPage) {
                    acc[lastIndex].push(parution);
                }
                else {
                    acc.push([parution]);
                }
                return acc;
            }, [[]]);
            return { listPages: listPages, currentPage: currentPage };
        }
    };
    return StaticFilters;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BusinessOperationsModalComponent = /** @class */ (function () {
    function BusinessOperationsModalComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        // Display name when type of parution is 1 or 4 aka Operation Promo ou Réglages
        this.validTypes = [1, 4];
        this.isLoading = true;
        this.parutionsNbr = 0;
        this.savedOrder = null;
        this.closeModal = new EventEmitter();
    }
    Object.defineProperty(BusinessOperationsModalComponent.prototype, "specifiedOperation", {
        get: /**
         * @return {?}
         */
        function () {
            return this._specifiedOperation;
        },
        set: /**
         * @param {?} specifiedOpe
         * @return {?}
         */
        function (specifiedOpe) {
            this._specifiedOperation = specifiedOpe;
            this._wsRequestParams.opType = this.getKeyFromType(this._specifiedOperation).toString();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOperationsModalComponent.prototype, "includeHS", {
        set: /**
         * @param {?} includeHS
         * @return {?}
         */
        function (includeHS) {
            this._wsRequestParams.includeHS = includeHS;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOperationsModalComponent.prototype, "mulitpleFilters", {
        set: /**
         * @param {?} filters
         * @return {?}
         */
        function (filters) {
            if (filters) {
                StaticInputProccesor.processMultipleFilters(filters, this._wsRequestParams);
                if (!this.isfirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        res = _a.sent();
                        if (res.filters) {
                            this.orders = res.filters.orderByItems;
                        }
                        this.publicationBusiness = res.publications;
                        this.parutionsNbr = this.publicationBusiness.length;
                        this.initialPublicationBusiness = this.publicationBusiness;
                        this.isLoading = false;
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.getDataFromWS = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var businessPublications;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.apiUrl, {
                            withCredentials: true,
                            params: Object.assign({}, __assign({}, params)),
                        }).toPromise()];
                    case 1:
                        businessPublications = _a.sent();
                        return [2 /*return*/, businessPublications];
                }
            });
        });
    };
    /**
     * @param {?} order
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.onOrderByItems = /**
     * @param {?} order
     * @return {?}
     */
    function (order) {
        /** @type {?} */
        var res = StaticFilters.orderByItems(order, this.initialPublicationBusiness, this.publicationBusiness);
        this.publicationBusiness = res.list;
        this.savedOrder = res.savedOrder;
    };
    /**
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.onCloseModal = /**
     * @return {?}
     */
    function () {
        this.closeModal.emit();
    };
    /**
     * @private
     * @param {?} type
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.getKeyFromType = /**
     * @private
     * @param {?} type
     * @return {?}
     */
    function (type) {
        switch (type) {
            case 'Réglages':
                return 4;
            case 'Titres infos':
                return 3;
            case 'Opérations promotionnelles':
                return 1;
            case 'Opérations terrain':
                return 2;
            case null:
                return 'all';
            default:
                return -1;
        }
    };
    /**
     * @param {?} bo
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.showBusinessOperations = /**
     * @param {?} bo
     * @return {?}
     */
    function (bo) {
        return !this.specifiedOperation || this.validTypes.includes(bo.type) || (bo.start && bo.end);
    };
    /**
     * @param {?} bo
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.hasValidType = /**
     * @param {?} bo
     * @return {?}
     */
    function (bo) {
        return this.validTypes.includes(bo.type);
    };
    /**
     * @param {?} bo
     * @return {?}
     */
    BusinessOperationsModalComponent.prototype.showDate = /**
     * @param {?} bo
     * @return {?}
     */
    function (bo) {
        return bo.start && bo.end && bo.type === 1;
    };
    BusinessOperationsModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-business-operations-modal',
                    template: "<div class=\"modal-container\">\n  <div class=\"modal-content-container\">\n    <div class=\"close-button-container\" (click)=\"onCloseModal()\">X</div>\n    <ng-container *ngIf=\"!isLoading; else loader\">\n      <div class=\"modal-content-header-container\">\n        <ng-container *ngIf=\"!specifiedOperation\">\n          <span class=\"title\">Actions mises en place</span>\n          <span>{{opeNbr}} actions mises en place sur {{parutionsNbr}} parutions</span>\n        </ng-container>\n        <ng-container *ngIf=\"specifiedOperation\">\n          <span class=\"title\">{{specifiedOperation}}</span>\n          <span>{{opeNbr}} {{specifiedOperation | lowercase}} sur {{parutionsNbr}} parutions</span>\n        </ng-container>\n      </div>\n      <div *ngIf=\"publicationBusiness?.length > 0\" class=\"modal-filter-container\">\n        <lib-select class=\"filter-orders\" [options]=\"orders\" placeholder=\"Trier par\" (change)=\"onOrderByItems($event)\">\n        </lib-select>\n      </div>\n      <div class=\"modal-content-main-container\">\n        <ng-container *ngIf=\"publicationBusiness?.length > 0; else noPublications\">\n          <div class=\"parution-business-container\" *ngFor=\"let parution of publicationBusiness\">\n            <div class=\"parution-business-infos\">\n              <div class=\"title\">\n                {{ parution?.publicationId | RemoveAfterHyphenPipe }} \u2022 {{ parution?.name }}\n                n\u00B0{{ parution?.publicationNumber }}\n                <ng-container *ngIf=\"parution?.price\"> \u2022 {{ parution?.price | number: '.2':'fr-FR' }} \u20AC</ng-container>\n              </div>\n              <div class=\"date\" *ngIf=\"parution?.sellingStartDate && parution?.sellingEndDate\">MEV du {{ parution?.sellingStartDate | date: 'dd/MM/yyyy' }} au\n                {{ parution?.sellingEndDate | date: 'dd/MM/yyyy' }}</div>\n            </div>\n            <div class=\"parution-business-main\">\n              <div class=\"parution-business-cover\"\n                   [ngStyle]=\"{ 'background-image': 'url(' + parution?.coverUrl + ')' }\">\n              </div>\n              <div class=\"parution-business-operations\">\n                <ng-container *ngFor=\"let bo of parution.businessOperations\">\n                  <div class=\"bo-container\" *ngIf=\"showBusinessOperations(bo)\">\n                    <div class=\"bo-type\" *ngIf=\"!specifiedOperation\">\n                      {{bo.type | businessOperationsType}}\n                    </div>\n                    <div *ngIf=\"hasValidType(bo)\" class=\"bo-infos\">\n                      {{bo.name}}\n                    </div>\n                    <div *ngIf=\"showDate(bo)\" class=\"bo-infos\">\n                      du {{ bo?.start | date: 'dd/MM/yyyy' }} au\n                      {{ bo?.end | date: 'dd/MM/yyyy' }}\n                    </div>\n                  </div>\n                </ng-container>\n              </div>\n            </div>\n          </div>\n        </ng-container>\n        <ng-template #noPublications>\n          <span class=\"no-parution-text\">Aucune parution n'est disponible.</span>\n        </ng-template>\n      </div>\n    </ng-container>\n  </div>\n  <ng-template #loader>\n    <lib-loader class=\"loader\" loaderSize=\"big\" loaderTheme=\"light\"></lib-loader>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.modal-container{position:fixed;top:0;right:0;left:0;bottom:0;height:100%;overflow:auto;z-index:10400;background-color:#0f1112;color:#fff}.modal-container .modal-content-container{display:flex;flex-direction:column;padding:20px}.modal-container .modal-content-container .modal-content-header-container{font-family:Poppins,sans-serif;font-size:2rem;font-weight:600;display:flex;flex-direction:column;margin-bottom:20px}.modal-container .modal-content-container .modal-content-header-container .title{font-family:\"Roboto Slab\",serif;font-size:5.6rem;font-weight:100}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.modal-container .modal-content-container .modal-content-header-container{margin-bottom:100px;align-items:center}}.modal-container .modal-content-container .modal-filter-container{display:flex;width:1140px;align-self:center;justify-content:flex-start;margin-bottom:40px}@media (max-width:1139px){.modal-container .modal-content-container .modal-content-header-container .title{font-size:4rem;margin-bottom:20px;max-width:80%}.modal-container .modal-content-container .modal-filter-container{align-self:flex-start;width:350px;margin-bottom:30px}}.modal-container .modal-content-container .modal-filter-container .filter-orders{min-width:200px;margin-right:40px}.modal-container .modal-content-container .modal-content-main-container{display:flex;flex-wrap:wrap;width:1140px;align-self:center}.modal-container .modal-content-container .modal-content-main-container .parution-business-container{display:flex;flex-direction:column;margin-right:20px;margin-left:20px;margin-bottom:30px;max-width:340px}@media (min-width:1140px){.modal-container .modal-content-container .modal-filter-container .filter-orders{min-width:260px}.modal-container .modal-content-container .modal-content-main-container .parution-business-container{margin-bottom:60px}}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-infos{margin-bottom:10px}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-infos .title{font-family:\"Roboto Slab\",serif;font-size:1.8rem;margin-bottom:8px}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-infos .date{font-family:Poppins,sans-serif;font-size:1.4rem;color:#d8d8d8}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main{display:flex}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-cover{margin-right:10px;width:250px;height:300px;background-size:contain;background-repeat:no-repeat}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-operations{display:flex;flex-direction:column}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-operations .bo-container{margin-bottom:10px;width:110px;border-radius:4px;background-color:#282727;padding:8px 12px;word-break:break-word}@media (max-width:1139px){.modal-container .modal-content-container .modal-content-main-container{align-self:flex-start;width:350px}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main{max-width:320px}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-cover{min-width:170px;width:170px;height:230px}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-operations{max-width:170px}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-operations .bo-container{max-width:120px}}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-operations .bo-container .bo-infos{font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500}.modal-container .modal-content-container .modal-content-main-container .parution-business-container .parution-business-main .parution-business-operations .bo-container .bo-type{font-family:Poppins,sans-serif;font-size:1.6rem;font-weight:600}.modal-container .modal-content-container .modal-content-main-container .no-parution-text{margin:0 auto}.modal-container .modal-content-container .close-button-container{position:absolute;top:25px;right:40px;font-size:2rem}.modal-container .modal-content-container .close-button-container:hover{cursor:pointer}.modal-container .modal-content-container .loader{margin-top:20%}"]
                }] }
    ];
    /** @nocollapse */
    BusinessOperationsModalComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    BusinessOperationsModalComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        specifiedOperation: [{ type: Input, args: ['specifiedOperation',] }],
        includeHS: [{ type: Input }],
        mulitpleFilters: [{ type: Input, args: ['multipleFilters',] }],
        opeNbr: [{ type: Input }],
        closeModal: [{ type: Output }]
    };
    return BusinessOperationsModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BusinessOperationsModalModule = /** @class */ (function () {
    function BusinessOperationsModalModule() {
    }
    BusinessOperationsModalModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [BusinessOperationsModalComponent],
                    imports: [
                        CommonModule,
                        SelectModule,
                        PipesModule,
                        LoaderModule,
                    ],
                    exports: [
                        BusinessOperationsModalComponent,
                    ],
                },] }
    ];
    return BusinessOperationsModalModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var BusinessOperationsMetadata = {
    declarations: [BusinessOperationsComponent],
    imports: [CommonModule, HttpClientModule, LoaderModule, PipesModule, SelectModule, BusinessOperationsModalModule],
    exports: [BusinessOperationsComponent],
};
var BusinessOperationsModule = /** @class */ (function () {
    function BusinessOperationsModule() {
    }
    BusinessOperationsModule.decorators = [
        { type: NgModule, args: [BusinessOperationsMetadata,] }
    ];
    return BusinessOperationsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TextBadgeComponent = /** @class */ (function () {
    function TextBadgeComponent() {
    }
    TextBadgeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-text-badge',
                    template: "<div class=\"container\" [ngClass]=\"background\">\n  <div class=\"container-content\">\n    {{ content | uppercase }}\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{display:inline-flex;color:#fff;font-weight:600;font-size:1.2rem;padding:4px;border-radius:4px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container{padding:4px 10px}}.container.black{background:#0f1112}.container.grey{background:#657478}"]
                }] }
    ];
    TextBadgeComponent.propDecorators = {
        content: [{ type: Input }],
        background: [{ type: Input }]
    };
    return TextBadgeComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TextBadgeMetadata = {
    declarations: [TextBadgeComponent],
    imports: [CommonModule],
    exports: [TextBadgeComponent],
};
var TextBadgeModule = /** @class */ (function () {
    function TextBadgeModule() {
    }
    TextBadgeModule.decorators = [
        { type: NgModule, args: [TextBadgeMetadata,] }
    ];
    return TextBadgeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SalesPointsStatsMock = /** @class */ (function () {
    function SalesPointsStatsMock() {
    }
    /**
     * @return {?}
     */
    SalesPointsStatsMock.prototype.getMock = /**
     * @return {?}
     */
    function () {
        return {
            total: '5',
            salespoints: [
                {
                    salespoint: {
                        id: '787654',
                        name: 'Maison de la Presse Lyon',
                        city: 'Lyon',
                        postalCode: '69000',
                        street: '42 rue de la verrerie',
                        currentStatus: 'en rupture',
                    },
                    deliveredItems: {
                        currentPublication: {
                            value: 1285,
                        },
                        previousPublication: {
                            value: 1285,
                        },
                        homologousPublication: {
                            value: 1285,
                        },
                    },
                    soldItems: {
                        currentPublication: {
                            value: 1285,
                        },
                        previousPublication: {
                            value: 1285,
                        },
                        homologousPublication: {
                            value: 1285,
                        },
                    },
                    soldRate: {
                        currentPublication: {
                            mirror: 0.12,
                        },
                        previousPublication: {
                            mirror: 0.06,
                        },
                        homologousPublication: {
                            mirror: 0.06,
                        },
                    },
                    marketShare: {
                        currentPublication: {
                            mirror: 0.12,
                        },
                        previousPublication: {
                            mirror: 0.06,
                        },
                        homologousPublication: {
                            mirror: 0.06,
                        },
                    },
                },
                {
                    salespoint: {
                        id: '801651',
                        name: "Kiosque Lyon - Porte de l'Ain",
                        city: 'Lyon',
                        postalCode: '69000',
                        street: '42 rue de la verrerie',
                        currentStatus: 'en rupture',
                    },
                    deliveredItems: {
                        currentPublication: {
                            value: 925,
                        },
                        previousPublication: {
                            value: 950,
                        },
                        homologousPublication: {
                            value: 950,
                        },
                    },
                    soldItems: {
                        currentPublication: {
                            value: 925,
                        },
                        previousPublication: {
                            value: 833,
                        },
                        homologousPublication: {
                            value: 833,
                        },
                    },
                    soldRate: {
                        currentPublication: {
                            mirror: 0.0,
                        },
                        previousPublication: {
                            mirror: 0.14,
                        },
                        homologousPublication: {
                            mirror: 0.14,
                        },
                    },
                    marketShare: {
                        currentPublication: {
                            mirror: 0.07,
                        },
                        previousPublication: {
                            mirror: 0.0,
                        },
                        homologousPublication: {
                            mirror: 0.0,
                        },
                    },
                },
                {
                    salespoint: {
                        id: '802749',
                        name: 'Maison de la Presse Chamonix',
                        city: 'Lyon',
                        postalCode: '69000',
                        street: '42 rue de la verrerie',
                        currentStatus: null,
                    },
                    deliveredItems: {
                        currentPublication: {
                            value: 30,
                        },
                        previousPublication: {
                            value: 30,
                        },
                        homologousPublication: {
                            value: 30,
                        },
                    },
                    soldItems: {
                        currentPublication: {
                            value: 27,
                        },
                        previousPublication: {
                            value: 24,
                        },
                        homologousPublication: {
                            value: 24,
                        },
                    },
                    soldRate: {
                        currentPublication: {
                            mirror: 0.12,
                        },
                        previousPublication: {
                            mirror: 0.24,
                        },
                        homologousPublication: {
                            mirror: 0.24,
                        },
                    },
                    marketShare: {
                        currentPublication: {
                            mirror: 0.14,
                        },
                        previousPublication: {
                            mirror: 0.03,
                        },
                        homologousPublication: {
                            mirror: 0.03,
                        },
                    },
                },
                {
                    salespoint: {
                        id: '987655',
                        name: 'Maison de la Presse Annecy',
                        city: 'Lyon',
                        postalCode: '69000',
                        street: '42 rue de la verrerie',
                        currentStatus: 'rupture imminente',
                    },
                    deliveredItems: {
                        currentPublication: {
                            value: 123,
                        },
                        previousPublication: {
                            value: 123,
                        },
                        homologousPublication: {
                            value: 123,
                        },
                    },
                    soldItems: {
                        currentPublication: {
                            value: 86,
                        },
                        previousPublication: {
                            value: 86,
                        },
                        homologousPublication: {
                            value: 86,
                        },
                    },
                    soldRate: {
                        currentPublication: {
                            mirror: 0.07,
                        },
                        previousPublication: {
                            mirror: 0.06,
                        },
                        homologousPublication: {
                            mirror: 0.06,
                        },
                    },
                    marketShare: {
                        currentPublication: {
                            mirror: 0.15,
                        },
                        previousPublication: {
                            mirror: 0.09,
                        },
                        homologousPublication: {
                            mirror: 0.09,
                        },
                    },
                },
                {
                    salespoint: {
                        id: '894946',
                        name: 'Maison de la Presse Grenoble',
                        city: 'Lyon',
                        postalCode: '69000',
                        street: '42 rue de la verrerie',
                        currentStatus: null,
                    },
                    deliveredItems: {
                        currentPublication: {
                            value: 150,
                        },
                        previousPublication: {
                            value: 120,
                        },
                        homologousPublication: {
                            value: 120,
                        },
                    },
                    soldItems: {
                        currentPublication: {
                            value: 134,
                        },
                        previousPublication: {
                            value: 113,
                        },
                        homologousPublication: {
                            value: 113,
                        },
                    },
                    soldRate: {
                        currentPublication: {
                            mirror: 0.12,
                        },
                        previousPublication: {
                            mirror: 0.06,
                        },
                        homologousPublication: {
                            mirror: 0.06,
                        },
                    },
                    marketShare: {
                        currentPublication: {
                            mirror: 0.0,
                        },
                        previousPublication: {
                            mirror: 0.03,
                        },
                        homologousPublication: {
                            mirror: 0.03,
                        },
                    },
                },
            ],
        };
    };
    return SalesPointsStatsMock;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SalesPointsStatsComponent = /** @class */ (function () {
    function SalesPointsStatsComponent(http, mock, sanitizer) {
        this.http = http;
        this.mock = mock;
        this.sanitizer = sanitizer;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this._valueComparison = 'comparePublication';
        this.cardHeaderLabels = [
            {
                label: 'Nom',
                name: 'name',
                filterSelected: [false, false],
            },
            {
                label: 'Fournis',
                name: 'delivered',
                filterSelected: [false, false],
            },
            {
                label: 'Ventes',
                name: 'sold',
                filterSelected: [false, false],
            },
            {
                label: 'Tx de vente',
                name: 'soldRate',
                filterSelected: [false, false],
            },
            {
                label: 'Pdm ss famille',
                name: 'familyMarket',
                filterSelected: [false, false],
            },
        ];
        this.isLoading = true;
        this.isWholeTableLoading = false;
        this.isTableContentLoading = false;
        this.salesPointsStatsPages = [];
        this.nbItemPerPage = 50;
        this.currentPage = 1;
    }
    Object.defineProperty(SalesPointsStatsComponent.prototype, "comparedParution", {
        get: /**
         * @return {?}
         */
        function () {
            return this._comparedParution;
        },
        set: /**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            this._comparedParution = id;
            if (this._comparedParution) {
                this._wsRequestParams.compareToId = id;
            }
            else {
                delete this._wsRequestParams.compareToId;
            }
            // First actual call with compareId parameter, no call in ngOnInit just check if parameters are ok
            if (this._wsRequestParams.publicationId && this._wsRequestParams.compareToId) {
                this.getDataFromWS(this._wsRequestParams);
                this.isfirstCall = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesPointsStatsComponent.prototype, "marketType", {
        get: /**
         * @return {?}
         */
        function () {
            return this._marketType;
        },
        set: /**
         * @param {?} market
         * @return {?}
         */
        function (market) {
            this._marketType = market ? market : 'family';
            /** @type {?} */
            var familyMarket = this.cardHeaderLabels.find(function (cardLabel) { return cardLabel.name === 'familyMarket'; });
            familyMarket.label = this.marketType === 'family' ? 'Pdm ss famille' : 'Pdm marché SPRINT';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesPointsStatsComponent.prototype, "valueComparison", {
        get: /**
         * @return {?}
         */
        function () {
            return this._valueComparison;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesPointsStatsComponent.prototype, "warehouseId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._warehouseId;
        },
        set: /**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            this._warehouseId = id;
            this._wsRequestParams.warehouseId = id ? id : '';
            if (!id) {
                delete this._wsRequestParams.warehouseId;
            }
            if (this._wsRequestParams.segmentId) {
                delete this._wsRequestParams.segmentId;
            }
            if (!this.isfirstCall && this._wsRequestParams.publicationId) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesPointsStatsComponent.prototype, "segmentId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._segmentId;
        },
        set: /**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            this._segmentId = id;
            this._wsRequestParams.segmentId = id ? id : '';
            if (!id) {
                delete this._wsRequestParams.segmentId;
            }
            if (!this.isfirstCall && this._wsRequestParams.publicationId) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.exportLink = this.apiUrl + '/../sales-point-statistics-csv';
        this._wsRequestParams = Object.assign({}, this._wsRequestParams, {
            publicationId: this.publicationId,
            limit: this.nbItemPerPage,
            start: (this.currentPage - 1) * this.nbItemPerPage,
        });
    };
    /**
     * Generates data from WS or a mock if no data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS or a mock if no data from WS
     * @param {?} params QueryParams to be used in WS call
     * @param {?=} isFilter
     * @param {?=} isOrder
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.getDataFromWS = /**
     * Generates data from WS or a mock if no data from WS
     * @param {?} params QueryParams to be used in WS call
     * @param {?=} isFilter
     * @param {?=} isOrder
     * @return {?}
     */
    function (params, isFilter, isOrder) {
        if (isFilter === void 0) { isFilter = false; }
        if (isOrder === void 0) { isOrder = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = !isFilter && !isOrder;
                        this.isWholeTableLoading = isFilter;
                        this.isTableContentLoading = isOrder;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.salesPointsStats = _b.sent();
                        this.initialSalesPoints = this.salesPointsStats.salespoints;
                        this.isLoading = false;
                        this.isWholeTableLoading = false;
                        this.isTableContentLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Determine status badge color
     * @param status 'En Rupture' / 'Rupture Imminente'
     */
    /**
     * Determine status badge color
     * @param {?} status 'En Rupture' / 'Rupture Imminente'
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.getRuptureColor = /**
     * Determine status badge color
     * @param {?} status 'En Rupture' / 'Rupture Imminente'
     * @return {?}
     */
    function (status) {
        switch (status.toLowerCase()) {
            case 'en rupture':
                return 'black';
            case 'rupture imminente':
                return 'grey';
            default:
                break;
        }
    };
    /**
     * Navigate btw pages set by pagination
     * @param page Page number clicked (or set in queryparams)
     */
    /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.paginationPageChange = /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    function (page) {
        var _this = this;
        this.currentPage = page;
        // set start item for ws pagination
        this._wsRequestParams = Object.assign({}, this._wsRequestParams, {
            start: (this.currentPage - 1) * this.nbItemPerPage,
        });
        this.getDataFromWS(this._wsRequestParams, false, true).then(function () {
            if (_this.anchorForScroll) {
                /** @type {?} */
                var scrollSize = _this.anchorForScroll.nativeElement.offsetTop - 110;
                window.scroll({ top: scrollSize, left: 0 });
            }
        });
    };
    /**
     *
     */
    /**
     *
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.havePagination = /**
     *
     * @return {?}
     */
    function () {
        return parseInt(this.salesPointsStats.total, 10) - this.nbItemPerPage > 0;
    };
    /**
     * Filter sales points when a filter is selected
     * @param filter Filter from the select
     */
    /**
     * Filter sales points when a filter is selected
     * @param {?} filter Filter from the select
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.onFilterBy = /**
     * Filter sales points when a filter is selected
     * @param {?} filter Filter from the select
     * @return {?}
     */
    function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (filter && filter.value) {
                            this._wsRequestParams = Object.assign({}, this._wsRequestParams, {
                                status: filter.value,
                            });
                        }
                        else {
                            if (this._wsRequestParams.status) {
                                delete this._wsRequestParams.status;
                            }
                        }
                        return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams, true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Order sales point by cardHeaderLabels selected item
     * @param index position of selected item
     * @param isUp direction of the order
     */
    /**
     * Order sales point by cardHeaderLabels selected item
     * @param {?} index position of selected item
     * @param {?} isUp direction of the order
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.onOrderBy = /**
     * Order sales point by cardHeaderLabels selected item
     * @param {?} index position of selected item
     * @param {?} isUp direction of the order
     * @return {?}
     */
    function (index, isUp) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.cardHeaderLabels[index]) {
                            this.cardHeaderLabels.forEach(function (item, i) {
                                _this.cardHeaderLabels[i].filterSelected = i === index ? [isUp, !isUp] : [false, false];
                            });
                            this._wsRequestParams = Object.assign({}, this._wsRequestParams, {
                                orderBy: this.cardHeaderLabels[index].name,
                                direction: isUp ? 'asc' : 'desc',
                            });
                        }
                        else if (this._wsRequestParams.orderBy) {
                            delete this._wsRequestParams.orderBy;
                            delete this._wsRequestParams.direction;
                        }
                        return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams, false, true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    SalesPointsStatsComponent.prototype.onCsvDownloadClicked = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var csvContentWS, blobData, url, a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http
                            .get(this.exportLink, {
                            responseType: 'text',
                            withCredentials: true,
                            params: (/** @type {?} */ (this._wsRequestParams)),
                        })
                            .toPromise()];
                    case 1:
                        csvContentWS = _a.sent();
                        blobData = new Blob(['\ufeff', csvContentWS], { type: 'text/csv;charset=utf-8,' });
                        url = window.URL.createObjectURL(blobData);
                        if (navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blobData, "export_csv_" + this.publicationId + "_" + new Date().getTime() + ".csv");
                        }
                        else {
                            a = document.createElement('a');
                            a.href = url;
                            a.download = "export_csv_" + this.publicationId + "_" + new Date().getTime() + ".csv";
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                        window.URL.revokeObjectURL(url);
                        return [2 /*return*/];
                }
            });
        });
    };
    SalesPointsStatsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-sales-points-stats',
                    template: "<ng-container *ngIf=\"isLoading; else isLoaded\">\n  <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div #scrollAnchor class=\"container-content\">\n    <div class=\"container-header\">\n      <div class=\"header-title\">\n        <span>\n          {{ salesPointsStats?.warehouseName ? 'D\u00E9p\u00F4t ' + salesPointsStats?.warehouseName : 'France enti\u00E8re' }}\n        </span>\n        \u2014 <span class=\"header-subtitle\">{{ salesPointsStats?.total }} points de vente caisses fiabilis\u00E9es</span>\n      </div>\n      <div class=\"position-relative header-select\">\n        <lib-select\n          class=\"header-select-comp\"\n          [options]=\"[{ value: 'En rupture', label: 'En Rupture' }]\"\n          clearable=\"true\"\n          placeholder=\"Filtrer par\"\n          [disabled]=\"salesPointsStats?.displayCode?.salespoints > 1\"\n          (change)=\"onFilterBy($event)\"\n        ></lib-select>\n        <lib-button-gold\n          [subscription]=\"salesPointsStats?.displayCode?.export\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [text]=\"'Export'\"\n          [center]=\"false\"\n          type=\"button\"\n          *ngIf=\"salesPointsStats?.displayCode?.export > 1\"\n        ></lib-button-gold>\n        <div *ngIf=\"salesPointsStats?.displayCode?.export === 1\">\n          Exporter la liste\n        </div>\n        <div *ngIf=\"salesPointsStats?.displayCode?.export === 1\" class=\"header-download\"\n             (click)=\"onCsvDownloadClicked()\">\n          <img src=\"/assets/icons/download.svg\"/>\n        </div>\n      </div>\n    </div>\n\n    <ng-container *ngIf=\"isWholeTableLoading; else content\">\n      <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n    </ng-container>\n    <ng-template #content>\n      <div class=\"mobile-container\">\n        <ng-container *ngIf=\"isTableContentLoading; else mobileContent\">\n          <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n        </ng-container>\n        <ng-template #mobileContent>\n          <ng-container *ngFor=\"let salesPoint of salesPointsStats?.salespoints; let i = index\">\n            <div class=\"container-card\"\n                 [ngClass]=\"{'text-blur': i > 4 && salesPointsStats?.displayCode?.salespoints > 1}\">\n              <lib-button-gold\n                [subscription]=\"salesPointsStats?.displayCode?.salespoints\"\n                [goldUrl]=\"goldUrl\"\n                [accountUrl]=\"accountUrl\"\n                [text]=\"'Points de vente'\"\n                [center]=\"true\"\n                type=\"button\"\n                *ngIf=\"salesPointsStats?.displayCode?.salespoints > 1 && i === 6\"\n              ></lib-button-gold>\n              <div class=\"card-title\">{{ salesPoint?.salespoint?.id }} \u2022 {{ salesPoint?.salespoint?.name }}\n                <div class=\"card-subtitle\">\n                  {{ salesPoint?.salespoint?.street }}, {{ salesPoint?.salespoint?.postalCode }}\n                  {{ salesPoint?.salespoint?.city }}\n                </div>\n              </div>\n              <div class=\"card-line\">\n                <div class=\"card-distribute\">\n                  <div class=\"distribute-label\">Servis</div>\n                  <div class=\"distribute-data\">\n                    <div class=\"data-value\">{{ salesPoint?.deliveredItems?.currentPublication?.value }}</div>\n                    <div class=\"data-previous\">{{ salesPoint?.deliveredItems[valueComparison]?.value }}</div>\n                  </div>\n                </div>\n                <div class=\"card-sold\">\n                  <div class=\"sold-label\">Vendus</div>\n                  <div class=\"sold-data\">\n                    <div class=\"data-value\">{{ salesPoint?.soldItems?.currentPublication?.value }}</div>\n                    <div class=\"data-previous\">{{ salesPoint?.soldItems[valueComparison]?.value }}</div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"card-line\">\n                <div class=\"card-unsold\">\n                  <div class=\"unsold-label\">Tx de vente</div>\n                  <div class=\"unsold-data\">\n                    <div class=\"data-value\">\n                      {{ salesPoint?.soldRate?.currentPublication?.value | floorPercent }}\n                    </div>\n                    <div class=\"data-previous\">\n                      {{ salesPoint?.soldRate[valueComparison]?.value | floorPercent }}\n                    </div>\n                  </div>\n                </div>\n                <lib-text-badge\n                  *ngIf=\"salesPoint?.salespoint?.currentStatus\"\n                  [content]=\"salesPoint?.salespoint?.currentStatus\"\n                  [background]=\"getRuptureColor(salesPoint?.salespoint?.currentStatus)\"\n                  class=\"text-badge\"\n                ></lib-text-badge>\n              </div>\n            </div>\n          </ng-container>\n        </ng-template>\n      </div>\n      <div class=\"desktop-container\">\n        <div class=\"card-header\">\n          <ng-container *ngFor=\"let item of cardHeaderLabels; let i = index\">\n            <div class=\"card-header-label\" *ngIf=\"salesPointsStats?.displayCode?.salespoints > 1\">\n              {{ item.label }}\n            </div>\n            <div class=\"card-header-label\" (click)=\"onOrderBy(i, !item.filterSelected[0])\"\n                 *ngIf=\"salesPointsStats?.displayCode?.salespoints === 1\">\n              {{ item.label }}\n              <div class=\"filter-select\">\n                <div class=\"filter-select-up\" [ngClass]=\"{ 'filter-selected': item.filterSelected[0] }\"></div>\n                <div class=\"filter-select-down\" [ngClass]=\"{ 'filter-selected': item.filterSelected[1] }\"></div>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n\n        <ng-container *ngIf=\"isTableContentLoading; else desktopContent\">\n          <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n        </ng-container>\n        <ng-template #desktopContent>\n          <ng-container *ngFor=\"let salesPoint of salesPointsStats?.salespoints; let i = index\">\n            <div class=\"container-card\"\n                 [ngClass]=\"{'text-blur': i > 4 && salesPointsStats?.displayCode?.salespoints > 1}\">\n              <lib-button-gold\n                [subscription]=\"salesPointsStats?.displayCode?.salespoints\"\n                [goldUrl]=\"goldUrl\"\n                [accountUrl]=\"accountUrl\"\n                [text]=\"'Points de vente'\"\n                [center]=\"true\"\n                type=\"button\"\n                *ngIf=\"salesPointsStats?.displayCode?.salespoints > 1 && i === 6\"\n              ></lib-button-gold>\n              <div class=\"card-title\">\n                {{ salesPoint?.salespoint?.id }} \u2022 {{ salesPoint?.salespoint?.name }}\n                <div class=\"card-subtitle\">\n                  {{ salesPoint?.salespoint?.street }}, {{ salesPoint?.salespoint?.postalCode }}\n                  {{ salesPoint?.salespoint?.city }}\n                </div>\n              </div>\n              <div class=\"distribute-data\">\n                <div class=\"data-value\">{{ salesPoint?.deliveredItems?.currentPublication?.value }}</div>\n                <div class=\"data-previous\">{{ salesPoint?.deliveredItems[valueComparison]?.value }}</div>\n              </div>\n              <div class=\"sold-data\">\n                <div class=\"data-value\">{{ salesPoint?.soldItems?.currentPublication?.value }}</div>\n                <div class=\"data-previous\">{{ salesPoint?.soldItems[valueComparison]?.value }}</div>\n              </div>\n              <div class=\"unsold-data\">\n                <div class=\"data-value\">\n                  {{ salesPoint?.soldRate?.currentPublication?.value | floorPercent }}\n                </div>\n                <div class=\"data-previous\">\n                  {{ salesPoint?.soldRate[valueComparison]?.value | floorPercent }}\n                </div>\n              </div>\n              <div class=\"marketshare-data\">\n                <div class=\"data-value\">\n                  {{ salesPoint[marketType ? marketType : 'family']?.currentPublication?.value | floorPercent }}\n                </div>\n                <div class=\"data-previous\">\n                  {{ salesPoint[marketType ? marketType : 'family'][valueComparison]?.value | floorPercent }}\n                </div>\n              </div>\n              <lib-text-badge\n                *ngIf=\"salesPoint?.salespoint?.currentStatus\"\n                [content]=\"salesPoint?.salespoint?.currentStatus\"\n                [background]=\"getRuptureColor(salesPoint?.salespoint?.currentStatus)\"\n                class=\"text-badge\"\n              ></lib-text-badge>\n            </div>\n          </ng-container>\n        </ng-template>\n      </div>\n      <lib-pagination\n        class=\"pagination\"\n        [numberOfItems]=\"salesPointsStats?.total\"\n        [itemsPerPage]=\"nbItemPerPage\"\n        [currentPage]=\"currentPage\"\n        (pageChange)=\"paginationPageChange($event)\"\n        *ngIf=\"havePagination() && salesPointsStats?.displayCode?.salespoints === 1\"\n      ></lib-pagination>\n    </ng-template>\n  </div>\n</ng-template>\n",
                    providers: [SalesPointsStatsMock],
                    encapsulation: ViewEncapsulation.None,
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container-content .container-header{display:flex;flex-flow:wrap;margin-bottom:16px}.container-content .container-header .header-title{order:1;width:80%;font-size:2rem;font-weight:500}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container-content .container-header{align-items:center}.container-content .container-header .header-title{width:inherit}}.container-content .container-header .header-title .header-subtitle{font-weight:400}.container-content .container-header .header-download{order:2;width:24px;height:24px;padding:12px;border:1px solid rgba(15,17,18,.16);border-radius:4px;margin-left:auto;cursor:pointer;align-items:center}.container-content .container-header .header-select{order:3;flex-grow:0;margin-top:24px;flex-basis:100%;position:relative;display:flex;align-items:center}.container-content .container-header .header-select .header-select-comp{margin-right:16px}.container-content .desktop-container{display:none}@media (min-width:1140px){.container-content .container-header .header-download{margin-left:10px;order:3}.container-content .container-header .header-select{margin-top:0;margin-left:auto;flex-basis:auto;order:2}.container-content .mobile-container{display:none}.container-content .desktop-container{background:#fff;display:block}.container-content .desktop-container .card-header{display:flex;padding:16px;font-size:1.2rem;font-weight:500;line-height:2;border-bottom:1px solid rgba(122,140,145,.2)}.container-content .desktop-container .card-header .card-header-label{cursor:pointer;flex-basis:13%;display:flex;align-items:center}.container-content .desktop-container .card-header .card-header-label:first-child{flex-basis:375px}.container-content .desktop-container .card-header .filter-select{margin-left:8px}.container-content .desktop-container .card-header .filter-select .filter-select-down,.container-content .desktop-container .card-header .filter-select .filter-select-up{width:0;height:0;border-style:solid;cursor:pointer}.container-content .desktop-container .card-header .filter-select .filter-select-up{border-width:0 4px 6px;border-color:transparent transparent rgba(122,140,145,.5);margin-bottom:2px}.container-content .desktop-container .card-header .filter-select .filter-select-up.filter-selected{border-color:transparent transparent #0f1112}.container-content .desktop-container .card-header .filter-select .filter-select-down{border-width:6px 4px 0;border-color:rgba(122,140,145,.5) transparent transparent}.container-content .desktop-container .card-header .filter-select .filter-select-down.filter-selected{border-color:#0f1112 transparent transparent}}.container-content .container-card{background:#fff;border-radius:4px;padding:16px;display:flex;flex-direction:column;position:relative}.container-content .container-card .card-title{font-size:1.4rem;font-weight:500;line-height:1.71;margin-bottom:4px}@media (min-width:1140px){.container-content .container-card{flex-direction:row;align-items:center;padding:11px 16px;border-bottom:1px solid rgba(122,140,145,.2)}.container-content .container-card .card-title{display:flex;flex-direction:column;margin-bottom:0;flex-basis:375px;line-height:1.2}}.container-content .container-card .card-title .card-subtitle{color:#657478;font-size:1.2rem}.container-content .container-card .card-line{display:flex;color:#657478;font-size:1.6rem;font-weight:300}.container-content .container-card .distribute-label,.container-content .container-card .sold-label,.container-content .container-card .unsold-label{font-weight:500;font-size:1.2rem;line-height:1.33}@media (min-width:1140px){.container-content .container-card .distribute-label,.container-content .container-card .sold-label,.container-content .container-card .unsold-label{display:none}}.container-content .container-card .distribute-data,.container-content .container-card .marketshare-data,.container-content .container-card .sold-data,.container-content .container-card .unsold-data{display:flex;min-width:135px}@media (min-width:1140px){.container-content .container-card .distribute-data,.container-content .container-card .marketshare-data,.container-content .container-card .sold-data,.container-content .container-card .unsold-data{color:#657478;flex-direction:row;margin-right:0;min-width:0;flex-basis:13%}}.container-content .container-card .data-value{color:#2d54d2;width:57px}.container-content .container-card .text-badge{display:flex;align-items:center}.container-content .container-card.text-blur,.container-content .container-card.text-blur .card-subtitle,.container-content .container-card.text-blur .data-previous,.container-content .container-card.text-blur .data-value,.container-content .container-card.text-blur .distribute-label,.container-content .container-card.text-blur .sold-label,.container-content .container-card.text-blur .unsold-label{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}.container-content .pagination{display:flex;width:100%;justify-content:center;margin-top:20px}@media (min-width:1140px){.container-content .pagination{justify-content:flex-end;margin-top:16px}}"]
                }] }
    ];
    /** @nocollapse */
    SalesPointsStatsComponent.ctorParameters = function () { return [
        { type: HttpClient },
        { type: SalesPointsStatsMock },
        { type: DomSanitizer }
    ]; };
    SalesPointsStatsComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        publicationId: [{ type: Input }],
        componentId: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        comparedParution: [{ type: Input, args: ['comparedParution',] }],
        marketType: [{ type: Input }],
        warehouseId: [{ type: Input }],
        segmentId: [{ type: Input }],
        anchorForScroll: [{ type: ViewChild, args: ['scrollAnchor',] }]
    };
    return SalesPointsStatsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SalesPointsStatsMetadata = {
    declarations: [SalesPointsStatsComponent],
    imports: [
        CommonModule,
        HttpClientModule,
        LoaderModule,
        SelectModule,
        TextBadgeModule,
        PaginationModule,
        PipesModule.forRoot(),
        ButtonGoldModule
    ],
    exports: [SalesPointsStatsComponent],
};
var SalesPointsStatsModule = /** @class */ (function () {
    function SalesPointsStatsModule() {
    }
    SalesPointsStatsModule.decorators = [
        { type: NgModule, args: [SalesPointsStatsMetadata,] }
    ];
    return SalesPointsStatsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FooterComponent = /** @class */ (function () {
    function FooterComponent(http) {
        this.http = http;
    }
    /**
     * @return {?}
     */
    FooterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.copyright = '';
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        // Get copyright and links
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.apiUrl).toPromise()];
                    case 1:
                        // Get copyright and links
                        _a.footerData = _b.sent();
                        // Ensure not empty
                        if (!this.footerData.links || !this.footerData.links.length) {
                            this.footerData.links = [];
                        }
                        // Add all url and labels in links
                        this.links = this.footerData.links;
                        //Update copyright if not empty
                        if (this.footerData.copyright) {
                            this.copyright = this.footerData.copyright;
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FooterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-footer',
                    template: "<div class=\"footer-wrapper\">\n  <div class=\"footer-wrapper-left\">\n    {{ copyright }}\n  </div>\n  <div class=\"footer-wrapper-right\">\n    <a *ngFor=\"let link of links\" [href]=\"link.url\">{{ link.label }}</a>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.footer-wrapper{display:flex;justify-content:space-between;background-color:#0f1112;color:#fff;height:160px;padding:30px 0 10px;box-sizing:border-box}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.footer-wrapper{height:80px;align-items:center;padding:0}}.footer-wrapper-left{justify-content:center}.footer-wrapper-right{display:flex;flex-direction:column;text-align:right}.footer-wrapper-right a{color:#fff;text-decoration:none;margin-bottom:20px}@media (min-width:1140px){.footer-wrapper-right{flex-direction:row}.footer-wrapper-right a{margin-bottom:0;margin-right:30px}.footer-wrapper-right a:last-child{margin-right:0}}.footer-wrapper-right a:hover{text-decoration:underline}"]
                }] }
    ];
    /** @nocollapse */
    FooterComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    FooterComponent.propDecorators = {
        apiUrl: [{ type: Input }]
    };
    return FooterComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FooterMetadata = {
    declarations: [FooterComponent],
    imports: [CommonModule, HttpClientModule],
    exports: [FooterComponent],
};
var FooterModule = /** @class */ (function () {
    function FooterModule() {
    }
    FooterModule.decorators = [
        { type: NgModule, args: [FooterMetadata,] }
    ];
    return FooterModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FrontpagesComponent = /** @class */ (function () {
    function FrontpagesComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isLoading = true;
        this.itemsPerPage = 60;
        this.currentPage = 1;
        this.formGroup = new FormGroup({
            day: new FormControl(''),
        });
        this.savedFilter = null;
        this.valueMonth = 'Sélectionner la période';
        this.includeTitleImport = false;
        this.dayOptions = [
            { label: 'Lundi', value: 1 },
            { label: 'Mardi', value: 2 },
            { label: 'Mercredi', value: 3 },
            { label: 'Jeudi', value: 4 },
            { label: 'Vendredi', value: 5 },
            { label: 'Samedi', value: 6 },
            { label: 'Dimanche', value: 7 },
        ];
    }
    /**
     * @return {?}
     */
    FrontpagesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var date;
            return __generator(this, function (_a) {
                date = new Date();
                this.firstCall(date);
                this.maxDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
                return [2 /*return*/];
            });
        });
    };
    /**
     * @param {?} date
     * @return {?}
     */
    FrontpagesComponent.prototype.firstCall = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        this.formGroup.get('day').patchValue(null);
        this.valueMonth = "Aujourd'hui";
        this.fromDate = new NgbDate(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
        this.toDate = new NgbDate(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
        this.getDataFromWS();
    };
    /**
     * @return {?}
     */
    FrontpagesComponent.prototype.getDataFromWS = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        if (this.fromDate && this.toDate) {
                            this._wsRequestParams.start = this.fromDate.year + "-" + this.fromDate.month + "-" + this.fromDate.day;
                            this._wsRequestParams.end = this.toDate.year + "-" + this.toDate.month + "-" + this.toDate.day;
                        }
                        if (this.valueDaySelected) {
                            this._wsRequestParams.day = this.valueDaySelected;
                        }
                        else {
                            delete this._wsRequestParams.day;
                        }
                        this._wsRequestParams.includeImport = this.includeTitleImport;
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.apiUrl, {
                                withCredentials: true,
                                params: (/** @type {?} */ (Object.assign({}, this._wsRequestParams))),
                            }).toPromise()];
                    case 1:
                        _a.frontpages = _b.sent();
                        this.initialFrontpages = this.frontpages.frontpages;
                        this.setPaginationPages(this.initialFrontpages);
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Divide publications in multiple arrays based on itemsPerPage if necessary
     * @param publications Publications Object
     */
    /**
     * Divide publications in multiple arrays based on itemsPerPage if necessary
     * @param {?} publications Publications Object
     * @return {?}
     */
    FrontpagesComponent.prototype.setPaginationPages = /**
     * Divide publications in multiple arrays based on itemsPerPage if necessary
     * @param {?} publications Publications Object
     * @return {?}
     */
    function (publications) {
        var _this = this;
        this.currentPage = 1;
        this.paginationPagesItems = [[]];
        if (publications) {
            this.paginationPagesItems = publications.reduce(function (acc, parution) {
                /** @type {?} */
                var lastIndex = acc.length > 0 ? acc.length - 1 : 0;
                if (acc[lastIndex] && acc[lastIndex].length < _this.itemsPerPage) {
                    acc[lastIndex].push(parution);
                }
                else {
                    acc.push([parution]);
                }
                return acc;
            }, [[]]);
        }
    };
    /**
     * Navigate btw pages set by pagination
     * @param page Page number clicked (or set in queryparams)
     */
    /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    FrontpagesComponent.prototype.paginationPageChange = /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    function (page) {
        this.currentPage = page;
        /** @type {?} */
        var scrollSize = this.anchorForScroll.nativeElement.offsetTop - 110;
        window.scroll({ top: scrollSize, left: 0 });
    };
    /**
     * Filter frontpage publications when a filter is selected
     * @param filter Filter from the select
     */
    /**
     * Filter frontpage publications when a filter is selected
     * @param {?} filter Filter from the select
     * @return {?}
     */
    FrontpagesComponent.prototype.onFilterByItems = /**
     * Filter frontpage publications when a filter is selected
     * @param {?} filter Filter from the select
     * @return {?}
     */
    function (filter) {
        /** @type {?} */
        var res = StaticFilters.filterByItems(filter, this.initialFrontpages, this.frontpages.frontpages, null, this.itemsPerPage);
        this.frontpages.frontpages = res.list;
        this.paginationPagesItems = res.listPages;
        this.currentPage = res.currentPage;
        this.savedFilter = res.savedFilter;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    FrontpagesComponent.prototype.includeTitle = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.includeTitleImport = !this.includeTitleImport;
        this.getDataFromWS();
    };
    /**
     * @param {?} day
     * @return {?}
     */
    FrontpagesComponent.prototype.onDayChange = /**
     * @param {?} day
     * @return {?}
     */
    function (day) {
        /** @type {?} */
        var previousDaySelected = this.valueDaySelected;
        this.valueDaySelected = day ? day.value : null;
        if (previousDaySelected !== this.valueDaySelected) {
            this.getDataFromWS();
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    FrontpagesComponent.prototype.onSelectDate = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!this.fromDate && !this.toDate) {
            this.fromDate = e;
        }
        else if (this.fromDate && !this.toDate && (e.after(this.fromDate) || e.equals(this.fromDate))) {
            this.toDate = e;
        }
        else {
            this.toDate = null;
            this.fromDate = e;
        }
        /** @type {?} */
        var today = new Date();
        if (this.fromDate && this.toDate && this.fromDate === this.toDate && this.fromDate === new NgbDate(today.getFullYear(), today.getMonth() + 1, today.getDate())) {
            this.valueMonth = 'Aujourd\'hui';
        }
        else if (this.fromDate && !this.toDate) {
            this.valueMonth = "Du " + ('0' + this.fromDate.day).slice(-2) + "/" + ('0' + this.fromDate.month).slice(-2) + " au";
        }
        else if (this.fromDate && this.toDate && this.fromDate === this.toDate) {
            this.valueMonth = "Du " + ('0' + this.fromDate.day).slice(-2) + "/" + ('0' + this.fromDate.month).slice(-2);
        }
        else if (this.fromDate && this.toDate) {
            this.valueMonth = "Du " + ('0' + this.fromDate.day).slice(-2) + "/" + ('0' + this.fromDate.month).slice(-2) + " au " + ('0' + this.toDate.day).slice(-2) + "/" + ('0' + this.toDate.month).slice(-2);
        }
        else {
            this.valueMonth = "S\u00E9lectionner la p\u00E9riode";
        }
        // this.valueMonth = `Afficher la période du ${('0' + this.fromDateMonth.day).slice(-2)}/${('0' + this.fromDateMonth.month).slice(-2)} au ${('0' + this.toDateMonth.day).slice(-2)}/${('0' + this.toDateMonth.month).slice(-2)}`;
        if (this.fromDate && this.toDate) {
            this.getDataFromWS();
        }
    };
    /**
     * @param {?} date
     * @return {?}
     */
    FrontpagesComponent.prototype.isInside = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return date.after(this.fromDate) && date.before(this.toDate);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    FrontpagesComponent.prototype.isSelected = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return date.equals(this.fromDate) || date.equals(this.toDate);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    FrontpagesComponent.prototype.isHovered = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return date.equals(this.hoveredDate);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    FrontpagesComponent.prototype.isInsideHovered = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        return this.fromDate && !this.toDate && date.after(this.fromDate) && date.before(this.hoveredDate);
    };
    FrontpagesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-frontpages',
                    template: "<div class=\"container\">\n  <lib-loader *ngIf=\"isLoading; else isLoaded\" loaderSize=\"big\"></lib-loader>\n  <ng-template #isLoaded>\n\n    <div #scrollAnchor *ngIf=\"!isLoading\" class=\"container-frontpages\">\n      <div class=\"container-frontpages-header-title\">\n        <span class=\"title-frontpages-number\">{{ frontpages?.frontpages?.length }}</span\n        >unes\n      </div>\n      <div class=\"container-header-input\">\n        <div class=\"selector-title\">\n          S\u00E9lectionner la p\u00E9riode :\n        </div>\n        <input\n          (focus)=\"!datepicker.isOpen() ? datepicker.open() : ''\"\n          class=\"form-control\"\n          name=\"dp\" [displayMonths]=\"1\" [navigation]=\"'arrows'\" [outsideDays]=\"'visible'\"\n          (dateSelect)=\"onSelectDate($event)\"\n          [showWeekNumbers]=\"false\" ngbDatepicker #datepicker=\"ngbDatepicker\" [readOnly]=\"true\"\n          [maxDate]=\"maxDate\"\n          [autoClose]=\"'outside'\"\n          [ngClass]=\"{'active': fromDate && toDate }\"\n          [dayTemplate]=\"datepickerTemplate\" [value]=\"valueMonth\"/>\n        <ng-template #datepickerTemplate let-date=\"date\"\n                     let-disabled=\"disabled\">\n          <div class=\"custom-day\"\n               [class.text-muted]=\"disabled\"\n               [class.faded]=\"isSelected(date) || isHovered(date) && !disabled\"\n               [class.between]=\"isInside(date) || isInsideHovered(date) && !disabled\"\n               (mouseenter)=\"hoveredDate = date\"\n               (mouseleave)=\"hoveredDate = null\">\n            {{ date.day }}\n          </div>\n        </ng-template>\n        <ng-container *ngIf=\"fromDate && toDate && !fromDate.equals(toDate)\">\n          <span class=\"separator\">et</span>\n          <lib-select\n            clearable=\"true\"\n            [options]=\"dayOptions\"\n            [group]=\"formGroup\"\n            controlName=\"day\"\n            placeholder=\"Tous les jours\"\n            (change)=\"onDayChange($event)\"\n            class=\"day-selector\"\n          >\n          </lib-select>\n        </ng-container>\n      </div>\n      <div class=\"container-frontpages-header\">\n        <div class=\"container-frontpages-checkbox\">\n          <label class=\"checkbox-button\">\n            <input type=\"checkbox\" class=\"checkbox-button-input\" id=\"import\" name=\"import\"\n                   (change)=\"includeTitle($event)\" [checked]=\"includeTitleImport\">\n            <span class=\"checkbox-button-control\"></span>\n            <span class=\"checkbox-button-label\">Inclure titres imports</span>\n          </label>\n        </div>\n        <div class=\"filter-container\">\n          <lib-select\n            clearable=\"true\"\n            [options]=\"frontpages?.filters?.filterByItems\"\n            placeholder=\"Filter par:\"\n            ngClassName=\"filter-select\"\n            (change)=\"onFilterByItems($event)\"\n          ></lib-select>\n        </div>\n      </div>\n      <div class=\"container-frontpages-list\" *ngIf=\"paginationPagesItems && paginationPagesItems.length > 0\">\n        <ng-container *ngFor=\"let frontpage of paginationPagesItems[currentPage - 1]\">\n          <lib-parution\n            [publication]=\"frontpage\"\n            class=\"container-frontpages-frontpage\"\n            [isFrontpage]=\"true\"\n          ></lib-parution>\n        </ng-container>\n      </div>\n      <lib-pagination\n        [numberOfItems]=\"frontpages?.frontpages?.length\"\n        [itemsPerPage]=\"itemsPerPage\"\n        [currentPage]=\"currentPage\"\n        (pageChange)=\"paginationPageChange($event)\"\n        *ngIf=\"paginationPagesItems && paginationPagesItems.length > 1\"\n      ></lib-pagination>\n    </div>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{max-width:1100px;color:#0f1112}.container .container-frontpages-header-title{display:flex;align-items:baseline;font-size:2rem;font-weight:600;margin-bottom:24px}.container .container-frontpages-header-title .title-frontpages-number{font-family:\"Roboto Slab\",serif;font-size:5.6rem;font-weight:100;margin-right:14px}.container .container-header-input .form-control{border:1px solid #d3d4d4;padding:16px;font-size:1.4rem;color:#657478;width:280px;display:block}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container .container-header-input .form-control{margin-bottom:28px;display:inline-block}}@media (max-width:1139px){.container .container-header-input .form-control{margin-top:10px}}.container .container-header-input .form-control.active{background-color:#2d54d2;border-color:#2d54d2;color:#fff}.container .container-header-input .separator{margin:20px 0;display:block}@media (min-width:1140px){.container .container-header-input .separator{margin:0 20px;display:inline-block}.container .container-header-input .selector-title{margin-right:20px}}.container .container-header-input .day-selector{display:inline-block;min-width:150px}.container .container-header-input .selector-title{display:inline}.container .container-frontpages-checkbox{padding:20px 0}.container .container-frontpages-header{display:block;margin-bottom:40px}@media (min-width:1140px){.container .container-frontpages-checkbox{padding:0}.container .container-frontpages-header{display:flex;justify-content:space-between;align-items:baseline}}.container .container-frontpages-header .container-frontpages-header-filter{width:364px;max-width:100%}.container .container-frontpages-header .checkbox-button{cursor:pointer;box-sizing:border-box;font-size:1.6rem;line-height:1.5;color:#657478}.container .container-frontpages-header .checkbox-button-input{opacity:0;position:absolute;font-size:1.6rem;line-height:1.5;padding:11px 23px;border:1px solid #979797;border-radius:0;outline:0;background-color:transparent}.container .container-frontpages-header .checkbox-button-control{position:relative;display:inline-block;width:14px;height:14px;margin-right:12px;vertical-align:middle;background-color:#fff;color:#2d54d2;border:1px solid #979797;transition:.3s}.container .container-frontpages-header .checkbox-button-input:checked+.checkbox-button-control:after{content:\"\";display:block;position:absolute;top:2px;left:2px;width:10px;height:10px;background-color:#2d54d2}.container .container-frontpages-header .checkbox-button-input:checked+.checkbox-button-control{border-color:#2d54d2}.container .container-frontpages-header .filter-container{min-width:200px}.container .container-frontpages-list{display:flex;flex-wrap:wrap}@media (max-width:1139px){.container .container-frontpages-list{margin:0 -3px}.container .container-frontpages-list .container-frontpages-frontpage{margin:0 7px 20px}}@media (min-width:1140px){.container .container-frontpages-list .container-frontpages-frontpage{margin:0 8px 40px}.container .container-frontpages-list .container-frontpages-frontpage:nth-child(6n+1){margin:0 8px 40px 0}.container .container-frontpages-list .container-frontpages-frontpage:nth-child(6n){margin:0 0 40px 8px}}.container ::ng-deep .custom-day{padding:10px 20px;margin:10px 0}.container ::ng-deep .ngb-dp-header{margin-top:10px}"]
                }] }
    ];
    /** @nocollapse */
    FrontpagesComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    FrontpagesComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        anchorForScroll: [{ type: ViewChild, args: ['scrollAnchor',] }]
    };
    return FrontpagesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FrontpagesMetadata = {
    declarations: [FrontpagesComponent],
    imports: [CommonModule, HttpClientModule, ParutionModule, SelectModule, PaginationModule, LoaderModule, NgbDatepickerModule],
    exports: [FrontpagesComponent],
};
var FrontpagesModule = /** @class */ (function () {
    function FrontpagesModule() {
    }
    FrontpagesModule.decorators = [
        { type: NgModule, args: [FrontpagesMetadata,] }
    ];
    return FrontpagesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FinancialStatsComponent = /** @class */ (function () {
    function FinancialStatsComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.isLoading = true;
    }
    Object.defineProperty(FinancialStatsComponent.prototype, "mulitpleFilters", {
        set: /**
         * @param {?} filters
         * @return {?}
         */
        function (filters) {
            if (filters) {
                this._wsRequestParams = StaticInputProccesor.processMultipleFilters(filters, this._wsRequestParams);
                if (!this.isfirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinancialStatsComponent.prototype, "compareParution", {
        get: /**
         * @return {?}
         */
        function () {
            return this._compareParution;
        },
        set: /**
         * @param {?} compareParution
         * @return {?}
         */
        function (compareParution) {
            this._compareParution = compareParution;
            if (compareParution && compareParution.showCompare) {
                this._wsRequestParams.periodId = compareParution.refParution.periodId;
                this._wsRequestParams.compareId = compareParution.compareParution.periodId;
                this.getDataFromWS(this._wsRequestParams);
            }
            if (!compareParution.showCompare && !!this._wsRequestParams.compareId) {
                delete this._wsRequestParams.compareId;
            }
            if (!compareParution.showCompare && !!this._wsRequestParams.periodId) {
                delete this._wsRequestParams.periodId;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinancialStatsComponent.prototype, "includeHS", {
        set: /**
         * @param {?} includeHS
         * @return {?}
         */
        function (includeHS) {
            this._wsRequestParams.includeHS = includeHS;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinancialStatsComponent.prototype, "componentId", {
        set: /**
         * @param {?} componentId
         * @return {?}
         */
        function (componentId) {
            this._wsRequestParams.componentId = componentId;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinancialStatsComponent.prototype, "titleId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._titleId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FinancialStatsComponent.prototype, "periodId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._periodId;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FinancialStatsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Format number from thousands to K
     * @param value number in thousands
     */
    /**
     * Format number from thousands to K
     * @param {?} value number in thousands
     * @return {?}
     */
    FinancialStatsComponent.prototype.getThousandFormatedNumber = /**
     * Format number from thousands to K
     * @param {?} value number in thousands
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var divider = 1000;
        /** @type {?} */
        var newVal = {
            value: value < divider ? Math.round(value) : Math.round(value / divider),
            unit: value > divider ? 'k' : '',
        };
        return newVal;
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    FinancialStatsComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, Promise.all([
                                this.wsRequest('cumulative', params),
                                this.wsRequest('byParution', params),
                                this.wsRequest('netProfitByparution', params),
                            ])];
                    case 1:
                        _a.FinancialStats = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Specific WS call to get the 3 parts of FinancialStats
     * @param type cumulative / byParution / netProfitByParution
     * @param params QueryParams
     */
    /**
     * Specific WS call to get the 3 parts of FinancialStats
     * @private
     * @param {?} type cumulative / byParution / netProfitByParution
     * @param {?} params QueryParams
     * @return {?}
     */
    FinancialStatsComponent.prototype.wsRequest = /**
     * Specific WS call to get the 3 parts of FinancialStats
     * @private
     * @param {?} type cumulative / byParution / netProfitByParution
     * @param {?} params QueryParams
     * @return {?}
     */
    function (type, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http
                            .get(this.apiUrl, {
                            withCredentials: true,
                            params: Object.assign({}, params, { type: type }),
                        })
                            .toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FinancialStatsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-financial-stats',
                    template: "<ng-container>\n  <lib-loader [loaderText]=\"loadingMessage\" *ngIf=\"isLoading; else isLoaded\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <section>\n    <h3 class=\"title\">Finances</h3>\n    <ul class=\"item-list\">\n      <li class=\"item\" *ngFor=\"let statItem of FinancialStats\">\n        <div class=\"value-n-indicator\">\n          <span class=\"value\">{{ getThousandFormatedNumber(statItem.amount).value | number: '':'fr-FR' }}</span>\n          <span class=\"indicator\">{{ getThousandFormatedNumber(statItem.amount).unit }}{{ statItem.currency }}</span>\n        </div>\n        <div class=\"name-n-evaluation\">\n          <div class=\"name\">{{ statItem.label }}</div>\n          <div class=\"evaluation\">\n            <div *ngIf=\"!compareParution?.showCompare\" class=\"evaluation-type\">{{ 'Evol. ann\u00E9e-1' }}</div>\n            <div *ngIf=\"compareParution?.showCompare\" class=\"evaluation-type\">{{ 'Evol. parution compar\u00E9e' }}</div>\n            <div class=\"evaluation-value\">{{ statItem.mirror | custompercent }}</div>\n          </div>\n        </div>\n      </li>\n    </ul>\n  </section>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:flex;border-radius:4px;padding:24px 16px 32px;background-color:#fff}section{overflow:hidden;-webkit-animation:2s fadein;animation:2s fadein}.title{margin:0 0 11px;font-family:Poppins,sans-serif;font-size:1.6rem;font-weight:500;line-height:1.5;color:#657478}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}:host{padding:24px}.title{margin:0 0 35px}}.item-list{display:block;margin:0;padding:0;list-style:none}.item{display:flex;padding:24px 0}.item:first-child{padding-top:0}.item:not(:last-child){border-bottom:1px solid #f7f7f7}.value-n-indicator{-ms-grid-row-align:center;align-self:center;margin-right:9px;font-family:\"Roboto Slab\",serif;line-height:1.17;color:#2d54d2;min-width:125px}@media (min-width:1140px){.item-list{display:flex}.item{padding:0 24px;flex:1 0 0;flex-direction:column;display:flex}.item:first-child{padding-left:0}.item:not(:last-child){border-right:1px solid #f7f7f7;border-bottom:none}.item:last-child{padding-right:0}.value-n-indicator{margin-right:0;margin-bottom:8px;min-width:initial}}.value-n-indicator .value{font-size:2.8rem;font-weight:300;word-break:break-all}.value-n-indicator .indicator{font-size:1.6rem;font-weight:300}.name-n-evaluation{flex:1;margin-left:9px;font-family:Poppins,sans-serif;color:#0f1112}.name{font-size:1.4rem;font-weight:500;line-height:1.43}@media (min-width:1140px){.name-n-evaluation{margin-left:0;justify-content:space-between;display:flex;flex-direction:column}.name{margin-bottom:11px}}.evaluation{display:flex;align-items:center}.evaluation .evaluation-type{margin-right:9px;font-size:12px;line-height:1.67}@media (min-width:1140px){.evaluation{justify-content:space-between}.evaluation .evaluation-type{margin-right:0}}.evaluation .evaluation-value{font-family:\"Roboto Slab\",serif;font-size:16px;font-weight:300;line-height:1.5}"]
                }] }
    ];
    /** @nocollapse */
    FinancialStatsComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    FinancialStatsComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        mulitpleFilters: [{ type: Input, args: ['multipleFilters',] }],
        compareParution: [{ type: Input }],
        includeHS: [{ type: Input }],
        componentId: [{ type: Input }]
    };
    return FinancialStatsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var FinancialStatsMetadata = {
    declarations: [FinancialStatsComponent],
    imports: [CommonModule, HttpClientModule, PipesModule.forRoot(), LoaderModule],
    exports: [FinancialStatsComponent],
};
var FinancialStatsModule = /** @class */ (function () {
    function FinancialStatsModule() {
    }
    FinancialStatsModule.decorators = [
        { type: NgModule, args: [FinancialStatsMetadata,] }
    ];
    return FinancialStatsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(http) {
        this.http = http;
        this.brandChanged = new EventEmitter();
        this.brandEditorChanged = new EventEmitter();
        this.editorChanged = new EventEmitter();
        this.logoutClicked = new EventEmitter();
        this.changePage = new EventEmitter();
        this.editors = [];
        this.selectEditorEnabled = false;
        this.isLoading = false;
        this.brandEditor = { editor: { value: null, label: null }, brand: { value: null, label: null } };
    }
    Object.defineProperty(HeaderComponent.prototype, "setCurrentUser", {
        set: /**
         * @param {?} currentUser
         * @return {?}
         */
        function (currentUser) {
            if (currentUser) {
                this.currentUser = currentUser;
                if (currentUser && currentUser.groups && currentUser.groups.editors && currentUser.groups.editors.length > 0) {
                    if (currentUser.groups.editors.length > 1) {
                        this.selectEditorEnabled = true;
                    }
                    this.editor = currentUser.groups.editors[0].groupId;
                    this.brandEditor.editor.value = currentUser.groups.editors[0].groupId;
                    this.brandEditor.editor.label = currentUser.groups.editors[0].name;
                    this.editors = currentUser.groups.editors.map(function (item) { return ({
                        value: item.groupId,
                        label: item.name,
                    }); });
                    this.editors.sort(function (a, b) {
                        if (a && b) {
                            if (a.label.toLowerCase() > b.label.toLowerCase()) {
                                return 1;
                            }
                            else if (a.label.toLowerCase() < b.label.toLowerCase()) {
                                return -1;
                            }
                        }
                        return 0;
                    });
                    this.getDataFromWS(this.editor);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    HeaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    /**
     * @param {?=} groupId
     * @return {?}
     */
    HeaderComponent.prototype.getDataFromWS = /**
     * @param {?=} groupId
     * @return {?}
     */
    function (groupId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, headerData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        params = {};
                        if (groupId) {
                            params = {
                                groupId: groupId,
                            };
                        }
                        // Get brands
                        return [4 /*yield*/, this.http.get(this.apiUrl, { params: params }).toPromise()];
                    case 1:
                        headerData = _a.sent();
                        // Ensure not empty
                        if (!headerData.brands || !headerData.brands.length) {
                            headerData.brands = [];
                        }
                        // // Add the "All brands" item
                        headerData.brands.unshift({ id: '', label: 'Toutes les marques' });
                        // Map to the value/label Select needed properties
                        this.brands = headerData.brands.map(function (item) { return ({
                            value: item.id,
                            label: item.label,
                        }); });
                        // Ensure not empty
                        if (!headerData.menu || !headerData.menu.length) {
                            headerData.menu = [];
                        }
                        // Map to the value/label Select needed properties
                        this.menu = headerData.menu;
                        this.isLoading = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    HeaderComponent.prototype.logout = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.logoutClicked.emit(evt);
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    HeaderComponent.prototype.onBrandChanged = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.brandEditor.brand.value = evt && evt.value ? evt.value : null;
        this.brandEditor.brand.label = evt && evt.label ? evt.label : null;
        this.brandChanged.emit(this.brandEditor);
        this.brandEditorChanged.emit(this.brandEditor);
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    HeaderComponent.prototype.onEditorChanged = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        if (evt && evt.value) {
            this.brandEditor.brand.value = null;
            this.brandEditor.brand.label = null;
            this.brandEditor.editor.value = evt.value;
            this.brandEditor.editor.label = evt.label;
            this.getDataFromWS(evt.value);
        }
        this.editorChanged.emit(this.brandEditor);
        this.brandEditorChanged.emit(this.brandEditor);
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    HeaderComponent.prototype.handleChangePage = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.changePage.emit(evt);
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.onGoBackHome = /**
     * @return {?}
     */
    function () {
        this.handleChangePage('tdb');
    };
    HeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-header',
                    template: "<div class=\"title-bar\">\n  <div class=\"editor-brand\">\n    <div class=\"editor\">\n      <lib-select\n        [model]=\"editor\"\n        [options]=\"editors\"\n        class=\"editors-select\"\n        [binding]=\"true\"\n        [placeholder]=\"null\"\n        [disabled]=\"!selectEditorEnabled\"\n        searchable=\"true\"\n        [clearable]=\"false\"\n        [className]=\"'editor-select'\"\n        (change)=\"onEditorChanged($event)\"\n      ></lib-select>\n    </div>\n\n    <div class=\"brands\">\n      <lib-select\n        *ngIf=\"!isLoading\"\n        [model]=\"brand\"\n        [options]=\"brands\"\n        class=\"brands-select\"\n        placeholder=\"Toutes les marques\"\n        [disabled]=\"!selectEnabled\"\n        searchable=\"true\"\n        clearable=\"true\"\n        (change)=\"onBrandChanged($event)\"\n      ></lib-select>\n    </div>\n  </div>\n  <a role=\"button\" class=\"logout\" href=\"javascript:void(0)\" (click)=\"logout($event)\"></a>\n\n  <div class=\"menu\">\n    <lib-menu-button\n      [menu]=\"menu\"\n      (logout)=\"logout($event)\"\n      (changePage)=\"handleChangePage($event)\"\n      [currentPage]=\"currentPage\"\n    ></lib-menu-button>\n  </div>\n</div>\n<lib-menu-desktop\n  class=\"menu-desktop\"\n  [menu]=\"menu\"\n  (changePage)=\"handleChangePage($event)\"\n  [currentPage]=\"currentPage\"\n></lib-menu-desktop>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.title-bar{height:136px;display:flex;justify-content:space-between;align-items:center;position:relative}.container{display:inline-flex}.editor-brand{width:100%}.editor{margin-bottom:10px}.editor .ng-value-container .ng-value{font-size:2rem;font-weight:700}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.title-bar{height:64px}.editor-brand{display:flex;justify-content:space-between}.editor{margin:0}}.brands{flex-grow:100}.brands-select{z-index:10400}.editors-select{z-index:10500}@media (min-width:1140px){.brands{display:flex;justify-content:flex-end}.brands-select,.editors-select{width:330px}}.logout{position:relative;right:-4px;top:0;z-index:2;width:48px;height:48px;background:url(assets/icons/logout.svg) center center no-repeat;border-radius:24px;display:none}@media (min-width:1140px){.logout{right:-14px;display:inline-block}}.logout:hover{background-color:rgba(101,116,120,.2)}.menu{display:flex;margin-left:9px;margin-right:-7px;width:32px;height:32px}.menu-desktop{display:none}@media (min-width:1140px){.menu{display:none}.menu-desktop{display:flex}}"]
                }] }
    ];
    /** @nocollapse */
    HeaderComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    HeaderComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        setCurrentUser: [{ type: Input, args: ['currentUser',] }],
        currentPage: [{ type: Input }],
        selectEnabled: [{ type: Input }],
        brand: [{ type: Input }],
        brandChanged: [{ type: Output }],
        brandEditorChanged: [{ type: Output }],
        editorChanged: [{ type: Output }],
        logoutClicked: [{ type: Output }],
        changePage: [{ type: Output }]
    };
    return HeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var HeaderMetadata = {
    declarations: [HeaderComponent],
    imports: [CommonModule, HttpClientModule, SelectModule, BubbleModule, MenuButtonModule, MenuDesktopModule],
    exports: [HeaderComponent],
};
var HeaderModule = /** @class */ (function () {
    function HeaderModule() {
    }
    HeaderModule.decorators = [
        { type: NgModule, args: [HeaderMetadata,] }
    ];
    return HeaderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HelloComponent = /** @class */ (function () {
    function HelloComponent(http) {
        this.http = http;
        this.isLoading = true;
    }
    /**
     * @return {?}
     */
    HelloComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: {
                                    componentId: this.componentId,
                                },
                            })
                                .toPromise()];
                    case 1:
                        _a.helloWSResponse = _b.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    HelloComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-hello',
                    template: "<div class=\"lib-hello-wrapper\">\n    <ng-container *ngIf=\"isLoading;else isLoaded\">\n        <lib-loader [loaderText]=\"loadingMessage\"></lib-loader>\n    </ng-container>\n    <ng-template #isLoaded>\n        <div class=\"lib-hello-content-wrapper\">\n            <div class=\"lib-hello-hello-text\">Bonjour,</div>\n            <div class=\"lib-hello-message\">{{ helloWSResponse.welcomeMessage }}</div>\n        </div>\n    </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.lib-hello-wrapper .lib-hello-content-wrapper{-webkit-animation:2s fadein;animation:2s fadein}.lib-hello-wrapper .lib-hello-content-wrapper .lib-hello-hello-text{font-size:3.2rem;margin-bottom:8px;font-family:\"Roboto Slab\",serif;font-weight:300}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.lib-hello-wrapper .lib-hello-content-wrapper .lib-hello-hello-text{font-size:4rem;margin-bottom:16px}}.lib-hello-wrapper .lib-hello-content-wrapper .lib-hello-message{color:#657478;font-size:1.4rem}@media (min-width:1140px){.lib-hello-wrapper .lib-hello-content-wrapper .lib-hello-message{font-size:1.6rem}}"]
                }] }
    ];
    /** @nocollapse */
    HelloComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    HelloComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        componentId: [{ type: Input }]
    };
    return HelloComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var HelloMetadata = {
    declarations: [HelloComponent],
    imports: [CommonModule, FormsModule, HttpClientModule, LoaderModule],
    exports: [HelloComponent],
};
var HelloModule = /** @class */ (function () {
    function HelloModule() {
    }
    HelloModule.decorators = [
        { type: NgModule, args: [HelloMetadata,] }
    ];
    return HelloModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IncidentsIndicatorComponent = /** @class */ (function () {
    function IncidentsIndicatorComponent(http) {
        this.http = http;
        this._wsRequestParams = {
            minRate: '30',
            maxRate: '95',
            componentId: '',
        };
        this.isfirstCall = true;
        this.isLoading = true;
        this.isIndicatorSelected = false;
        this.clicked = new EventEmitter();
    }
    Object.defineProperty(IncidentsIndicatorComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IncidentsIndicatorComponent.prototype, "parutionListFilter", {
        set: /**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            var _this = this;
            // Active/deactive indicator
            if (this.filter && this.filter.filterContent) {
                this.filter.filterContent.forEach(function (item) {
                    _this.isIndicatorSelected = _this.isIndicatorSelected && _this.isEqualObject(item, filter);
                });
                this.filter.isActive = this.isIndicatorSelected;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IncidentsIndicatorComponent.prototype, "currentIndicatorFilter", {
        set: /**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            var _this = this;
            // Active/deactive indicator
            if (this.filter && filter) {
                this.filter.filterContent.forEach(function (item, i) {
                    _this.isIndicatorSelected = _this.isIndicatorSelected && _this.isEqualObject(item, filter.filterContent[i]);
                });
                this.filter.isActive = this.isIndicatorSelected;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    IncidentsIndicatorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._wsRequestParams.componentId = this.componentId;
                        return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    IncidentsIndicatorComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!(this.apiUrl && params.componentId)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.incidentsIndicator = _b.sent();
                        this.filter = {
                            isActive: this.isIndicatorSelected,
                            filterContent: [],
                        };
                        this.incidentsIndicator.filters.forEach(function (filterFromApi, index) {
                            _this.filter.filterContent[index] = filterFromApi;
                            _this.filter.filterContent[index].label = _this.incidentsIndicator.label;
                        });
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    IncidentsIndicatorComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.isIndicatorSelected = !this.isIndicatorSelected;
        this.filter.isActive = this.isIndicatorSelected;
        if (this.filter) {
            this.clicked.emit(Object.assign({}, this.filter));
        }
    };
    // TODO: Move it to utils class
    // TODO: Move it to utils class
    /**
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    IncidentsIndicatorComponent.prototype.isEqualObject = 
    // TODO: Move it to utils class
    /**
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    function (x, y) {
        var _this = this;
        /** @type {?} */
        var ok = Object.keys;
        /** @type {?} */
        var tx = typeof x;
        /** @type {?} */
        var ty = typeof y;
        return x && y && tx === 'object' && tx === ty
            ? ok(x).length === ok(y).length && ok(x).every(function (key) { return _this.isEqualObject(x[key], y[key]); })
            : x === y && ((x != null && y != null) || x.constructor === y.constructor);
    };
    IncidentsIndicatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-incidents-indicator',
                    template: "<div\r\n  class=\"incidents-indicator-wrapper\"\r\n  (click)=\"handleClicked($event)\"\r\n  [ngClass]=\"{ 'is-selected': isIndicatorSelected }\"\r\n>\r\n  <ng-container *ngIf=\"isLoading; else isLoaded\">\r\n    <lib-loader [loaderText]=\"loadingMessage\"></lib-loader>\r\n  </ng-container>\r\n  <ng-template #isLoaded>\r\n    <div class=\"incidents-indicator-container\">\r\n      <div class=\"incidents-indicator-number\">{{ incidentsIndicator.quantity }}</div>\r\n      <div class=\"incidents-indicator-message\">\r\n        {{ incidentsIndicator.label }}\r\n        <lib-tooltip\r\n          contentType=\"text\"\r\n          *ngIf=\"incidentsIndicator.tooltip\"\r\n          [content]=\"incidentsIndicator.tooltip\"\r\n          icon=\"info\"\r\n        ></lib-tooltip>\r\n      </div>\r\n      <div *ngIf=\"isIndicatorSelected\" class=\"incidents-indicator-desactivate\">x</div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.incidents-indicator-wrapper{cursor:pointer;background:#ffede6;padding:16px 32px;border-radius:4px}.incidents-indicator-wrapper .incidents-indicator-container{font-family:\"Roboto Slab\",serif;-webkit-animation:2s fadein;animation:2s fadein;color:#0f1112;display:flex;align-items:center;position:relative}.incidents-indicator-wrapper .incidents-indicator-container .incidents-indicator-number{font-size:5.6rem;margin-right:15px;font-weight:100;width:53px;display:flex;justify-content:center;color:#ff642e}.incidents-indicator-wrapper .incidents-indicator-container .incidents-indicator-message{max-width:170px;font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500;line-height:1.43;display:flex;align-items:center}.incidents-indicator-wrapper .incidents-indicator-container .incidents-indicator-message lib-tooltip{flex-shrink:0}.incidents-indicator-wrapper .incidents-indicator-container .incidents-indicator-desactivate{font-size:1.5em;font-family:Poppins,sans-serif;color:#fff;position:absolute;top:-15px;right:-20px}.incidents-indicator-wrapper.is-selected,.incidents-indicator-wrapper:hover{background:#ff642e}.incidents-indicator-wrapper.is-selected .incidents-indicator-container,.incidents-indicator-wrapper.is-selected .incidents-indicator-container .incidents-indicator-message,.incidents-indicator-wrapper.is-selected .incidents-indicator-container .incidents-indicator-number,.incidents-indicator-wrapper:hover .incidents-indicator-container,.incidents-indicator-wrapper:hover .incidents-indicator-container .incidents-indicator-message,.incidents-indicator-wrapper:hover .incidents-indicator-container .incidents-indicator-number{color:#fff}"]
                }] }
    ];
    /** @nocollapse */
    IncidentsIndicatorComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    IncidentsIndicatorComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        componentId: [{ type: Input }],
        type: [{ type: Input }],
        groupId: [{ type: Input, args: ['brandEditor',] }],
        parutionListFilter: [{ type: Input }],
        currentIndicatorFilter: [{ type: Input }],
        clicked: [{ type: Output }]
    };
    return IncidentsIndicatorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var IncidentsIndicatorMetadata = {
    declarations: [IncidentsIndicatorComponent],
    imports: [CommonModule, HttpClientModule, TooltipModule, LoaderModule],
    exports: [IncidentsIndicatorComponent],
};
var IncidentsIndicatorModule = /** @class */ (function () {
    function IncidentsIndicatorModule() {
    }
    IncidentsIndicatorModule.decorators = [
        { type: NgModule, args: [IncidentsIndicatorMetadata,] }
    ];
    return IncidentsIndicatorModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IncidentsOverviewComponent = /** @class */ (function () {
    function IncidentsOverviewComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.isLoading = true;
        this.tooltipIcon = 'info';
        this.tooltipContent = 'Lorem ipsum...';
    }
    Object.defineProperty(IncidentsOverviewComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    IncidentsOverviewComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    IncidentsOverviewComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.alerts = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IncidentsOverviewComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-incidents-overview',
                    template: "<ng-container *ngIf=\"isLoading; else isLoaded\">\n  <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div class=\"lib-incidents-overview-wrapper\">\n    <lib-map\n      class=\"lib-incidents-overview-map\"\n      mode=\"minimap\"\n      [mapUrl]=\"mapUrl\"\n      [isInteractive]=\"false\"\n      [warehousesInAlert]=\"alerts?.impactedWarehouses\"\n    ></lib-map>\n\n    <ng-container *ngIf=\"!isLoading\">\n      <lib-incidents-list\n        [globalMessage]=\"alerts?.globalMessage\"\n        [impactedWarehouses]=\"alerts?.impactedWarehouses\"\n        class=\"lib-incident-overview-alert\"\n        *ngIf=\"alerts\"\n      ></lib-incidents-list>\n    </ng-container>\n  </div>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block;background-color:#fff}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}:host{padding:36px 78px}}.lib-incidents-overview-wrapper{flex-direction:column;-webkit-animation:2s fadein;animation:2s fadein;display:flex;padding-top:32px}.lib-incidents-overview-wrapper .lib-incidents-overview-map{display:block;margin:0 auto;width:208px}@media (min-width:1140px){.lib-incidents-overview-wrapper{flex-direction:row;justify-content:normal;padding-top:0}.lib-incidents-overview-wrapper .lib-incidents-overview-map{margin:0 100px 0 0}}.lib-incidents-overview-wrapper .lib-incident-overview-alert{flex-grow:1}"]
                }] }
    ];
    /** @nocollapse */
    IncidentsOverviewComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    IncidentsOverviewComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        mapUrl: [{ type: Input }],
        groupId: [{ type: Input, args: ['brandEditor',] }]
    };
    return IncidentsOverviewComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var IncidentsOverviewMetadata = {
    declarations: [IncidentsOverviewComponent],
    imports: [CommonModule, PipesModule.forRoot(), MapModule, IncidentsListModule, LoaderModule],
    exports: [IncidentsOverviewComponent],
};
var IncidentsOverviewModule = /** @class */ (function () {
    function IncidentsOverviewModule() {
    }
    IncidentsOverviewModule.decorators = [
        { type: NgModule, args: [IncidentsOverviewMetadata,] }
    ];
    return IncidentsOverviewModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LifecycleArrowComponent = /** @class */ (function () {
    function LifecycleArrowComponent() {
        this.arrowData = {
            label: 'parution(s) régalable(s)',
            quantity: 36,
            value: 'status',
            operator: '=',
            filterTerm: 'Réglable',
        };
        this.position = 'middle';
        this.color = 'blue';
        this.withoutArrow = false;
        this.arrowClicked = new EventEmitter();
        this.isActive = false;
    }
    /**
     * Apply filter based on arrow content on arrow click
     * @param arrowData Arrow Object
     */
    /**
     * Apply filter based on arrow content on arrow click
     * @param {?} arrowData Arrow Object
     * @return {?}
     */
    LifecycleArrowComponent.prototype.onArrow = /**
     * Apply filter based on arrow content on arrow click
     * @param {?} arrowData Arrow Object
     * @return {?}
     */
    function (arrowData) {
        /** @type {?} */
        var filter = {
            filterTerm: arrowData.filterTerm,
            label: arrowData.label,
            value: arrowData.value,
            operator: arrowData.operator,
        };
        this.isActive = !this.isActive;
        this.arrowClicked.emit(filter);
    };
    LifecycleArrowComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-lifecycle-arrow',
                    template: "<div\n  class=\"arrow-item\"\n  [ngClass]=\"[position, color]\"\n  [class.without]=\"withoutArrow\"\n  [class.is-active]=\"isActive\"\n  (click)=\"onArrow(arrowData)\"\n  *ngIf=\"arrowData\"\n>\n  <div class=\"arrow-queue\"></div>\n  <div class=\"arrow-content\">\n    <span class=\"indicator-number\">{{ arrowData.quantity }}</span>\n    <span class=\"indicator-label\">{{ arrowData.label }}</span>\n  </div>\n  <div *ngIf=\"isActive\" class=\"arrow-desactivate\">x</div>\n  <div class=\"arrow-head\"></div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}:host{display:inline-flex;flex:1 0 0}}.arrow-item{cursor:pointer;position:relative;flex-wrap:nowrap;display:inline-flex;height:120px}.arrow-item:hover .arrow-queue::before{border-color:#7a8c91 #7a8c91 #7a8c91 transparent}.arrow-item:hover .arrow-content{background-color:#7a8c91}.arrow-item:hover .arrow-head::before{border-color:transparent transparent transparent #7a8c91}@media (max-width:1139px){.arrow-item{width:100%}}.arrow-queue{display:none}@media (min-width:1140px){.arrow-queue{display:flex;align-items:center;height:100%;background:0 0}.arrow-queue::before{content:'';display:block;width:0;height:0;margin-left:-4px;border-style:solid;border-width:60px 0 60px 60px;border-color:#ebedf3 #ebedf3 #ebedf3 transparent}}.arrow-content{display:flex;align-items:center;padding:24px;width:100%;border-radius:4px;background:#ebedf3;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500}.arrow-content .indicator-number{color:#2d54d2;font-family:\"Roboto Slab\",serif;font-size:5.6rem;font-weight:100;margin-right:20px}.arrow-head{display:none}@media (min-width:1140px){.arrow-content{width:initial;border-top-right-radius:1.8em .7em;border-bottom-right-radius:1.8em .7em}.arrow-head{display:flex;align-items:center;height:100%;background:0 0}.arrow-head::before{content:'';display:block;width:0;height:0;border-style:solid;border-width:52px 0 52px 45px;border-color:transparent transparent transparent #ebedf3}.first .arrow-queue{display:none}.first.without{margin-right:25px}.middle .arrow-content{border-radius:0 1.8em 1.8em 0/0 .7em .7em 0}.middle.without{margin:0 25px}.last .arrow-content{border-radius:0 4px 4px 0}.last .arrow-head{display:none}.last.without{margin-left:25px}.without .arrow-queue{display:none}.without .arrow-content{border-radius:0 4px 4px 0}.without .arrow-head{display:none}.last,.middle{margin-left:-25px}.arrow-desactivate{font-size:1.5em;font-family:Poppins,sans-serif;color:#fff;position:absolute;top:0;right:55px}}.blue .arrow-queue::before{border-color:rgba(1,157,212,.1) rgba(1,157,212,.1) rgba(1,157,212,.1) transparent}.blue .arrow-content{background-color:rgba(1,157,212,.1);color:#0f1112}.blue .arrow-head::before{border-color:transparent transparent transparent rgba(1,157,212,.1)}.blue .arrow-content .indicator-number{color:#019dd4}.blue.is-active .arrow-queue::before,.blue:hover .arrow-queue::before{border-color:#019dd4 #019dd4 #019dd4 transparent}.blue.is-active .arrow-content,.blue:hover .arrow-content{background-color:#019dd4}.blue.is-active .arrow-head::before,.blue:hover .arrow-head::before{border-color:transparent transparent transparent #019dd4}.blue.is-active .arrow-content,.blue.is-active .arrow-content .indicator-number,.blue:hover .arrow-content,.blue:hover .arrow-content .indicator-number{color:#fff}.orange .arrow-queue::before{border-color:#ffede6 #ffede6 #ffede6 transparent}.orange .arrow-content{background-color:#ffede6;color:#0f1112;border-radius:5px}.orange .arrow-head::before{border-color:transparent transparent transparent #ffede6}.orange .arrow-content .indicator-number{color:#ff642e}.orange.is-active .arrow-queue::before,.orange:hover .arrow-queue::before{border-color:#ff642e #ff642e #ff642e transparent}.orange.is-active .arrow-content,.orange:hover .arrow-content{background-color:#ff642e}.orange.is-active .arrow-head::before,.orange:hover .arrow-head::before{border-color:transparent transparent transparent #ff642e}.orange.is-active .arrow-content,.orange.is-active .arrow-content .indicator-number,.orange:hover .arrow-content,.orange:hover .arrow-content .indicator-number{color:#fff}.green .arrow-queue::before{border-color:#dfebe4 #dfebe4 #dfebe4 transparent}.green .arrow-content{background-color:#dfebe4;color:#0f1112}.green .arrow-head::before{border-color:transparent transparent transparent #dfebe4}.green .arrow-content .indicator-number{color:#0da54c}.green.is-active .arrow-queue::before,.green:hover .arrow-queue::before{border-color:#0da54c #0da54c #0da54c transparent}.green.is-active .arrow-content,.green:hover .arrow-content{background-color:#0da54c}.green.is-active .arrow-head::before,.green:hover .arrow-head::before{border-color:transparent transparent transparent #0da54c}.green.is-active .arrow-content,.green.is-active .arrow-content .indicator-number,.green:hover .arrow-content,.green:hover .arrow-content .indicator-number{color:#fff}.gray .arrow-queue::before{border-color:#ebedf3 #ebedf3 #ebedf3 transparent}.gray .arrow-content{background-color:#ebedf3;color:#0f1112}.gray .arrow-head::before{border-color:transparent transparent transparent #ebedf3}.gray .arrow-content .indicator-number{color:#2d54d2}.gray.is-active .arrow-queue::before,.gray:hover .arrow-queue::before{border-color:#2d54d2 #2d54d2 #2d54d2 transparent}.gray.is-active .arrow-content,.gray:hover .arrow-content{background-color:#2d54d2}.gray.is-active .arrow-head::before,.gray:hover .arrow-head::before{border-color:transparent transparent transparent #2d54d2}.gray.is-active .arrow-content,.gray.is-active .arrow-content .indicator-number,.gray:hover .arrow-content,.gray:hover .arrow-content .indicator-number{color:#fff}@media (min-width:1140px){.last .arrow-desactivate{right:10px}}"]
                }] }
    ];
    LifecycleArrowComponent.propDecorators = {
        arrowData: [{ type: Input }],
        position: [{ type: Input }],
        color: [{ type: Input }],
        withoutArrow: [{ type: Input }],
        arrowClicked: [{ type: Output }]
    };
    return LifecycleArrowComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LifecycleUpcomingComponent = /** @class */ (function () {
    function LifecycleUpcomingComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.isLoading = true;
        this.arrowColors = ['gray', 'blue', 'green', 'orange'];
        this.indicatorClick = new EventEmitter();
    }
    Object.defineProperty(LifecycleUpcomingComponent.prototype, "upComingFilter", {
        get: /**
         * @return {?}
         */
        function () {
            return this.currentFilter;
        },
        set: /**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            var _this = this;
            this.currentFilter = filter;
            if (this.lifecycleArrowComponentsRef) {
                this.lifecycleArrowComponentsRef.forEach(function (item) {
                    /** @type {?} */
                    var itemFilter = {
                        filterTerm: item.arrowData.filterTerm,
                        label: item.arrowData.label,
                        value: item.arrowData.value,
                        operator: item.arrowData.operator,
                    };
                    item.isActive = _this.isEqualObject(itemFilter, filter);
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LifecycleUpcomingComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LifecycleUpcomingComponent.prototype, "brandId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._brandId;
        },
        set: /**
         * @param {?} brand
         * @return {?}
         */
        function (brand) {
            this._brandId = brand;
            this._wsRequestParams.brand = brand ? brand : '';
            if (!brand && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            this.getDataFromWS(this._wsRequestParams);
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    LifecycleUpcomingComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    LifecycleUpcomingComponent.prototype.getDataFromWS = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.arrows = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} indicatorFilter
     * @param {?} index
     * @return {?}
     */
    LifecycleUpcomingComponent.prototype.handleIndicatorClick = /**
     * @param {?} indicatorFilter
     * @param {?} index
     * @return {?}
     */
    function (indicatorFilter, index) {
        this.currentFilter = this.currentFilter && this.isEqualObject(this.currentFilter, indicatorFilter) ? null : indicatorFilter;
        this.indicatorClick.emit(this.currentFilter);
        this.lifecycleArrowComponentsRef.forEach(function (item, i) {
            item.isActive = i !== index ? false : item.isActive;
        });
    };
    // TODO: Move it to utils class
    // TODO: Move it to utils class
    /**
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    LifecycleUpcomingComponent.prototype.isEqualObject = 
    // TODO: Move it to utils class
    /**
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    function (x, y) {
        var _this = this;
        /** @type {?} */
        var ok = Object.keys;
        /** @type {?} */
        var tx = typeof x;
        /** @type {?} */
        var ty = typeof y;
        return x && y && tx === 'object' && tx === ty ? (ok(x).length === ok(y).length &&
            ok(x).every(function (key) { return _this.isEqualObject(x[key], y[key]); })) : (x === y && (x != null && y != null || x.constructor === y.constructor));
    };
    LifecycleUpcomingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-lifecycle-upcoming',
                    template: "<ng-container>\n  <lib-loader [loaderText]=\"loadingMessage\" *ngIf=\"isLoading; else isLoaded\"></lib-loader>\n</ng-container>\n<ng-template #isLoaded>\n  <div class=\"container\">\n    <ng-container *ngFor=\"let arrow of arrows; let i = index\">\n      <lib-lifecycle-arrow\n        class=\"arrow\"\n        [arrowData]=\"arrow\"\n        [position]=\"i === 0 ? 'first' : i === arrows.length - 1 || i === arrows.length - 2 ? 'last' : 'middle'\"\n        [withoutArrow]=\"i === arrows.length - 1\"\n        [color]=\"arrowColors[i]\"\n        (arrowClicked)=\"handleIndicatorClick($event, i)\"\n      >\n      </lib-lifecycle-arrow>\n      <div\n        class=\"arrow-chevron-mobile\"\n        [ngClass]=\"{ 'last-item': i === arrows.length - 2 }\"\n        *ngIf=\"i !== arrows.length - 1\"\n      >\n        >\n      </div>\n    </ng-container>\n  </div>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{margin:auto;-webkit-animation:2s fadein;animation:2s fadein}.arrow-chevron-mobile{font-size:3.2rem;-webkit-transform:rotate(-270deg);transform:rotate(-270deg);width:30px;margin:auto;top:7px;position:relative}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container{max-width:none;display:inline-flex}.container .last-container{margin-left:24px}.arrow-chevron-mobile{display:none}}.last-item{color:transparent}"]
                }] }
    ];
    /** @nocollapse */
    LifecycleUpcomingComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    LifecycleUpcomingComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        upComingFilter: [{ type: Input }],
        groupId: [{ type: Input, args: ['brandEditor',] }],
        brandId: [{ type: Input, args: ['brand',] }],
        indicatorClick: [{ type: Output }],
        lifecycleArrowComponentsRef: [{ type: ViewChildren, args: [LifecycleArrowComponent,] }]
    };
    return LifecycleUpcomingComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var LifecycleArrowMetadata = {
    declarations: [LifecycleArrowComponent],
    imports: [CommonModule, HttpClientModule],
    exports: [LifecycleArrowComponent],
};
var LifecycleArrowModule = /** @class */ (function () {
    function LifecycleArrowModule() {
    }
    LifecycleArrowModule.decorators = [
        { type: NgModule, args: [LifecycleArrowMetadata,] }
    ];
    return LifecycleArrowModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LifecycleIndicatorComponent = /** @class */ (function () {
    function LifecycleIndicatorComponent() {
        this.indicator = {
            label: 'parution(s) en anomalie de livraison France Messagerie',
            quantity: 1,
            value: 'nbWarhousesInAlert',
            operator: '>',
            filterTerm: 'Anomalie de livraison France Messagerie',
        };
        this.indicatorId = 3;
        this.indicatorClicked = new EventEmitter();
    }
    /**
     * Apply filter based on indicator content on indicator click
     * @param indicator Indicator Object
     */
    /**
     * Apply filter based on indicator content on indicator click
     * @param {?} indicator Indicator Object
     * @return {?}
     */
    LifecycleIndicatorComponent.prototype.onIndicator = /**
     * Apply filter based on indicator content on indicator click
     * @param {?} indicator Indicator Object
     * @return {?}
     */
    function (indicator) {
        /** @type {?} */
        var filter = {
            label: indicator.label,
            operator: indicator.operator,
            filterTerm: indicator.value,
            value: indicator.filterTerm,
        };
        this.indicatorClicked.emit(filter);
    };
    LifecycleIndicatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-lifecycle-indicator',
                    template: "<div class=\"container\">\r\n  <div class=\"container-content\" (click)=\"onIndicator(indicator)\">\r\n    <div class=\"container-content-number\">{{ indicator.quantity }}</div>\r\n    {{ indicator.label }}\r\n  </div>\r\n</div>\r\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{height:120px;min-width:275px;display:block;flex-wrap:nowrap}.container .container-content{background:#ffede6;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500;display:flex;padding:24px;border-radius:5px;align-items:center;z-index:1;cursor:pointer}.container .container-content .container-content-number{color:#ff642e;font-family:\"Roboto Slab\",serif;font-size:5.6rem;font-weight:100;margin-right:20px}"]
                }] }
    ];
    LifecycleIndicatorComponent.propDecorators = {
        indicator: [{ type: Input }],
        indicatorId: [{ type: Input }],
        indicatorClicked: [{ type: Output }]
    };
    return LifecycleIndicatorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var LifecycleIndicatorMetadata = {
    declarations: [LifecycleIndicatorComponent],
    imports: [CommonModule],
    exports: [LifecycleIndicatorComponent],
};
var LifecycleIndicatorModule = /** @class */ (function () {
    function LifecycleIndicatorModule() {
    }
    LifecycleIndicatorModule.decorators = [
        { type: NgModule, args: [LifecycleIndicatorMetadata,] }
    ];
    return LifecycleIndicatorModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var LifecycleUpcomingMetadata = {
    declarations: [LifecycleUpcomingComponent],
    imports: [CommonModule, LifecycleArrowModule, LifecycleIndicatorModule, LoaderModule],
    exports: [LifecycleUpcomingComponent],
};
var LifecycleUpcomingModule = /** @class */ (function () {
    function LifecycleUpcomingModule() {
    }
    LifecycleUpcomingModule.decorators = [
        { type: NgModule, args: [LifecycleUpcomingMetadata,] }
    ];
    return LifecycleUpcomingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PageTitleComponent = /** @class */ (function () {
    function PageTitleComponent(http) {
        this.http = http;
        this.isLoading = true;
    }
    /**
     * @return {?}
     */
    PageTitleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: {
                                    componentId: this.componentId,
                                    page: this.page,
                                },
                            })
                                .toPromise()];
                    case 1:
                        _a.pagetitleWS = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PageTitleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-page-title',
                    template: "\n    <ng-container *ngIf=\"!isLoading; else loading\">\n      <lib-title [content]=\"pagetitleWS.pageTitle\"></lib-title>\n    </ng-container>\n\n    <ng-template #loading>\n      {{ loadingMessage }}\n    </ng-template>\n  ",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}"]
                }] }
    ];
    /** @nocollapse */
    PageTitleComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    PageTitleComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        page: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }]
    };
    return PageTitleComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PageTitleMetadata = {
    declarations: [PageTitleComponent],
    imports: [CommonModule, HttpClientModule, TitleModule],
    exports: [PageTitleComponent],
};
var PageTitleModule = /** @class */ (function () {
    function PageTitleModule() {
    }
    PageTitleModule.decorators = [
        { type: NgModule, args: [PageTitleMetadata,] }
    ];
    return PageTitleModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParutionsListComponent = /** @class */ (function () {
    function ParutionsListComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.publicationsPages = [];
        this.isLoading = true;
        this.currentPage = 1;
        this.nbItemPerPage = 60;
        this.alertMessageContent = [];
        this.savedFilter = null;
        this.savedOrder = null;
        this.filterChange = new EventEmitter();
    }
    Object.defineProperty(ParutionsListComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParutionsListComponent.prototype, "incidentsIndicatorFilter", {
        set: /**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            var _this = this;
            if (filter && filter.isActive) {
                if (filter.filterContent && this.initialPublications) {
                    filter.filterContent.forEach(function (filterFromIndicator) { return _this.onFilter(filterFromIndicator); });
                }
            }
            else {
                if (this.initialPublications) {
                    this.onFilter('');
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ParutionsListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    ParutionsListComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, res;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.parutionsList = _b.sent();
                        this.initialPublications = this.parutionsList.publications;
                        res = StaticFilters.setPublicationsPages(this.initialPublications, this.nbItemPerPage);
                        this.publicationsPages = res.listPages;
                        this.currentPage = res.currentPage;
                        this.isLoading = false;
                        if (this.parutionsList && this.parutionsList.publications) {
                            this.parutionsList.publications.filter(function (publication) {
                                if (publication.warehouseInAlertHref) {
                                    _this.getTooltipAlertContent(publication);
                                }
                            });
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates the content of the tooltip listing all the warehouses alerts
     * @param publication Publication Object
     */
    /**
     * Creates the content of the tooltip listing all the warehouses alerts
     * @param {?} publication Publication Object
     * @return {?}
     */
    ParutionsListComponent.prototype.getTooltipAlertContent = /**
     * Creates the content of the tooltip listing all the warehouses alerts
     * @param {?} publication Publication Object
     * @return {?}
     */
    function (publication) {
        return __awaiter(this, void 0, void 0, function () {
            var alertMessagesList_1, alertMessagesFromWS;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.apiUrl && publication && publication.nbWarehousesInAlert)) return [3 /*break*/, 2];
                        alertMessagesList_1 = [];
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl + '/..' + publication.warehouseInAlertHref, {
                                withCredentials: true,
                            })
                                .toPromise()];
                    case 1:
                        alertMessagesFromWS = _a.sent();
                        alertMessagesFromWS.forEach(function (message) {
                            alertMessagesList_1.push({
                                label: message.warehouseName,
                                value: message.warehouseCurrentStatus,
                            });
                        });
                        this.alertMessageContent[publication.publicationId] = alertMessagesList_1;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Navigate btw pages set by pagination
     * @param page Page number clicked (or set in queryparams)
     */
    /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    ParutionsListComponent.prototype.paginationPageChange = /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    function (page) {
        this.currentPage = page;
        /** @type {?} */
        var scrollSize = this.anchorForScroll.nativeElement.offsetTop - 110;
        window.scroll({ top: scrollSize, left: 0 });
    };
    /**
     * Return the number of day between the current date and the sellingStartDate of a publication
     */
    /**
     * Return the number of day between the current date and the sellingStartDate of a publication
     * @param {?} publication
     * @return {?}
     */
    ParutionsListComponent.prototype.setPublicationToSale = /**
     * Return the number of day between the current date and the sellingStartDate of a publication
     * @param {?} publication
     * @return {?}
     */
    function (publication) {
        return Math.floor((new Date().getTime() - new Date(publication.sellingStartDate).getTime()) / (3600000 * 24));
    };
    /**
     * Return the color of the ruptureRate label according to the value
     */
    /**
     * Return the color of the ruptureRate label according to the value
     * @param {?} publication
     * @return {?}
     */
    ParutionsListComponent.prototype.getColorRupture = /**
     * Return the color of the ruptureRate label according to the value
     * @param {?} publication
     * @return {?}
     */
    function (publication) {
        return publication.ruptureRate < 0.3 ? 'white' : 'orange';
    };
    /**
     * Return an icon or not according to the value of ruptureRate
     */
    /**
     * Return an icon or not according to the value of ruptureRate
     * @param {?} publication
     * @return {?}
     */
    ParutionsListComponent.prototype.getIconRupture = /**
     * Return an icon or not according to the value of ruptureRate
     * @param {?} publication
     * @return {?}
     */
    function (publication) {
        return publication.ruptureRate < 0.3 ? '' : 'alertes';
    };
    /**
     * @param {?} filter
     * @return {?}
     */
    ParutionsListComponent.prototype.onFilter = /**
     * @param {?} filter
     * @return {?}
     */
    function (filter) {
        /** @type {?} */
        var res = StaticFilters.filterByItems(filter, this.initialPublications, this.parutionsList.publications, this.savedOrder, this.nbItemPerPage);
        this.parutionsList.publications = res.list;
        this.publicationsPages = res.listPages;
        this.currentPage = res.currentPage;
        this.savedFilter = res.savedFilter;
    };
    /**
     * Sort publications when an order is selected
     * @param order Filter from the select
     */
    /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    ParutionsListComponent.prototype.onOrderByItems = /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    function (order) {
        /** @type {?} */
        var res = StaticFilters.orderByItems(order, this.initialPublications, this.parutionsList.publications, this.savedFilter, this.nbItemPerPage);
        this.parutionsList.publications = res.list;
        this.publicationsPages = res.listPages;
        this.savedOrder = res.savedOrder;
        this.currentPage = res.currentPage;
    };
    ParutionsListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parutions-list',
                    template: "<ng-container *ngIf=\"isLoading; else isLoaded\">\n  <lib-loader [loaderText]=\"loadingMessage\" displayMode=\"both\" loaderSize=\"big\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div #scrollAnchor class=\"parutions-list\">\n    <div class=\"parutions-list-header\">\n      <div class=\"parutions-list-header-top\">\n        <div class=\"parutions-list-header-top-title\">\n          <span class=\"parutions-list-header-top-nbpublications\">{{ parutionsList.publicationNumber }}</span>\n          parutions en vente <span class=\"display-on-desktop\">en ce moment</span>\n        </div>\n        <div class=\"parutions-list-header-top-update\">\n          Donn\u00E9es de taux de vente et de rupture bas\u00E9es sur un panel significatif de {{ parutionsList.nbSellers | number: '':'fr-FR' }} diffuseurs\n        </div>\n      </div>\n      <div class=\"parutions-list-header-filters\">\n        <div class=\"parutions-list-header-filters-global\">\n          <lib-select\n            clearable=\"true\"\n            [options]=\"parutionsList?.filters?.filterByItems\"\n            [model]=\"savedFilter\"\n            placeholder=\"Filter par\"\n            ngClassName=\"filter-select\"\n            (change)=\"onFilter($event)\"\n          ></lib-select>\n        </div>\n        <div class=\"parutions-list-header-filters-date\">\n          <lib-select\n            clearable=\"true\"\n            [options]=\"parutionsList?.filters?.orderByItems\"\n            placeholder=\"Trier par\"\n            ngClassName=\"filter-select\"\n            (change)=\"onOrderByItems($event)\"\n          ></lib-select>\n        </div>\n      </div>\n    </div>\n    <div class=\"parutions-list-display\">\n      <ng-container *ngFor=\"let publication of publicationsPages[currentPage - 1]\">\n        <!-- On a des anomalies OU on est au jour ISIS J => MEV -->\n        <lib-parution\n          *ngIf=\"\n            setPublicationToSale(publication) === 0 ||\n            (setPublicationToSale(publication) > 0 && publication.nbWarehousesInAlert > 0)\n          \"\n          class=\"parutions-list-display-item\"\n          [publication]=\"publication\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [leftStatus]=\"{\n            value: publication.upForSaleRate,\n            code: 'upForSaleRate',\n            label: 'MEV',\n            isPercent: true,\n            withCircle: true,\n            circleColor: 'blue',\n            alertColor: 'white'\n          }\"\n          [rightStatus]=\"{\n            value: publication.nbWarehousesInAlert,\n            label: 'D\u00E9p\u00F4ts en anomalie',\n            alertColor: 'orange',\n            icon: 'info',\n            tooltipContent: alertMessageContent[publication.publicationId],\n            tooltipContentType: 'list',\n            tooltipPosition: 'top'\n          }\"\n        >\n        </lib-parution>\n        <!-- Pas d'anomalies ET on est au jour ISIS J + x => Tx de vente -->\n        <lib-parution\n          *ngIf=\"setPublicationToSale(publication) > 0 && !publication.nbWarehousesInAlert\"\n          class=\"parutions-list-display-item\"\n          [publication]=\"publication\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [leftStatus]=\"{\n            value: publication.soldRate,\n            code: 'soldRate',\n            label: 'Tx vente',\n            isPercent: true,\n            withCircle: true,\n            circleColor: 'yellow',\n            alertColor: 'white'\n          }\"\n          [rightStatus]=\"{\n            value: publication.ruptureRate,\n            label: 'Tx rupture',\n            isPercent: true,\n            icon: getIconRupture(publication),\n            alertColor: getColorRupture(publication)\n          }\"\n          [apiUrlForCompare]=\"apiUrl\"\n        >\n        </lib-parution>\n      </ng-container>\n    </div>\n    <lib-pagination\n      [numberOfItems]=\"parutionsList.publications.length\"\n      [itemsPerPage]=\"nbItemPerPage\"\n      [currentPage]=\"currentPage\"\n      (pageChange)=\"paginationPageChange($event)\"\n      *ngIf=\"publicationsPages && publicationsPages.length > 1\"\n    ></lib-pagination>\n  </div>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.parutions-list{-webkit-animation:2s fadein;animation:2s fadein;max-width:1100px;color:#0f1112;font-family:Poppins,sans-serif;font-weight:500;font-size:1.4rem}.parutions-list .parutions-list-header-top{justify-content:space-between;align-items:baseline;margin-bottom:15px}.parutions-list .parutions-list-header-top-title{font-size:2rem;font-weight:600}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.parutions-list .parutions-list-header-filters,.parutions-list .parutions-list-header-top{display:flex}.parutions-list .parutions-list-header-top{margin-bottom:24px}.parutions-list .parutions-list-header-top-title{flex-shrink:0;margin-right:12px}}.parutions-list .parutions-list-header-top-title .parutions-list-header-top-nbpublications{font-family:\"Roboto Slab\",serif;font-weight:100;font-size:5.6rem;margin-right:8px}.parutions-list .display-on-desktop{display:none}.parutions-list .parutions-list-header-top-update{color:#657478}@media (min-width:1140px){.parutions-list .display-on-desktop{display:inline}.parutions-list .parutions-list-header-top-update{text-align:right}}.parutions-list .parutions-list-header-filters{margin-bottom:40px}.parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:50%;margin-right:7px}@media (min-width:1140px){.parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:400px;margin-right:24px}}.parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:50%}.parutions-list .parutions-list-display{display:flex;flex-wrap:wrap}@media (max-width:1139px){.parutions-list .parutions-list-header-filters{display:flex;margin-bottom:16px}.parutions-list .parutions-list-display{margin:0 -3px}.parutions-list .parutions-list-display .parutions-list-display-item{margin:0 7px 24px}}@media (min-width:1140px){.parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:400px}.parutions-list .parutions-list-display .parutions-list-display-item{margin:0 17px 64px}.parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n+1){margin:0 17px 64px 0}.parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n){margin:0 0 64px 17px}}"]
                }] }
    ];
    /** @nocollapse */
    ParutionsListComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    ParutionsListComponent.propDecorators = {
        anchorForScroll: [{ type: ViewChild, args: ['scrollAnchor',] }],
        goldUrl: [{ type: Input }],
        apiUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        groupId: [{ type: Input, args: ['brandEditor',] }],
        incidentsIndicatorFilter: [{ type: Input, args: ['incidentsIndicatorFilter',] }],
        filterChange: [{ type: Output }]
    };
    return ParutionsListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ParutionsListMetadata = {
    declarations: [ParutionsListComponent],
    imports: [CommonModule, HttpClientModule, SelectModule, ParutionModule, LoaderModule, PaginationModule],
    exports: [ParutionsListComponent],
};
var ParutionsListModule = /** @class */ (function () {
    function ParutionsListModule() {
    }
    ParutionsListModule.decorators = [
        { type: NgModule, args: [ParutionsListMetadata,] }
    ];
    return ParutionsListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ParutionsIncludedComponent = /** @class */ (function () {
    function ParutionsIncludedComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isFirstCall = true;
        this.parutionsNbr = 0;
        this.isLoading = false;
        this.modalOpened = false;
        this.compareListModal = false;
        this.filterChange = new EventEmitter();
        this.changeFilterDate = new EventEmitter();
        this.includeHsChange = new EventEmitter();
        this.changeCompareParution = new EventEmitter();
        this.includeHS = true;
        this.modifyRefParution = false;
    }
    Object.defineProperty(ParutionsIncludedComponent.prototype, "params", {
        get: /**
         * @return {?}
         */
        function () {
            return this._wsRequestParams;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParutionsIncludedComponent.prototype, "mulitpleFilters", {
        set: /**
         * @param {?} filters
         * @return {?}
         */
        function (filters) {
            if (filters) {
                this._wsRequestParams = StaticInputProccesor.processMultipleFilters(filters, this._wsRequestParams);
                if (!this.isFirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParutionsIncludedComponent.prototype, "compareParution", {
        get: /**
         * @return {?}
         */
        function () {
            return this._compareParution;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._compareParution = val;
            if (!this._compareParution.comparableParutions) {
                this.initialComparableParutions = null;
            }
            if (!this.initialComparableParutions) {
                this.initialComparableParutions = this._compareParution.comparableParutions;
            }
            if (this._compareParution.refParution) {
                if (this._wsRequestParams.periodId !== this.compareParution.refParution.periodId) {
                    this._wsRequestParams.periodId = this.compareParution.refParution.periodId;
                    this.getDataFromWS(this._wsRequestParams);
                    this.parutionsIncluded = [this.compareParution.refParution];
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParutionsIncludedComponent.prototype, "componentId", {
        set: /**
         * @param {?} componentId
         * @return {?}
         */
        function (componentId) {
            this._wsRequestParams.componentId = componentId;
            if (!this.isFirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParutionsIncludedComponent.prototype, "currentMarket", {
        get: /**
         * @return {?}
         */
        function () {
            return this._currentMarket;
        },
        set: /**
         * @param {?} market
         * @return {?}
         */
        function (market) {
            if (market) {
                this._currentMarket = market;
            }
            else {
                this._currentMarket = 'family';
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.includeHsChange.emit(this.includeHS);
        this.getDataFromWS(this._wsRequestParams);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.getDataFromWS = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (this.isFirstCall) {
                            this.isFirstCall = false;
                        }
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        this._wsRequestParams.includeHS = this.includeHS;
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, (/** @type {?} */ (this._wsRequestParams))),
                            }).toPromise()];
                    case 1:
                        _a.parutionsIncludedNbr = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} e
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.handleHS = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.includeHS = !this.includeHS;
        if (!this.isFirstCall) {
            this.getDataFromWS(this._wsRequestParams);
        }
        this.includeHsChange.emit(this.includeHS);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.openModal = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        switch (type) {
            case 'market':
                this.parutionsNbr = this.parutionsIncludedNbr.sprint;
                this.parutionsType = 'du marché sprint';
                this.paramType = type;
                this.inputParutions = null;
                break;
            case 'family':
                this.parutionsNbr = this.parutionsIncludedNbr.family;
                this.parutionsType = 'du marché sous famille';
                this.paramType = type;
                this.inputParutions = null;
                break;
            case 'finance':
                this.parutionsNbr = this.parutionsIncludedNbr.finance;
                this.parutionsType = type;
                this.paramType = type;
                this.inputParutions = this.compareParution.showCompare ? this.parutionsIncluded : null;
                break;
            case 'sales':
                this.parutionsNbr = this.parutionsIncludedNbr.sales;
                this.parutionsType = 'ventes';
                this.paramType = type;
                this.inputParutions = this.compareParution.showCompare ? this.parutionsIncluded : null;
                break;
            default:
                break;
        }
        this.modalOpened = true;
        document.body.style.overflow = 'hidden';
    };
    /**
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        document.body.style.overflow = 'auto';
        if (this._wsRequestParams.type) {
            delete this._wsRequestParams.type;
        }
        this.modalOpened = false;
    };
    /**
     * @param {?} e
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.onFilterChange = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        this.filterChange.emit(e);
    };
    /**
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.showCurrentMarket = /**
     * @return {?}
     */
    function () {
        return this.parutionsIncludedNbr[this.currentMarket === 'market' ? 'sprint' : 'family'] > 0;
    };
    /**
     * @param {?=} modifyRefParution
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.handleModal = /**
     * @param {?=} modifyRefParution
     * @return {?}
     */
    function (modifyRefParution) {
        this.modifyRefParution = modifyRefParution;
        this.compareListModal = !this.compareListModal;
        if (this.compareListModal) {
            this.filterComparableParution();
        }
        document.body.style.overflow = this.compareListModal ? 'hidden' : 'visible';
    };
    /**
     * @param {?} pub
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.changeComparedParution = /**
     * @param {?} pub
     * @return {?}
     */
    function (pub) {
        /** @type {?} */
        var compareParution = {
            refParution: this.modifyRefParution ? pub : this.compareParution.refParution,
            compareParution: this.modifyRefParution ? this.compareParution.compareParution : pub,
            showCompare: this.compareParution.showCompare,
            comparableParutions: this.compareParution.comparableParutions,
        };
        this.changeCompareParution.emit(compareParution);
        this.changeFilterDate.emit(compareParution.refParution.periodId);
        document.body.style.overflow = 'visible';
        this.compareListModal = false;
    };
    /**
     * @private
     * @return {?}
     */
    ParutionsIncludedComponent.prototype.filterComparableParution = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.compareParution.comparableParutions = this.initialComparableParutions.filter(function (parution) { return parution.publicationId !==
            (_this.modifyRefParution ? _this.compareParution.refParution.publicationId : _this.compareParution.compareParution.publicationId); });
    };
    ParutionsIncludedComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-parutions-included',
                    template: "<lib-compare-parutions *ngIf=\"compareParution?.showCompare\" [currentParution]=\"compareParution?.refParution\"\n                       [currentPublicationId]=\"compareParution?.refParution?.publicationId\"\n                       [comparedParution]=\"compareParution?.compareParution\" additonalModifyButton=\"true\"\n                       [comparableParutions]=\"compareParution?.comparableParutions\"\n                       (openModal)=\"handleModal($event)\"></lib-compare-parutions>\n<lib-compare-parutions-list *ngIf=\"compareListModal\" [comparablePublications]=\"compareParution?.comparableParutions\"\n                            [currentParution]=\"compareParution?.refParution\"\n                            [currentTitle]=\"compareParution?.refParution?.name\" [newRefParution]=\"modifyRefParution\"\n                            (toCompareParution)=\"changeComparedParution($event)\"\n                            (closeModal)=\"handleModal(true)\"></lib-compare-parutions-list>\n<div class=\"container\">\n  <ng-container>\n    <lib-loader *ngIf=\"isLoading; else noLoader\"></lib-loader>\n  </ng-container>\n\n  <ng-template #noLoader>\n    <lib-publications-modal *ngIf=\"modalOpened\" [parutionsNbr]=\"parutionsNbr\" [params]=\"params\" [paramType]=\"paramType\" [apiUrl]=\"apiUrl\" [useMirror]=\"true\"\n                            [parutionsType]=\"parutionsType\" (closeModal)=\"closeModal()\"\n                            (filterChange)=\"onFilterChange($event)\"></lib-publications-modal>\n    <div class=\"parutions-container\">\n      <div class=\"subtitle-container\">\n        <h6 class=\"subtitle\">Parutions prises en compte dans les calculs</h6>\n      </div>\n      <div class=\"stat-container\"\n           *ngIf=\"showCurrentMarket()\"\n           (click)=\"openModal(currentMarket)\">\n        <div class=\"top-stat\">\n            <span class=\"to-border\"><span\n              class=\"number\">{{ currentMarket === 'family' ? parutionsIncludedNbr.family : parutionsIncludedNbr.sprint | number }}</span><span>\n                parutions</span></span>\n        </div>\n        <div class=\"bottom-stat\">\n          <span>march\u00E9 {{currentMarket === 'market' ? 'SPRINT' : 'sous famille'}}</span>\n        </div>\n      </div>\n      <div class=\"stat-container\" (click)=\"openModal('finance')\" value=\"parutionsIncluded?.finance?.length\">\n        <div class=\"top-stat\">\n          <span class=\"to-border\"><span\n            class=\"number\">{{ parutionsIncludedNbr?.finance | number }}</span><span>{{parutionsIncludedNbr?.finance === 1 ? ' parution' : ' parutions'}}</span></span>\n        </div>\n        <div class=\"bottom-stat\">\n          <span>stat finance</span>\n        </div>\n      </div>\n      <div class=\"stat-container\" (click)=\"openModal('sales')\">\n        <div class=\"top-stat\">\n            <span class=\"to-border\"><span class=\"number\">{{ parutionsIncludedNbr?.sales | number }}</span><span>{{parutionsIncludedNbr?.sales === 1 ? ' parution' : ' parutions'}}</span></span>\n        </div>\n        <div class=\"bottom-stat\">\n          <span>stat de vente</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"checkbox-container\">\n      <label class=\"checkbox-button\">\n        <input type=\"checkbox\" class=\"checkbox-button-input\" id=\"hs\" name=\"hs\" [checked]=\"includeHS\"\n               (change)=\"handleHS($event)\">\n        <span class=\"checkbox-button-control\"></span>\n        <span class=\"checkbox-button-label\">Inclure les Hors-s\u00E9rie</span>\n      </label>\n    </div>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.container{display:flex;flex-direction:column}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container{flex-direction:row}}.container .parutions-container{display:flex;justify-content:space-between;flex-grow:5;flex-direction:column;align-self:center}@media (min-width:1140px){.container .parutions-container{flex-direction:row}.container .parutions-container .subtitle-container .subtitle{max-width:250px}}.container .parutions-container .subtitle-container{flex-grow:1}.container .parutions-container .subtitle-container .subtitle{font-family:Poppins,sans-serif;color:#0f1112;font-size:1.4rem;line-height:1.21}.container .parutions-container .stat-container{text-align:center;flex-grow:1;-ms-grid-row-align:center;align-self:center;font-family:Poppins,sans-serif;color:#8e8e8e;font-size:1.2rem;cursor:pointer}.container .parutions-container .stat-container .top-stat .to-border{border-bottom:1.2px solid #8e8e8e}.container .parutions-container .stat-container .top-stat .number{font-size:2rem;font-family:\"Roboto Slab\",serif}.container .parutions-container .stat-container:hover .top-stat{color:#0f1112}.container .checkbox-container{display:flex;justify-content:flex-end;align-self:center;flex-grow:2;flex-direction:column;margin-top:20px}@media (min-width:1140px){.container .checkbox-container{flex-direction:row}}.container .checkbox-container .checkbox-button{cursor:pointer;box-sizing:border-box;font-size:1.4rem;line-height:normal;color:#7a8c91}.container .checkbox-container .checkbox-button-input{opacity:0;position:absolute;font-size:1.4rem;line-height:1.5;padding:11px 23px;border:1px solid #7a8c91;border-radius:0;outline:0;background-color:transparent}.container .checkbox-container .checkbox-button-control{position:relative;display:inline-block;width:14px;height:14px;margin-right:12px;vertical-align:middle;background-color:#fff;color:#2d54d2;border:1px solid #7a8c91;transition:.3s}.container .checkbox-container .checkbox-button-input:checked+.checkbox-button-control:after{content:\"\";display:block;position:absolute;top:2px;left:2px;width:10px;height:10px;background-color:#2d54d2}.container .checkbox-container .checkbox-button-input:checked+.checkbox-button-control{border-color:#2d54d2}"]
                }] }
    ];
    /** @nocollapse */
    ParutionsIncludedComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    ParutionsIncludedComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        mulitpleFilters: [{ type: Input, args: ['multipleFilters',] }],
        compareParution: [{ type: Input, args: ['compareParution',] }],
        filterChange: [{ type: Output }],
        changeFilterDate: [{ type: Output }],
        includeHsChange: [{ type: Output }],
        changeCompareParution: [{ type: Output }],
        componentId: [{ type: Input }],
        currentMarket: [{ type: Input, args: ['filterMarket',] }]
    };
    return ParutionsIncludedComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PublicationsModalComponent = /** @class */ (function () {
    function PublicationsModalComponent(http) {
        this.http = http;
        this.modalToggled = false;
        this.itemsPerPage = 60;
        this.currentPage = 1;
        this.isLoading = true;
        this.savedOrder = null;
        this.savedFilter = null;
        this.useMirror = false;
        this.closeModal = new EventEmitter();
        this.filterChange = new EventEmitter();
    }
    Object.defineProperty(PublicationsModalComponent.prototype, "params", {
        get: /**
         * @return {?}
         */
        function () {
            return this._wsRequestParams;
        },
        set: /**
         * @param {?} parameters
         * @return {?}
         */
        function (parameters) {
            this._wsRequestParams = parameters;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PublicationsModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS()];
                    case 1:
                        _a.sent();
                        res = StaticFilters.setPublicationsPages(this.parutions, this.itemsPerPage, true);
                        this.parutionsPages = res.listPages;
                        this.currentPage = res.currentPage;
                        this.initialParutions = this.parutions;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    PublicationsModalComponent.prototype.getDataFromWS = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var apiResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        this._wsRequestParams.type = this.paramType;
                        return [4 /*yield*/, this.http.get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, this._wsRequestParams),
                            }).toPromise()];
                    case 1:
                        apiResult = _a.sent();
                        this.parutions = apiResult.publications;
                        this.parutionsFilters = apiResult.filters;
                        this.isLoading = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    PublicationsModalComponent.prototype.onToggleModal = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (evt) {
                    evt.stopPropagation();
                }
                this.closeModal.emit();
                return [2 /*return*/];
            });
        });
    };
    // Stop click event in parution component in order to not display publication details
    // Stop click event in parution component in order to not display publication details
    /**
     * @param {?} evt
     * @return {?}
     */
    PublicationsModalComponent.prototype.stopClickEventParution = 
    // Stop click event in parution component in order to not display publication details
    /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        evt.stopPropagation();
    };
    /**
     * @param {?} pageNbr
     * @return {?}
     */
    PublicationsModalComponent.prototype.onPageChange = /**
     * @param {?} pageNbr
     * @return {?}
     */
    function (pageNbr) {
        this.currentPage = pageNbr;
        /** @type {?} */
        var el = document.getElementById('scrollAnchor');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    };
    /**
     * @param {?} currentPage
     * @param {?} index
     * @param {?} isMirror
     * @return {?}
     */
    PublicationsModalComponent.prototype.onSwitchMirror = /**
     * @param {?} currentPage
     * @param {?} index
     * @param {?} isMirror
     * @return {?}
     */
    function (currentPage, index, isMirror) {
        if (isMirror) {
            /** @type {?} */
            var targetParution = this.parutionsPages[currentPage - 1][index];
            if (targetParution) {
                targetParution.isMirror = !targetParution.isMirror;
                if (targetParution.mirror) {
                    targetParution.mirror.isMirror = !targetParution.mirror.isMirror;
                }
            }
        }
    };
    /**
     * @param {?} order
     * @return {?}
     */
    PublicationsModalComponent.prototype.onOrderByItems = /**
     * @param {?} order
     * @return {?}
     */
    function (order) {
        /** @type {?} */
        var res = StaticFilters.orderByItems(order, this.initialParutions, this.parutions, this.savedFilter, this.itemsPerPage, false, true);
        this.parutions = res.list;
        this.parutionsPages = res.listPages;
        this.savedOrder = res.savedOrder;
        this.currentPage = res.currentPage;
    };
    PublicationsModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-publications-modal',
                    template: "<div class=\"container\" (click)=\"stopClickEventParution($event)\">\n  <div class=\"container-modal-overlay\"></div>\n  <div class=\"container-modal-content\">\n    <ng-container *ngIf=\"!isLoading; else Loading\">\n      <div class=\"container-modal-content-header\">\n        <div class=\"container-modal-content-title\">\n          <span>{{ parutionsNbr }} parutions</span>\n          prises en compte dans les statistiques {{ parutionsType }}\n        </div>\n        <div class=\"container-modal-content-close\" (click)=\"onToggleModal($event)\">X</div>\n      </div>\n      <div class=\"row container-modal-content-main\" id=\"scrollAnchor\">\n        <div class=\"parutions-list-header-filters\">\n          <div *ngIf=\"parutionsFilters?.orderByItems\" class=\"parutions-list-header-filters-date\">\n            <lib-select className=\"filter-modal\" clearable=\"true\" placeholder=\"Trier par\" ngClassName=\"filter-select\"\n                        [options]=\"parutionsFilters.orderByItems\" (change)=\"onOrderByItems($event)\">\n            </lib-select>\n          </div>\n        </div>\n        <ng-container *ngIf=\"parutions && parutions.length > 0 && (parutionsPages && currentPage); else noParutions\">\n          <div class=\"container-modal-content-parutions\">\n            <ng-container *ngFor=\"let parution of parutionsPages[currentPage - 1]; let i = index\">\n              <div class=\"double-parutions-container\">\n                <div class=\"mirror-overlay\"\n                     [ngClass]=\"{'mirror-parution': parution.isMirror, 'no-mirror-parution': !parution.isMirror}\">\n                  <lib-parution [isFromComparator]=\"true\" [publication]=\"parution\" [isHomologous]=\"true\"\n                                [isModal]=\"true\"\n                                [subFamily]=\"parution.familyLabel\" [useMirror]=\"useMirror\"\n                                [isMirror]=\"parution.isMirror\"\n                                (click)=\"onSwitchMirror(currentPage, i, parution.isMirror)\"></lib-parution>\n                </div>\n                <div class=\"mirror-overlay\"\n                     [ngClass]=\"{'mirror-parution': parution.mirror?.isMirror, 'no-mirror-parution': !parution.mirror?.isMirror}\">\n                  <lib-parution *ngIf=\"parution?.mirror\" [isFromComparator]=\"true\" [isHomologous]=\"true\"\n                                [publication]=\"parution?.mirror\"\n                                [isModal]=\"true\" [subFamily]=\"parution?.mirror?.familyLabel\"\n                                [isMirror]=\"parution.mirror?.isMirror\"\n                                (click)=\"onSwitchMirror(currentPage, i, parution.mirror?.isMirror)\">\n                  </lib-parution>\n                  <div class=\"container-previous\" *ngIf=\"(parution.mirror && parution.mirror?.isMirror) || (parution && parution.isMirror)\">\n                    <div class=\"previous-year\"\n                         [ngClass]=\"{'bright-yellow': !parution.mirror?.isMirror, 'normal-yellow': parution.mirror?.isMirror}\">\n                      A-1\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </ng-container>\n          </div>\n          <lib-pagination *ngIf=\"parutionsPages?.length > 1\" [currentPage]=\"currentPage\" [itemsPerPage]=\"itemsPerPage\" [numberOfItems]=\"parutions.length\"\n                          (pageChange)=\"onPageChange($event)\" [fromModal]=\"true\"></lib-pagination>\n        </ng-container>\n        <ng-template #noParutions>\n          <div class=\"no-parutions-to-compare\">Pas de parutions disponibles</div>\n        </ng-template>\n      </div>\n    </ng-container>\n    <ng-template #Loading>\n      <lib-loader class=\"loader\" loaderTheme=\"light\" loaderSize=\"big\"></lib-loader>\n    </ng-template>\n  </div>\n</div>\n\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.container{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10400}.container .container-modal-button{cursor:pointer}.container .container-modal-button .container-modal-button-icon{background-color:rgba(15,17,18,.8);display:flex;justify-content:center;align-items:center;width:38px;height:40px;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.container .container-modal-content{-webkit-animation:.2s fadein;animation:.2s fadein;opacity:1;position:relative;background-color:#0f1112;color:#fff;overflow:auto;height:100vh;z-index:10300}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container .container-modal-content{display:flex;flex-direction:column;background-color:#0f1112;padding:45px 16px}}.container .container-modal-content .container-modal-content-header{display:flex;justify-content:space-between;font-size:2rem}.container .container-modal-content .container-modal-content-header .container-modal-content-title{padding:10px;width:100%;text-align:center;font-weight:500}.container .container-modal-content .container-modal-content-header .container-modal-content-title span{font-size:5.6rem;font-family:\"Roboto Slab\",serif;font-weight:100;display:block;line-height:1.14}.container .container-modal-content .container-modal-content-header .container-modal-content-close{cursor:pointer;position:absolute;top:30px;right:40px}.container .container-modal-content .container-modal-content-main{padding-bottom:50px;margin:0 auto;max-width:1400px}.container .container-modal-content .container-modal-content-selector{text-align:center;margin:64px auto}.container .container-modal-content .container-modal-content-selector .container-modal-content-selector-title{font-size:1.6rem;color:#657478;margin-bottom:16px}@media (min-width:1140px){.container .container-modal-content .container-modal-content-selector{display:flex;justify-content:center;align-items:center;margin:98px auto;text-align:left}.container .container-modal-content .container-modal-content-selector .container-modal-content-selector-title{margin-bottom:0;margin-right:16px}}.container .container-modal-content .container-modal-content-selector .container-modal-content-selector-navigator{display:flex;justify-content:center}.container .container-modal-content .container-modal-content-parutions{display:flex;justify-content:center;position:relative;flex-wrap:wrap;margin-top:72px}.container .container-modal-content .container-modal-content-parutions .double-parutions-container{position:relative;margin-right:25px;height:326px;width:238px}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .mirror-overlay{width:168px;height:221px}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .mirror-overlay .container-previous{position:absolute;top:0;right:15px}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .mirror-overlay .container-previous .previous-year{color:#0f1112;font-size:1.8rem;font-family:\"Roboto Slab\",serif;border-radius:4px;font-weight:400;padding:8px;position:relative;z-index:5001}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .mirror-overlay .bright-yellow{background-color:#ffec00}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .mirror-overlay .normal-yellow{background-color:#fff790}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .mirror-parution{position:absolute;top:0;left:70px}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .no-mirror-parution{position:absolute;top:0;left:0}.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous{margin-left:4px}@media (min-width:1140px){.container .container-modal-content .container-modal-content-parutions .double-parutions-container{height:457px;width:319px}.container .container-modal-content .container-modal-content-parutions .double-parutions-container .mirror-overlay{width:249px;height:328px}.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous{margin-left:24px}}.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous.no-homologous{margin-top:8%;text-align:center;width:168px}.container .container-modal-content .parutions-list-header-filters{margin-top:51px;position:relative;z-index:10000;display:flex}.container .container-modal-content .parutions-list-header-filters .parutions-list-header-filters-global{width:50%}@media (min-width:1140px){.container .container-modal-content .container-modal-content-parutions .container-modal-content-previous.no-homologous{width:249px}.container .container-modal-content .parutions-list-header-filters .parutions-list-header-filters-global{width:400px;margin-right:24px}}@media (max-width:1139px){.container .container-modal-content .container-modal-content-header .container-modal-content-close{top:10px;right:15px}.container .container-modal-content .parutions-list-header-filters{display:flex;flex-direction:column;align-items:center;margin-bottom:16px}.container .container-modal-content .parutions-list-header-filters .parutions-list-header-filters-global{margin-bottom:10px}}.container .container-modal-content .parutions-list-header-filters .parutions-list-header-filters-date{width:50%}@media (min-width:1140px){.container .container-modal-content .parutions-list-header-filters .parutions-list-header-filters-date{width:400px}}.container .container-modal-content .parutions-list-header-filters .ng-select .ng-select-container{border:1px solid rgba(255,255,255,.72);color:#fff;background-color:transparent}.no-parutions-to-compare{display:flex;margin-top:100px;justify-content:center}.loader{margin-top:100px}"]
                }] }
    ];
    /** @nocollapse */
    PublicationsModalComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    PublicationsModalComponent.propDecorators = {
        params: [{ type: Input, args: ['params',] }],
        parutionsNbr: [{ type: Input }],
        parutionsType: [{ type: Input }],
        apiUrl: [{ type: Input }],
        paramType: [{ type: Input }],
        useMirror: [{ type: Input }],
        closeModal: [{ type: Output }],
        filterChange: [{ type: Output }],
        scrollAnchor: [{ type: ViewChild, args: ['scrollAnchor',] }]
    };
    return PublicationsModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PublicationsModalModule = /** @class */ (function () {
    function PublicationsModalModule() {
    }
    PublicationsModalModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [PublicationsModalComponent],
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        SelectModule,
                        ParutionModule,
                        PaginationModule,
                        LoaderModule,
                    ],
                    exports: [PublicationsModalComponent]
                },] }
    ];
    return PublicationsModalModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ParutionsIncludedMetadata = {
    declarations: [ParutionsIncludedComponent],
    imports: [
        CommonModule,
        HttpClientModule,
        LoaderModule,
        SelectModule,
        PublicationsModalModule,
        CompareParutionsModule,
        CompareParutionsListModule
    ],
    exports: [ParutionsIncludedComponent]
};
var ParutionsIncludedModule = /** @class */ (function () {
    function ParutionsIncludedModule() {
    }
    ParutionsIncludedModule.decorators = [
        { type: NgModule, args: [ParutionsIncludedMetadata,] }
    ];
    return ParutionsIncludedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PublicationDetailsComponent = /** @class */ (function () {
    function PublicationDetailsComponent(http) {
        this.http = http;
        // In mobile version display all the details or not
        this.displayDetails = false;
        // In desktop version display the right chevron or not
        this.canScrollRight = true;
        // In desktop version display the left chevron or not
        this.canScrollLeft = false;
        // Indicate the state of the loading
        this.isLoading = true;
        this.dataPublication = {};
    }
    /**
     * @return {?}
     */
    PublicationDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var httpParams, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        this.isLoading = true;
                        httpParams = new HttpParams().set('publicationId', this.publicationId);
                        // Get details
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: httpParams,
                            })
                                .toPromise()];
                    case 1:
                        // Get details
                        _a.dataPublication = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * In mobile version, display all the details displayDetails or not !displayDetails
     */
    /**
     * In mobile version, display all the details displayDetails or not !displayDetails
     * @return {?}
     */
    PublicationDetailsComponent.prototype.displayMore = /**
     * In mobile version, display all the details displayDetails or not !displayDetails
     * @return {?}
     */
    function () {
        this.displayDetails = !this.displayDetails;
    };
    /**
     * In desktop version, scroll the details part
     * @param side Right or Left scrolling in the details
     */
    /**
     * In desktop version, scroll the details part
     * @param {?} side Right or Left scrolling in the details
     * @return {?}
     */
    PublicationDetailsComponent.prototype.scrollDetails = /**
     * In desktop version, scroll the details part
     * @param {?} side Right or Left scrolling in the details
     * @return {?}
     */
    function (side) {
        /** @type {?} */
        var elt = this.details.nativeElement;
        /** @type {?} */
        var clic;
        if (side === 'right') {
            elt.scrollLeft += 150;
            clic = 1;
        }
        else {
            this.canScrollRight = true;
            elt.scrollLeft -= 150;
            clic = 0;
        }
        this.canScrollLeft = elt.scrollLeft > 0 || (clic === 1 && !(elt.scrollWidth - elt.offsetWidth === 0));
        this.canScrollRight =
            elt.scrollLeft + elt.offsetWidth < elt.scrollWidth || (clic === 0 && !(elt.scrollWidth - elt.offsetWidth === 0));
    };
    PublicationDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-publication-details',
                    template: "<section *ngIf=\"!isLoading; else loading\">\n  <div class=\"publication-details-global-container-desktop\">\n    <div class=\"publication-details-cover desktop\">\n      <img [src]=\"dataPublication.coverUrl\" alt=\"Cover\" />\n    </div>\n    <div class=\"publication-details-desktop\">\n      <div class=\"publication-details-top-desktop\">\n        <div class=\"publication-details-title\">\n          {{ dataPublication.publicationId | RemoveAfterHyphenPipe }} \u2022\n          <span class=\"publication-details-name\"> {{ dataPublication.name }} </span>\n          n\u00B0{{ dataPublication.publicationNumber }}\n        </div>\n        <div class=\"publication-details-wrapper-mobile\">\n          <div class=\"publication-details-cover\">\n            <img [src]=\"dataPublication.coverUrl\" alt=\"Cover\" />\n          </div>\n          <div class=\"publication-details-container mobile\">\n            <table class=\"publication-details-information-top\">\n              <tr>\n                <td class=\"publication-details-information left\">\n                  Prix\n                  <div class=\"publication-details-information-value\">\n                    {{ dataPublication.price | number: '.2':'fr-FR' }} \u20AC\n                  </div>\n                </td>\n                <td class=\"publication-details-information \">\n                  P\u00E9riode de Vente\n                  <div class=\"publication-details-information-value\">\n                    <ng-container *ngIf=\"dataPublication?.sellingEndDate; else noEndDate\">\n                      Du {{ dataPublication.sellingStartDate | date: 'dd/MM' }} au\n                      {{ dataPublication.sellingEndDate | date: 'dd/MM' }}\n                    </ng-container>\n                    <ng-template #noEndDate>\n                      <span>MEV \u00E0 partir du {{ dataPublication?.sellingStartDate | date: 'dd/MM' }}</span>\n                    </ng-template>\n                  </div>\n                </td>\n              </tr>\n              <tr>\n                <td class=\"publication-details-information left\">\n                  Pack\n                  <div class=\"publication-details-information-value\">{{ dataPublication.pack }}</div>\n                </td>\n                <td class=\"publication-details-information \">\n                  Promo\n                  <div class=\"publication-details-information-value\">{{ dataPublication.isPromo ? 'Oui' : 'Non' }}</div>\n                </td>\n              </tr>\n              <tr\n                *ngIf=\"!displayDetails; else details\"\n                class=\"publication-details-information-link\"\n                (click)=\"displayMore()\"\n              >\n                <td colspan=\"2\">Plus de d\u00E9tails</td>\n              </tr>\n              <ng-template #details class=\"publication-kldetails-information-details\">\n                <tr>\n                  <td class=\"publication-details-information left\">\n                    Fournis\n                    <div class=\"publication-details-information-value\">\n                      {{ dataPublication.delivered | number: '':'fr-FR' }}\n                    </div>\n                  </td>\n                  <td class=\"publication-details-information \">\n                    R\u00E9assort\n                    <div class=\"publication-details-information-value\">\n                      {{ dataPublication.restocking ? 'Oui' : 'Non' }}\n                    </div>\n                  </td>\n                </tr>\n                <tr>\n                  <td class=\"publication-details-information left\">\n                    R\u00E9cup. Invendus\n                    <div class=\"publication-details-information-value\">{{ dataPublication.unsoldsStatus ? 'Oui' : 'Non' }}</div>\n                  </td>\n                  <td class=\"publication-details-information \">\n                    Plus produit\n                    <div class=\"publication-details-information-value\">\n                      {{ dataPublication.additionalProduct ? 'Oui' : 'Non' }}\n                    </div>\n                  </td>\n                </tr>\n                <tr>\n                  <td class=\"publication-details-information left\">\n                    Sous-famille observatoire\n                    <div class=\"publication-details-information-value\">{{ dataPublication.familyLabel }}</div>\n                  </td>\n                  <td class=\"publication-details-information \">\n                    Positionnement lin\u00E9aire\n                    <div class=\"publication-details-information-value\">{{ dataPublication.shelfDisplayPosition }}</div>\n                  </td>\n                </tr>\n              </ng-template>\n            </table>\n          </div>\n        </div>\n        <a\n          class=\"publication-details-contact\"\n          [href]=\"'mailto:' + dataPublication.accountManagerEmail + '?subject=[Pressmine]'\"\n        >\n          <lib-icon class=\"icon\" icon=\"mail-outline\" iconWidth=\"24px\" iconHeight=\"24px\"></lib-icon>\n          Contacter mon charg\u00E9 de compte\n        </a>\n      </div>\n      <div class=\"publication-details-wrapper-desktop\">\n        <div *ngIf=\"canScrollLeft\" class=\"chevron left\">\n          <lib-icon icon=\"chevron-right\" (click)=\"scrollDetails('left')\" iconHeight=\"24px\" iconWidth=\"24px\"></lib-icon>\n        </div>\n        <div #detailsList [ngClass]=\"{ 'publication-details-container': true, desktop: true }\">\n          <div class=\"publication-details-information left first\">\n            Prix\n            <div class=\"publication-details-information-value\">\n              {{ dataPublication.price | number: '.2':'fr-FR' }} \u20AC\n            </div>\n          </div>\n          <div class=\"publication-details-information left\">\n            P\u00E9riode de Vente\n            <div class=\"publication-details-information-value\">\n              <ng-container *ngIf=\"dataPublication?.sellingEndDate; else noEndDate\">\n                Du {{ dataPublication.sellingStartDate | date: 'dd/MM' }} au\n                {{ dataPublication.sellingEndDate | date: 'dd/MM' }}\n              </ng-container>\n              <ng-template #noEndDate>\n                <span>MEV \u00E0 partir du {{ dataPublication?.sellingStartDate | date: 'dd/MM' }}</span>\n              </ng-template>\n            </div>\n          </div>\n          <div class=\"publication-details-information left\">\n            Pack\n            <div class=\"publication-details-information-value\">{{ dataPublication.pack }}</div>\n          </div>\n          <div class=\"publication-details-information left\">\n            Promo\n            <div class=\"publication-details-information-value\">{{ dataPublication.isPromo ? 'Oui' : 'Non' }}</div>\n          </div>\n          <div class=\"publication-details-information left\">\n            Fournis\n            <div class=\"publication-details-information-value\">\n              {{ dataPublication.delivered | number: '':'fr-FR' }}\n            </div>\n          </div>\n          <div class=\"publication-details-information left\">\n            R\u00E9assort\n            <div class=\"publication-details-information-value\">{{ dataPublication.restocking ? 'Oui' : 'Non' }}</div>\n          </div>\n          <div class=\"publication-details-information left\">\n            R\u00E9cup. Invendus\n            <div class=\"publication-details-information-value\">\n              {{ dataPublication.unsoldsStatus ? 'Oui' : 'Non' }}\n            </div>\n          </div>\n          <div class=\"publication-details-information left\">\n            Plus produit\n            <div class=\"publication-details-information-value\">\n              {{ dataPublication.additionalProduct ? 'Oui' : 'Non' }}\n            </div>\n          </div>\n          <div class=\"publication-details-information left\">\n            Sous-famille observatoire\n            <div class=\"publication-details-information-value\">{{ dataPublication.familyLabel | titlecase }}</div>\n          </div>\n          <div class=\"publication-details-information left last \">\n            Positionnement lin\u00E9aire\n            <div class=\"publication-details-information-value\">\n              {{ dataPublication.shelfDisplayPosition | titlecase }}\n            </div>\n          </div>\n        </div>\n\n        <div *ngIf=\"canScrollRight\" class=\"chevron\">\n          <lib-icon icon=\"chevron-right\" (click)=\"scrollDetails('right')\" iconHeight=\"24px\" iconWidth=\"24px\"></lib-icon>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n\n<ng-template #loading>\n  {{ loadingMessage }}\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.publication-details-desktop{width:100%;overflow-x:hidden;position:relative}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.publication-details-global-container-desktop{display:flex}.publication-details-top-desktop{display:flex;justify-content:space-between;margin-left:30px;margin-bottom:24px}}.publication-details-title{color:#0f1112;font-size:2.4rem;font-family:\"Roboto Slab\",serif;font-weight:300;margin-top:7px;display:flex;white-space:nowrap;margin-bottom:30px}.publication-details-name{white-space:nowrap;padding:0 5px}@media (min-width:1140px){.publication-details-title{margin-bottom:0}.publication-details-name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:400px}}.publication-details-cover{max-width:100px;max-height:130px}.publication-details-cover>img{border-radius:2.6px;width:100%;height:100%}.publication-details-cover.desktop{display:none}@media (min-width:1140px){.publication-details-cover.desktop{display:block;max-width:86px;max-height:112px}}.publication-details-container{display:flex;color:#657478;font-size:1.2rem}.publication-details-container.mobile{display:table;border-collapse:separate;padding-left:12px}.publication-details-wrapper-mobile{display:flex}.publication-details-wrapper-desktop{display:none}.publication-details-information{padding-right:10px;padding-left:15px;padding-bottom:13px;vertical-align:top}.publication-details-information.left{padding-left:0;border-right:1px solid rgba(15,17,18,.12)}@media (min-width:1140px){.publication-details-container.desktop{scroll-behavior:smooth;display:flex;white-space:nowrap;bottom:0;overflow:auto;-ms-overflow-style:none;overflow:-moz-scrollbars-none;scrollbar-width:none;max-width:990px}.publication-details-container.desktop::-webkit-scrollbar{display:none}.publication-details-wrapper-mobile{display:none}.publication-details-wrapper-desktop{display:flex;margin-left:30px}.publication-details-information.left{padding:0 30px}.publication-details-information.left.last{padding-right:70px;border-right:0}.publication-details-information.left.first{padding-left:0}}.publication-details-information-value{font-family:\"Roboto Slab\",serif;color:#0f1112;font-size:1.4rem}.publication-details-information-link{color:#2d54d2;font-weight:500;text-decoration:underline;cursor:pointer}.publication-details-contact{color:#fff;font-size:1.4rem;background-color:#2d54d2;font-weight:500;height:48px;border-radius:4px;border:none;display:flex;align-items:center;padding:0 24px;width:100%;margin-top:17px;text-decoration:none;cursor:pointer}.publication-details-contact>lib-icon{margin-right:12px}.chevron{display:none}@media (min-width:1140px){.publication-details-contact{margin-top:0;max-width:323px;justify-content:center}.chevron{cursor:pointer;display:flex;align-items:center;color:#2d54d2;height:48px;width:40px;background-image:linear-gradient(to right,rgba(247,247,247,0),#f7f7f7,#f7f7f7)}.chevron.left{left:30px;-webkit-transform:scaleX(-1);transform:scaleX(-1)}}"]
                }] }
    ];
    /** @nocollapse */
    PublicationDetailsComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    PublicationDetailsComponent.propDecorators = {
        publicationId: [{ type: Input }],
        apiUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        componentId: [{ type: Input }],
        details: [{ type: ViewChild, args: ['detailsList',] }]
    };
    return PublicationDetailsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PublicationDetailsMetadata = {
    declarations: [PublicationDetailsComponent],
    imports: [CommonModule, IconModule, HttpClientModule, PipesModule.forRoot()],
    exports: [PublicationDetailsComponent],
};
var PublicationDetailsModule = /** @class */ (function () {
    function PublicationDetailsModule() {
    }
    PublicationDetailsModule.decorators = [
        { type: NgModule, args: [PublicationDetailsMetadata,] }
    ];
    return PublicationDetailsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RankingsSetComponent = /** @class */ (function () {
    function RankingsSetComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        // Data from api
        this.isLoading = true;
        this.displayButton = true;
        // Swiper configurations
        this.config = {
            direction: 'horizontal',
            slidesPerView: 1,
            keyboard: true,
            mousewheel: true,
            scrollbar: false,
            navigation: false,
            pagination: true,
        };
        this.displayAll = false;
        this.data = {
            publications: { top: [], flop: [] },
            titles: { top: [], flop: [] },
            resellers: { top: [], flop: [] },
        };
        this.rankingData = {
            filters: {
                value: '',
                mirror: '',
            },
            soldNumber: {
                asc: {
                    publications: {
                        rankings: [],
                    },
                    titles: {
                        rankings: [],
                    },
                    resellers: {
                        rankings: [],
                    },
                },
                desc: {
                    publications: {
                        rankings: [],
                    },
                    titles: {
                        rankings: [],
                    },
                    resellers: {
                        rankings: [],
                    },
                },
            },
            mirrorRate: {
                asc: {
                    publications: {
                        rankings: [],
                    },
                    titles: {
                        rankings: [],
                    },
                    resellers: {
                        rankings: [],
                    },
                },
                desc: {
                    publications: {
                        rankings: [],
                    },
                    titles: {
                        rankings: [],
                    },
                    resellers: {
                        rankings: [],
                    },
                },
            },
        };
    }
    Object.defineProperty(RankingsSetComponent.prototype, "mulitpleFilters", {
        set: /**
         * @param {?} filters
         * @return {?}
         */
        function (filters) {
            if (filters) {
                this._wsRequestParams = StaticInputProccesor.processMultipleFilters(filters, this._wsRequestParams);
                if (!this.isfirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RankingsSetComponent.prototype, "compareParution", {
        get: /**
         * @return {?}
         */
        function () {
            return this._compareParution;
        },
        set: /**
         * @param {?} compareParution
         * @return {?}
         */
        function (compareParution) {
            if (JSON.stringify(this._compareParution) !== JSON.stringify(compareParution)) {
                this._compareParution = compareParution;
                if (compareParution && compareParution.showCompare) {
                    this._wsRequestParams.periodId = compareParution.refParution.periodId;
                    this._wsRequestParams.compareId = compareParution.compareParution.periodId;
                    this.getDataFromWS(this._wsRequestParams);
                }
                if (!compareParution.showCompare && !!this._wsRequestParams.compareId) {
                    delete this._wsRequestParams.compareId;
                }
                if (!compareParution.showCompare && !!this._wsRequestParams.periodId) {
                    delete this._wsRequestParams.periodId;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RankingsSetComponent.prototype, "includeHS", {
        set: /**
         * @param {?} includeHS
         * @return {?}
         */
        function (includeHS) {
            this._wsRequestParams.includeHS = includeHS;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RankingsSetComponent.prototype, "titleId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._titleId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RankingsSetComponent.prototype, "periodId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._periodId;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RankingsSetComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.updateSize();
                        return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        this.displayButton =
                            this.data.publications.flop.length > 6 ||
                                this.data.publications.top.length > 6 ||
                                this.data.titles.flop.length > 6 ||
                                this.data.titles.top.length > 6 ||
                                this.data.resellers.flop.length > 6 ||
                                this.data.resellers.top.length > 6;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    RankingsSetComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, init;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.rankingData = _b.sent();
                        // TODO : PUT DEFAULT VALUE IN THE SELECT INSTEAD OF INIT FOR SELECT WITH NAME OF THE DEFAULT VALUE IN THE PLACEHOLDER
                        init = { value: 'soldNumber' };
                        this.changeRankings(init);
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the swiper slides
     */
    /**
     * Update the swiper slides
     * @return {?}
     */
    RankingsSetComponent.prototype.updateSize = /**
     * Update the swiper slides
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () {
            if (_this.componentRef) {
                _this.componentRef.directiveRef.update();
            }
        }, 2000);
    };
    /**
     * Change the displaying data with the select choice
     * @param selection Top / Flop
     */
    /**
     * Change the displaying data with the select choice
     * @param {?} selection Top / Flop
     * @return {?}
     */
    RankingsSetComponent.prototype.changeRankings = /**
     * Change the displaying data with the select choice
     * @param {?} selection Top / Flop
     * @return {?}
     */
    function (selection) {
        if (selection.value === 'soldNumber') {
            this.data.publications.top = this.rankingData.soldNumber.desc.publications.rankings;
            this.data.publications.flop = this.rankingData.soldNumber.asc.publications.rankings;
            this.data.publications.displayCode = this.rankingData.soldNumber.asc.publications.displayCode;
            this.data.titles.top = this.rankingData.soldNumber.desc.titles.rankings;
            this.data.titles.flop = this.rankingData.soldNumber.asc.titles.rankings;
            this.data.titles.displayCode = this.rankingData.soldNumber.asc.titles.displayCode;
            this.data.resellers.top = this.rankingData.soldNumber.desc.resellers.rankings;
            this.data.resellers.flop = this.rankingData.soldNumber.asc.resellers.rankings;
            this.data.resellers.displayCode = this.rankingData.soldNumber.asc.resellers.displayCode;
        }
        if (selection.value === 'mirror') {
            this.data.publications.top = this.rankingData.mirrorRate.desc.publications.rankings;
            this.data.publications.flop = this.rankingData.mirrorRate.asc.publications.rankings;
            this.data.publications.displayCode = this.rankingData.mirrorRate.asc.publications.displayCode;
            this.data.titles.top = this.rankingData.mirrorRate.desc.titles.rankings;
            this.data.titles.flop = this.rankingData.mirrorRate.asc.titles.rankings;
            this.data.titles.displayCode = this.rankingData.mirrorRate.asc.titles.displayCode;
            this.data.resellers.top = this.rankingData.mirrorRate.desc.resellers.rankings;
            this.data.resellers.flop = this.rankingData.mirrorRate.asc.resellers.rankings;
            this.data.resellers.displayCode = this.rankingData.mirrorRate.asc.resellers.displayCode;
        }
        this.updateSize();
    };
    /**
     * @return {?}
     */
    RankingsSetComponent.prototype.displayMore = /**
     * @return {?}
     */
    function () {
        this.displayAll = !this.displayAll;
    };
    RankingsSetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-rankings',
                    template: "<ng-container *ngIf=\"isLoading; else isLoaded\">\n  <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <ng-container>\n    <div class=\"rankings-set-wrapper\">\n      <div class=\"rankings-set-top\">\n        <div class=\"rankings-set-title\">Les tops et les flops</div>\n        <lib-select\n                [options]=\"[\n        { value: 'soldNumber', label: rankingData.filters.value },\n        { value: 'mirror', label: rankingData.filters.mirror }\n      ]\"\n                placeholder=\"Par d\u00E9faut: Quantit\u00E9 vendue \"\n                (change)=\"changeRankings($event)\"\n        ></lib-select>\n      </div>\n      <div class=\"rankings-set-down\">\n        <div class=\"rankings-set-rankings-desktop\">\n          <lib-ranking\n                  type=\"resellers\"\n                  [displayMore]=\"displayAll\"\n                  [top]=\"data.resellers.top\"\n                  [flop]=\"data.resellers.flop\"\n                  [displayCode]=\"data.resellers.displayCode\"\n                  [compareMode]=\"compareParution?.showCompare\"\n                  class=\"rankings-set-ranking\"\n          ></lib-ranking>\n          <lib-ranking\n                  type=\"publications\"\n                  [displayMore]=\"displayAll\"\n                  [top]=\"data.publications.top\"\n                  [flop]=\"data.publications.flop\"\n                  [displayCode]=\"data.publications.displayCode\"\n                  [compareMode]=\"compareParution?.showCompare\"\n                  class=\"rankings-set-ranking margin\"\n          ></lib-ranking>\n          <lib-ranking\n                  type=\"titles\"\n                  [displayMore]=\"displayAll\"\n                  [top]=\"data.titles.top\"\n                  [flop]=\"data.titles.flop\"\n                  [displayCode]=\"data.titles.displayCode\"\n                  [compareMode]=\"compareParution?.showCompare\"\n                  class=\"rankings-set-ranking margin\"\n          ></lib-ranking>\n        </div>\n      </div>\n      <div class=\"rankings-set-rankings-mobile\" (window:resize)=\"updateSize()\">\n        <div class=\"content-container\">\n          <swiper class=\"swiper-container\" [config]=\"config\">\n            <div *ngFor=\"let slide of [1, 2, 3]; let i = index\" class=\"swiper-slide\">\n              <div>\n                <lib-ranking\n                        *ngIf=\"i === 0\"\n                        type=\"resellers\"\n                        [displayMore]=\"displayAll\"\n                        [top]=\"data.resellers.top\"\n                        [flop]=\"data.resellers.flop\"\n                        [displayCode]=\"data.resellers.displayCode\"\n                        [compareMode]=\"compareParution?.showCompare\"\n                        class=\"rankings-set-ranking\"\n                ></lib-ranking>\n                <lib-ranking\n                        *ngIf=\"i === 1\"\n                        type=\"publications\"\n                        [displayMore]=\"displayAll\"\n                        [top]=\"data.publications.top\"\n                        [flop]=\"data.publications.flop\"\n                        [displayCode]=\"data.publications.displayCode\"\n                        [compareMode]=\"compareParution?.showCompare\"\n                        class=\"rankings-set-ranking\"\n                ></lib-ranking>\n                <lib-ranking\n                        *ngIf=\"i === 2\"\n                        type=\"titles\"\n                        [displayMore]=\"displayAll\"\n                        [top]=\"data.titles.top\"\n                        [flop]=\"data.titles.flop\"\n                        [displayCode]=\"data.titles.displayCode\"\n                        [compareMode]=\"compareParution?.showCompare\"\n                        class=\"rankings-set-ranking\"\n                ></lib-ranking>\n                <div class=\"rankings-set-button-background\">\n                  <button *ngIf=\"displayButton\" type=\"button\" class=\"rankings-set-button\" (click)=\"displayMore()\">\n                    {{ displayAll ? 'Afficher moins' : 'Afficher plus' }}\n                    <span [ngClass]=\"[displayAll ? 'arrow-up' : 'arrow-down']\"></span>\n                  </button>\n                </div>\n              </div>\n            </div>\n          </swiper>\n        </div>\n      </div>\n      <div class=\"rankings-set-button-background desktop\">\n        <button *ngIf=\"displayButton\" type=\"button\" class=\"rankings-set-button\" (click)=\"displayMore()\">\n          {{ displayAll ? 'Afficher moins' : 'Afficher plus' }}\n          <span [ngClass]=\"[displayAll ? 'arrow-up' : 'arrow-down']\"></span>\n        </button>\n      </div>\n    </div>\n  </ng-container>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block;max-width:1100px}.rankings-set-wrapper{-webkit-animation:2s fadein;animation:2s fadein}.rankings-set-top{width:100%;margin-bottom:16px}.rankings-set-down{background:#fff;padding:24px 16px 12px}.rankings-set-title{font-size:2rem;font-weight:600;margin-bottom:16px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.rankings-set-top{display:flex;justify-content:space-between;align-items:center}.rankings-set-down{padding:24px 24px 12px}.rankings-set-title{margin-bottom:0}.rankings-set-rankings-mobile{display:none}}.rankings-set-rankings-desktop{display:none}@media (min-width:1140px){.rankings-set-rankings-desktop{display:flex;justify-content:space-between}}.rankings-set-ranking{flex-grow:1;width:316px}.rankings-set-ranking.margin{margin-left:72px}.rankings-set-button-background{background:#fff}.rankings-set-button{width:100%;color:#2d54d2;font-size:1.4rem;font-weight:500;background-color:rgba(136,154,214,.1);height:48px;border-radius:4px;border-color:transparent;display:flex;align-items:center;justify-content:center}.rankings-set-button:hover{cursor:pointer}.desktop{display:none}@media (min-width:1140px){.rankings-set-button{width:364px;margin:auto}.desktop{display:block}}.arrow-up{width:0;height:0;border-style:solid;border-width:0 5px 5px;border-color:transparent transparent #2d54d2;margin-left:7px;margin-top:3px}.arrow-down{width:0;height:0;border-style:solid;border-width:5px 5px 0;border-color:#2d54d2 transparent transparent;margin-left:7px;margin-top:3px}.content-container{display:flex;overflow:hidden}.swiper-container{height:100%;display:flex}.swiper-slide{margin-bottom:50px;background-color:#fff}::ng-deep swiper>.swiper.swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet-first,::ng-deep swiper>.swiper.swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet-last,::ng-deep swiper>.swiper.swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet-middle{border:none;width:8px;height:8px;margin:0;background-color:#657478}::ng-deep swiper>.swiper.swiper.s-wrapper.swiper-container-horizontal>.swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-first,::ng-deep swiper>.swiper.swiper.s-wrapper.swiper-container-horizontal>.swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-last{margin:0}"]
                }] }
    ];
    /** @nocollapse */
    RankingsSetComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    RankingsSetComponent.propDecorators = {
        componentRef: [{ type: ViewChild, args: [SwiperComponent,] }],
        directiveRef: [{ type: ViewChild, args: [SwiperDirective,] }],
        apiUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        mulitpleFilters: [{ type: Input, args: ['multipleFilters',] }],
        compareParution: [{ type: Input }],
        includeHS: [{ type: Input }]
    };
    return RankingsSetComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var DEFAULT_SWIPER_CONFIG = {
    direction: 'horizontal',
    slidesPerView: 'auto',
};
/** @type {?} */
var RankingsSetMetadata = {
    declarations: [RankingsSetComponent],
    imports: [CommonModule, HttpClientModule, SwiperModule, SelectModule, IconModule, RankingModule, LoaderModule],
    exports: [RankingsSetComponent],
    providers: [
        {
            provide: SWIPER_CONFIG,
            useValue: DEFAULT_SWIPER_CONFIG,
        },
    ],
};
var RankingsSetModule = /** @class */ (function () {
    function RankingsSetModule() {
    }
    RankingsSetModule.decorators = [
        { type: NgModule, args: [RankingsSetMetadata,] }
    ];
    return RankingsSetModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RealtimeStatsComponent = /** @class */ (function () {
    function RealtimeStatsComponent(http) {
        this.http = http;
        this.isfirstCall = true;
        this.modalOpened = false;
        this.isLoading = true;
        this.isSegmentLoading = false;
        this.tabs = [
            { label: 'Tx de vente', legendLabel: 'Taux de vente', value: 'soldRate', isActive: true },
            { label: 'Tx de rupture', legendLabel: 'Taux de rupture', value: 'soldOutRate', isActive: false },
            {
                label: 'Part de marché',
                legendLabel: 'Part de marché famille ou marché sprint',
                value: 'marketShare',
                isActive: false,
            },
        ];
        this.selectComparisonOptions = [
            { value: 'previousPublication', label: 'Numéro précédent' },
            { value: 'homologousPublication', label: 'Numéro homologue' },
        ];
        this.selectMarketOptions = [{ value: 'marketShare', label: 'Marché SPRINT' }, { value: 'family', label: 'Sous-famille' }];
        this.segmentChange = new EventEmitter();
        this.warehouseChange = new EventEmitter();
        this.marketTypeChange = new EventEmitter();
        this.comparedParutionChange = new EventEmitter();
    }
    Object.defineProperty(RealtimeStatsComponent.prototype, "brandId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._brandId;
        },
        set: /**
         * @param {?} brand
         * @return {?}
         */
        function (brand) {
            this._brandId = brand;
            if (!this.isfirstCall) {
                this.getDataFromWS();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RealtimeStatsComponent.prototype, "valueType", {
        get: /**
         * @return {?}
         */
        function () {
            return this._valueType;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._valueType = value;
            if (this.warehouseStats && this.warehouseStats.warehouses) {
                this.warehouseCurrentPublicationValuesQuartiles = this.getValuesQuartiles(this.warehouseStats.warehouses);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RealtimeStatsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.onTabChanged(this.tabs[0].value);
                        this.valueMarket = this.selectMarketOptions[1].value; // Default market value = family
                        return [4 /*yield*/, this.getDataFromWS()];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?=} fromSegment
     * @return {?}
     */
    RealtimeStatsComponent.prototype.getDataFromWS = /**
     * @param {?=} fromSegment
     * @return {?}
     */
    function (fromSegment) {
        return __awaiter(this, void 0, void 0, function () {
            var httpParams, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (fromSegment) {
                            this.isSegmentLoading = true;
                        }
                        else {
                            this.isLoading = true;
                        }
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        if (this.selectedSegmentId && this.selectedComparedParutionId) {
                            httpParams = new HttpParams().set('publicationId', this.publicationId).set('segmentId', this.selectedSegmentId).set('compareToId', this.selectedComparedParutionId);
                        }
                        else if (this.selectedSegmentId && !this.selectedComparedParutionId) {
                            httpParams = new HttpParams().set('publicationId', this.publicationId).set('segmentId', this.selectedSegmentId);
                        }
                        else if (!this.selectedSegmentId && this.selectedComparedParutionId) {
                            httpParams = new HttpParams().set('publicationId', this.publicationId).set('compareToId', this.selectedComparedParutionId);
                        }
                        else {
                            httpParams = new HttpParams().set('publicationId', this.publicationId);
                        }
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: httpParams,
                            })
                                .toPromise()];
                    case 1:
                        _a.warehouseStats = _b.sent();
                        this.warehouseCurrentPublicationValuesQuartiles = this.getValuesQuartiles(this.warehouseStats.warehouses);
                        this.extractParutions(this.warehouseStats);
                        if (fromSegment) {
                            this.isSegmentLoading = false;
                        }
                        else {
                            this.isLoading = false;
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    RealtimeStatsComponent.prototype.onTabChanged = /**
     * @param {?} tab
     * @return {?}
     */
    function (tab) {
        this.valueType = tab;
        for (var t = void 0, iTab = 0, nbTabs = this.tabs.length; iTab < nbTabs; iTab++) {
            t = this.tabs[iTab];
            if (t.value === tab) {
                this.legendTitle = t.legendLabel;
                break;
            }
        }
    };
    /**
     * @param {?} warehouseId
     * @return {?}
     */
    RealtimeStatsComponent.prototype.onWarehouseChanged = /**
     * @param {?} warehouseId
     * @return {?}
     */
    function (warehouseId) {
        this.selectedWarehouse = warehouseId;
        this.warehouseChange.emit(this.selectedWarehouse);
    };
    /**
     * @param {?} segmentId
     * @return {?}
     */
    RealtimeStatsComponent.prototype.onSegmentChanged = /**
     * @param {?} segmentId
     * @return {?}
     */
    function (segmentId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedSegmentId = segmentId;
                        this.segmentChange.emit(this.selectedSegmentId);
                        return [4 /*yield*/, this.getDataFromWS(true)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} publicationId
     * @return {?}
     */
    RealtimeStatsComponent.prototype.onParutionToCompareChanged = /**
     * @param {?} publicationId
     * @return {?}
     */
    function (publicationId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.comparedParution = this.warehouseStats.comparable.publications.find(function (parution) { return parution.publicationId.toString() === publicationId; });
                        this.selectedComparedParutionId = publicationId;
                        this.comparedParutionChange.emit(this.selectedComparedParutionId);
                        return [4 /*yield*/, this.getDataFromWS()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} tab
     * @return {?}
     */
    RealtimeStatsComponent.prototype.onWarehouseStatsTabChange = /**
     * @param {?} tab
     * @return {?}
     */
    function (tab) {
        this.warehouseStatsCurrentTab = tab;
    };
    /**
     * @param {?} marketValue
     * @return {?}
     */
    RealtimeStatsComponent.prototype.onMarketChanged = /**
     * @param {?} marketValue
     * @return {?}
     */
    function (marketValue) {
        this.valueMarket = marketValue.value ? marketValue.value : marketValue;
        this.warehouseCurrentPublicationValuesQuartiles = this.getValuesQuartiles(this.warehouseStats.warehouses);
        this.marketTypeChange.emit(this.valueMarket);
    };
    /**
     * @return {?}
     */
    RealtimeStatsComponent.prototype.onEvolutionClicked = /**
     * @return {?}
     */
    function () {
        this.isEvol = !this.isEvol;
    };
    /**
     * @private
     * @param {?} warehouses
     * @return {?}
     */
    RealtimeStatsComponent.prototype.getValuesQuartiles = /**
     * @private
     * @param {?} warehouses
     * @return {?}
     */
    function (warehouses) {
        /** @type {?} */
        var tempValueType = this.valueType;
        if (tempValueType === 'marketShare' && this.valueMarket === 'family') {
            tempValueType = 'family';
        }
        /** @type {?} */
        var currentPublicationValues = warehouses.map(function (warehouse) { return warehouse[tempValueType]['currentPublication'].value; });
        currentPublicationValues.sort(function (a, b) { return a - b; }); // Order values
        // Order values
        /** @type {?} */
        var setOfValues = new Set(currentPublicationValues);
        currentPublicationValues = Array.from(setOfValues);
        /** @type {?} */
        var nbItem = currentPublicationValues.length;
        // Calculate the mediane of the values
        /** @type {?} */
        var mediane;
        if (nbItem % 2 !== 0) {
            /** @type {?} */
            var medianeIndex = Math.ceil(nbItem / 2) - 1;
            mediane = currentPublicationValues[medianeIndex];
        }
        else {
            /** @type {?} */
            var middleIndex = nbItem / 2;
            mediane =
                (currentPublicationValues[Math.floor(middleIndex) - 1] + currentPublicationValues[Math.ceil(middleIndex) - 1]) /
                    2;
        }
        // Calculate the first and the third quartile of the values
        /** @type {?} */
        var q1 = currentPublicationValues[Math.ceil(nbItem / 4) - 1];
        /** @type {?} */
        var q3 = currentPublicationValues[Math.ceil((nbItem * 3) / 4) - 1];
        return {
            first: q1,
            mediane: mediane,
            third: q3,
        };
    };
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    RealtimeStatsComponent.prototype.extractParutions = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        /** @type {?} */
        var comparedParutionId = this.selectedComparedParutionId ? this.selectedComparedParutionId : data.comparable.comparePublication;
        this.currentParution = data.comparable.currentPublication;
        this.comparedParution = data.comparable.publications.find(function (parution) { return parution.publicationId.toString() === comparedParutionId; });
        if (!this.comparedParution) {
            this.comparedParution = this.currentParution;
        }
        this.comparableParutions = data.comparable.publications;
        this.comparedParutionChange.emit(this.comparedParution.publicationId.toString());
    };
    /**
     * @param {?} newComparedParution
     * @return {?}
     */
    RealtimeStatsComponent.prototype.updateComparedParution = /**
     * @param {?} newComparedParution
     * @return {?}
     */
    function (newComparedParution) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.comparedParution !== newComparedParution)) return [3 /*break*/, 2];
                        this.comparedParution = newComparedParution;
                        this.selectedComparedParutionId = this.comparedParution.publicationId.toString();
                        this.comparedParutionChange.emit(this.selectedComparedParutionId);
                        return [4 /*yield*/, this.getDataFromWS()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.handleModal();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    RealtimeStatsComponent.prototype.handleModal = /**
     * @return {?}
     */
    function () {
        this.modalOpened = !this.modalOpened;
        if (this.modalOpened) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'visible';
        }
    };
    RealtimeStatsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-realtime-stats',
                    template: "<ng-container *ngIf=\"isLoading; else isLoaded\">\n  <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <lib-compare-parutions [currentPublicationId]=\"publicationId\" [currentParution]=\"currentParution\"\n    [comparedParution]=\"comparedParution\" [comparableParutions]=\"comparableParutions\"\n    (changeComparedParution)=\"onParutionToCompareChanged($event)\" (openModal)=\"handleModal()\">\n  </lib-compare-parutions>\n  <lib-compare-parutions-list *ngIf=\"modalOpened\" [comparablePublications]=\"comparableParutions\" [currentParution]=\"currentParution\" (toCompareParution)=\"updateComparedParution($event)\" (closeModal)=\"handleModal()\"></lib-compare-parutions-list>\n  <div class=\"realtime-stats-wrapper\">\n    <div class=\"map-panel\">\n      <div class=\"switch\">\n        <lib-nav-switch [tabs]=\"tabs\" background=\"slategray\" (tabSelected)=\"onTabChanged($event)\"></lib-nav-switch>\n      </div>\n      <div class=\"map\">\n        <lib-map mode=\"map\" [labelMap]=\"true\" [mapUrl]=\"mapUrl\" [goldUrl]=\"goldUrl\" [accountUrl]=\"accountUrl\"\n          [isInteractive]=\"true\" [isEvol]=\"isEvol\" [market]=\"valueMarket\" [selectedWarehouse]=\"selectedWarehouse\"\n          [warehouseStats]=\"warehouseStats\" [valueType]=\"valueType\"\n          [currentPublicationsQuartile]=\"warehouseCurrentPublicationValuesQuartiles\"\n          (warehouseChange)=\"onWarehouseChanged($event)\"></lib-map>\n      </div>\n      <div class=\"map-additional-panel\">\n        <div class=\"map-legend-normal\" *ngIf=\"!isEvol\">\n          <div class=\"map-legend-title\">{{ legendTitle }}</div>\n          <div class=\"map-legend-bar\">\n            <div class=\"part1\">0-{{ warehouseCurrentPublicationValuesQuartiles.first | percent: '.0-1':'fr' }}</div>\n            <div class=\"part2\">\n              {{ warehouseCurrentPublicationValuesQuartiles.first | percent: '.0-1':'fr' }}-{{\n                warehouseCurrentPublicationValuesQuartiles.mediane | percent: '.0-1':'fr'\n              }}\n            </div>\n            <div class=\"part3\">\n              {{ warehouseCurrentPublicationValuesQuartiles.mediane | percent: '.0-1':'fr' }}-{{\n                warehouseCurrentPublicationValuesQuartiles.third | percent: '.0-1':'fr'\n              }}\n            </div>\n            <div class=\"part4\">{{ warehouseCurrentPublicationValuesQuartiles.third | percent: '.0-1':'fr' }}-100%</div>\n          </div>\n        </div>\n        <div class=\"map-legend-evol\" *ngIf=\"isEvol\">\n          <div class=\"map-legend-title\">\n            Carte en \u00E9volution\n          </div>\n          <div class=\"map-legend-bar\">\n            <div class=\"part1\">- performant</div>\n            <div class=\"part2\"></div>\n            <div class=\"part3\">+ performant</div>\n          </div>\n        </div>\n        <div class=\"map-evol-button\">\n          <button class=\"button-evol\" [class.is-evol]=\"isEvol\" (click)=\"onEvolutionClicked()\">\n            <div class=\"icon-evol\" [ngSwitch]=\"isEvol\">\n              <lib-icon icon=\"close2\" *ngSwitchCase=\"true\"></lib-icon>\n              <lib-icon icon=\"evol\" *ngSwitchDefault></lib-icon>\n            </div>\n            {{ !isEvol ? '\u00C9volution' : 'Retour \u00E0 mes donn\u00E9es' }}\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <hr class=\"separator\" />\n\n    <div class=\"details-panel\">\n      <div class=\"filters\">\n        <lib-select [options]=\"selectMarketOptions\" placeholder=\"Afficher : sous-famille\" ngClassName=\"filter-select\"\n          (change)=\"onMarketChanged($event)\"></lib-select>\n      </div>\n      <div class=\"status\">\n        <div [ngClass]=\"{'not-updated': !warehouseStats.isUpToDate}\">{{ warehouseStats.updateMessage }}</div>\n        <div class=\"not-updated\" *ngIf=\"!warehouseStats.isUpToDate\">Donn\u00E9es non remises \u00E0 jour</div>\n        <div class=\"details\">{{ warehouseStats.updateTooltip }}</div>\n      </div>\n      <div class=\"stats\">\n        <lib-map-warehouse-details [warehouseDetails]=\"warehouseStats\" [publicationId]=\"publicationId\"\n          [currentWarehouse]=\"selectedWarehouse\" [currentParution]=\"currentParution\"\n          [comparedParution]=\"comparedParution\" [comparableParutions]=\"comparableParutions\" [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\" [market]=\"valueMarket\" [isSegmentLoading]=\"isSegmentLoading\" [mevDelay]=\"mevDelay\" [selectedSegmentId]=\"selectedSegmentId\"\n          (warehouseChange)=\"onWarehouseChanged($event)\" (segmentChange)=\"onSegmentChanged($event)\"\n          (tabChange)=\"onWarehouseStatsTabChange($event)\">\n        </lib-map-warehouse-details>\n      </div>\n    </div>\n  </div>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block;background-color:#fff;padding:24px 14px 14px}.realtime-stats-wrapper{display:flex;flex-direction:column}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}:host{padding:24px}.realtime-stats-wrapper{flex-direction:row}.realtime-stats-wrapper .map-panel{margin-right:48px}}.realtime-stats-wrapper .map-panel{flex-grow:1}.realtime-stats-wrapper .map-panel .switch{margin-bottom:30px}.realtime-stats-wrapper .map-panel .switch lib-nav-switch{display:block;margin:0 auto}.realtime-stats-wrapper .map-panel lib-map{max-width:500px;display:block;margin:0 auto}.realtime-stats-wrapper .map-panel .map-legend-title{font-size:1.2rem;font-weight:600}.realtime-stats-wrapper .map-panel .map-legend-bar{display:flex}.realtime-stats-wrapper .map-panel .part1,.realtime-stats-wrapper .map-panel .part2,.realtime-stats-wrapper .map-panel .part3,.realtime-stats-wrapper .map-panel .part4{height:24px;width:100%;margin-top:6px;border-top-width:4px;border-top-style:solid;font-size:1.2rem;color:#657478;vertical-align:bottom;flex:1 1 0;display:flex;align-items:flex-end;justify-content:center}@media (min-width:1140px){.realtime-stats-wrapper .map-panel .switch lib-nav-switch{width:485px;margin-bottom:60px}.realtime-stats-wrapper .map-panel .map-additional-panel{display:flex;justify-content:space-between}}.realtime-stats-wrapper .map-panel .map-evol-button,.realtime-stats-wrapper .map-panel .map-legend-evol,.realtime-stats-wrapper .map-panel .map-legend-normal{flex:1 1 0}.realtime-stats-wrapper .map-panel .map-evol-button{display:flex;justify-content:flex-end}.realtime-stats-wrapper .map-panel .map-evol-button .button-evol{color:#2d54d2;background-color:#fff;font-size:1.4rem;font-weight:600;border:1px solid #2d54d2;border-radius:4px;height:48px;margin-top:26px;width:100%;display:flex;justify-content:center;align-items:center;cursor:pointer;text-decoration:underline}.realtime-stats-wrapper .map-panel .map-evol-button .button-evol:hover{text-decoration:none}.realtime-stats-wrapper .map-panel .map-evol-button .button-evol.is-evol{background-color:rgba(122,140,145,.08);border-color:transparent}.realtime-stats-wrapper .map-panel .map-evol-button .button-evol .icon-evol{width:24px;height:24px;display:inline-flex;margin-right:8px;justify-content:center}.realtime-stats-wrapper .map-panel .map-legend-normal .part1{border-color:#eaeced}.realtime-stats-wrapper .map-panel .map-legend-normal .part2{border-color:#a3a9bf}.realtime-stats-wrapper .map-panel .map-legend-normal .part3{border-color:#596280}.realtime-stats-wrapper .map-panel .map-legend-normal .part4{border-color:#232a40}.realtime-stats-wrapper .map-panel .map-legend-evol .part1{border-color:#e8e4d8}.realtime-stats-wrapper .map-panel .map-legend-evol .part2{border-color:#bfb9a3}.realtime-stats-wrapper .map-panel .map-legend-evol .part3{border-color:#807759}@media (min-width:1140px){.realtime-stats-wrapper .map-panel .map-evol-button .button-evol{width:240px;margin-top:0}.realtime-stats-wrapper .map-panel .map-legend-evol,.realtime-stats-wrapper .map-panel .map-legend-normal{width:300px}.realtime-stats-wrapper .separator{display:none}.realtime-stats-wrapper .details-panel{margin:0;width:414px}}.realtime-stats-wrapper .details-panel{display:flex;flex-direction:column}.realtime-stats-wrapper .details-panel .filters{display:flex;flex-direction:column;margin-bottom:18px}@media (min-width:1140px){.realtime-stats-wrapper .details-panel .filters{flex-direction:row;width:414px;margin-bottom:20px}}.realtime-stats-wrapper .details-panel .filters lib-select{flex-grow:1;margin-top:10px;width:100%}.realtime-stats-wrapper .details-panel .filters lib-select:first-child{margin-top:0}@media (min-width:1140px){.realtime-stats-wrapper .details-panel .filters lib-select{margin-top:0;margin-left:10px}.realtime-stats-wrapper .details-panel .filters lib-select:first-child{margin-left:0}}.separator{margin:30px 0;color:#ececec;border:1px solid #ececec}.status{font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500;color:#657478;text-align:right;margin-bottom:10px}.status .not-updated{color:#ee3251;text-align:right}.details{font-size:1.3rem;font-weight:100;color:#657478;text-align:right}"]
                }] }
    ];
    /** @nocollapse */
    RealtimeStatsComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    RealtimeStatsComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        publicationId: [{ type: Input }],
        mapUrl: [{ type: Input }],
        isEvol: [{ type: Input }],
        mevDelay: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        brandId: [{ type: Input, args: ['brand',] }],
        segmentChange: [{ type: Output }],
        warehouseChange: [{ type: Output }],
        marketTypeChange: [{ type: Output }],
        comparedParutionChange: [{ type: Output }]
    };
    return RealtimeStatsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RealtimeStatsMetadata = {
    declarations: [RealtimeStatsComponent],
    imports: [
        CommonModule,
        PipesModule.forRoot(),
        MapModule,
        CompareParutionsModule,
        MapWarehouseDetailsModule,
        IconModule,
        IncidentsListModule,
        LoaderModule,
        CompareParutionsListModule,
        NavSwitchModule,
        SelectModule,
    ],
    exports: [RealtimeStatsComponent],
};
var RealtimeStatsModule = /** @class */ (function () {
    function RealtimeStatsModule() {
    }
    RealtimeStatsModule.decorators = [
        { type: NgModule, args: [RealtimeStatsMetadata,] }
    ];
    return RealtimeStatsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SalesSegmentComponent = /** @class */ (function () {
    function SalesSegmentComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.isLoading = true;
    }
    Object.defineProperty(SalesSegmentComponent.prototype, "includeHS", {
        set: /**
         * @param {?} includeHS
         * @return {?}
         */
        function (includeHS) {
            this._wsRequestParams.includeHS = includeHS;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentComponent.prototype, "componentId", {
        set: /**
         * @param {?} componentId
         * @return {?}
         */
        function (componentId) {
            this._wsRequestParams.componentId = componentId;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentComponent.prototype, "mulitpleFilters", {
        set: /**
         * @param {?} filters
         * @return {?}
         */
        function (filters) {
            if (filters) {
                this._wsRequestParams = StaticInputProccesor.processMultipleFilters(filters, this._wsRequestParams);
                if (!this.isfirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentComponent.prototype, "titleId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._titleId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentComponent.prototype, "periodId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._periodId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentComponent.prototype, "compareParution", {
        get: /**
         * @return {?}
         */
        function () {
            return this._compareParution;
        },
        set: /**
         * @param {?} compareParution
         * @return {?}
         */
        function (compareParution) {
            if (JSON.stringify(this._compareParution) !== JSON.stringify(compareParution)) {
                this._compareParution = compareParution;
                if (compareParution && compareParution.showCompare) {
                    this._wsRequestParams.periodId = compareParution.refParution.periodId;
                    this._wsRequestParams.compareId = compareParution.compareParution.periodId;
                }
                if (!compareParution.showCompare && !!this._wsRequestParams.compareId) {
                    delete this._wsRequestParams.compareId;
                }
                if (!compareParution.showCompare && !!this._wsRequestParams.periodId) {
                    delete this._wsRequestParams.periodId;
                }
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesSegmentComponent.prototype, "filterMarket", {
        get: 
        // family | market | undefined
        /**
         * @return {?}
         */
        function () {
            return this._market;
        },
        set: /**
         * @param {?} market
         * @return {?}
         */
        function (market) {
            this._market = market ? market : 'family';
            this.marketLabel = this._market === 'family' ? 'Sous-famille' : 'Marché';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SalesSegmentComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    SalesSegmentComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.salesSegment = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SalesSegmentComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-sales-segment',
                    template: "<div class=\"container\">\n  <ng-container *ngIf=\"isLoading; else isLoaded\">\n    <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\"></lib-loader>\n  </ng-container>\n  <ng-template #isLoaded>\n    <div class=\"container-title\">R\u00E9partition des ventes par segment</div>\n    <div class=\"container-content\">\n      <div class=\"container-content-top\">\n        <lib-sales-segment-line\n          [isMain]=\"true\"\n          [salesSegmentLine]=\"salesSegment[0]\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [filterMarket]=\"filterMarket\"\n          [marketLabel]=\"marketLabel\"\n          [compareMode]=\"compareParution?.showCompare\"\n        ></lib-sales-segment-line>\n      </div>\n      <div class=\"container-content-middle\">\n        <div class=\"container-content-middle-label\" [ngClass]=\"{ 'no-margin': salesSegment.length === 1 }\">\n          <div class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 1 && salesSegment[1]?.values?.displayCode['value'] > 1}\">Ventes</div>\n          <div *ngIf=\"!compareParution?.showCompare\" class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 2 && salesSegment[2]?.values?.displayCode['mirror'] > 1}\">Ann\u00E9e-1</div>\n          <div *ngIf=\"compareParution?.showCompare\" class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 2 && salesSegment[2]?.values?.displayCode['mirror'] > 1}\">Parution comp.</div>\n          <div class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 3 && (salesSegment[3]?.values?.displayCode)[filterMarket] > 1}\">{{ marketLabel }}</div>\n        </div>\n        <ng-container *ngIf=\"salesSegment.length > 1; else noDataAvailable\">\n          <ng-container *ngFor=\"let segment of (salesSegment | slice: 1:4); let i = index;\">\n            <lib-sales-segment-line\n              [line]=\"(i + 1)\"\n              [goldUrl]=\"goldUrl\"\n              [accountUrl]=\"accountUrl\"\n              [salesSegmentLine]=\"segment\"\n              [filterMarket]=\"filterMarket\"\n              [marketLabel]=\"marketLabel\"\n              [compareMode]=\"compareParution?.showCompare\"\n              class=\"container-content-line\"\n            >\n            </lib-sales-segment-line>\n          </ng-container>\n        </ng-container>\n        <ng-template #noDataAvailable>\n          <div class=\"container-content-nodata\">\n            Pas de donn\u00E9es disponibles\n          </div>\n        </ng-template>\n      </div>\n      <div class=\"container-content-low\">\n        <div class=\"container-content-low-label\">\n          <div class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 4 && salesSegment[4]?.values?.displayCode['value'] > 1}\">Ventes</div>\n          <div *ngIf=\"!compareParution?.showCompare\" class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 5 && salesSegment[5]?.values?.displayCode['mirror'] > 1}\">Ann\u00E9e-1</div>\n          <div *ngIf=\"compareParution?.showCompare\" class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 5 && salesSegment[5]?.values?.displayCode['mirror'] > 1}\">Parution comp.</div>\n          <div class=\"container-content-desktop-label\" [ngClass]=\"{'text-blur': salesSegment.length > 6 && (salesSegment[6]?.values?.displayCode)[filterMarket] > 1}\">{{ marketLabel }}</div>\n        </div>\n        <ng-container *ngIf=\"salesSegment.length > 4; else noDataAvailable\">\n          <ng-container *ngFor=\"let segment of (salesSegment | slice: 4:7); let i = index;\">\n            <lib-sales-segment-line\n              [line]=\"(i + 1)\"\n              [goldUrl]=\"goldUrl\"\n              [accountUrl]=\"accountUrl\"\n              [salesSegmentLine]=\"segment\"\n              [filterMarket]=\"filterMarket\"\n              [marketLabel]=\"marketLabel\"\n              [compareMode]=\"compareParution?.showCompare\"\n              class=\"container-content-line\"\n            >\n            </lib-sales-segment-line>\n          </ng-container>\n        </ng-container>\n        <ng-template #noDataAvailable>\n          <div class=\"container-content-nodata\">\n            Pas de donn\u00E9es disponibles\n          </div>\n        </ng-template>\n      </div>\n    </div>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block;padding:24px 0}.container{color:#0f1112}.container .container-title{font-size:2rem;font-weight:600;line-height:2.4;margin-bottom:24px}.container .container-content{background-color:#fff;padding:24px 16px}.container .container-content-top{margin-bottom:20px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container .container-content{padding:22px;display:flex;justify-content:space-between;align-items:flex-start}.container .container-content-top{margin-bottom:0}.container .container-content-low,.container .container-content-middle{height:200px}}.container .container-content-low,.container .container-content-middle{display:flex;flex-direction:column;justify-content:space-between}.container .container-content-low .container-content-line,.container .container-content-middle .container-content-line{margin-bottom:20px}.container .container-content-low .container-content-line:last-child,.container .container-content-middle .container-content-line:last-child{margin-bottom:0}.container .container-content-low-label,.container .container-content-middle-label{display:flex;justify-content:flex-end;font-size:1.2rem;line-height:1.67}.container .container-content-low-label .container-content-desktop-label,.container .container-content-middle-label .container-content-desktop-label{display:none}.container .container-content-low-label .container-content-desktop-label.text-blur,.container .container-content-middle-label .container-content-desktop-label.text-blur{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}.container .container-content-low-label{padding-top:16px}@media (min-width:1140px){.container .container-content-low .container-content-nodata,.container .container-content-middle .container-content-nodata{margin:auto;font-weight:700;color:#ee3251}.container .container-content-low-label .container-content-desktop-label,.container .container-content-middle-label .container-content-desktop-label{display:block;margin-left:20px}.container .container-content-low-label{padding-top:0}}"]
                }] }
    ];
    /** @nocollapse */
    SalesSegmentComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    SalesSegmentComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        includeHS: [{ type: Input }],
        componentId: [{ type: Input }],
        mulitpleFilters: [{ type: Input, args: ['multipleFilters',] }],
        compareParution: [{ type: Input }],
        filterMarket: [{ type: Input }]
    };
    return SalesSegmentComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SalesSegmentMetadata = {
    declarations: [SalesSegmentComponent],
    imports: [CommonModule, HttpClientModule, SalesSegmentLineModule, LoaderModule],
    exports: [SalesSegmentComponent],
};
var SalesSegmentModule = /** @class */ (function () {
    function SalesSegmentModule() {
    }
    SalesSegmentModule.decorators = [
        { type: NgModule, args: [SalesSegmentMetadata,] }
    ];
    return SalesSegmentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SalesStatisticPageFiltersComponent = /** @class */ (function () {
    function SalesStatisticPageFiltersComponent(http) {
        this.http = http;
        this.isfirstCall = true;
        this._wsRequestParams = {};
        this.titleSelected = false;
        this.titleSelector = null;
        this.periodSelector = null;
        this.marketSelector = null;
        this.showCompareModal = false;
        this.showCompareComponents = false;
        this.refParution = null;
        this.compareParution = null;
        this.titleChanged = new EventEmitter();
        this.slidingYearChanged = new EventEmitter();
        this.marketChanged = new EventEmitter();
        this.toCompareParution = new EventEmitter();
    }
    Object.defineProperty(SalesStatisticPageFiltersComponent.prototype, "groupIdFunction", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this.groupId = brandEditor.editor.value;
            this.brandId = brandEditor.brand.value;
            this.titleChanged.emit(null);
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            this.periodSelector = null;
            this.titleSelector = null;
            this.titleSelected = false;
            this.refParution = null;
            this.compareParution = null;
            this.resetCompareParutions();
            this.showCompareComponents = !!this.refParution && !!this.compareParution;
            if (!this.groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this.brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: {
                                    componentId: this.componentId,
                                    brand: params.brand,
                                    groupId: params.groupId,
                                },
                            })
                                .toPromise()];
                    case 1:
                        _a.filters = _b.sent();
                        this.isLoading = false;
                        this.enabled(false);
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.getPublicationsByTitleForHistory = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http
                            .get(this.baseUrl + "/publications-for-history", {
                            withCredentials: true,
                            params: {
                                brand: params.brand,
                                titleId: this.titleSelector ? this.titleSelector.value : null,
                            },
                        })
                            .toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Disabled or not some filters in select
     * TODO : Fix dinamically
     * @param enable false to disabled
     */
    /**
     * Disabled or not some filters in select
     * TODO : Fix dinamically
     * @param {?} enable false to disabled
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.enabled = /**
     * Disabled or not some filters in select
     * TODO : Fix dinamically
     * @param {?} enable false to disabled
     * @return {?}
     */
    function (enable) {
        /** @type {?} */
        var temp = JSON.parse(JSON.stringify(this.filters));
        if (enable) {
            temp.date_filter[2].disabled = false;
            temp.date_filter[3].disabled = false;
        }
        else {
            temp.date_filter[2].disabled = true;
            temp.date_filter[3].disabled = true;
        }
        this.filters = temp;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.handleTitleChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var value = event && event.value ? event.value : event;
        this.titleSelected = !!value;
        this.enabled(!!value);
        if (this.titleSelected && !this.filters.date_filter.find(function (el) { return el.value === 'compare'; })) {
            this.filters.date_filter.push({
                value: 'compare',
                label: 'Choisir deux parutions',
            });
        }
        else if (!this.titleSelected && this.filters.date_filter.find(function (el) { return el.value === 'compare'; })) {
            this.filters.date_filter.pop();
        }
        this.refParution = null;
        this.compareParution = null;
        this.showCompareComponents = !!this.refParution && !!this.compareParution;
        this.periodSelector = null;
        this.titleSelector = event;
        this.resetCompareParutions();
        this.titleChanged.emit(value);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.handleSlidingYearsChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var value, _a, valueToEmit;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        value = event && event.value ? event.value : event;
                        this.showCompareModal = value === 'compare';
                        if (!(value === 'compare')) return [3 /*break*/, 2];
                        this.handleBodyOverflow();
                        this.modalLoading = true;
                        _a = this;
                        return [4 /*yield*/, this.getPublicationsByTitleForHistory(this._wsRequestParams)];
                    case 1:
                        _a.parutionsList = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.refParution = null;
                        this.compareParution = null;
                        this.resetCompareParutions();
                        this.showCompareComponents = !!this.refParution && !!this.compareParution;
                        _b.label = 3;
                    case 3:
                        this.periodSelector = event;
                        valueToEmit = value === 'compare' ? 5 : value;
                        this.slidingYearChanged.emit(valueToEmit);
                        this.modalLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.handleMarketChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var value = event && event.value ? event.value : event;
        this.marketChanged.emit(value);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.handleTitleModelChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event === null) {
            this.marketSelector = null;
            this.marketChanged.emit(null);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.handleMarketModelChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.marketSelector = event;
    };
    /**
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.handleModal = /**
     * @return {?}
     */
    function () {
        this.showCompareModal = !this.showCompareModal;
        this.handleBodyOverflow();
        if (!this.showCompareModal && !(this.refParution && this.compareParution)) {
            this.periodSelector = null;
            this.refParution = null;
            this.compareParution = null;
        }
    };
    /**
     * @param {?} selectedParution
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.selectedParution = /**
     * @param {?} selectedParution
     * @return {?}
     */
    function (selectedParution) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.modalLoading = true;
                        this.refParution = selectedParution;
                        _a = this;
                        return [4 /*yield*/, this.getPublicationsByTitleForHistory(this._wsRequestParams)];
                    case 1:
                        _a.initalComparableParutions = _b.sent();
                        this.parutionsCompareList = this.initalComparableParutions.filter(function (publication) { return publication.publicationId !== selectedParution.publicationId; });
                        this.modalLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} comparedParution
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.comparedParution = /**
     * @param {?} comparedParution
     * @return {?}
     */
    function (comparedParution) {
        this.compareParution = comparedParution;
        this.showCompareModal = false;
        this.showCompareComponents = !!this.refParution && !!this.compareParution;
        this.handleBodyOverflow();
        /** @type {?} */
        var toEmit = {
            showCompare: true,
            refParution: this.refParution,
            compareParution: this.compareParution,
            comparableParutions: this.initalComparableParutions,
        };
        this.toCompareParution.emit(toEmit);
    };
    /**
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.resetCompareParutions = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var toEmit = {
            showCompare: false,
            refParution: null,
            compareParution: null,
            comparableParutions: null,
        };
        this.toCompareParution.emit(toEmit);
    };
    /**
     * @return {?}
     */
    SalesStatisticPageFiltersComponent.prototype.handleBodyOverflow = /**
     * @return {?}
     */
    function () {
        if (this.showCompareModal) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
    };
    SalesStatisticPageFiltersComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-sales-statistic-page-filters',
                    template: "<div class=\"container\">\n  <ng-container>\n    <lib-loader [loaderText]=\"loadingMessage\" *ngIf=\"isLoading; else isLoaded\"></lib-loader>\n  </ng-container>\n  <ng-template #isLoaded>\n    <ng-container *ngIf=\"!showCompareModal; else showModal\">\n      <div class=\"asterisk\">Donn\u00E9es bas\u00E9es sur les parutions dont le taux de retour est > \u00E0 95%</div>\n      <div class=\"container-title-filters\">\n        <div class=\"select-list\">\n          <div class=\"title-selector-container\">\n          <span class=\"title-selector-label\" *ngIf=\"!brandId\">{{\n            'S\u00E9lectionnez une marque avant de choisir un titre'\n            }}</span>\n            <lib-select\n              class=\"select title-selector\"\n              [options]=\"filters?.title_filter\"\n              placeholder=\"Selectionner un titre\"\n              ngClassName=\"filter-select\"\n              [disabled]=\"!brandId\"\n              (change)=\"handleTitleChange($event)\"\n              (modelChange)=\"handleTitleModelChange($event)\"\n              clearable=\"true\"\n              [model]=\"titleSelector\"\n            ></lib-select>\n          </div>\n          <lib-select\n            class=\"select sliding-year-selector\"\n            [options]=\"filters?.date_filter\"\n            placeholder=\"Ann\u00E9e glissante\"\n            ngClassName=\"filter-select\"\n            (modelChange)=\"handleSlidingYearsChange($event)\"\n            [model]=\"periodSelector\"\n          ></lib-select>\n          <lib-select\n            class=\"select market-selector\"\n            [options]=\"filters?.market_filter\"\n            placeholder=\"VS Sous-famille\"\n            ngClassName=\"filter-select\"\n            [disabled]=\"!titleSelected\"\n            (change)=\"handleMarketChange($event)\"\n            (modelChange)=\"handleMarketModelChange($event)\"\n            [model]=\"marketSelector\"\n          ></lib-select>\n        </div>\n        <h2 class=\"title\">{{ filters?.component_label }}</h2>\n      </div>\n    </ng-container>\n    <ng-template #showModal>\n      <!--      TODO MODAL COMPARE     -->\n      <lib-compare-parutions-list *ngIf=\"!refParution\" [comparablePublications]=\"parutionsList\" [currentTitle]=\"titleSelector?.label\" [isLoading]=\"modalLoading\" (closeModal)=\"handleModal()\" (toCompareParution)=\"selectedParution($event)\"></lib-compare-parutions-list>\n      <lib-compare-parutions-list *ngIf=\"refParution\" [comparablePublications]=\"parutionsCompareList\" [isLoading]=\"modalLoading\" [currentParution]=\"refParution\" (closeModal)=\"handleModal()\" (toCompareParution)=\"comparedParution($event)\"></lib-compare-parutions-list>\n    </ng-template>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.asterisk{color:#657478;text-align:left;margin-bottom:5px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container-title-filters{display:flex;justify-content:space-between;align-items:center}.asterisk{text-align:right}}.select-list{-webkit-animation:2s fadein;animation:2s fadein;display:flex;justify-content:space-between;flex-wrap:wrap;margin:-4px}@media (min-width:1140px){.select-list{order:2;flex-wrap:nowrap;margin:0 -8px}}.select-list .select{flex-grow:1;margin:4px}@media (max-width:1139px){.title-selector-container{width:100%}}@media (min-width:1140px){.select-list .select{margin:0 8px}.select-list .sliding-year-selector{width:192px}.select-list .market-selector{width:170px}.title-selector-container{display:flex;align-items:center}}.title-selector-container .title-selector-label{display:none;margin-right:16px;font-size:1.2rem;font-weight:500;line-height:1.42;text-align:right;color:#8e8e8e}.title{margin:45px 0 0;padding:0}@media (min-width:1140px){.title-selector-container .title-selector-label{display:inline-block;width:267px}.title-selector-container .title-selector{width:267px}.title{order:1;flex-shrink:0;margin:0}}"]
                }] }
    ];
    /** @nocollapse */
    SalesStatisticPageFiltersComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    SalesStatisticPageFiltersComponent.propDecorators = {
        baseUrl: [{ type: Input }],
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        groupIdFunction: [{ type: Input, args: ['brandEditor',] }],
        titleChanged: [{ type: Output }],
        slidingYearChanged: [{ type: Output }],
        marketChanged: [{ type: Output }],
        toCompareParution: [{ type: Output }]
    };
    return SalesStatisticPageFiltersComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SalesStatisticPageFiltersMetadata = {
    declarations: [SalesStatisticPageFiltersComponent],
    imports: [CommonModule, HttpClientModule, SelectModule, LoaderModule, CompareParutionsListModule],
    exports: [SalesStatisticPageFiltersComponent],
};
var SalesStatisticPageFiltersModule = /** @class */ (function () {
    function SalesStatisticPageFiltersModule() {
    }
    SalesStatisticPageFiltersModule.decorators = [
        { type: NgModule, args: [SalesStatisticPageFiltersMetadata,] }
    ];
    return SalesStatisticPageFiltersModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SalesStatsComponent = /** @class */ (function () {
    function SalesStatsComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.subscription = 0;
        this.isLoading = true;
        this.marketShare = false;
    }
    Object.defineProperty(SalesStatsComponent.prototype, "mulitpleFilters", {
        set: /**
         * @param {?} filters
         * @return {?}
         */
        function (filters) {
            if (filters) {
                this._wsRequestParams = StaticInputProccesor.processMultipleFilters(filters, this._wsRequestParams);
                if (!this.isfirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesStatsComponent.prototype, "compareParution", {
        get: /**
         * @return {?}
         */
        function () {
            return this._compareParution;
        },
        set: /**
         * @param {?} compareParution
         * @return {?}
         */
        function (compareParution) {
            if (JSON.stringify(this._compareParution) !== JSON.stringify(compareParution)) {
                this._compareParution = compareParution;
                if (compareParution && compareParution.showCompare) {
                    this._wsRequestParams.periodId = compareParution.refParution.periodId;
                    this._wsRequestParams.compareId = compareParution.compareParution.periodId;
                }
                if (!compareParution.showCompare && !!this._wsRequestParams.compareId) {
                    delete this._wsRequestParams.compareId;
                }
                if (!compareParution.showCompare && !!this._wsRequestParams.periodId) {
                    delete this._wsRequestParams.periodId;
                }
                if (!this.isfirstCall) {
                    this.getDataFromWS(this._wsRequestParams);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesStatsComponent.prototype, "componentId", {
        set: /**
         * @param {?} componentId
         * @return {?}
         */
        function (componentId) {
            this._wsRequestParams.componentId = componentId;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesStatsComponent.prototype, "includeHS", {
        set: /**
         * @param {?} includeHS
         * @return {?}
         */
        function (includeHS) {
            this._wsRequestParams.includeHS = includeHS;
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesStatsComponent.prototype, "titleId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._titleId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesStatsComponent.prototype, "periodId", {
        get: /**
         * @return {?}
         */
        function () {
            return this._periodId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SalesStatsComponent.prototype, "marketIdFunction", {
        get: /**
         * @return {?}
         */
        function () {
            return this.marketId;
        },
        set: /**
         * @param {?} filterMarket
         * @return {?}
         */
        function (filterMarket) {
            if (filterMarket) {
                this.marketId = filterMarket;
            }
            else {
                this.marketId = 'family';
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SalesStatsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.apiUrl.indexOf('/title-marketshares') !== -1) {
                            this.marketShare = true;
                        }
                        return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    SalesStatsComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.stat = _b.sent();
                        if (typeof this.stat.marketSprint !== 'undefined' && this.marketId === 'market') {
                            this.stat.value = this.stat.marketSprint;
                        }
                        this.subscription = 0;
                        if (this.stat.displayCode) {
                            Object.keys(this.stat.displayCode).forEach(function (key) {
                                if (_this.stat.displayCode[key] > _this.subscription) {
                                    _this.subscription = _this.stat.displayCode[key];
                                }
                            });
                        }
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SalesStatsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-sales-stats',
                    template: "<div class=\"sales-container\" [ngClass]=\"{'text-blur': subscription > 1}\">\n  <lib-button-gold\n    *ngIf=\"subscription > 1\"\n    [goldUrl]=\"goldUrl\"\n    [text]=\"stat?.label\"\n    [blur]=\"true\"\n    [center]=\"true\"\n    [accountUrl]=\"accountUrl\"\n    [subscription]=\"subscription\"\n    type=\"button\"\n  ></lib-button-gold>\n  <ng-container>\n    <lib-loader [loaderText]=\"loadingMessage\" *ngIf=\"isLoading; else isLoaded\"></lib-loader>\n  </ng-container>\n\n  <ng-template #isLoaded>\n    <div class=\"sales-container-header\">\n      <div class=\"sales-container-header-major\">\n        <div *ngIf=\"stat?.isPercent\" class=\"sales-container-header-major-circle\">\n          <lib-percentage-circle *ngIf=\"subscription === 1\" [percentage]=\"stat?.value * 100\" color=\"blue-stats\" size=\"46\"></lib-percentage-circle>\n        </div>\n        <ng-container *ngIf=\"stat?.isPercent\">\n          <div *ngIf=\"stat?.isFloat\" class=\"sales-container-header-major-part\">\n            {{ stat?.value * 100 | number: '.0-1':'fr-FR' }}\n          </div>\n          <div *ngIf=\"!stat?.isFloat\" class=\"sales-container-header-major-part\">\n            {{ stat?.value * 100 | number: '.0-0':'fr-FR' }}\n          </div>\n          <div class=\"sales-container-header-major-indicator\">%</div>\n        </ng-container>\n        <ng-container *ngIf=\"!stat?.isPercent\">\n          <div *ngIf=\"stat?.isFloat\" class=\"sales-container-header-major-part\">\n            {{ stat?.value / 1000 | number: '.0-1':'fr-FR' }}\n          </div>\n          <div *ngIf=\"!stat?.isFloat\" class=\"sales-container-header-major-part\">\n            {{ stat?.value / 1000 | number: '.0-0':'fr-FR' }}\n          </div>\n          <div class=\"sales-container-header-major-indicator\">k</div>\n        </ng-container>\n      </div>\n      <div class=\"sales-container-header-label\">{{ stat?.label }}</div>\n    </div>\n    <div class=\"sales-container-footer\">\n      <div\n        class=\"sales-container-footer-left\"\n        [ngClass]=\"{ bordered: (marketId === 'family' && stat?.family) || (marketId === 'market' && stat?.market) }\"\n      >\n        <div *ngIf=\"!compareParution?.showCompare\">Evol. Ann\u00E9e -1</div>\n        <div *ngIf=\"compareParution?.showCompare\">Evol. parution compar\u00E9e</div>\n        <div *ngIf=\"stat?.isPercent\" class=\"sales-container-footer-left-datas\">\n          <div>{{ stat?.mirror * 100 | addSign }}</div>\n          <div>pts</div>\n        </div>\n        <div *ngIf=\"!stat?.isPercent\" class=\"sales-container-footer-left-datas\">\n          <div>{{ stat?.mirror * 100 | addSign }}</div>\n          <div>%</div>\n        </div>\n        <div *ngIf=\"marketShare\">\n          <div *ngIf=\"marketId === 'market'\">March\u00E9 SPRINT</div>\n          <div *ngIf=\"marketId !== 'market'\">Sous-famille</div>\n        </div>\n      </div>\n      <div *ngIf=\"marketId === 'market' && stat?.market\" class=\"sales-container-footer-right\">\n        <div *ngIf=\"stat.isPercent\">March\u00E9 SPRINT</div>\n        <div *ngIf=\"!stat.isPercent\">Evol. march\u00E9</div>\n        <div *ngIf=\"stat.isPercent\" class=\"sales-container-footer-right-datas\">\n          {{ stat.market * 100 | number: '.0-1':'fr-FR' }}%\n        </div>\n        <div *ngIf=\"!stat.isPercent\" class=\"sales-container-footer-right-datas\">{{ stat.market * 100 | addSign }}%</div>\n      </div>\n      <div *ngIf=\"marketId === 'family' && stat?.family\" class=\"sales-container-footer-right\">\n        <div>Sous-famille</div>\n        <div *ngIf=\"stat.isPercent\" class=\"sales-container-footer-right-datas\">\n          {{ stat.family * 100 | number: '.0-1':'fr-FR' }}%\n        </div>\n        <div *ngIf=\"!stat.isPercent\" class=\"sales-container-footer-right-datas\">{{ stat.family * 100 | addSign }}%</div>\n      </div>\n    </div>\n  </ng-template>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.sales-container-footer,.sales-container-header-label,.sales-container-header-major{display:flex}.sales-container{font-family:Poppins,sans-serif;color:#0f1112;background:#ebedf3;padding:24px 16px;height:100%;box-sizing:border-box;position:relative}.sales-container-header{-webkit-animation:2s fadein;animation:2s fadein;display:inline-flex;align-items:center}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.sales-container-header{display:block;align-items:baseline}}.sales-container-header .sales-container-header-major{align-items:baseline;font-family:\"Roboto Slab\",serif;color:#2d54d2}.sales-container-header .sales-container-header-major .sales-container-header-major-circle{margin-right:16px;display:inline-flex}.sales-container-header .sales-container-header-major .sales-container-header-major-part{font-size:5.6rem;font-weight:100}.sales-container-header .sales-container-header-major .sales-container-header-major-indicator{font-size:2.4rem;font-weight:300}.sales-container-header .sales-container-header-label{margin-left:16px;font-size:1.4rem;font-weight:500}@media (min-width:1140px){.sales-container-header .sales-container-header-label{margin-left:0;margin-bottom:12px}}.sales-container-footer{-webkit-animation:2s fadein;animation:2s fadein;font-size:1.2rem}.sales-container-footer .sales-container-footer-left{color:#657478;padding-right:30px}.sales-container-footer .sales-container-footer-left.bordered{border-right:1px solid #657478}.sales-container-footer .sales-container-footer-left .sales-container-footer-left-datas{font-weight:300;font-size:1.2rem;display:inline-flex}.sales-container-footer .sales-container-footer-right{padding-left:24px}.sales-container-footer .sales-container-footer-right .sales-container-footer-right-datas{font-weight:300;font-size:1.2rem}.sales-container.text-blur .sales-container-footer,.sales-container.text-blur .sales-container-footer-left,.sales-container.text-blur .sales-container-header-label,.sales-container.text-blur .sales-container-header-major{color:transparent!important;text-shadow:0 0 15px rgba(0,0,0,.5)}"]
                }] }
    ];
    /** @nocollapse */
    SalesStatsComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    SalesStatsComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        goldUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        mulitpleFilters: [{ type: Input, args: ['multipleFilters',] }],
        compareParution: [{ type: Input }],
        componentId: [{ type: Input }],
        includeHS: [{ type: Input }],
        marketIdFunction: [{ type: Input, args: ['filterMarket',] }]
    };
    return SalesStatsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SalesStatsMetadata = {
    declarations: [SalesStatsComponent],
    imports: [CommonModule, FormsModule, PercentageCircleModule, PipesModule.forRoot(), LoaderModule, ButtonGoldModule],
    exports: [SalesStatsComponent],
};
var SalesStatsModule = /** @class */ (function () {
    function SalesStatsModule() {
    }
    SalesStatsModule.decorators = [
        { type: NgModule, args: [SalesStatsMetadata,] }
    ];
    return SalesStatsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectTabsComponent = /** @class */ (function () {
    function SelectTabsComponent(http) {
        this.http = http;
        this.tabSelected = new EventEmitter();
        this.loading = true;
    }
    Object.defineProperty(SelectTabsComponent.prototype, "selectedTabValue", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selectedTabValue;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._selectedTabValue = value;
            if (value) {
                this.updateActiveTab();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SelectTabsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var homePageTabsData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                params: {
                                    componentId: this.componentId,
                                },
                            })
                                .toPromise()];
                    case 1:
                        homePageTabsData = _a.sent();
                        this.tabs = homePageTabsData.tabs.map(function (tab) { return ({
                            label: tab.label,
                            value: tab.url,
                            isActive: tab.url === _this.selectedTabValue,
                            updateLabel: tab.updateLabel,
                            tooltip: tab.tooltip,
                            isUpToDate: tab.isUpToDate
                        }); });
                        this.updateActiveTab();
                        this.loading = false;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    SelectTabsComponent.prototype.updateActiveTab = /**
     * @return {?}
     */
    function () {
        if (this.tabs && this.tabs.length > 0) {
            /** @type {?} */
            var isActive = void 0;
            /** @type {?} */
            var activeTab = void 0;
            for (var iTab = 0, nbTabs = this.tabs.length; iTab < nbTabs; iTab++) {
                isActive = this.isSelectedTab(this.tabs[iTab], iTab);
                this.tabs[iTab].isActive = isActive;
                if (isActive) {
                    activeTab = this.tabs[iTab];
                }
            }
            this.onSelectTab(activeTab ? activeTab : this.tabs[1]);
        }
    };
    /**
     * @private
     * @param {?} tab
     * @param {?} index
     * @return {?}
     */
    SelectTabsComponent.prototype.isSelectedTab = /**
     * @private
     * @param {?} tab
     * @param {?} index
     * @return {?}
     */
    function (tab, index) {
        if (!this.selectedTabValue) {
            return index === 1;
        }
        else {
            if (tab.value) {
                return tab.value.substr(tab.value.indexOf('=') + 1) === this.selectedTabValue;
            }
            else {
                return false;
            }
        }
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    SelectTabsComponent.prototype.onSelectTab = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.tabSelected.emit(evt);
    };
    SelectTabsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-select-tabs',
                    template: "<ng-container *ngIf=\"loading\">\n  {{ loadingMessage }}\n</ng-container>\n<div *ngIf=\"!loading\">\n  <lib-nav-tabs\n    [tabs]=\"tabs\"\n    background=\"yellow\"\n    (tabSelected)=\"onSelectTab($event)\"\n    [updateMessage]=\"true\"\n  ></lib-nav-tabs>\n</div>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    SelectTabsComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    SelectTabsComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        componentId: [{ type: Input }],
        currentPage: [{ type: Input }],
        selectedTabValue: [{ type: Input }],
        tabSelected: [{ type: Output }]
    };
    return SelectTabsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var SelectTabsMetadata = {
    declarations: [SelectTabsComponent],
    imports: [CommonModule, FormsModule, HttpClientModule, NavTabsModule],
    exports: [SelectTabsComponent],
};
var SelectTabsModule = /** @class */ (function () {
    function SelectTabsModule() {
    }
    SelectTabsModule.decorators = [
        { type: NgModule, args: [SelectTabsMetadata,] }
    ];
    return SelectTabsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PublicationTimelineComponent = /** @class */ (function () {
    function PublicationTimelineComponent(http) {
        this.http = http;
        // Indicate which timeline to display
        this.displayTimeline = 'inSale';
        // Indicate if the user has started a swipe or not
        this.swipping = false;
        // Record the current position before swipping
        this.coord = 0;
        // Indicate if the popup for alerts is displayed or not
        this.displayHistory = false;
        // Indicate the state of the loading
        this.isLoading = true;
        this.todaysDate = new Date();
        this.dataTimeline = {
            inPreparation: [],
            inSale: [],
            effectiveSales: [],
        };
        this.dataHistory = {
            inPreparation: [],
            inSale: [],
            effectiveSales: [],
        };
        this.dataTimelineStatusAll = [
            {
                name: '',
                date: '',
                type: '',
                status: '',
            },
        ];
    }
    /**
     * Display the history popup
     */
    /**
     * Display the history popup
     * @return {?}
     */
    PublicationTimelineComponent.prototype.openHistory = /**
     * Display the history popup
     * @return {?}
     */
    function () {
        this.displayHistory = true;
    };
    /**
     * Close the history popup
     */
    /**
     * Close the history popup
     * @return {?}
     */
    PublicationTimelineComponent.prototype.closeHistory = /**
     * Close the history popup
     * @return {?}
     */
    function () {
        this.displayHistory = false;
    };
    /**
     * @return {?}
     */
    PublicationTimelineComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var dataTimelineAPI;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: {
                                    publicationId: this.publicationId,
                                },
                            })
                                .toPromise()];
                    case 1:
                        // Get details
                        dataTimelineAPI = _a.sent();
                        this.isLoading = false;
                        _a.label = 2;
                    case 2:
                        // Data for the timeline
                        this.processingData(dataTimelineAPI.inPreparation, this.dataTimeline.inPreparation, -1);
                        this.processingData(dataTimelineAPI.inSale, this.dataTimeline.inSale, dataTimelineAPI.inPreparation.alerts.length);
                        this.processingData(dataTimelineAPI.effectiveSales, this.dataTimeline.effectiveSales, dataTimelineAPI.inSale.alerts.length);
                        this.dataTimelineStatusAll = this.concatenateDataForTimeline();
                        this.displayTimeline = dataTimelineAPI.status;
                        // Data for the alerts history
                        this.dataHistory.inPreparation = dataTimelineAPI.inPreparation.alerts;
                        this.dataHistory.inSale = dataTimelineAPI.inSale.alerts;
                        this.dataHistory.effectiveSales = dataTimelineAPI.effectiveSales.alerts;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} timeline
     * @param {?} dataProcess
     * @param {?} nbAlerts
     * @return {?}
     */
    PublicationTimelineComponent.prototype.processingData = /**
     * @param {?} timeline
     * @param {?} dataProcess
     * @param {?} nbAlerts
     * @return {?}
     */
    function (timeline, dataProcess, nbAlerts) {
        var _this = this;
        /** @type {?} */
        var timelineAlert;
        timelineAlert = {
            name: '',
            date: '',
            type: '',
            status: '',
        };
        /** @type {?} */
        var add = false;
        if (timeline.alerts.length > 0) {
            // If the last alert is a rupture alert then get the first rupture alert instead of the last one (client wish)
            if (timeline.alerts[timeline.alerts.length - 1].title.indexOf('rupture') !== -1) {
                /** @type {?} */
                var firstRuptureAlert = this.findFirstAlert(timeline.alerts, timeline.alerts[timeline.alerts.length - 1].title);
                timelineAlert = {
                    name: firstRuptureAlert.title,
                    date: firstRuptureAlert.date,
                    type: 'alert',
                    status: this.earlier(firstRuptureAlert.date, this.todaysDate) ? 'finished' : 'pending',
                };
            }
            else {
                timelineAlert = {
                    name: timeline.alerts[timeline.alerts.length - 1].title,
                    date: timeline.alerts[timeline.alerts.length - 1].date,
                    type: 'alert',
                    status: this.earlier(timelineAlert.date, this.todaysDate) ? 'finished' : 'pending',
                };
            }
            add = true;
        }
        timeline.steps.forEach(function (stepAPI) {
            /** @type {?} */
            var step = {
                name: stepAPI.name,
                date: stepAPI.date,
                type: 'breakpoint',
                status: _this.earlier(stepAPI.date, _this.todaysDate) ? 'finished' : 'pending',
            };
            if (add === true && _this.earlier(timelineAlert.date, new Date(step.date))) {
                dataProcess.push(timelineAlert);
                add = false;
            }
            dataProcess.push(step);
        });
        if (add === true) {
            dataProcess.push(timelineAlert);
        }
        if (nbAlerts === 0 && (dataProcess.length > 0 && dataProcess[0] && dataProcess[0].status === 'finished')) {
            dataProcess[0].type = 'success';
        }
    };
    /**
     * @return {?}
     */
    PublicationTimelineComponent.prototype.concatenateDataForTimeline = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var concatenateTimeLine = [];
        this.dataTimeline.inPreparation.map(function (data) {
            concatenateTimeLine.push(data);
        });
        this.dataTimeline.inSale.map(function (data) {
            concatenateTimeLine.push(data);
        });
        this.dataTimeline.effectiveSales.map(function (data) {
            concatenateTimeLine.push(data);
        });
        return concatenateTimeLine;
    };
    /**
     * Compares two Date objects and returns a boolean value that represents
     * the result:
     * false if the two dates are equal if the first date is greater than second.
     * true if the first date is less than second.
     * @param date1 First date object to compare.
     * @param date2 Second date object to compare.
     */
    /**
     * Compares two Date objects and returns a boolean value that represents
     * the result:
     * false if the two dates are equal if the first date is greater than second.
     * true if the first date is less than second.
     * @param {?} date1 First date object to compare.
     * @param {?} date2 Second date object to compare.
     * @return {?}
     */
    PublicationTimelineComponent.prototype.earlier = /**
     * Compares two Date objects and returns a boolean value that represents
     * the result:
     * false if the two dates are equal if the first date is greater than second.
     * true if the first date is less than second.
     * @param {?} date1 First date object to compare.
     * @param {?} date2 Second date object to compare.
     * @return {?}
     */
    function (date1, date2) {
        /** @type {?} */
        var d1 = new Date(date1);
        /** @type {?} */
        var d2 = new Date(date2);
        // Check if the first is less than second
        if (d1 > d2) {
            return false;
        }
        return true;
    };
    // Retrieve the first alert in alerts[] array which has the same title as 2nd parameter
    // Retrieve the first alert in alerts[] array which has the same title as 2nd parameter
    /**
     * @param {?} alerts
     * @param {?} title
     * @return {?}
     */
    PublicationTimelineComponent.prototype.findFirstAlert = 
    // Retrieve the first alert in alerts[] array which has the same title as 2nd parameter
    /**
     * @param {?} alerts
     * @param {?} title
     * @return {?}
     */
    function (alerts, title) {
        /** @type {?} */
        var firstAlert = alerts[alerts.length - 1];
        if (alerts.length > 1) {
            for (var i = alerts.length - 1; i >= 0; i--) {
                if (!alerts[i - 1] || alerts[i - 1].title !== title) {
                    firstAlert = alerts[i];
                    break;
                }
            }
        }
        return firstAlert;
    };
    /**
     * Activate the swipe when the user click on the timeline
     */
    /**
     * Activate the swipe when the user click on the timeline
     * @param {?} event
     * @return {?}
     */
    PublicationTimelineComponent.prototype.mousedown = /**
     * Activate the swipe when the user click on the timeline
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.coord = event.clientX;
        this.swipping = true;
    };
    /**
     * Scroll the timeline
     */
    /**
     * Scroll the timeline
     * @param {?} event
     * @return {?}
     */
    PublicationTimelineComponent.prototype.mousemove = /**
     * Scroll the timeline
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.swipping) {
            /** @type {?} */
            var scroll_1 = -event.clientX + this.coord;
            this.timelineSwipe.nativeElement.scrollLeft += scroll_1;
            this.coord = event.clientX;
        }
    };
    /**
     * Stop the swipe
     */
    /**
     * Stop the swipe
     * @param {?} event
     * @return {?}
     */
    PublicationTimelineComponent.prototype.mouseup = /**
     * Stop the swipe
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.swipping = false;
    };
    PublicationTimelineComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-publication-timeline',
                    template: "<section *ngIf=\"!isLoading; else loading\">\n  <button class=\"timeline-history-button-mobile\" (click)=\"openHistory()\">\n    Historique d'alertes\n  </button>\n\n  <lib-alerts-history\n    [saleAlerts]=\"dataHistory.inSale\"\n    [preparationAlerts]=\"dataHistory.inPreparation\"\n    [modalToggled]=\"displayHistory\"\n    (closeHistory)=\"closeHistory()\"\n  ></lib-alerts-history>\n\n  <div class=\"timeline-container-wrapper\">\n    <div class=\"timeline-container\">\n      <div class=\"timeline-navigation-mobile\">\n        <div>{{ displayTimeline | titlecase }}</div>\n      </div>\n\n      <div class=\"timeline-navigation-desktop\">\n        <div>{{ displayTimeline | titlecase }}</div>\n        <a class=\"timeline-history-link-desktop\" (click)=\"openHistory()\">Historique d'alertes</a>\n      </div>\n\n      <div\n        #timelineMobile\n        class=\"timeline-labels\"\n        (mousedown)=\"mousedown($event)\"\n        (mousemove)=\"mousemove($event)\"\n        (mouseup)=\"mouseup($event)\"\n      >\n        <div class=\"timeline-first\"></div>\n        <div\n          *ngFor=\"let step of dataTimelineStatusAll; let i = index\"\n          [ngClass]=\"{ 'timeline-step': true, first: i === 0 }\"\n        >\n          <lib-timeline-label\n            [type]=\"step.type\"\n            [name]=\"step.name\"\n            [date]=\"step.date\"\n            [status]=\"step.status\"\n          ></lib-timeline-label>\n        </div>\n        <div class=\"timeline-last\"></div>\n      </div>\n    </div>\n  </div>\n</section>\n\n<ng-template #loading>\n  {{ loadingMessage }}\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.timeline-history-button-mobile{height:48px;border-radius:4px;border:.7px solid #2d54d2;color:#2d54d2;background-color:transparent;width:100%;font-weight:500;font-size:1.4rem;margin-bottom:42px;cursor:pointer}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.timeline-history-button-mobile{display:none}}.timeline-history-link-desktop{display:inline-block;text-decoration:underline;cursor:pointer;color:#2d54d2;font-size:1.4rem;font-weight:500}.timeline-container{background-color:#fff;margin-right:-16px;margin-left:-16px}@media (min-width:1140px){.timeline-container{flex-grow:1;margin:auto}}.timeline-navigation-mobile{display:flex;align-items:center;height:45px;justify-content:space-between;font-size:1.6rem;font-weight:600;padding:0 20px}.timeline-navigation-mobile:after{content:'';position:absolute;left:0;right:0;height:2px;background-color:rgba(15,17,18,.12);margin-top:45px}.timeline-navigation-desktop{display:none}.timeline-icon{color:rgba(45,84,210,.3);cursor:pointer}.timeline-icon.chevron-left{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.timeline-icon.active{color:#2d54d2}.timeline-icon.desktop{display:none}@media (min-width:1140px){.timeline-navigation-mobile{display:none}.timeline-navigation-desktop{display:flex;justify-content:space-between;padding:16px 28px 0;margin-bottom:35px;font-size:1.6rem;font-weight:600}.timeline-icon.desktop{display:flex;color:#fff;padding:30px;cursor:auto}.timeline-icon.desktop.active{color:#2d54d2;cursor:pointer}}.timeline-first{background-image:linear-gradient(to right,#fff,#b7b7b7);height:2px;min-width:70px}.timeline-last{height:2px;background-image:linear-gradient(90deg,transparent,transparent 50%,#fff 50%,#fff 100%),linear-gradient(90deg,#b7b7b7,#b7b7b7,#fff);background-size:20px 3px,100% 3px;border:none;min-width:130px}.timeline-labels{padding:45px 24px 35px;display:flex;overflow:auto;-ms-overflow-style:none;overflow:-moz-scrollbars-none;scrollbar-width:none}.timeline-labels::-webkit-scrollbar{display:none}.timeline-step{flex-grow:1;height:48px;min-width:140px}.timeline-step.first{flex-grow:0;min-width:0}@media (min-width:1140px){.timeline-labels{padding-top:24px}.timeline-step{min-width:inherit}.timeline-container-wrapper{display:flex;background-color:#fff}}"]
                }] }
    ];
    /** @nocollapse */
    PublicationTimelineComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    PublicationTimelineComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        componentId: [{ type: Input }],
        publicationId: [{ type: Input }],
        timelineSwipe: [{ type: ViewChild, args: ['timelineMobile',] }]
    };
    return PublicationTimelineComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimelineLabelComponent = /** @class */ (function () {
    function TimelineLabelComponent() {
        this.display = true;
    }
    TimelineLabelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-timeline-label',
                    template: "<div [ngClass]=\"{ 'timeline-label-container': true, dashed: status === 'pending', solid: status === 'finished' }\">\n  <div *ngIf=\"type === 'breakpoint'\" class=\"timeline-label-breakpoint\"></div>\n  <img *ngIf=\"type === 'alert'\" class=\"timeline-label-alert\" src=\"assets/icons/error.svg\" />\n  <img *ngIf=\"type === 'success'\" class=\"timeline-label-success\" src=\"assets/icons/success.svg\" />\n  <div class=\"timeline-label-content-container\">\n    <div [ngClass]=\"{ 'timeline-label-name': true, alert: type === 'alert' }\">{{ name }}</div>\n    <div [ngClass]=\"{ 'timeline-label-date': true, alert: type === 'alert' }\">{{ date | date: 'dd/MM' }}</div>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.timeline-label-container{color:#657478;font-size:1.4rem;font-weight:500;position:relative}.timeline-label-container.solid{border-top:2px solid #b7b7b7}.timeline-label-container.dashed{border-top:2px dashed #b7b7b7;color:#7a8c91}.timeline-label-content-container{position:absolute;left:100%}.timeline-label-name{margin-top:12px;min-width:100px}.timeline-label-name.alert{color:#ff642e}.timeline-label-date{font-size:1.2rem}.timeline-label-date.alert{color:#0f1112}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.timeline-label-name{white-space:nowrap;min-width:inherit}.timeline-label-date{white-space:nowrap}}.timeline-label-alert,.timeline-label-success{position:absolute;top:-14px;right:-10px;z-index:1}.timeline-label-breakpoint{width:9px;height:9px;background-color:#b7b7b7;border-radius:50%;position:absolute;top:-6px;right:-6px;z-index:1}"]
                }] }
    ];
    /** @nocollapse */
    TimelineLabelComponent.ctorParameters = function () { return []; };
    TimelineLabelComponent.propDecorators = {
        type: [{ type: Input }],
        name: [{ type: Input }],
        date: [{ type: Input }],
        status: [{ type: Input }],
        display: [{ type: Input }]
    };
    return TimelineLabelComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var TimelineLabelMetadata = {
    declarations: [TimelineLabelComponent],
    imports: [CommonModule, IconModule],
    exports: [TimelineLabelComponent],
};
var TimelineLabelModule = /** @class */ (function () {
    function TimelineLabelModule() {
    }
    TimelineLabelModule.decorators = [
        { type: NgModule, args: [TimelineLabelMetadata,] }
    ];
    return TimelineLabelModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AlertsHistoryComponent = /** @class */ (function () {
    function AlertsHistoryComponent(http) {
        this.http = http;
        this.closeHistory = new EventEmitter();
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    AlertsHistoryComponent.prototype.onToggleModal = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.closeHistory.emit(evt);
    };
    AlertsHistoryComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-alerts-history',
                    template: "<div class=\"alerts-history-container\" *ngIf=\"modalToggled\">\n  <div class=\"alerts-history-header\">\n    <div class=\"alerts-history-title\">Historique d'alerte</div>\n    <div class=\"alerts-history-close\" (click)=\"onToggleModal($event)\">X</div>\n  </div>\n  <div class=\"alerts-history-body\">\n    <ng-container *ngIf=\"preparationAlerts?.length > 0 || saleAlerts?.length > 0; else noAlerts\">\n      <div class=\"alerts-history-values-preparation\">\n        <div>EN PR\u00C9PARATION</div>\n        <ul class=\"alerts-history-values\">\n          <li *ngFor=\"let alert of preparationAlerts\">\n            {{ alert.date | date: 'dd.MM' }}\n            <span class=\"alert-history-name-alert\">{{ alert.title }}</span>\n            <br/>\n            <div class=\"alert-history-message-alert\">{{ alert.message }}</div>\n          </li>\n        </ul>\n      </div>\n      <div class=\"alerts-history-values-vente\">\n        <div>EN VENTE</div>\n        <ul class=\"alerts-history-values\">\n          <li *ngFor=\"let alert of saleAlerts\">\n            {{ alert.date | date: 'dd.MM' }}\n            <span class=\"alert-history-name-alert\">{{ alert.title }}</span>\n            <br/>\n            <div class=\"alert-history-message-alert\">{{ alert.message }}</div>\n          </li>\n        </ul>\n      </div>\n    </ng-container>\n    <ng-template #noAlerts>\n    <div class=\"no-alerts\">\n      Pas d'alertes\n    </div>\n    </ng-template>\n  </div>\n</div>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:block}.alerts-history-container{background-color:#0f1112;color:#fff;font-weight:500;font-size:2rem;z-index:10200;height:100%;position:fixed;overflow:auto;width:100%;top:0;left:0;overflow-y:scroll;scrollbar-width:none;-ms-overflow-style:none;scroll-behavior:smooth}::-webkit-scrollbar{display:none}.alerts-history-header{display:flex;justify-content:space-between;font-size:2rem;padding:24px 16px 0;margin-bottom:58px;width:75%}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.alerts-history-header{padding:24px 30px 0;margin-bottom:150px;width:95%}}.alerts-history-title{width:100%;text-align:center}.alerts-history-body{padding:0 16px 24px}.alerts-history-values-preparation{margin-bottom:50px}@media (min-width:1140px){.alerts-history-body{display:flex;justify-content:center;padding:0}.alerts-history-values-vente{margin-left:50px;max-width:400px}.alerts-history-values-preparation{max-width:400px}}.alerts-history-values{margin-top:24px;font-size:1.8rem;margin-left:-20px}.alerts-history-values>li{margin-bottom:20px}.alert-history-name-alert{color:#ff642e}.alerts-history-close{cursor:pointer}.alert-history-message-alert{margin-left:-17px}"]
                }] }
    ];
    /** @nocollapse */
    AlertsHistoryComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    AlertsHistoryComponent.propDecorators = {
        saleAlerts: [{ type: Input }],
        preparationAlerts: [{ type: Input }],
        modalToggled: [{ type: Input }],
        closeHistory: [{ type: Output }]
    };
    return AlertsHistoryComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var AlertsHistoryMetadata = {
    declarations: [AlertsHistoryComponent],
    imports: [CommonModule, HttpClientModule],
    exports: [AlertsHistoryComponent],
};
var AlertsHistoryModule = /** @class */ (function () {
    function AlertsHistoryModule() {
    }
    AlertsHistoryModule.decorators = [
        { type: NgModule, args: [AlertsHistoryMetadata,] }
    ];
    return AlertsHistoryModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PublicationTimelineMetadata = {
    declarations: [PublicationTimelineComponent],
    imports: [CommonModule, IconModule, TimelineLabelModule, HttpClientModule, AlertsHistoryModule],
    exports: [PublicationTimelineComponent],
};
var PublicationTimelineModule = /** @class */ (function () {
    function PublicationTimelineModule() {
    }
    PublicationTimelineModule.decorators = [
        { type: NgModule, args: [PublicationTimelineMetadata,] }
    ];
    return PublicationTimelineModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpcomingParutionsListMock = /** @class */ (function () {
    function UpcomingParutionsListMock() {
    }
    /**
     * @return {?}
     */
    UpcomingParutionsListMock.prototype.getMock = /**
     * @return {?}
     */
    function () {
        return {
            filters: {
                filterByItems: [
                    {
                        value: 'val123',
                        label: 'Valeur 123',
                    },
                ],
                orderByItems: [
                    {
                        value: 'val123',
                        label: 'Valeur 123',
                    },
                ],
            },
            publicationsInPreparation: [
                {
                    nbSettledDistributors: null,
                    status: 'Livrée',
                    alerts: [
                        {
                            date: '1995/12/22',
                            title: 'Alerte livraison',
                            message: 'Livré en retard',
                            critical: true,
                        },
                        {
                            date: '1995/12/22',
                            title: 'Alerte rupture',
                            message: 'Quantités incorrectes',
                            critical: false,
                        },
                    ],
                    publication: {
                        name: 'Prima',
                        magazineId: 1,
                        publicationId: '0853',
                        publicationNumber: 440,
                        coverUrl: 'https://picsum.photos/250/300?image=1062',
                        sellingStartDate: '2019-05-10',
                        sellingEndDate: '2019-06-10',
                        nbSold: null,
                        upForSaleRate: null,
                        soldOutRate: null,
                        isPromo: null,
                        status: null,
                        nbWarehousesInAlert: null,
                        warehouseInAlertHref: null,
                    },
                },
                {
                    nbSettledDistributors: null,
                    status: 'Livrée',
                    alerts: [
                        {
                            date: '1995/12/22',
                            title: 'Alerte livraison',
                            message: 'Non livrée',
                            critical: false,
                        },
                    ],
                    publication: {
                        name: 'Management',
                        magazineId: 1,
                        publicationId: '0895',
                        publicationNumber: 271,
                        coverUrl: 'https://picsum.photos/250/300?image=1072',
                        sellingStartDate: '2019-05-13',
                        sellingEndDate: '2019-06-13',
                        nbSold: null,
                        upForSaleRate: null,
                        soldOutRate: null,
                        isPromo: null,
                        status: null,
                        nbWarehousesInAlert: null,
                        warehouseInAlertHref: null,
                    },
                },
                {
                    nbSettledDistributors: null,
                    status: 'Livraison planifiée',
                    alerts: null,
                    publication: {
                        name: 'Harvard Business Review',
                        magazineId: 1,
                        publicationId: '0896',
                        publicationNumber: 32,
                        coverUrl: 'https://picsum.photos/250/300?image=1077',
                        sellingStartDate: '2019-05-10',
                        sellingEndDate: '2019-06-09',
                        nbSold: null,
                        upForSaleRate: null,
                        soldOutRate: null,
                        isPromo: null,
                        status: null,
                        nbWarehousesInAlert: null,
                        warehouseInAlertHref: null,
                    },
                },
                {
                    nbSettledDistributors: null,
                    status: 'Livrée',
                    alerts: null,
                    publication: {
                        name: 'Gala',
                        magazineId: 1,
                        publicationId: '0436',
                        publicationNumber: 1136,
                        coverUrl: 'https://picsum.photos/250/300?image=1057',
                        sellingStartDate: '2019-05-10',
                        sellingEndDate: '2019-06-10',
                        nbSold: null,
                        upForSaleRate: null,
                        soldOutRate: null,
                        isPromo: null,
                        status: null,
                        nbWarehousesInAlert: null,
                        warehouseInAlertHref: null,
                    },
                },
                {
                    nbSettledDistributors: 0,
                    status: 'Réglable',
                    alerts: null,
                    publication: {
                        name: 'Géo',
                        magazineId: 1,
                        publicationId: '0678',
                        publicationNumber: 480,
                        coverUrl: 'https://picsum.photos/250/300?image=1052',
                        sellingStartDate: '2019-05-05',
                        sellingEndDate: '2019-06-05',
                        nbSold: null,
                        upForSaleRate: null,
                        soldOutRate: null,
                        isPromo: null,
                        status: null,
                        nbWarehousesInAlert: null,
                        warehouseInAlertHref: null,
                    },
                },
                {
                    nbSettledDistributors: 300,
                    status: 'Réglable',
                    alerts: null,
                    publication: {
                        name: 'Femme Actuelle',
                        magazineId: 1,
                        publicationId: '0362',
                        publicationNumber: 1791,
                        coverUrl: 'https://picsum.photos/250/300?image=1047',
                        sellingStartDate: '2019-12-20',
                        sellingEndDate: '2020-01-20',
                        nbSold: null,
                        upForSaleRate: null,
                        soldOutRate: null,
                        isPromo: null,
                        status: null,
                        nbWarehousesInAlert: null,
                        warehouseInAlertHref: null,
                    },
                },
            ],
        };
    };
    return UpcomingParutionsListMock;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpcomingParutionsListComponent = /** @class */ (function () {
    function UpcomingParutionsListComponent(http, mock) {
        this.http = http;
        this.mock = mock;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.publicationsPages = [];
        this.isLoading = true;
        this.currentPage = 1;
        this.nbItemPerPage = 24;
        this.savedOrder = null;
        this.savedFilter = null;
        this.filterChange = new EventEmitter();
    }
    Object.defineProperty(UpcomingParutionsListComponent.prototype, "upComingIndicatorFilter", {
        set: /**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            if (filter) {
                if (this.initialPublications) {
                    /** @type {?} */
                    var res = StaticFilters.filterByItems(filter, this.initialPublications, this.parutionsList.publicationsInPreparation, this.savedOrder, this.nbItemPerPage, true);
                    this.parutionsList.publicationsInPreparation = res.list;
                    this.publicationsPages = res.listPages;
                    this.savedFilter = res.savedFilter;
                    this.currentPage = res.currentPage;
                }
            }
            else {
                if (this.initialPublications) {
                    /** @type {?} */
                    var res = StaticFilters.filterByItems('', this.initialPublications, this.parutionsList.publicationsInPreparation, this.savedOrder, this.nbItemPerPage, true);
                    this.parutionsList.publicationsInPreparation = res.list;
                    this.publicationsPages = res.listPages;
                    this.savedFilter = res.savedFilter;
                    this.currentPage = res.currentPage;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpcomingParutionsListComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    UpcomingParutionsListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    UpcomingParutionsListComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.parutionsList = _b.sent();
                        // Capitalize filter label
                        this.parutionsList.filters.filterByItems.forEach(function (item) {
                            /** @type {?} */
                            var uppercaseFirstLetter = item.label.charAt(0).toUpperCase();
                            item.label = uppercaseFirstLetter + item.label.slice(1);
                        });
                        this.initialPublications = this.parutionsList.publicationsInPreparation;
                        res = StaticFilters.setPublicationsPages(this.initialPublications, this.nbItemPerPage);
                        this.publicationsPages = res.listPages;
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Navigate btw pages set by pagination
     * @param page Page number clicked (or set in queryparams)
     */
    /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    UpcomingParutionsListComponent.prototype.paginationPageChange = /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    function (page) {
        this.currentPage = page;
        /** @type {?} */
        var scrollSize = this.anchorForScroll.nativeElement.offsetTop - 110;
        window.scroll({ top: scrollSize, left: 0 });
    };
    /**
     * Creates the content of the tooltip listing all the warehouses alerts
     * @param publication Publication object
     */
    /**
     * Creates the content of the tooltip listing all the warehouses alerts
     * @param {?} publication Publication object
     * @return {?}
     */
    UpcomingParutionsListComponent.prototype.getAlertMessages = /**
     * Creates the content of the tooltip listing all the warehouses alerts
     * @param {?} publication Publication object
     * @return {?}
     */
    function (publication) {
        /** @type {?} */
        var alertMessages = [];
        publication.alerts.forEach(function (alert) {
            alertMessages.push({
                value: alert.message,
                label: alert.title,
            });
        });
        return alertMessages;
    };
    /**
     * Determine color of the status background
     * @param publication Publication object
     */
    /**
     * Determine color of the status background
     * @param {?} publication Publication object
     * @return {?}
     */
    UpcomingParutionsListComponent.prototype.getStatusColor = /**
     * Determine color of the status background
     * @param {?} publication Publication object
     * @return {?}
     */
    function (publication) {
        switch (publication.status.toLowerCase()) {
            case 'livré à presstalis':
            case 'livré à france messagerie':
                return 'green';
            case 'livraison planifiée':
                return 'light-blue';
            case 'réglable':
                return 'blue';
        }
    };
    /**
     * Filter the publications when a filter is selected and emit it
     * @param filter Filter from the select
     */
    /**
     * Filter the publications when a filter is selected and emit it
     * @param {?} filter Filter from the select
     * @return {?}
     */
    UpcomingParutionsListComponent.prototype.onFilterByItems = /**
     * Filter the publications when a filter is selected and emit it
     * @param {?} filter Filter from the select
     * @return {?}
     */
    function (filter) {
        /** @type {?} */
        var filterToEmit = null;
        if (filter) {
            filterToEmit = {
                filterTerm: filter.filterTerm,
                label: filter.label,
                value: filter.value,
                operator: filter.operator,
            };
        }
        this.filterChange.emit(filterToEmit);
    };
    /**
     * Sort publications when an order is selected
     * @param order Filter from the select
     */
    /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    UpcomingParutionsListComponent.prototype.onOrderByItems = /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    function (order) {
        /** @type {?} */
        var res = StaticFilters.orderByItems(order, this.initialPublications, this.parutionsList.publicationsInPreparation, this.savedFilter, this.nbItemPerPage, true);
        this.parutionsList.publicationsInPreparation = res.list;
        this.publicationsPages = res.listPages;
        this.savedOrder = res.savedOrder;
        this.currentPage = res.currentPage;
    };
    UpcomingParutionsListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-upcoming-parutions-list',
                    template: "<ng-container>\n  <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\" *ngIf=\"isLoading; else isLoaded\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div #scrollAnchor class=\"parutions-list\" *ngIf=\"parutionsList && parutionsList.publicationsInPreparation\">\n    <div class=\"parutions-list-header\">\n      <div class=\"parutions-list-header-top\">\n        <div class=\"parutions-list-header-top-title\">\n          <span class=\"parutions-list-header-top-nbpublications\">{{\n            parutionsList.publicationsInPreparation.length\n          }}</span>\n          parutions \u00E0 venir <span class=\"display-on-desktop\">en ce moment</span>\n        </div>\n      </div>\n      <div class=\"parutions-list-header-filters\">\n        <div class=\"parutions-list-header-filters-global\">\n          <lib-select\n            [options]=\"parutionsList.filters.filterByItems\"\n            [model]=\"savedFilter\"\n            placeholder=\"Filter par\"\n            ngClassName=\"filter-select\"\n            clearable=\"true\"\n            (change)=\"onFilterByItems($event)\"\n          ></lib-select>\n        </div>\n        <div class=\"parutions-list-header-filters-date\">\n          <lib-select\n            [options]=\"parutionsList.filters.orderByItems\"\n            placeholder=\"Trier par\"\n            ngClassName=\"filter-select\"\n            clearable=\"true\"\n            (change)=\"onOrderByItems($event)\"\n          ></lib-select>\n        </div>\n      </div>\n    </div>\n    <div class=\"parutions-list-display\">\n      <ng-container *ngFor=\"let publication of publicationsPages[currentPage - 1]; let i = index\">\n        <lib-upcoming-parution\n          *ngIf=\"publication.alerts.length\"\n          class=\"parutions-list-display-item\"\n          [upcomingPublication]=\"publication\"\n          [leftStatus]=\"publication.status\"\n          [leftStatusColor]=\"getStatusColor(publication)\"\n          [rightStatus]=\"{\n            value: publication.alerts.length,\n            label: 'Anomalies',\n            icon: 'info',\n            tooltipContentType: 'list',\n            tooltipContent: getAlertMessages(publication),\n            tooltipPosition: 'top',\n            alertColor: 'orange'\n          }\"\n        >\n        </lib-upcoming-parution>\n        <lib-upcoming-parution\n          *ngIf=\"publication.alerts.length === 0 && publication.status !== 'R\u00E9glable'\"\n          class=\"parutions-list-display-item\"\n          [upcomingPublication]=\"publication\"\n          [leftStatus]=\"publication.status\"\n          [leftStatusColor]=\"getStatusColor(publication)\"\n        >\n        </lib-upcoming-parution>\n        <lib-upcoming-parution\n          *ngIf=\"publication.alerts.length === 0 && publication.status === 'R\u00E9glable'\"\n          class=\"parutions-list-display-item\"\n          [upcomingPublication]=\"publication\"\n          [leftStatus]=\"publication.status\"\n          [leftStatusColor]=\"getStatusColor(publication)\"\n          [rightStatus]=\"{ value: publication.nbSettledDistributors, label: 'diffuseurs r\u00E9gl\u00E9s' }\"\n        >\n        </lib-upcoming-parution>\n      </ng-container>\n    </div>\n    <lib-pagination\n      [numberOfItems]=\"parutionsList.publicationsInPreparation.length\"\n      [itemsPerPage]=\"nbItemPerPage\"\n      [currentPage]=\"currentPage\"\n      (pageChange)=\"paginationPageChange($event)\"\n      *ngIf=\"publicationsPages && publicationsPages.length > 1\"\n    ></lib-pagination>\n  </div>\n</ng-template>\n",
                    providers: [UpcomingParutionsListMock],
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.parutions-list{-webkit-animation:2s fadein;animation:2s fadein;max-width:1100px;color:#0f1112;font-family:Poppins,sans-serif;font-weight:500;font-size:1.4rem}.parutions-list .parutions-list-header-top{justify-content:space-between;align-items:baseline;margin-bottom:15px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.parutions-list .parutions-list-header-filters,.parutions-list .parutions-list-header-top{display:flex}.parutions-list .parutions-list-header-top{margin-bottom:24px}}.parutions-list .parutions-list-header-top-title{font-size:2rem;font-weight:600}.parutions-list .parutions-list-header-top-title .parutions-list-header-top-nbpublications{font-family:\"Roboto Slab\",serif;font-weight:100;font-size:5.6rem;margin-right:8px}.parutions-list .display-on-desktop{display:none}@media (min-width:1140px){.parutions-list .display-on-desktop{display:inline}}.parutions-list .parutions-list-header-top-update{color:#657478}.parutions-list .parutions-list-header-filters{margin-bottom:40px}.parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:50%;margin-right:7px}@media (min-width:1140px){.parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:400px;margin-right:24px}}.parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:50%}.parutions-list .parutions-list-display{display:flex;flex-wrap:wrap}@media (max-width:1139px){.parutions-list .parutions-list-header-filters{display:flex;margin-bottom:16px}.parutions-list .parutions-list-display{margin:0 -3px}.parutions-list .parutions-list-display .parutions-list-display-item{margin:0 7px 24px}}@media (min-width:1140px){.parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:400px}.parutions-list .parutions-list-display .parutions-list-display-item{margin:0 17px 64px}.parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n+1){margin:0 17px 64px 0}.parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n){margin:0 0 64px 17px}}"]
                }] }
    ];
    /** @nocollapse */
    UpcomingParutionsListComponent.ctorParameters = function () { return [
        { type: HttpClient },
        { type: UpcomingParutionsListMock }
    ]; };
    UpcomingParutionsListComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        componentId: [{ type: Input }],
        size: [{ type: Input }],
        upComingIndicatorFilter: [{ type: Input, args: ['upComingIndicatorFilter',] }],
        groupId: [{ type: Input, args: ['brandEditor',] }],
        anchorForScroll: [{ type: ViewChild, args: ['scrollAnchor',] }],
        filterChange: [{ type: Output }]
    };
    return UpcomingParutionsListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpcomingParutionComponent = /** @class */ (function () {
    function UpcomingParutionComponent() {
        this.showTooltip = false;
        this.click = new EventEmitter();
    }
    /**
     * @return {?}
     */
    UpcomingParutionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    Object.defineProperty(UpcomingParutionComponent.prototype, "mevDelayDelta", {
        /**
         * Display the content of the MEV Delta
         * MEV Delta is the difference btw the actual day and the selling start day
         */
        get: /**
         * Display the content of the MEV Delta
         * MEV Delta is the difference btw the actual day and the selling start day
         * @return {?}
         */
        function () {
            this.mevDelay = Math.floor((new Date().getTime() - new Date(this.upcomingPublication.publication.sellingStartDate).getTime()) / (3600000 * 24));
            return this.mevDelay.toString();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UpcomingParutionComponent.prototype, "publicationNumberNTile", {
        /**
         * Display 1st part of publication id & publication number
         */
        get: /**
         * Display 1st part of publication id & publication number
         * @return {?}
         */
        function () {
            return (this.upcomingPublication &&
                this.upcomingPublication.publication.publicationId.toString().split('-', 1) + " \u2022 " + this.upcomingPublication.publication.name + " n\u00B0" + this.upcomingPublication.publication.publicationNumber);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} evt
     * @return {?}
     */
    UpcomingParutionComponent.prototype.handleClicked = /**
     * @param {?} evt
     * @return {?}
     */
    function (evt) {
        this.click.emit(evt);
    };
    /**
     * Detect when the mouse enter the publication div
     */
    /**
     * Detect when the mouse enter the publication div
     * @return {?}
     */
    UpcomingParutionComponent.prototype.mouseHovering = /**
     * Detect when the mouse enter the publication div
     * @return {?}
     */
    function () {
        this.showTooltip = true;
    };
    /**
     * Detect when the mouse leave the publication div
     */
    /**
     * Detect when the mouse leave the publication div
     * @return {?}
     */
    UpcomingParutionComponent.prototype.mouseLeft = /**
     * Detect when the mouse leave the publication div
     * @return {?}
     */
    function () {
        this.showTooltip = false;
    };
    UpcomingParutionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-upcoming-parution',
                    template: "<article class=\"container\">\n  <div class=\"parution-cover\" (mouseenter)=\"mouseHovering()\" (mouseleave)=\"mouseLeft()\">\n    <div class=\"top-status\" *ngIf=\"leftStatus || rightStatus\">\n      <span class=\"day-alert\" *ngIf=\"mevDelayDelta\">J{{ mevDelayDelta }}</span>\n    </div>\n    <div class=\"parution-state\">\n      <div class=\"parution-info\">\n        <div class=\"number-n-title\">\n          {{ publicationNumberNTile }}\n        </div>\n        <div class=\"mev-dates\">\n          <span class=\"promo\" *ngIf=\"upcomingPublication?.publication?.isPromo\">{{ 'promo' }}</span>\n\n          <ng-container *ngIf=\"upcomingPublication?.publication?.sellingEndDate; else noEndDate\">\n            <span\n            >MEV du {{ upcomingPublication?.publication?.sellingStartDate | date: 'dd/MM' }} au\n              {{ upcomingPublication?.publication?.sellingEndDate | date: 'dd/MM' }}</span\n            >\n          </ng-container>\n          <ng-template #noEndDate>\n            <span>MEV \u00E0 partir du {{ upcomingPublication?.publication?.sellingStartDate | date: 'dd/MM' }}</span>\n          </ng-template>\n        </div>\n      </div>\n      <div class=\"left-status\" [ngClass]=\"leftStatusColor\">{{ leftStatus | uppercase }}</div>\n    </div>\n    <div class=\"bottom-status\" *ngIf=\"rightStatus\">\n      <lib-publication-state\n        class=\"right-status\"\n        *ngIf=\"rightStatus\"\n        [value]=\"rightStatus?.value\"\n        [label]=\"rightStatus?.label\"\n        [alertColor]=\"rightStatus?.alertColor\"\n        [icon]=\"rightStatus?.icon\"\n        [tooltipContentType]=\"rightStatus?.tooltipContentType\"\n        [tooltipContent]=\"rightStatus?.tooltipContent\"\n        [tooltipPosition]=\"rightStatus?.tooltipPosition\"\n        [isFromUpcoming]=\"true\"\n        [showTooltip]=\"showTooltip\"\n      >\n      </lib-publication-state>\n    </div>\n  </div>\n  <div\n    *ngIf=\"upcomingPublication.serviceRequests?.requests !== null || upcomingPublication.storeRequests?.requests !== null\"\n    class=\"parution-infos\">\n    <div class=\"info\" *ngIf=\"upcomingPublication.storeRequests?.requests !== null\">\n      <div class=\"sub-info\">\n        <span class=\"big-number\">{{upcomingPublication.storeRequests?.requests}}</span> dem. modif. service\n        diffuseurs\n      </div>\n      <div class=\"sub-info\">\n        <div class=\"flex-container\">\n          <lib-percentage-circle class=\"circle\"\n                                 [percentage]=\"(upcomingPublication.storeRequests?.rate * 100).toFixed(0)\"\n                                 size=\"35\"\n                                 color=\"yellow\">\n          </lib-percentage-circle>\n          <span>{{(upcomingPublication.storeRequests?.rate * 100).toFixed(0)}}\n            % accept\u00E9es (soit {{upcomingPublication.storeRequests?.accepted}}\n            demandes)</span>\n        </div>\n      </div>\n    </div>\n    <hr\n      *ngIf=\"upcomingPublication.serviceRequests?.requests !== null && upcomingPublication.storeRequests?.requests !== null\"\n      class=\"separator\"/>\n    <div class=\"info\" *ngIf=\"upcomingPublication.serviceRequests?.requests !== null\">\n      <div class=\"sub-info\">\n        <span class=\"big-number\">{{upcomingPublication.serviceRequests?.requests}}</span> dont dem. mise en service\n      </div>\n      <div class=\"sub-info\">\n        <div class=\"flex-container\">\n          <lib-percentage-circle class=\"circle\"\n                                 [percentage]=\"(upcomingPublication.serviceRequests?.rate * 100).toFixed(0)\"\n                                 size=\"35\"\n                                 color=\"yellow\">\n          </lib-percentage-circle>\n          <span>{{(upcomingPublication.serviceRequests?.rate * 100).toFixed(0)}}\n            % accept\u00E9es (soit {{upcomingPublication.serviceRequests?.accepted}}\n            demandes)</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</article>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.container{width:168px}.parution-cover{position:relative;height:221px;border-radius:2.7px;background:center/cover no-repeat #fff}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.container{width:249px}.parution-cover{height:328px;border-radius:4px}}.parution-infos{margin-top:10px}.parution-infos .info{padding:5px}.parution-infos .info .sub-info{font-family:Poppins,sans-serif;font-size:1.2rem;font-weight:500;color:#0f1112;margin-bottom:7px}.parution-infos .info .sub-info .big-number{margin-left:3px;font-family:\"Roboto Slab\",serif;font-size:2.2rem;font-weight:400}.parution-infos .info .sub-info .flex-container{display:flex;align-items:center}.parution-infos .info .sub-info .flex-container .circle{margin-right:8px;display:inline-block}.parution-infos .separator{border:1px solid;color:rgba(15,17,18,.1)}.top-status{display:flex;justify-content:flex-end;padding:0 8px}.top-status .day-alert{display:block;justify-content:center;align-items:center;height:20px;margin:0 2px;padding:8px;border-radius:0 0 4px 4px;text-align:right;font-family:\"Roboto Slab\",serif;font-size:1.6rem;line-height:1.33;color:#0f1112;box-shadow:0 2px 6px 0 rgba(122,140,145,.5);background-color:#ffec00}.bottom-status{position:absolute;display:flex;left:0;right:0;bottom:0;padding:16px 8px}.bottom-status .right-status{margin-left:auto}.parution-state .parution-info{text-align:center;margin-top:8px}.parution-state .parution-info .number-n-title{min-height:40px;font-family:\"Roboto Slab\",serif;font-size:1.4rem;line-height:1.43;color:#0f1112}@media (min-width:1140px){.top-status .day-alert{height:24px;font-size:1.8rem}.bottom-status{padding:16px}.parution-state .parution-info{margin-top:70px}.parution-state .parution-info .number-n-title{min-height:inherit;margin-bottom:4px;font-size:1.8rem}}.parution-state .parution-info .mev-dates{display:flex;align-items:center;justify-content:center;font-family:Poppins,sans-serif;font-size:1.3rem;line-height:1.23;color:#7a8c91}.parution-state .left-status{text-align:center;position:relative;border-radius:4px;left:2%;width:96%;margin-top:38px;z-index:10000;font-size:1.3rem;font-weight:600}@media (min-width:1140px){.parution-state .parution-info .mev-dates{font-size:1.4rem}.parution-state .left-status{left:17%;width:66%}}.parution-state .left-status.green{background:#dfebe4;color:#0da54c}.parution-state .left-status.light-blue{background:#dcecf2;color:#019dd4}.parution-state .left-status.blue{background:#ebedf3;color:#2d54d2}"]
                }] }
    ];
    UpcomingParutionComponent.propDecorators = {
        upcomingPublication: [{ type: Input }],
        leftStatus: [{ type: Input }],
        leftStatusColor: [{ type: Input }],
        rightStatus: [{ type: Input }],
        click: [{ type: Output }]
    };
    return UpcomingParutionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var UpcomingParutionMetadata = {
    declarations: [UpcomingParutionComponent],
    imports: [CommonModule, PublicationStateModule, HttpClientModule, NavTabsModule, IconModule, PercentageCircleModule],
    exports: [UpcomingParutionComponent],
};
var UpcomingParutionModule = /** @class */ (function () {
    function UpcomingParutionModule() {
    }
    UpcomingParutionModule.decorators = [
        { type: NgModule, args: [UpcomingParutionMetadata,] }
    ];
    return UpcomingParutionModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var UpcomingParutionsListMetadata = {
    declarations: [UpcomingParutionsListComponent],
    imports: [CommonModule, HttpClientModule, LoaderModule, PaginationModule, SelectModule, UpcomingParutionModule],
    exports: [UpcomingParutionsListComponent],
};
var UpcomingParutionsListModule = /** @class */ (function () {
    function UpcomingParutionsListModule() {
    }
    UpcomingParutionsListModule.decorators = [
        { type: NgModule, args: [UpcomingParutionsListMetadata,] }
    ];
    return UpcomingParutionsListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpdateMessageComponent = /** @class */ (function () {
    function UpdateMessageComponent(http) {
        this.http = http;
        this.isLoading = true;
        this.tooltipIcon = 'info';
        this.tooltipContent = 'Lorem ipsum...';
    }
    /**
     * @return {?}
     */
    UpdateMessageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: {
                                    componentId: this.componentId ? this.componentId : '',
                                },
                            })
                                .toPromise()];
                    case 1:
                        _a.updateMessageWSResponse = _b.sent();
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    UpdateMessageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-update-message',
                    template: "<div *ngIf=\"!isLoading; else loading\">\n  <div class=\"status\" [ngClass]=\"{'not-updated': !updateMessageWSResponse.isUpToDate}\">{{ updateMessageWSResponse.updateLabel }}</div>\n  <div class=\"status\" [ngClass]=\"{'not-updated': !updateMessageWSResponse.isUpToDate}\" *ngIf=\"!updateMessageWSResponse.isUpToDate\">Donn\u00E9es non remises \u00E0 jour</div>\n  <div class=\"details\">{{ updateMessageWSResponse.tooltip }}</div>\n</div>\n\n<ng-template #loading>\n  {{ loadingMessage }}\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}:host{display:flex;align-items:center;justify-content:flex-end}.status{font-family:Poppins,sans-serif;font-size:1.4rem;font-weight:500;color:#657478;text-align:right}.status.not-updated{color:#ee3251}.details{font-size:1.3rem;font-weight:100;color:#657478;text-align:right}"]
                }] }
    ];
    /** @nocollapse */
    UpdateMessageComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    UpdateMessageComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }]
    };
    return UpdateMessageComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var UpdateMessageMetadata = {
    declarations: [UpdateMessageComponent],
    imports: [CommonModule, TooltipModule, HttpClientModule],
    exports: [UpdateMessageComponent],
};
var UpdateMessageModule = /** @class */ (function () {
    function UpdateMessageModule() {
    }
    UpdateMessageModule.decorators = [
        { type: NgModule, args: [UpdateMessageMetadata,] }
    ];
    return UpdateMessageModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConsolidationParutionsListComponent = /** @class */ (function () {
    function ConsolidationParutionsListComponent(http) {
        this.http = http;
        this._wsRequestParams = {};
        this.isfirstCall = true;
        this.publicationsPages = [];
        this.isLoading = true;
        this.currentPage = 1;
        this.nbItemPerPage = 24;
        this.savedFilter = null;
        this.savedOrder = null;
        this.filterChange = new EventEmitter();
    }
    Object.defineProperty(ConsolidationParutionsListComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (!this.isfirstCall) {
                this.getDataFromWS(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDataFromWS(this._wsRequestParams)];
                    case 1:
                        _a.sent();
                        this.isfirstCall = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Generates data from WS
     * @param params QueryParams to be used in WS call
     */
    /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.getDataFromWS = /**
     * Generates data from WS
     * @param {?} params QueryParams to be used in WS call
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        if (!this.apiUrl) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.http
                                .get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            })
                                .toPromise()];
                    case 1:
                        _a.parutionsList = _b.sent();
                        // Capitalize filter label
                        this.parutionsList.filters.filterByItems.forEach(function (item) {
                            /** @type {?} */
                            var uppercaseFirstLetter = item.label.charAt(0).toUpperCase();
                            item.label = uppercaseFirstLetter + item.label.slice(1);
                        });
                        this.initialPublications = this.parutionsList.publications;
                        res = StaticFilters.setPublicationsPages(this.initialPublications, this.nbItemPerPage);
                        this.publicationsPages = res.listPages;
                        this.currentPage = res.currentPage;
                        this.isLoading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Navigate btw pages set by pagination
     * @param page Page number clicked (or set in queryparams)
     */
    /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.paginationPageChange = /**
     * Navigate btw pages set by pagination
     * @param {?} page Page number clicked (or set in queryparams)
     * @return {?}
     */
    function (page) {
        this.currentPage = page;
        /** @type {?} */
        var scrollSize = this.anchorForScroll.nativeElement.offsetTop - 110;
        window.scroll({ top: scrollSize, left: 0 });
    };
    /**
     * Return the number of day between the current date and the sellingStartDate of a publication
     */
    /**
     * Return the number of day between the current date and the sellingStartDate of a publication
     * @param {?} publication
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.setPublicationToSale = /**
     * Return the number of day between the current date and the sellingStartDate of a publication
     * @param {?} publication
     * @return {?}
     */
    function (publication) {
        return Math.floor((new Date().getTime() - new Date(publication.sellingStartDate).getTime()) / (3600000 * 24));
    };
    /**
     * Return the color of the ruptureRate label according to the value
     */
    /**
     * Return the color of the ruptureRate label according to the value
     * @param {?} publication
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.getColorRupture = /**
     * Return the color of the ruptureRate label according to the value
     * @param {?} publication
     * @return {?}
     */
    function (publication) {
        return publication.ruptureRate < 0.3 ? 'white' : 'orange';
    };
    /**
     * Return an icon or not according to the value of ruptureRate
     */
    /**
     * Return an icon or not according to the value of ruptureRate
     * @param {?} publication
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.getIconRupture = /**
     * Return an icon or not according to the value of ruptureRate
     * @param {?} publication
     * @return {?}
     */
    function (publication) {
        return publication.ruptureRate < 0.3 ? '' : 'alertes';
    };
    /**
     * Filter publications when a filter is selected and emit it
     * @param filter Filter from the select
     */
    /**
     * Filter publications when a filter is selected and emit it
     * @param {?} filter Filter from the select
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.onFilterByItems = /**
     * Filter publications when a filter is selected and emit it
     * @param {?} filter Filter from the select
     * @return {?}
     */
    function (filter) {
        /** @type {?} */
        var res = StaticFilters.filterByItems(filter, this.initialPublications, this.parutionsList.publications, this.savedOrder, this.nbItemPerPage);
        this.parutionsList.publications = res.list;
        this.publicationsPages = res.listPages;
        this.savedFilter = res.savedFilter;
        this.currentPage = res.currentPage;
    };
    /**
     * Sort publications when an order is selected
     * @param order Filter from the select
     */
    /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    ConsolidationParutionsListComponent.prototype.onOrderByItems = /**
     * Sort publications when an order is selected
     * @param {?} order Filter from the select
     * @return {?}
     */
    function (order) {
        /** @type {?} */
        var res = StaticFilters.orderByItems(order, this.initialPublications, this.parutionsList.publications, this.savedFilter, this.nbItemPerPage);
        this.parutionsList.publications = res.list;
        this.publicationsPages = res.listPages;
        this.savedOrder = res.savedOrder;
        this.currentPage = res.currentPage;
    };
    ConsolidationParutionsListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-consolidation-parutions-list',
                    template: "<ng-container>\n  <lib-loader [loaderText]=\"loadingMessage\" loaderSize=\"big\" *ngIf=\"isLoading; else isLoaded\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div #scrollAnchor class=\"parutions-list\" *ngIf=\"parutionsList && parutionsList.publications\">\n    <div class=\"parutions-list-header\">\n      <div class=\"parutions-list-header-top\">\n        <div class=\"parutions-list-header-top-title\">\n          <span class=\"parutions-list-header-top-nbpublications\">{{\n            parutionsList.nbPublications\n            }}</span>\n          parutions en consolidation\n        </div>\n      </div>\n      <div class=\"parutions-list-header-filters\">\n        <div class=\"parutions-list-header-filters-global\">\n          <lib-select\n            [options]=\"parutionsList.filters.filterByItems\"\n            [model]=\"savedFilter\"\n            placeholder=\"Filter par\"\n            ngClassName=\"filter-select\"\n            clearable=\"true\"\n            (change)=\"onFilterByItems($event)\"\n          ></lib-select>\n        </div>\n        <div class=\"parutions-list-header-filters-date\">\n          <lib-select\n            [options]=\"parutionsList.filters.orderByItems\"\n            placeholder=\"Trier par\"\n            ngClassName=\"filter-select\"\n            clearable=\"true\"\n            (change)=\"onOrderByItems($event)\"\n          ></lib-select>\n        </div>\n      </div>\n    </div>\n    <div class=\"parutions-list-display\">\n      <ng-container *ngFor=\"let publication of publicationsPages[currentPage - 1]; let i = index\">\n        <lib-parution\n          *ngIf=\"setPublicationToSale(publication) > 0 && !publication.nbWarehousesInAlert\"\n          class=\"parutions-list-display-item\"\n          [publication]=\"publication\"\n          [goldUrl]=\"goldUrl\"\n          [accountUrl]=\"accountUrl\"\n          [leftStatus]=\"{\n            value: publication.soldRate,\n            code: 'soldRate',\n            label: 'Tx vente',\n            isPercent: true,\n            withCircle: true,\n            circleColor: 'yellow',\n            alertColor: 'white'\n          }\"\n          [rightStatus]=\"{\n            value: publication.ruptureRate,\n            label: 'Tx rupture',\n            isPercent: true,\n            icon: getIconRupture(publication),\n            alertColor: getColorRupture(publication)\n          }\"\n          [apiUrlForCompare]=\"apiUrl\"\n        >\n        </lib-parution>\n      </ng-container>\n    </div>\n    <lib-pagination\n      [numberOfItems]=\"parutionsList.publications.length\"\n      [itemsPerPage]=\"nbItemPerPage\"\n      [currentPage]=\"currentPage\"\n      (pageChange)=\"paginationPageChange($event)\"\n      *ngIf=\"publicationsPages && publicationsPages.length > 1\"\n    ></lib-pagination>\n  </div>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.parutions-list{-webkit-animation:2s fadein;animation:2s fadein;max-width:1100px;color:#0f1112;font-family:Poppins,sans-serif;font-weight:500;font-size:1.4rem}.parutions-list .parutions-list-header-top{justify-content:space-between;align-items:baseline;margin-bottom:15px}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}.parutions-list .parutions-list-header-filters,.parutions-list .parutions-list-header-top{display:flex}.parutions-list .parutions-list-header-top{margin-bottom:24px}}.parutions-list .parutions-list-header-top-title{font-size:2rem;font-weight:600}.parutions-list .parutions-list-header-top-title .parutions-list-header-top-nbpublications{font-family:\"Roboto Slab\",serif;font-weight:100;font-size:5.6rem;margin-right:8px}.parutions-list .display-on-desktop{display:none}@media (min-width:1140px){.parutions-list .display-on-desktop{display:inline}}.parutions-list .parutions-list-header-top-update{color:#657478}.parutions-list .parutions-list-header-filters{margin-bottom:40px}.parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:50%;margin-right:7px}@media (min-width:1140px){.parutions-list .parutions-list-header-filters .parutions-list-header-filters-global{width:400px;margin-right:24px}}.parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:50%}.parutions-list .parutions-list-display{display:flex;flex-wrap:wrap}@media (max-width:1139px){.parutions-list .parutions-list-header-filters{display:flex;margin-bottom:16px}.parutions-list .parutions-list-display{margin:0 -3px}.parutions-list .parutions-list-display .parutions-list-display-item{margin:0 7px 24px}}@media (min-width:1140px){.parutions-list .parutions-list-header-filters .parutions-list-header-filters-date{width:400px}.parutions-list .parutions-list-display .parutions-list-display-item{margin:0 17px 64px}.parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n+1){margin:0 17px 64px 0}.parutions-list .parutions-list-display .parutions-list-display-item:nth-child(4n){margin:0 0 64px 17px}}"]
                }] }
    ];
    /** @nocollapse */
    ConsolidationParutionsListComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    ConsolidationParutionsListComponent.propDecorators = {
        goldUrl: [{ type: Input }],
        apiUrl: [{ type: Input }],
        accountUrl: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        componentId: [{ type: Input }],
        size: [{ type: Input }],
        filterChange: [{ type: Output }],
        anchorForScroll: [{ type: ViewChild, args: ['scrollAnchor',] }],
        groupId: [{ type: Input, args: ['brandEditor',] }]
    };
    return ConsolidationParutionsListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ConsolidationParutionsListMetadata = {
    declarations: [ConsolidationParutionsListComponent],
    imports: [CommonModule, HttpClientModule, LoaderModule, PaginationModule, SelectModule, UpcomingParutionModule, ParutionModule],
    exports: [ConsolidationParutionsListComponent],
};
var ConsolidationParutionsListModule = /** @class */ (function () {
    function ConsolidationParutionsListModule() {
    }
    ConsolidationParutionsListModule.decorators = [
        { type: NgModule, args: [ConsolidationParutionsListMetadata,] }
    ];
    return ConsolidationParutionsListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VentesScanneesComponent = /** @class */ (function () {
    function VentesScanneesComponent(http, router) {
        this.http = http;
        this.router = router;
        this._wsRequestParams = {};
        this.group = new FormGroup({
            title: new FormControl({ value: '', disabled: true }),
            number: new FormControl({ value: '', disabled: true }),
        });
        this.isLoading = false;
        this.searchFn = function (term, item) {
            if (term.length === 6 && /^\d+$/.test(term)) {
                if (item.value.toString() === term) {
                    return true;
                }
            }
            return item.label.toLowerCase().includes(term.toLowerCase());
        };
    }
    Object.defineProperty(VentesScanneesComponent.prototype, "groupId", {
        set: /**
         * @param {?} brandEditor
         * @return {?}
         */
        function (brandEditor) {
            this._groupId = brandEditor.editor.value;
            this._brandId = brandEditor.brand.value;
            this._wsRequestParams.groupId = brandEditor && brandEditor.editor && brandEditor.editor.value ? brandEditor.editor.value : '';
            this._wsRequestParams.brand = brandEditor && brandEditor.brand && brandEditor.brand.value ? brandEditor.brand.value : '';
            if (!this._groupId && this._wsRequestParams.groupId) {
                delete this._wsRequestParams.groupId;
            }
            if (!this._brandId && this._wsRequestParams.brand) {
                delete this._wsRequestParams.brand;
            }
            if (this._wsRequestParams.titleId) {
                delete this._wsRequestParams.titleId;
            }
            this.selectorOptions = [];
            this.selectorNumber = [];
            this.group.get('number').setValue(null);
            this.group.get('number').disable();
            this.selectedParution = null;
            this.group.get('title').setValue(null);
            this.group.get('title').disable();
            if (this._brandId !== null) {
                this.getTitleList(this._wsRequestParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VentesScanneesComponent.prototype, "selected", {
        get: /**
         * @return {?}
         */
        function () {
            return {
                editor: this._groupId ? true : false,
                brand: this._brandId ? true : false,
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    VentesScanneesComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._brandId !== null) {
                    this.getTitleList(this._wsRequestParams);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    VentesScanneesComponent.prototype.getTitleList = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _a = this;
                        return [4 /*yield*/, this.http.get(this.apiUrl, {
                                withCredentials: true,
                                params: Object.assign({}, params),
                            }).toPromise()];
                    case 1:
                        _a.titleList = _b.sent();
                        this.selectorOptions = [];
                        this.selectedTitle = null;
                        this.titleList.titles.forEach(function (title) {
                            _this.selectorOptions.push({
                                label: title.name,
                                value: title.id,
                            });
                        });
                        this.group.get('title').enable();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} params
     * @return {?}
     */
    VentesScanneesComponent.prototype.getParutionList = /**
     * @param {?} params
     * @return {?}
     */
    function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res, tmpSelectorNumber;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.apiUrl, {
                            withCredentials: true,
                            params: Object.assign({}, params),
                        }).toPromise()];
                    case 1:
                        res = _a.sent();
                        this.parutions = res.publications;
                        tmpSelectorNumber = [];
                        this.parutions.forEach(function (parution) {
                            if (parution.name === _this.selectedTitle) {
                                tmpSelectorNumber.push({
                                    label: parution.publicationNumber,
                                    value: parution,
                                });
                            }
                        });
                        this.selectorNumber = tmpSelectorNumber;
                        this.group.get('number').enable();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} option
     * @return {?}
     */
    VentesScanneesComponent.prototype.onSelect = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        this.selectorNumber = [];
        this.selectedParution = null;
        this.selectedTitle = option.label;
        this.group.get('number').patchValue(null);
        this._wsRequestParams.titleId = option.value;
        this.getParutionList(this._wsRequestParams);
    };
    /**
     * @param {?} option
     * @return {?}
     */
    VentesScanneesComponent.prototype.onSelectNumber = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        this.selectedParution = option.value;
    };
    /**
     * @param {?} parution
     * @return {?}
     */
    VentesScanneesComponent.prototype.goToParutionDetails = /**
     * @param {?} parution
     * @return {?}
     */
    function (parution) {
        this.router
            .navigate(['/page/temps-reel'], {
            queryParams: {
                publicationId: parution.publicationId,
            },
        });
    };
    VentesScanneesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'lib-ventes-scannees',
                    template: "<ng-container>\n  <lib-loader *ngIf=\"isLoading; else isLoaded\" loaderSize=\"big\" [loaderText]=\"loadingMessage\"></lib-loader>\n</ng-container>\n\n<ng-template #isLoaded>\n  <div class=\"container\">\n    <div class=\"flex-container\">\n      <div class=\"cover-container\"\n           [ngStyle]=\"selectedParution ? {'background-image': 'url(' + selectedParution?.coverUrl + ')'} : {'background-color': '#cecece'}\">\n      </div>\n      <div class=\"infos-container\">\n        <div class=\"title\">\n          S\u00E9lectionner une marque puis une titre par nom ou par codif\n        </div>\n        <div class=\"selector-container\">\n          <lib-select class=\"selector\" searchable=\"true\"\n                      [options]=\"selectorOptions\" (change)=\"onSelect($event)\" [group]=\"group\" controlName=\"title\"\n                      notFoundText=\"Pas de titres disponibles\" [searchFn]=\"searchFn\" placeholder=\"Titre\"></lib-select>\n          <lib-select class=\"selector\" [group]=\"group\" controlName=\"number\" [options]=\"selectorNumber\" notFoundText=\"Pas de publications disponibles\"\n                      (change)=\"onSelectNumber($event)\" placeholder=\"Num\u00E9ro (ex: 433)\"></lib-select>\n        </div>\n        <div class=\"button-container\">\n          <lib-button *ngIf=\"selectedParution\" text=\"Choisir la parution\"\n                      (click)=\"goToParutionDetails(selectedParution)\"></lib-button>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n",
                    styles: ["@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@import url(https://fonts.googleapis.com/css?family=Poppins:400,500,600|Roboto+Slab:100,300,400);@-webkit-keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadein{from{opacity:0}to{opacity:1}}html{font-size:62.5%;height:100%}body{background-color:#f7f7f7;margin:0;padding:0;color:#0f1112;font-family:Poppins,sans-serif;font-size:1.4rem}input{font-family:Poppins,sans-serif}ngb-datepicker.dropdown-menu{background:#fff;z-index:999;padding:10px!important;border:1px solid #979797;border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:auto!important;height:auto!important;padding:5px;font-style:normal;font-size:1.6rem;font-weight:500;text-align:center;text-transform:uppercase}@media (min-width:1140px){ngb-datepicker.dropdown-menu{padding:37px}ngb-datepicker.dropdown-menu .ngb-dp-day,ngb-datepicker.dropdown-menu .ngb-dp-week-number,ngb-datepicker.dropdown-menu .ngb-dp-weekday{padding:20px}}ngb-datepicker.dropdown-menu .ngb-dp-day{padding:0;outline:0}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:5px;width:30px!important}@media (min-width:1140px){ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day{padding:10px 20px;margin:10px 0}}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.between{color:#fff;background-color:rgba(55,92,210,.8)}ngb-datepicker.dropdown-menu .ngb-dp-day .custom-day.faded{color:#fff;background-color:#375cd2}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day{width:30px!important;border-bottom-right-radius:2px;border-top-right-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:last-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day{border-bottom-left-radius:2px;border-top-left-radius:2px}ngb-datepicker.dropdown-menu .ngb-dp-day:first-child .custom-day.not-rounded{border-radius:0}ngb-datepicker.dropdown-menu .ngb-dp-weekday{width:30px!important;font-size:1.4rem;color:#7a8c91}ngb-datepicker.dropdown-menu [ngbDatepickerDayView]{width:auto!important;height:auto!important;text-align:center}ngb-datepicker.dropdown-menu .ngb-dp-weekdays{border:none}ngb-datepicker.dropdown-menu .ngb-dp-header{padding-bottom:20px}ngb-datepicker.dropdown-menu .text-muted{color:#d3d4d4}.container .flex-container{display:flex;height:235px;max-width:1140px;width:100%;background-color:#ebedf3;padding:30px}.container .flex-container .cover-container{width:100%;max-width:190px;margin-right:40px;border-radius:2.7px;background-repeat:no-repeat;background-position:center;background-color:#cecece;background-size:cover}@media (max-width:1139px){.container .flex-container{flex-direction:column;max-width:300px;flex-wrap:wrap;height:100%}.container .flex-container .cover-container{width:170px;height:225px;margin:0 auto 20px}}.container .flex-container .infos-container{width:100%;display:flex;flex-direction:column}.container .flex-container .infos-container .title{margin-bottom:30px;font-family:Poppins,sans-serif;font-size:1.6rem;color:#0f1112}.container .flex-container .infos-container .selector-container{width:100%;margin:5px 0;display:flex;justify-content:space-between}.container .flex-container .infos-container .selector-container .selector{width:100%;max-width:430px}.container .flex-container .infos-container .button-container{width:210px;align-self:flex-start;margin-top:15px;border-radius:4px}@media (max-width:1139px){.container .flex-container .infos-container .selector-container{flex-direction:column}.container .flex-container .infos-container .selector-container .selector{margin-bottom:15px}.container .flex-container .infos-container .button-container{width:100%}}"]
                }] }
    ];
    /** @nocollapse */
    VentesScanneesComponent.ctorParameters = function () { return [
        { type: HttpClient },
        { type: Router }
    ]; };
    VentesScanneesComponent.propDecorators = {
        apiUrl: [{ type: Input }],
        componentId: [{ type: Input }],
        title: [{ type: Input }],
        size: [{ type: Input }],
        loadingMessage: [{ type: Input }],
        groupId: [{ type: Input, args: ['brandEditor',] }]
    };
    return VentesScanneesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VentesScanneesModule = /** @class */ (function () {
    function VentesScanneesModule() {
    }
    VentesScanneesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [VentesScanneesComponent],
                    exports: [
                        VentesScanneesComponent,
                    ],
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        PageTitleModule,
                        LoaderModule,
                        SelectModule,
                        ButtonModule,
                    ],
                },] }
    ];
    return VentesScanneesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PipesMetadata, PipesModule, ArrowIndicatorMetadata, ArrowIndicatorModule, BadgeMetadata, BadgeModule, BubbleMetadata, BubbleModule, ButtonMetadata, ButtonModule, IconMetadata, IconModule, InputMetadata, InputModule, MapMetadata, MapModule, MenuDesktopMetadata, MenuDesktopModule, MenuMobileMetadata, MenuMobileModule, NavSwitchMetadata, NavSwitchModule, PercentageCircleMetadata, PercentageCircleModule, SelectMetadata, SelectModule, TitleMetadata, TitleModule, LoaderMetadata, LoaderModule, PaginationMetadata, PaginationModule, ButtonGoldMetadata, ButtonGoldModule, IconButtonMetadata, IconButtonModule, IncidentsListMetadata, IncidentsListModule, MenuButtonMetadata, MenuButtonModule, ParutionMetadata, ParutionModule, PublicationStateMetadata, PublicationStateModule, RankingMetadata, RankingModule, RankingItemMetadata, RankingItemModule, SalesSegmentLineMetadata, SalesSegmentLineModule, ToasterMetadata, ToasterModule, TooltipMetadata, TooltipModule, MapWarehouseDetailsMetadata, MapWarehouseDetailsModule, CompareParutionsModule, CompareParutionsListModule, AccountInchargeMetadata, AccountInchargeModule, AnnualSalesMetadata, AnnualSalesModule, BusinessOperationsMetadata, BusinessOperationsModule, SalesPointsStatsMetadata, SalesPointsStatsModule, FooterMetadata, FooterModule, FrontpagesMetadata, FrontpagesModule, FinancialStatsMetadata, FinancialStatsModule, HeaderMetadata, HeaderModule, HelloMetadata, HelloModule, IncidentsIndicatorMetadata, IncidentsIndicatorModule, IncidentsOverviewMetadata, IncidentsOverviewModule, LifecycleUpcomingMetadata, LifecycleUpcomingModule, PageTitleMetadata, PageTitleModule, ParutionsListMetadata, ParutionsListModule, ParutionsIncludedMetadata, ParutionsIncludedModule, PublicationsModalModule, PublicationDetailsMetadata, PublicationDetailsModule, NavTabsMetadata, NavTabsModule, RankingsSetMetadata, RankingsSetModule, RealtimeStatsMetadata, RealtimeStatsModule, SalesSegmentMetadata, SalesSegmentModule, SalesStatisticPageFiltersMetadata, SalesStatisticPageFiltersModule, SalesStatsMetadata, SalesStatsModule, SelectTabsMetadata, SelectTabsModule, PublicationTimelineMetadata, PublicationTimelineModule, UpcomingParutionsListMetadata, UpcomingParutionsListModule, UpdateMessageMetadata, UpdateMessageModule, ConsolidationParutionsListMetadata, ConsolidationParutionsListModule, VentesScanneesModule, AccountInchargeComponent as ɵbp, AnnualSalesComponent as ɵbq, ArrowIndicatorComponent as ɵk, BadgeComponent as ɵl, BubbleComponent as ɵm, BusinessOperationsModalComponent as ɵbt, BusinessOperationsModalModule as ɵbs, BusinessOperationsComponent as ɵbr, ButtonGoldComponent as ɵr, ButtonComponent as ɵn, CompareParutionsListComponent as ɵbo, CompareParutionsComponent as ɵbn, ConsolidationParutionsListComponent as ɵdl, FinancialStatsComponent as ɵcb, FooterComponent as ɵbz, FrontpagesComponent as ɵca, HeaderComponent as ɵcc, HelloComponent as ɵcd, IconButtonComponent as ɵba, IconComponent as ɵo, IncidentsIndicatorComponent as ɵce, IncidentsListComponent as ɵbb, IncidentsOverviewComponent as ɵcf, InputComponent as ɵp, LifecycleArrowComponent as ɵch, LifecycleArrowMetadata as ɵci, LifecycleArrowModule as ɵcj, LifecycleIndicatorComponent as ɵcm, LifecycleIndicatorMetadata as ɵck, LifecycleIndicatorModule as ɵcl, LifecycleUpcomingComponent as ɵcg, LoaderComponent as ɵs, MapWarehouseDetailsComponent as ɵbm, MapComponent as ɵq, MenuButtonComponent as ɵbc, MenuDesktopComponent as ɵt, MenuMobileComponent as ɵu, NavSwitchComponent as ɵv, NavTabsComponent as ɵbh, PageTitleComponent as ɵcn, PaginationComponent as ɵz, ComparatorComponent as ɵbe, ParutionComponent as ɵbd, ParutionsIncludedComponent as ɵcp, ParutionsListComponent as ɵco, PercentageCircleComponent as ɵw, PublicationDetailsComponent as ɵcr, PublicationStateComponent as ɵbf, AlertsHistoryComponent as ɵde, AlertsHistoryMetadata as ɵdc, AlertsHistoryModule as ɵdd, PublicationTimelineComponent as ɵcy, TimelineLabelComponent as ɵdb, TimelineLabelMetadata as ɵcz, TimelineLabelModule as ɵda, PublicationsModalComponent as ɵcq, RankingItemComponent as ɵbj, RankingComponent as ɵbi, RankingsSetComponent as ɵcs, RealtimeStatsComponent as ɵct, SalesPointsStatsComponent as ɵbu, SalesPointsStatsMock as ɵbv, SalesSegmentLineComponent as ɵbk, SalesSegmentComponent as ɵcu, SalesStatisticPageFiltersComponent as ɵcv, SalesStatsComponent as ɵcw, SelectTabsComponent as ɵcx, SelectComponent as ɵx, TextBadgeComponent as ɵby, TextBadgeMetadata as ɵbw, TextBadgeModule as ɵbx, TitleComponent as ɵy, ToasterComponent as ɵbl, TooltipComponent as ɵbg, UpcomingParutionComponent as ɵdj, UpcomingParutionMetadata as ɵdh, UpcomingParutionModule as ɵdi, UpcomingParutionsListComponent as ɵdf, UpcomingParutionsListMock as ɵdg, UpdateMessageComponent as ɵdk, VentesScanneesComponent as ɵdm, AddSignPipe as ɵa, ArrayJoinPipe as ɵb, BusinessOperationsTypePipe as ɵj, CeilPipe as ɵc, CustomPercentPipe as ɵd, FloorPercentPipe as ɵe, RemoveAfterHyphenPipe as ɵf, SanitizeHtmlPipe as ɵg, TruncatePipe as ɵh, VersusPercentPipe as ɵi };

//# sourceMappingURL=components-library.js.map